// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2RPtJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jqueryGlobal = require("./jquery-global");
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _jssorSlider = require("jssor-slider");
var _jqueryNanogalleryMin = require("./jquery.nanogallery.min");
var _eventie = require("eventie");
var _wolfy87Eventemitter = require("wolfy87-eventemitter");
var _bootstrapMin = require("bootstrap/dist/js/bootstrap.min");
(0, _jqueryDefault.default)(document).ready(function() {
    fadeInPage();
    function fadeInPage() {
        if (!window.AnimationEvent) return;
        const fader = document.getElementById("fader");
        fader.classList.add("fade-out");
    }
    if ((0, _jqueryDefault.default)("#nanoGallery1").length !== 0) (0, _jqueryDefault.default)("#nanoGallery1").nanoGallery({
        kind: "flickr",
        userID: "130361385@N03",
        thumbnailLabel: {
            display: true,
            position: "onBottom",
            titleMaxLength: 20,
            align: "center"
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    if (!window.AnimationEvent) return;
    const anchors = document.getElementsByTagName("a");
    for(let idx = 0; idx < anchors.length; idx += 1){
        if (anchors[idx].hostname !== window.location.hostname || anchors[idx].pathname === window.location.pathname) continue;
        anchors[idx].addEventListener("click", function(event) {
            const fader = document.getElementById("fader"), anchor = event.currentTarget;
            const listener = function() {
                window.location = anchor.href;
                fader.removeEventListener("animationend", listener);
            };
            fader.addEventListener("animationend", listener);
            event.preventDefault();
            fader.classList.add("fade-in");
        });
    }
});
window.addEventListener("pageshow", function(event) {
    if (!event.persisted) return;
    const fader = document.getElementById("fader");
    fader.classList.remove("fade-in");
});
if ((0, _jqueryDefault.default)("#slider1_container").length !== 0) (0, _jqueryDefault.default)(document).ready(function($) {
    const options = {
        $FillMode: 1,
        $DragOrientation: 1,
        $AutoPlay: true,
        $AutoPlayInterval: 2500,
        $SlideshowOptions: {
            $Class: $JssorSlideshowRunner$,
            $TransitionsOrder: 1,
            $ShowLink: true //[Optional] Whether to bring slide link on top of the slider when slideshow is running, default value is false
        },
        $BulletNavigatorOptions: {
            $Class: $JssorBulletNavigator$,
            $ChanceToShow: 2,
            $AutoCenter: 1,
            $Steps: 1,
            $Lanes: 1,
            $SpacingX: 10,
            $SpacingY: 10,
            $Orientation: 1 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
        },
        $ArrowNavigatorOptions: {
            $Class: $JssorArrowNavigator$,
            $ChanceToShow: 1,
            $AutoCenter: 0,
            $Steps: 1 //[Optional] Steps to go for each navigation request, default value is 1
        }
    };
    const jssor_slider1 = new $JssorSlider$("slider1_container", options);
    const jssor_slider2 = new $JssorSlider$("slider2_container", options);
    function ScaleSlider() {
        const parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
        if (parentWidth) {
            jssor_slider1.$ScaleWidth(Math.min(parentWidth, 600));
            jssor_slider2.$ScaleWidth(Math.min(parentWidth, 600));
        } else window.setTimeout(ScaleSlider, 30);
    }
    ScaleSlider();
    $(window).bind("load", ScaleSlider);
    $(window).bind("resize", ScaleSlider);
    $(window).bind("orientationchange", ScaleSlider);
});

},{"./jquery-global":"3u24a","jquery":"2Z9Ua","jssor-slider":"hBcxX","./jquery.nanogallery.min":"4XqhK","eventie":"8jta7","wolfy87-eventemitter":"2eFNp","bootstrap/dist/js/bootstrap.min":"3wVYm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3u24a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
globalThis.jQuery = (0, _jqueryDefault.default);

},{"jquery":"2Z9Ua","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Z9Ua":[function(require,module,exports) {
/*!
 * jQuery JavaScript Library v1.12.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:17Z
 */ (function(global, factory) {
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function(window1, noGlobal) {
    // Support: Firefox 18+
    // Can't be in strict mode, several libs including ASP.NET trace
    // the stack via arguments.caller.callee and Firefox dies if
    // you try to trace through "use strict" call chains. (#13335)
    //"use strict";
    var deletedIds = [];
    var document = window1.document;
    var slice = deletedIds.slice;
    var concat = deletedIds.concat;
    var push = deletedIds.push;
    var indexOf = deletedIds.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var support = {};
    var version = "1.12.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    }, // Support: Android<4.1, IE<9
    // Make sure we trim BOM and NBSP
    rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, // Matches dashed string for camelizing
    rmsPrefix = /^-ms-/, rdashAlpha = /-([\da-z])/gi, // Used by jQuery.camelCase as callback to replace()
    fcamelCase = function(all, letter) {
        return letter.toUpperCase();
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // Start with an empty selector
        selector: "",
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            return num != null ? // Return just the one element from the set
            num < 0 ? this[num + this.length] : this[num] : // Return all the elements in a clean array
            slice.call(this);
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            ret.context = this.context;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: deletedIds.sort,
        splice: deletedIds.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var src, copyIsArray, copy, name, options, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !jQuery.isFunction(target)) target = {};
        // extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                src = target[name];
                copy = options[name];
                // Prevent never-ending loop
                if (target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && jQuery.isArray(src) ? src : [];
                    } else clone = src && jQuery.isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        // See test/unit/core.js for details concerning isFunction.
        // Since version 1.3, DOM methods and functions like alert
        // aren't supported. They return false on IE (#2968).
        isFunction: function(obj) {
            return jQuery.type(obj) === "function";
        },
        isArray: Array.isArray || function(obj) {
            return jQuery.type(obj) === "array";
        },
        isWindow: function(obj) {
            /* jshint eqeqeq: false */ return obj != null && obj == obj.window;
        },
        isNumeric: function(obj) {
            // parseFloat NaNs numeric-cast false positives (null|true|false|"")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            // adding 1 corrects loss of precision from parseFloat (#15100)
            var realStringObj = obj && obj.toString();
            return !jQuery.isArray(obj) && realStringObj - parseFloat(realStringObj) + 1 >= 0;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        isPlainObject: function(obj) {
            var key;
            // Must be an Object.
            // Because of IE, we also have to check the presence of the constructor property.
            // Make sure that DOM nodes and window objects don't pass through, as well
            if (!obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) return false;
            try {
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) return false;
            } catch (e) {
                // IE8,9 Will throw exceptions on certain host objects #9897
                return false;
            }
            // Support: IE<9
            // Handle iteration over inherited properties before own properties.
            if (!support.ownFirst) {
                for(key in obj)return hasOwn.call(obj, key);
            }
            // Own properties are enumerated firstly, so to speed up,
            // if last one is own, then all properties are own.
            for(key in obj);
            return key === undefined || hasOwn.call(obj, key);
        },
        type: function(obj) {
            if (obj == null) return obj + "";
            return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
        },
        // Workarounds based on findings by Jim Driscoll
        // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
        globalEval: function(data) {
            if (data && jQuery.trim(data)) // We use execScript on Internet Explorer
            // We use an anonymous function so that context is window
            // rather than jQuery in Firefox
            (window1.execScript || function(data) {
                window1["eval"].call(window1, data); // jscs:ignore requireDotNotation
            })(data);
        },
        // Convert dashed to camelCase; used by the css and data modules
        // Microsoft forgot to hump their vendor prefix (#9572)
        camelCase: function(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        },
        nodeName: function(elem, name) {
            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Support: Android<4.1, IE<9
        trim: function(text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            var len;
            if (arr) {
                if (indexOf) return indexOf.call(arr, elem, i);
                len = arr.length;
                i = i ? i < 0 ? Math.max(0, len + i) : i : 0;
                for(; i < len; i++){
                    // Skip accessing in sparse arrays
                    if (i in arr && arr[i] === elem) return i;
                }
            }
            return -1;
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            while(j < len)first[i++] = second[j++];
            // Support: IE<9
            // Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
            if (len !== len) while(second[j] !== undefined)first[i++] = second[j++];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return concat.apply([], ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // Bind a function to a context, optionally partially applying any
        // arguments.
        proxy: function(fn, context) {
            var args, proxy, tmp;
            if (typeof context === "string") {
                tmp = fn[context];
                context = fn;
                fn = tmp;
            }
            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!jQuery.isFunction(fn)) return undefined;
            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function() {
                return fn.apply(context || this, args.concat(slice.call(arguments)));
            };
            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;
            return proxy;
        },
        now: function() {
            return +new Date();
        },
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    // JSHint would error on this code due to the Symbol not being defined in ES5.
    // Defining this global in .jshintrc would create a danger of using the global
    // unguarded in another place, it seems safer to just disable JSHint for these
    // three lines.
    /* jshint ignore: start */ if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = deletedIds[Symbol.iterator];
    /* jshint ignore: end */ // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: iOS 8.2 (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = jQuery.type(obj);
        if (type === "function" || jQuery.isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // General-purpose constants
        MAX_NEGATIVE = -2147483648, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // http://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
        identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"), funescape = function(_, escaped, escapedWhitespace) {
            var high = "0x" + escaped - 0x10000;
            // NaN means non-codepoint
            // Support: Firefox<24
            // Workaround erroneous numeric interpretation of +"0x"
            return high !== high || escapedWhitespace ? escaped : high < 0 ? // BMP codepoint
            String.fromCharCode(high + 0x10000) : // Supplemental Plane codepoint (surrogate pair)
            String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        };
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    push_native.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, nidselect, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                if ((context ? context.ownerDocument || context : preferredDoc) !== document) setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        if (nodeType !== 1) {
                            newContext = context;
                            newSelector = selector;
                        // qSA looks outside Element context, which is not what we want
                        // Thanks to Andrew Dupont for this workaround technique
                        // Support: IE <=8
                        // Exclude object elements
                        } else if (context.nodeName.toLowerCase() !== "object") {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = nid.replace(rescape, "\\$&");
                            else context.setAttribute("id", nid = expando);
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            nidselect = ridentifier.test(nid) ? "#" + nid : "[id='" + nid + "']";
                            while(i--)groups[i] = nidselect + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        }
                        if (newSelector) try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {} finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */ function assert(fn) {
            var div = document.createElement("div");
            try {
                return !!fn(div);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (div.parentNode) div.parentNode.removeChild(div);
                // release memory in IE
                div = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            // documentElement is verified for cases where it doesn't yet exist
            // (such as loading iframes in IE - #4833)
            var documentElement = elem && (elem.ownerDocument || elem).documentElement;
            return documentElement ? documentElement.nodeName !== "HTML" : false;
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, parent, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            if (doc === document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9-11, Edge
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            if ((parent = document.defaultView) && parent.top !== parent) {
                // Support: IE 11
                if (parent.addEventListener) parent.addEventListener("unload", unloadHandler, false);
                else if (parent.attachEvent) parent.attachEvent("onunload", unloadHandler);
            }
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(div) {
                div.className = "i";
                return !div.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(div) {
                div.appendChild(document.createComment(""));
                return !div.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(div) {
                docElem.appendChild(div).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID find and filter
            if (support.getById) {
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var m = context.getElementById(id);
                        return m ? [
                            m
                        ] : [];
                    }
                };
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
            } else {
                // Support: IE6/7
                // getElementById is not reliable as a find shortcut
                delete Expr.find["ID"];
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See http://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(div) {
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // http://bugs.jquery.com/ticket/12359
                    docElem.appendChild(div).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (div.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!div.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!div.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!div.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibing-combinator selector` fails
                    if (!div.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                });
                assert(function(div) {
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    div.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (div.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (!div.querySelectorAll(":enabled").length) rbuggyQSA.push(":enabled", ":disabled");
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    div.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(div) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(div, "div");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(div, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) return -1;
                    if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            // Set document vars if needed
            if ((elem.ownerDocument || elem) !== document) setDocument(elem);
            // Make sure that attribute selectors are quoted
            expr = expr.replace(rattributeQuotes, "='$1']");
            if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {}
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            if ((context.ownerDocument || context) !== document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            if ((elem.ownerDocument || elem) !== document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    };
                },
                "CHILD": function(type, what, argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": function(elem) {
                    return elem.disabled === false;
                },
                "disabled": function(elem) {
                    return elem.disabled === true;
                },
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rcombinators.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, checkNonElements = base && dir === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if ((oldCache = uniqueCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[dir] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) outermostContext = context === document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        if (!context && elem.ownerDocument !== document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(div1) {
            // Should return 1, but returns 4 (following)
            return div1.compareDocumentPosition(document.createElement("div")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(div) {
            div.innerHTML = "<a href='#'></a>";
            return div.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(div) {
            div.innerHTML = "<input/>";
            div.firstChild.setAttribute("value", "");
            return div.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(div) {
            return div.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
    var risSimple = /^.[^:#\[\.,]*$/;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (jQuery.isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            /* jshint -W018 */ return !!qualifier.call(elem, i, elem) !== not;
        });
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        if (typeof qualifier === "string") {
            if (risSimple.test(qualifier)) return jQuery.filter(qualifier, elements, not);
            qualifier = jQuery.filter(qualifier, elements);
        }
        return jQuery.grep(elements, function(elem) {
            return jQuery.inArray(elem, qualifier) > -1 !== not;
        });
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        return elems.length === 1 && elem.nodeType === 1 ? jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [] : jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret = [], self = this, len = self.length;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            // Needed because $( selector, context ) becomes $( context ).find( selector )
            ret = this.pushStack(len > 1 ? jQuery.unique(ret) : ret);
            ret.selector = this.selector ? this.selector + " " + selector : selector;
            return ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // init accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (jQuery.isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    // Check parentNode to catch when Blackberry 4.6 returns
                    // nodes that are no longer in the document #6963
                    if (elem && elem.parentNode) {
                        // Handle the case where IE and Opera return items
                        // by name instead of ID
                        if (elem.id !== match[2]) return rootjQuery.find(selector);
                        // Otherwise, we inject the element directly into the jQuery object
                        this.length = 1;
                        this[0] = elem;
                    }
                    this.context = document;
                    this.selector = selector;
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this.context = this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (jQuery.isFunction(selector)) return typeof root.ready !== "undefined" ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        if (selector.selector !== undefined) {
            this.selector = selector.selector;
            this.context = selector.context;
        }
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var i, targets = jQuery(target, this), len = targets.length;
            return this.filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? jQuery(selectors, context || this.context) : 0;
            for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (pos ? pos.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within
        // the matched set of elements
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // index in selector
            if (typeof elem === "string") return jQuery.inArray(this[0], jQuery(elem));
            // Locate the position of the desired element
            return jQuery.inArray(// If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem, this);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        do cur = cur[dir];
        while (cur && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            return jQuery.nodeName(elem, "iframe") ? elem.contentDocument || elem.contentWindow.document : jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var ret = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") ret = jQuery.filter(selector, ret);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) ret = jQuery.uniqueSort(ret);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) ret = ret.reverse();
            }
            return this.pushStack(ret);
        };
    });
    var rnotwhite = /\S+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnotwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (jQuery.isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && jQuery.type(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = true;
                if (!memory) self.disable();
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, listener list, final state
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    "rejected"
                ],
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory")
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                then: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(i, tuple) {
                            var fn = jQuery.isFunction(fns[i]) && fns[i];
                            // deferred[ done | fail | progress ] for forwarding actions to newDefer
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && jQuery.isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Keep pipe for back-compat
            promise.pipe = promise.then;
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[3];
                // promise[ done | fail | progress ] = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = [ resolved | rejected ]
                    state = stateString;
                // [ reject_list | resolve_list ].disable; progress_list.lock
                }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
                // deferred[ resolve | reject | notify ]
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments);
                    return this;
                };
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(subordinate /* , ..., subordinateN */ ) {
            var i = 0, resolveValues = slice.call(arguments), length = resolveValues.length, // the count of uncompleted subordinates
            remaining = length !== 1 || subordinate && jQuery.isFunction(subordinate.promise) ? length : 0, // the master Deferred.
            // If resolveValues consist of only a single Deferred, just use that.
            deferred = remaining === 1 ? subordinate : jQuery.Deferred(), // Update function for both resolve and progress values
            updateFunc = function(i, contexts, values) {
                return function(value) {
                    contexts[i] = this;
                    values[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (values === progressValues) deferred.notifyWith(contexts, values);
                    else if (!--remaining) deferred.resolveWith(contexts, values);
                };
            }, progressValues, progressContexts, resolveContexts;
            // add listeners to Deferred subordinates; treat others as resolved
            if (length > 1) {
                progressValues = new Array(length);
                progressContexts = new Array(length);
                resolveContexts = new Array(length);
                for(; i < length; i++)if (resolveValues[i] && jQuery.isFunction(resolveValues[i].promise)) resolveValues[i].promise().progress(updateFunc(i, progressContexts, progressValues)).done(updateFunc(i, resolveContexts, resolveValues)).fail(deferred.reject);
                else --remaining;
            }
            // if we're not waiting on anything, resolve the master
            if (!remaining) deferred.resolveWith(resolveContexts, resolveValues);
            return deferred.promise();
        }
    });
    // The deferred used on DOM ready
    var readyList;
    jQuery.fn.ready = function(fn) {
        // Add the callback
        jQuery.ready.promise().done(fn);
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,
        // Hold (or release) the ready event
        holdReady: function(hold) {
            if (hold) jQuery.readyWait++;
            else jQuery.ready(true);
        },
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
            // Trigger any bound ready events
            if (jQuery.fn.triggerHandler) {
                jQuery(document).triggerHandler("ready");
                jQuery(document).off("ready");
            }
        }
    });
    /**
 * Clean-up method for dom ready events
 */ function detach() {
        if (document.addEventListener) {
            document.removeEventListener("DOMContentLoaded", completed);
            window1.removeEventListener("load", completed);
        } else {
            document.detachEvent("onreadystatechange", completed);
            window1.detachEvent("onload", completed);
        }
    }
    /**
 * The ready event handler and self cleanup method
 */ function completed() {
        // readyState === "complete" is good enough for us to call the dom ready in oldIE
        if (document.addEventListener || window1.event.type === "load" || document.readyState === "complete") {
            detach();
            jQuery.ready();
        }
    }
    jQuery.ready.promise = function(obj) {
        if (!readyList) {
            readyList = jQuery.Deferred();
            // Catch cases where $(document).ready() is called
            // after the browser event has already occurred.
            // Support: IE6-10
            // Older IE sometimes signals "interactive" too soon
            if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
            window1.setTimeout(jQuery.ready);
            else if (document.addEventListener) {
                // Use the handy event callback
                document.addEventListener("DOMContentLoaded", completed);
                // A fallback to window.onload, that will always work
                window1.addEventListener("load", completed);
            // If IE event model is used
            } else {
                // Ensure firing before onload, maybe late but safe also for iframes
                document.attachEvent("onreadystatechange", completed);
                // A fallback to window.onload, that will always work
                window1.attachEvent("onload", completed);
                // If IE and not a frame
                // continually check to see if the document is ready
                var top = false;
                try {
                    top = window1.frameElement == null && document.documentElement;
                } catch (e) {}
                if (top && top.doScroll) (function doScrollCheck() {
                    if (!jQuery.isReady) {
                        try {
                            // Use the trick by Diego Perini
                            // http://javascript.nwbox.com/IEContentLoaded/
                            top.doScroll("left");
                        } catch (e) {
                            return window1.setTimeout(doScrollCheck, 50);
                        }
                        // detach all dom ready events
                        detach();
                        // and execute any waiting functions
                        jQuery.ready();
                    }
                })();
            }
        }
        return readyList.promise(obj);
    };
    // Kick off the DOM ready check even if the user does not
    jQuery.ready.promise();
    // Support: IE<9
    // Iteration over object's inherited properties before its own
    var i;
    for(i in jQuery(support))break;
    support.ownFirst = i === "0";
    // Note: most support tests are defined in their respective modules.
    // false until the test is run
    support.inlineBlockNeedsLayout = false;
    // Execute ASAP in case we need to set body.style.zoom
    jQuery(function() {
        // Minified: var a,b,c,d
        var val, div, body, container;
        body = document.getElementsByTagName("body")[0];
        if (!body || !body.style) // Return for frameset docs that don't have a body
        return;
        // Setup
        div = document.createElement("div");
        container = document.createElement("div");
        container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
        body.appendChild(container).appendChild(div);
        if (typeof div.style.zoom !== "undefined") {
            // Support: IE<8
            // Check if natively block-level elements act like inline-block
            // elements when setting their display to 'inline' and giving
            // them layout
            div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
            support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
            if (val) // Prevent IE 6 from affecting layout for positioned elements #11048
            // Prevent IE from shrinking the body in IE 7 mode #12869
            // Support: IE<8
            body.style.zoom = 1;
        }
        body.removeChild(container);
    });
    (function() {
        var div = document.createElement("div");
        // Support: IE<9
        support.deleteExpando = true;
        try {
            delete div.test;
        } catch (e) {
            support.deleteExpando = false;
        }
        // Null elements to avoid leaks in IE.
        div = null;
    })();
    var acceptData = function(elem) {
        var noData = jQuery.noData[(elem.nodeName + " ").toLowerCase()], nodeType = +elem.nodeType || 1;
        // Do not set data on non-element DOM nodes because it will not be cleared (#8335).
        return nodeType !== 1 && nodeType !== 9 ? false : // Nodes accept data unless otherwise specified; rejection can be conditional
        !noData || noData !== true && elem.getAttribute("classid") === noData;
    };
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /([A-Z])/g;
    function dataAttr(elem, key, data) {
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = data === "true" ? true : data === "false" ? false : data === "null" ? null : // Only convert to a number if it doesn't change the string
                    +data + "" === data ? +data : rbrace.test(data) ? jQuery.parseJSON(data) : data;
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                jQuery.data(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    // checks a cache object for emptiness
    function isEmptyDataObject(obj) {
        var name;
        for(name in obj){
            // if the public data object is empty, the private is still empty
            if (name === "data" && jQuery.isEmptyObject(obj[name])) continue;
            if (name !== "toJSON") return false;
        }
        return true;
    }
    function internalData(elem, name, data, pvt /* Internal Use Only */ ) {
        if (!acceptData(elem)) return;
        var ret, thisCache, internalKey = jQuery.expando, // We have to handle DOM nodes and JS objects differently because IE6-7
        // can't GC object references properly across the DOM-JS boundary
        isNode = elem.nodeType, // Only DOM nodes need the global jQuery cache; JS object data is
        // attached directly to the object so GC can occur automatically
        cache = isNode ? jQuery.cache : elem, // Only defining an ID for JS objects if its cache already exists allows
        // the code to shortcut on the same path as a DOM node with no cache
        id = isNode ? elem[internalKey] : elem[internalKey] && internalKey;
        // Avoid doing any more work than we need to when trying to get data on an
        // object that has no data at all
        if ((!id || !cache[id] || !pvt && !cache[id].data) && data === undefined && typeof name === "string") return;
        if (!id) {
            // Only DOM nodes need a new unique ID for each element since their data
            // ends up in the global cache
            if (isNode) id = elem[internalKey] = deletedIds.pop() || jQuery.guid++;
            else id = internalKey;
        }
        if (!cache[id]) // Avoid exposing jQuery metadata on plain JS objects when the object
        // is serialized using JSON.stringify
        cache[id] = isNode ? {} : {
            toJSON: jQuery.noop
        };
        // An object can be passed to jQuery.data instead of a key/value pair; this gets
        // shallow copied over onto the existing cache
        if (typeof name === "object" || typeof name === "function") {
            if (pvt) cache[id] = jQuery.extend(cache[id], name);
            else cache[id].data = jQuery.extend(cache[id].data, name);
        }
        thisCache = cache[id];
        // jQuery data() is stored in a separate object inside the object's internal data
        // cache in order to avoid key collisions between internal data and user-defined
        // data.
        if (!pvt) {
            if (!thisCache.data) thisCache.data = {};
            thisCache = thisCache.data;
        }
        if (data !== undefined) thisCache[jQuery.camelCase(name)] = data;
        // Check for both converted-to-camel and non-converted data property names
        // If a data property was specified
        if (typeof name === "string") {
            // First Try to find as-is property data
            ret = thisCache[name];
            // Test for null|undefined property data
            if (ret == null) // Try to find the camelCased property
            ret = thisCache[jQuery.camelCase(name)];
        } else ret = thisCache;
        return ret;
    }
    function internalRemoveData(elem, name, pvt) {
        if (!acceptData(elem)) return;
        var thisCache, i, isNode = elem.nodeType, // See jQuery.data for more information
        cache = isNode ? jQuery.cache : elem, id = isNode ? elem[jQuery.expando] : jQuery.expando;
        // If there is already no cache entry for this object, there is no
        // purpose in continuing
        if (!cache[id]) return;
        if (name) {
            thisCache = pvt ? cache[id] : cache[id].data;
            if (thisCache) {
                // Support array or space separated string names for data keys
                if (!jQuery.isArray(name)) {
                    // try the string as a key before any manipulation
                    if (name in thisCache) name = [
                        name
                    ];
                    else {
                        // split the camel cased version by spaces unless a key with the spaces exists
                        name = jQuery.camelCase(name);
                        if (name in thisCache) name = [
                            name
                        ];
                        else name = name.split(" ");
                    }
                } else // If "name" is an array of keys...
                // When data is initially created, via ("key", "val") signature,
                // keys will be converted to camelCase.
                // Since there is no way to tell _how_ a key was added, remove
                // both plain key and camelCase key. #12786
                // This will only penalize the array argument path.
                name = name.concat(jQuery.map(name, jQuery.camelCase));
                i = name.length;
                while(i--)delete thisCache[name[i]];
                // If there is no data left in the cache, we want to continue
                // and let the cache object itself get destroyed
                if (pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache)) return;
            }
        }
        // See jQuery.data for more information
        if (!pvt) {
            delete cache[id].data;
            // Don't destroy the parent cache unless the internal data object
            // had been the only thing left in it
            if (!isEmptyDataObject(cache[id])) return;
        }
        // Destroy the cache
        if (isNode) jQuery.cleanData([
            elem
        ], true);
        else if (support.deleteExpando || cache != cache.window) /* jshint eqeqeq: true */ delete cache[id];
        else cache[id] = undefined;
    }
    jQuery.extend({
        cache: {},
        // The following elements (space-suffixed to avoid Object.prototype collisions)
        // throw uncatchable exceptions if you attempt to set expando properties
        noData: {
            "applet ": true,
            "embed ": true,
            // ...but Flash objects (which have this classid) *can* handle expandos
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function(elem) {
            elem = elem.nodeType ? jQuery.cache[elem[jQuery.expando]] : elem[jQuery.expando];
            return !!elem && !isEmptyDataObject(elem);
        },
        data: function(elem, name, data) {
            return internalData(elem, name, data);
        },
        removeData: function(elem, name) {
            return internalRemoveData(elem, name);
        },
        // For internal use only.
        _data: function(elem, name, data) {
            return internalData(elem, name, data, true);
        },
        _removeData: function(elem, name) {
            return internalRemoveData(elem, name, true);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Special expections of .data basically thwart jQuery.access,
            // so implement the relevant behavior ourselves
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = jQuery.data(elem);
                    if (elem.nodeType === 1 && !jQuery._data(elem, "parsedAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE11+
                        // The attrs elements can be null (#14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = jQuery.camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        jQuery._data(elem, "parsedAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                jQuery.data(this, key);
            });
            return arguments.length > 1 ? // Sets one value
            this.each(function() {
                jQuery.data(this, key, value);
            }) : // Gets one value
            // Try to fetch any internally stored data first
            elem ? dataAttr(elem, key, jQuery.data(elem, key)) : undefined;
        },
        removeData: function(key) {
            return this.each(function() {
                jQuery.removeData(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = jQuery._data(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || jQuery.isArray(data)) queue = jQuery._data(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // not intended for public consumption - generates a queueHooks object,
        // or returns the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return jQuery._data(elem, key) || jQuery._data(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    jQuery._removeData(elem, type + "queue");
                    jQuery._removeData(elem, key);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = jQuery._data(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    (function() {
        var shrinkWrapBlocksVal;
        support.shrinkWrapBlocks = function() {
            if (shrinkWrapBlocksVal != null) return shrinkWrapBlocksVal;
            // Will be changed later if needed.
            shrinkWrapBlocksVal = false;
            // Minified: var b,c,d
            var div, body, container;
            body = document.getElementsByTagName("body")[0];
            if (!body || !body.style) // Test fired too early or in an unsupported environment, exit.
            return;
            // Setup
            div = document.createElement("div");
            container = document.createElement("div");
            container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
            body.appendChild(container).appendChild(div);
            // Support: IE6
            // Check if elements with layout shrink-wrap their children
            if (typeof div.style.zoom !== "undefined") {
                // Reset CSS: box-sizing; display; margin; border
                div.style.cssText = // Support: Firefox<29, Android 2.3
                // Vendor-prefix box-sizing
                "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1";
                div.appendChild(document.createElement("div")).style.width = "5px";
                shrinkWrapBlocksVal = div.offsetWidth !== 3;
            }
            body.removeChild(container);
            return shrinkWrapBlocksVal;
        };
    })();
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var isHidden = function(elem, el) {
        // isHidden might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        return jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument, elem);
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale = 1, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            do {
                // If previous iteration zeroed out, double until we get *something*.
                // Use string for doubling so we don't accidentally see scale as unchanged below
                scale = scale || ".5";
                // Adjust and apply
                initialInUnit = initialInUnit / scale;
                jQuery.style(elem, prop, initialInUnit + unit);
            // Update scale, tolerating zero or NaN from tween.cur()
            // Break the loop if scale is unchanged or perfect, or if we've just had enough.
            }while (scale !== (scale = currentValue() / initial) && scale !== 1 && --maxIterations);
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, length = elems.length, bulk = key == null;
        // Sets many values
        if (jQuery.type(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!jQuery.isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < length; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        return chainable ? elems : // Gets
        bulk ? fn.call(elems) : length ? fn(elems[0], key) : emptyGet;
    };
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([\w:-]+)/;
    var rscriptType = /^$|\/(?:java|ecma)script/i;
    var rleadingWhitespace = /^\s+/;
    var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
    function createSafeFragment(document) {
        var list = nodeNames.split("|"), safeFrag = document.createDocumentFragment();
        if (safeFrag.createElement) while(list.length)safeFrag.createElement(list.pop());
        return safeFrag;
    }
    (function() {
        var div = document.createElement("div"), fragment = document.createDocumentFragment(), input = document.createElement("input");
        // Setup
        div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
        // IE strips leading whitespace when .innerHTML is used
        support.leadingWhitespace = div.firstChild.nodeType === 3;
        // Make sure that tbody elements aren't automatically inserted
        // IE will insert them into empty tables
        support.tbody = !div.getElementsByTagName("tbody").length;
        // Make sure that link elements get serialized correctly by innerHTML
        // This requires a wrapper element in IE
        support.htmlSerialize = !!div.getElementsByTagName("link").length;
        // Makes sure cloning an html5 element does not cause problems
        // Where outerHTML is undefined, this still works
        support.html5Clone = document.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>";
        // Check if a disconnected checkbox will retain its checked
        // value of true after appended to the DOM (IE6/7)
        input.type = "checkbox";
        input.checked = true;
        fragment.appendChild(input);
        support.appendChecked = input.checked;
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        // Support: IE6-IE11+
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // #11217 - WebKit loses check when the name is after the checked attribute
        fragment.appendChild(div);
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input = document.createElement("input");
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
        // old WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE<9
        // Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
        support.noCloneEvent = !!div.addEventListener;
        // Support: IE<9
        // Since attributes and properties are the same in IE,
        // cleanData must set properties to undefined rather than use removeAttribute
        div[jQuery.expando] = 1;
        support.attributes = !div.getAttribute(jQuery.expando);
    })();
    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {
        option: [
            1,
            "<select multiple='multiple'>",
            "</select>"
        ],
        legend: [
            1,
            "<fieldset>",
            "</fieldset>"
        ],
        area: [
            1,
            "<map>",
            "</map>"
        ],
        // Support: IE8
        param: [
            1,
            "<object>",
            "</object>"
        ],
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        col: [
            2,
            "<table><tbody></tbody><colgroup>",
            "</colgroup></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        // IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
        // unless wrapped in a div with non-breaking characters in front of it.
        _default: support.htmlSerialize ? [
            0,
            "",
            ""
        ] : [
            1,
            "X<div>",
            "</div>"
        ]
    };
    // Support: IE8-IE9
    wrapMap.optgroup = wrapMap.option;
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        var elems, elem, i = 0, found = typeof context.getElementsByTagName !== "undefined" ? context.getElementsByTagName(tag || "*") : typeof context.querySelectorAll !== "undefined" ? context.querySelectorAll(tag || "*") : undefined;
        if (!found) {
            for(found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++)if (!tag || jQuery.nodeName(elem, tag)) found.push(elem);
            else jQuery.merge(found, getAll(elem, tag));
        }
        return tag === undefined || tag && jQuery.nodeName(context, tag) ? jQuery.merge([
            context
        ], found) : found;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var elem, i = 0;
        for(; (elem = elems[i]) != null; i++)jQuery._data(elem, "globalEval", !refElements || jQuery._data(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/, rtbody = /<tbody/i;
    function fixDefaultChecked(elem) {
        if (rcheckableType.test(elem.type)) elem.defaultChecked = elem.checked;
    }
    function buildFragment(elems, context, scripts, selection, ignored) {
        var j, elem, contains, tmp, tag, tbody, wrap, l = elems.length, // Ensure a safe fragment
        safe = createSafeFragment(context), nodes = [], i = 0;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (jQuery.type(elem) === "object") jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || safe.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Manually add leading whitespace removed by IE
                    if (!support.leadingWhitespace && rleadingWhitespace.test(elem)) nodes.push(context.createTextNode(rleadingWhitespace.exec(elem)[0]));
                    // Remove IE's autoinserted <tbody> from table fragments
                    if (!support.tbody) {
                        // String was a <table>, *may* have spurious <tbody>
                        elem = tag === "table" && !rtbody.test(elem) ? tmp.firstChild : // String was a bare <thead> or <tfoot>
                        wrap[1] === "<table>" && !rtbody.test(elem) ? tmp : 0;
                        j = elem && elem.childNodes.length;
                        while(j--)if (jQuery.nodeName(tbody = elem.childNodes[j], "tbody") && !tbody.childNodes.length) elem.removeChild(tbody);
                    }
                    jQuery.merge(nodes, tmp.childNodes);
                    // Fix #12392 for WebKit and IE > 9
                    tmp.textContent = "";
                    // Fix #12392 for oldIE
                    while(tmp.firstChild)tmp.removeChild(tmp.firstChild);
                    // Remember the top-level container for proper cleanup
                    tmp = safe.lastChild;
                }
            }
        }
        // Fix #11356: Clear elements from fragment
        if (tmp) safe.removeChild(tmp);
        // Reset defaultChecked for any radios and checkboxes
        // about to be appended to the DOM in IE 6/7 (#8060)
        if (!support.appendChecked) jQuery.grep(getAll(nodes, "input"), fixDefaultChecked);
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            contains = jQuery.contains(elem.ownerDocument, elem);
            // Append to fragment
            tmp = getAll(safe.appendChild(elem), "script");
            // Preserve script evaluation history
            if (contains) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        tmp = null;
        return safe;
    }
    (function() {
        var i, eventName, div = document.createElement("div");
        // Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
        for(i in {
            submit: true,
            change: true,
            focusin: true
        }){
            eventName = "on" + i;
            if (!(support[i] = eventName in window1)) {
                // Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
                div.setAttribute(eventName, "t");
                support[i] = div.attributes[eventName].expando === false;
            }
        }
        // Null elements to avoid leaks in IE.
        div = null;
    })();
    var rformElems = /^(?:input|select|textarea)$/i, rkeyEvent = /^key/, rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE9
    // See #13393 for more info
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var tmp, events, t, handleObjIn, special, eventHandle, handleObj, handlers, type, namespaces, origType, elemData = jQuery._data(elem);
            // Don't attach events to noData or text/comment nodes (but allow plain objects)
            if (!elemData) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = {};
            if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function(e) {
                    // Discard the second event of a jQuery.event.trigger() and
                    // when an event is called after a page has unloaded
                    return typeof jQuery !== "undefined" && (!e || jQuery.event.triggered !== e.type) ? jQuery.event.dispatch.apply(eventHandle.elem, arguments) : undefined;
                };
                // Add elem as a property of the handle fn to prevent a memory leak
                // with IE non-native events
                eventHandle.elem = elem;
            }
            // Handle multiple events separated by a space
            types = (types || "").match(rnotwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener/attachEvent if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        // Bind the global event handler to the element
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle, false);
                        else if (elem.attachEvent) elem.attachEvent("on" + type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
            // Nullify elem to prevent memory leaks in IE
            elem = null;
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, handleObj, tmp, origCount, t, events, special, handlers, type, namespaces, origType, elemData = jQuery.hasData(elem) && jQuery._data(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnotwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) {
                delete elemData.handle;
                // removeData also checks for emptiness and clears the expando if empty
                // so use it instead of delete
                jQuery._removeData(elem, "events");
            }
        },
        trigger: function(event, data, elem, onlyHandlers) {
            var handle, ontype, cur, bubbleType, special, tmp, i, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (jQuery._data(cur, "events") || {})[event.type] && jQuery._data(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name name as the event.
                // Can't use an .isFunction() check here because IE6/7 fails that test.
                // Don't do default actions on window, that's where global variables be (#6170)
                {
                    if (ontype && elem[type] && !jQuery.isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        try {
                            elem[type]();
                        } catch (e) {
                        // IE<9 dies on focus/blur to hidden element (#1486,#12518)
                        // only reproducible on winXP IE8 native, not IE9 in IE8 mode
                        }
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        dispatch: function(event) {
            // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(event);
            var i, j, ret, matched, handleObj, handlerQueue = [], args = slice.call(arguments), handlers = (jQuery._data(this, "events") || {})[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// Triggered event must either 1) have no namespace, or 2) have namespace(s)
                // a subset or equal to those in the bound event (both can have no namespace).
                if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, matches, sel, handleObj, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Support (at least): Chrome, IE9
            // Find delegate handlers
            // Black-hole SVG <use> instance trees (#13180)
            //
            // Support: Firefox<=42+
            // Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
            if (delegateCount && cur.nodeType && (event.type !== "click" || isNaN(event.button) || event.button < 1)) {
                /* jshint eqeqeq: false */ for(; cur != this; cur = cur.parentNode || this)/* jshint eqeqeq: true */ // Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click")) {
                    matches = [];
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (#13203)
                        sel = handleObj.selector + " ";
                        if (matches[sel] === undefined) matches[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matches[sel]) matches.push(handleObj);
                    }
                    if (matches.length) handlerQueue.push({
                        elem: cur,
                        handlers: matches
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: this,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        fix: function(event) {
            if (event[jQuery.expando]) return event;
            // Create a writable copy of the event object and normalize some properties
            var i, prop, copy, type = event.type, originalEvent = event, fixHook = this.fixHooks[type];
            if (!fixHook) this.fixHooks[type] = fixHook = rmouseEvent.test(type) ? this.mouseHooks : rkeyEvent.test(type) ? this.keyHooks : {};
            copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;
            event = new jQuery.Event(originalEvent);
            i = copy.length;
            while(i--){
                prop = copy[i];
                event[prop] = originalEvent[prop];
            }
            // Support: IE<9
            // Fix target property (#1925)
            if (!event.target) event.target = originalEvent.srcElement || document;
            // Support: Safari 6-8+
            // Target should not be a text node (#504, #13143)
            if (event.target.nodeType === 3) event.target = event.target.parentNode;
            // Support: IE<9
            // For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
            event.metaKey = !!event.metaKey;
            return fixHook.filter ? fixHook.filter(event, originalEvent) : event;
        },
        // Includes some event props shared by KeyEvent and MouseEvent
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(event, original) {
                // Add which for key events
                if (event.which == null) event.which = original.charCode != null ? original.charCode : original.keyCode;
                return event;
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(event, original) {
                var body, eventDoc, doc, button = original.button, fromElement = original.fromElement;
                // Calculate pageX/Y if missing and clientX/Y available
                if (event.pageX == null && original.clientX != null) {
                    eventDoc = event.target.ownerDocument || document;
                    doc = eventDoc.documentElement;
                    body = eventDoc.body;
                    event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                    event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
                }
                // Add relatedTarget, if necessary
                if (!event.relatedTarget && fromElement) event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
                // Add which for click: 1 === left; 2 === middle; 3 === right
                // Note: button is not normalized, so don't use it
                if (!event.which && button !== undefined) event.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
                return event;
            }
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            focus: {
                // Fire native event if possible so blur/focus sequence is correct
                trigger: function() {
                    if (this !== safeActiveElement() && this.focus) try {
                        this.focus();
                        return false;
                    } catch (e) {
                    // Support: IE<9
                    // If we error on focus to hidden element (#1486, #12518),
                    // let .trigger() run the handlers
                    }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === safeActiveElement() && this.blur) {
                        this.blur();
                        return false;
                    }
                },
                delegateType: "focusout"
            },
            click: {
                // For checkbox, fire native event so checked state will be right
                trigger: function() {
                    if (jQuery.nodeName(this, "input") && this.type === "checkbox" && this.click) {
                        this.click();
                        return false;
                    }
                },
                // For cross-browser consistency, don't fire native .click() on links
                _default: function(event) {
                    return jQuery.nodeName(event.target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        },
        // Piggyback on a donor event to simulate a different one
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
            if (e.isDefaultPrevented()) event.preventDefault();
        }
    };
    jQuery.removeEvent = document.removeEventListener ? function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    } : function(elem, type, handle) {
        var name = "on" + type;
        if (elem.detachEvent) {
            // #8545, #7054, preventing memory leaks for custom events in IE6-8
            // detachEvent needed property on element, by name of that event,
            // to properly expose it to GC
            if (typeof elem[name] === "undefined") elem[name] = null;
            elem.detachEvent(name, handle);
        }
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: IE < 9, Android < 4.0
            src.returnValue === false ? returnTrue : returnFalse;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || jQuery.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (!e) return;
            // If preventDefault exists, run it on the original event
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (!e || this.isSimulated) return;
            // If stopPropagation exists, run it on the original event
            if (e.stopPropagation) e.stopPropagation();
            // Support: IE
            // Set the cancelBubble property of the original event to true
            e.cancelBubble = true;
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://code.google.com/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    // IE submit delegation
    if (!support.submit) jQuery.event.special.submit = {
        setup: function() {
            // Only need this for delegated form submit events
            if (jQuery.nodeName(this, "form")) return false;
            // Lazy-add a submit handler when a descendant form may potentially be submitted
            jQuery.event.add(this, "click._submit keypress._submit", function(e) {
                // Node name check avoids a VML-related crash in IE (#9807)
                var elem = e.target, form = jQuery.nodeName(elem, "input") || jQuery.nodeName(elem, "button") ? // Support: IE <=8
                // We use jQuery.prop instead of elem.form
                // to allow fixing the IE8 delegated submit issue (gh-2332)
                // by 3rd party polyfills/workarounds.
                jQuery.prop(elem, "form") : undefined;
                if (form && !jQuery._data(form, "submit")) {
                    jQuery.event.add(form, "submit._submit", function(event) {
                        event._submitBubble = true;
                    });
                    jQuery._data(form, "submit", true);
                }
            });
        // return undefined since we don't need an event listener
        },
        postDispatch: function(event) {
            // If form was submitted by the user, bubble the event up the tree
            if (event._submitBubble) {
                delete event._submitBubble;
                if (this.parentNode && !event.isTrigger) jQuery.event.simulate("submit", this.parentNode, event);
            }
        },
        teardown: function() {
            // Only need this for delegated form submit events
            if (jQuery.nodeName(this, "form")) return false;
            // Remove delegated handlers; cleanData eventually reaps submit handlers attached above
            jQuery.event.remove(this, "._submit");
        }
    };
    // IE change delegation and checkbox/radio fix
    if (!support.change) jQuery.event.special.change = {
        setup: function() {
            if (rformElems.test(this.nodeName)) {
                // IE doesn't fire change on a check/radio until blur; trigger it on click
                // after a propertychange. Eat the blur-change in special.change.handle.
                // This still fires onchange a second time for check/radio after blur.
                if (this.type === "checkbox" || this.type === "radio") {
                    jQuery.event.add(this, "propertychange._change", function(event) {
                        if (event.originalEvent.propertyName === "checked") this._justChanged = true;
                    });
                    jQuery.event.add(this, "click._change", function(event) {
                        if (this._justChanged && !event.isTrigger) this._justChanged = false;
                        // Allow triggered, simulated change events (#11500)
                        jQuery.event.simulate("change", this, event);
                    });
                }
                return false;
            }
            // Delegated event; lazy-add a change handler on descendant inputs
            jQuery.event.add(this, "beforeactivate._change", function(e) {
                var elem = e.target;
                if (rformElems.test(elem.nodeName) && !jQuery._data(elem, "change")) {
                    jQuery.event.add(elem, "change._change", function(event) {
                        if (this.parentNode && !event.isSimulated && !event.isTrigger) jQuery.event.simulate("change", this.parentNode, event);
                    });
                    jQuery._data(elem, "change", true);
                }
            });
        },
        handle: function(event) {
            var elem = event.target;
            // Swallow native change events from checkbox/radio, we already triggered them above
            if (this !== elem || event.isSimulated || event.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") return event.handleObj.handler.apply(this, arguments);
        },
        teardown: function() {
            jQuery.event.remove(this, "._change");
            return !rformElems.test(this.nodeName);
        }
    };
    // Support: Firefox
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome, Safari
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                var doc = this.ownerDocument || this, attaches = jQuery._data(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                jQuery._data(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this, attaches = jQuery._data(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    jQuery._removeData(doc, fix);
                } else jQuery._data(doc, fix, attaches);
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        },
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g, rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"), rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi, // Support: IE 10-11, Edge 10240+
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rscriptTypeMasked = /^true\/(.*)/, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g, safeFragment = createSafeFragment(document), fragmentDiv = safeFragment.appendChild(document.createElement("div"));
    // Support: IE<8
    // Manipulating tables requires a tbody
    function manipulationTarget(elem, content) {
        return jQuery.nodeName(elem, "table") && jQuery.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (jQuery.find.attr(elem, "type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        var match = rscriptTypeMasked.exec(elem.type);
        if (match) elem.type = match[1];
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        if (dest.nodeType !== 1 || !jQuery.hasData(src)) return;
        var type, i, l, oldData = jQuery._data(src), curData = jQuery._data(dest, oldData), events = oldData.events;
        if (events) {
            delete curData.handle;
            curData.events = {};
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // make the cloned public data object a copy from the original
        if (curData.data) curData.data = jQuery.extend({}, curData.data);
    }
    function fixCloneNodeIssues(src, dest) {
        var nodeName, e, data;
        // We do not need to do anything for non-Elements
        if (dest.nodeType !== 1) return;
        nodeName = dest.nodeName.toLowerCase();
        // IE6-8 copies events bound via attachEvent when using cloneNode.
        if (!support.noCloneEvent && dest[jQuery.expando]) {
            data = jQuery._data(dest);
            for(e in data.events)jQuery.removeEvent(dest, e, data.handle);
            // Event data gets referenced instead of copied if the expando gets copied too
            dest.removeAttribute(jQuery.expando);
        }
        // IE blanks contents when cloning scripts, and tries to evaluate newly-set text
        if (nodeName === "script" && dest.text !== src.text) {
            disableScript(dest).text = src.text;
            restoreScript(dest);
        // IE6-10 improperly clones children of object elements using classid.
        // IE10 throws NoModificationAllowedError if parent is null, #12132.
        } else if (nodeName === "object") {
            if (dest.parentNode) dest.outerHTML = src.outerHTML;
            // This path appears unavoidable for IE9. When cloning an object
            // element in IE9, the outerHTML strategy above is not sufficient.
            // If the src has innerHTML and the destination does not,
            // copy the src.innerHTML into the dest.innerHTML. #10324
            if (support.html5Clone && src.innerHTML && !jQuery.trim(dest.innerHTML)) dest.innerHTML = src.innerHTML;
        } else if (nodeName === "input" && rcheckableType.test(src.type)) {
            // IE6-8 fails to persist the checked state of a cloned checkbox
            // or radio button. Worse, IE6-7 fail to give the cloned element
            // a checked appearance if the defaultChecked value isn't also set
            dest.defaultChecked = dest.checked = src.checked;
            // IE6-7 get confused and end up setting the value of a cloned
            // checkbox/radio button to an empty string instead of "on"
            if (dest.value !== src.value) dest.value = src.value;
        // IE6-8 fails to return the selected option to the default selected
        // state when cloning options
        } else if (nodeName === "option") dest.defaultSelected = dest.selected = src.defaultSelected;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = concat.apply([], args);
        var first, node, hasScripts, scripts, doc, fragment, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], isFunction = jQuery.isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (isFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (isFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android<4.1, PhantomJS<2
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !jQuery._data(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src) // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl) jQuery._evalUrl(node.src);
                            } else jQuery.globalEval((node.text || node.textContent || node.innerHTML || "").replace(rcleanScript, ""));
                        }
                    }
                }
                // Fix #11809: Avoid leaking memory
                fragment = first = null;
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, elems = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = elems[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && jQuery.contains(node.ownerDocument, node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html.replace(rxhtmlTag, "<$1></$2>");
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var destElements, node, clone, i, srcElements, inPage = jQuery.contains(elem.ownerDocument, elem);
            if (support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">")) clone = elem.cloneNode(true);
            else {
                fragmentDiv.innerHTML = elem.outerHTML;
                fragmentDiv.removeChild(clone = fragmentDiv.firstChild);
            }
            if ((!support.noCloneEvent || !support.noCloneChecked) && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                // Fix all IE cloning issues
                for(i = 0; (node = srcElements[i]) != null; ++i)// Ensure that the destination node is not null; Fixes #9587
                if (destElements[i]) fixCloneNodeIssues(node, destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0; (node = srcElements[i]) != null; i++)cloneCopyEvent(node, destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            destElements = srcElements = node = null;
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems, /* internal */ forceAcceptData) {
            var elem, type, id, data, i = 0, internalKey = jQuery.expando, cache = jQuery.cache, attributes = support.attributes, special = jQuery.event.special;
            for(; (elem = elems[i]) != null; i++)if (forceAcceptData || acceptData(elem)) {
                id = elem[internalKey];
                data = id && cache[id];
                if (data) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Remove cache only if it was not already removed by jQuery.event.remove
                    if (cache[id]) {
                        delete cache[id];
                        // Support: IE<9
                        // IE does not allow us to delete expando properties from nodes
                        // IE creates expando attributes along with the property
                        // IE does not have a removeAttribute function on Document nodes
                        if (!attributes && typeof elem.removeAttribute !== "undefined") elem.removeAttribute(internalKey);
                        else elem[internalKey] = undefined;
                        deletedIds.push(id);
                    }
                }
            }
        }
    });
    jQuery.fn.extend({
        // Keep domManip exposed until 3.0 (gh-2225)
        domManip: domManip,
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().append((this[0] && this[0].ownerDocument || document).createTextNode(value));
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++){
                // Remove element nodes and prevent memory leaks
                if (elem.nodeType === 1) jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                while(elem.firstChild)elem.removeChild(elem.firstChild);
                // If this is a select, ensure that it displays empty (#12336)
                // Support: IE<9
                if (elem.options && jQuery.nodeName(elem, "select")) elem.options.length = 0;
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined) return elem.nodeType === 1 ? elem.innerHTML.replace(rinlinejQuery, "") : undefined;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && (support.htmlSerialize || !rnoshimcache.test(value)) && (support.leadingWhitespace || !rleadingWhitespace.test(value)) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            // Remove element nodes and prevent memory leaks
                            elem = this[i] || {};
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, i = 0, ret = [], insert = jQuery(selector), last = insert.length - 1;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var iframe, elemdisplay = {
        // Support: Firefox
        // We have to pre-define these values for FF (#10227)
        HTML: "block",
        BODY: "block"
    };
    /**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */ // Called only from within defaultDisplay
    function actualDisplay(name, doc) {
        var elem = jQuery(doc.createElement(name)).appendTo(doc.body), display = jQuery.css(elem[0], "display");
        // We don't have any data stored on the element,
        // so use "detach" method as fast way to get rid of the element
        elem.detach();
        return display;
    }
    /**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */ function defaultDisplay(nodeName) {
        var doc = document, display = elemdisplay[nodeName];
        if (!display) {
            display = actualDisplay(nodeName, doc);
            // If the simple way fails, read from inside an iframe
            if (display === "none" || !display) {
                // Use the already-created iframe if possible
                iframe = (iframe || jQuery("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement);
                // Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
                doc = (iframe[0].contentWindow || iframe[0].contentDocument).document;
                // Support: IE
                doc.write();
                doc.close();
                display = actualDisplay(nodeName, doc);
                iframe.detach();
            }
            // Store the correct default display
            elemdisplay[nodeName] = display;
        }
        return display;
    }
    var rmargin = /^margin/;
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var swap = function(elem, options, callback, args) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.apply(elem, args || []);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var documentElement = document.documentElement;
    (function() {
        var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal, reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        div.style.cssText = "float:left;opacity:.5";
        // Support: IE<9
        // Make sure that element opacity exists (as opposed to filter)
        support.opacity = div.style.opacity === "0.5";
        // Verify style float existence
        // (IE uses styleFloat instead of cssFloat)
        support.cssFloat = !!div.style.cssFloat;
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        container = document.createElement("div");
        container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute";
        div.innerHTML = "";
        container.appendChild(div);
        // Support: Firefox<29, Android 2.3
        // Vendor-prefix box-sizing
        support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" || div.style.WebkitBoxSizing === "";
        jQuery.extend(support, {
            reliableHiddenOffsets: function() {
                if (pixelPositionVal == null) computeStyleTests();
                return reliableHiddenOffsetsVal;
            },
            boxSizingReliable: function() {
                // We're checking for pixelPositionVal here instead of boxSizingReliableVal
                // since that compresses better and they're computed together anyway.
                if (pixelPositionVal == null) computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelMarginRight: function() {
                // Support: Android 4.0-4.3
                if (pixelPositionVal == null) computeStyleTests();
                return pixelMarginRightVal;
            },
            pixelPosition: function() {
                if (pixelPositionVal == null) computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginRight: function() {
                // Support: Android 2.3
                if (pixelPositionVal == null) computeStyleTests();
                return reliableMarginRightVal;
            },
            reliableMarginLeft: function() {
                // Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
                if (pixelPositionVal == null) computeStyleTests();
                return reliableMarginLeftVal;
            }
        });
        function computeStyleTests() {
            var contents, divStyle, documentElement = document.documentElement;
            // Setup
            documentElement.appendChild(container);
            div.style.cssText = // Support: Android 2.3
            // Vendor-prefix box-sizing
            "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%";
            // Support: IE<9
            // Assume reasonable values in the absence of getComputedStyle
            pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
            pixelMarginRightVal = reliableMarginRightVal = true;
            // Check for getComputedStyle so that this code is not run in IE<9.
            if (window1.getComputedStyle) {
                divStyle = window1.getComputedStyle(div);
                pixelPositionVal = (divStyle || {}).top !== "1%";
                reliableMarginLeftVal = (divStyle || {}).marginLeft === "2px";
                boxSizingReliableVal = (divStyle || {
                    width: "4px"
                }).width === "4px";
                // Support: Android 4.0 - 4.3 only
                // Some styles come back with percentage values, even though they shouldn't
                div.style.marginRight = "50%";
                pixelMarginRightVal = (divStyle || {
                    marginRight: "4px"
                }).marginRight === "4px";
                // Support: Android 2.3 only
                // Div with explicit width and no margin-right incorrectly
                // gets computed margin-right based on width of container (#3333)
                // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
                contents = div.appendChild(document.createElement("div"));
                // Reset CSS: box-sizing; display; margin; border; padding
                contents.style.cssText = div.style.cssText = // Support: Android 2.3
                // Vendor-prefix box-sizing
                "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0";
                contents.style.marginRight = contents.style.width = "0";
                div.style.width = "1px";
                reliableMarginRightVal = !parseFloat((window1.getComputedStyle(contents) || {}).marginRight);
                div.removeChild(contents);
            }
            // Support: IE6-8
            // First check that getClientRects works as expected
            // Check if table cells still have offsetWidth/Height when they are set
            // to display:none and there are still other visible table cells in a
            // table row; if so, offsetWidth/Height are not reliable for use when
            // determining if an element has been hidden directly using
            // display:none (it is still safe to use offsets if a parent element is
            // hidden; don safety goggles and see bug #4512 for more information).
            div.style.display = "none";
            reliableHiddenOffsetsVal = div.getClientRects().length === 0;
            if (reliableHiddenOffsetsVal) {
                div.style.display = "";
                div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
                div.childNodes[0].style.borderCollapse = "separate";
                contents = div.getElementsByTagName("td");
                contents[0].style.cssText = "margin:0;border:0;padding:0;display:none";
                reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
                if (reliableHiddenOffsetsVal) {
                    contents[0].style.display = "";
                    contents[1].style.display = "none";
                    reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
                }
            }
            // Teardown
            documentElement.removeChild(container);
        }
    })();
    var getStyles, curCSS, rposition = /^(top|right|bottom|left)$/;
    if (window1.getComputedStyle) {
        getStyles = function(elem) {
            // Support: IE<=11+, Firefox<=30+ (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;
            if (!view || !view.opener) view = window1;
            return view.getComputedStyle(elem);
        };
        curCSS = function(elem, name, computed) {
            var width, minWidth, maxWidth, ret, style = elem.style;
            computed = computed || getStyles(elem);
            // getPropertyValue is only needed for .css('filter') in IE9, see #12537
            ret = computed ? computed.getPropertyValue(name) || computed[name] : undefined;
            // Support: Opera 12.1x only
            // Fall back to style even without computed
            // computed is undefined for elems on document fragments
            if ((ret === "" || ret === undefined) && !jQuery.contains(elem.ownerDocument, elem)) ret = jQuery.style(elem, name);
            if (computed) // A tribute to the "awesome hack by Dean Edwards"
            // Chrome < 17 and Safari 5.0 uses "computed value"
            // instead of "used value" for margin-right
            // Safari 5.1.7 (at least) returns percentage for a larger set of values,
            // but width seems to be reliably pixels
            // this is against the CSSOM draft spec:
            // http://dev.w3.org/csswg/cssom/#resolved-values
            {
                if (!support.pixelMarginRight() && rnumnonpx.test(ret) && rmargin.test(name)) {
                    // Remember the original values
                    width = style.width;
                    minWidth = style.minWidth;
                    maxWidth = style.maxWidth;
                    // Put in the new values to get a computed value out
                    style.minWidth = style.maxWidth = style.width = ret;
                    ret = computed.width;
                    // Revert the changed values
                    style.width = width;
                    style.minWidth = minWidth;
                    style.maxWidth = maxWidth;
                }
            }
            // Support: IE
            // IE returns zIndex value as an integer.
            return ret === undefined ? ret : ret + "";
        };
    } else if (documentElement.currentStyle) {
        getStyles = function(elem) {
            return elem.currentStyle;
        };
        curCSS = function(elem, name, computed) {
            var left, rs, rsLeft, ret, style = elem.style;
            computed = computed || getStyles(elem);
            ret = computed ? computed[name] : undefined;
            // Avoid setting ret to empty string here
            // so we don't default to auto
            if (ret == null && style && style[name]) ret = style[name];
            // From the awesome hack by Dean Edwards
            // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
            // If we're not dealing with a regular pixel number
            // but a number that has a weird ending, we need to convert it to pixels
            // but not position css attributes, as those are
            // proportional to the parent element instead
            // and we can't measure the parent instead because it
            // might trigger a "stacking dolls" problem
            if (rnumnonpx.test(ret) && !rposition.test(name)) {
                // Remember the original values
                left = style.left;
                rs = elem.runtimeStyle;
                rsLeft = rs && rs.left;
                // Put in the new values to get a computed value out
                if (rsLeft) rs.left = elem.currentStyle.left;
                style.left = name === "fontSize" ? "1em" : ret;
                ret = style.pixelLeft + "px";
                // Revert the changed values
                style.left = left;
                if (rsLeft) rs.left = rsLeft;
            }
            // Support: IE
            // IE returns zIndex value as an integer.
            return ret === undefined ? ret : ret + "" || "auto";
        };
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var ralpha = /alpha\([^)]*\)/i, ropacity = /opacity\s*=\s*([^)]*)/i, // swappable if display is none or starts with table except
    // "table", "table-cell", or "table-caption"
    // see here for display values:
    // https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, rnumsplit = new RegExp("^(" + pnum + ")(.*)$", "i"), cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    }, cssPrefixes = [
        "Webkit",
        "O",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style;
    // return a css property mapped to a potentially vendor prefixed property
    function vendorPropName(name) {
        // shortcut for names that are not vendor prefixed
        if (name in emptyStyle) return name;
        // check for vendor prefixed names
        var capName = name.charAt(0).toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    function showHide(elements, show) {
        var display, elem, hidden, values = [], index = 0, length = elements.length;
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            values[index] = jQuery._data(elem, "olddisplay");
            display = elem.style.display;
            if (show) {
                // Reset the inline display of this element to learn if it is
                // being hidden by cascaded rules or not
                if (!values[index] && display === "none") elem.style.display = "";
                // Set elements which have been overridden with display: none
                // in a stylesheet to whatever the default browser style is
                // for such an element
                if (elem.style.display === "" && isHidden(elem)) values[index] = jQuery._data(elem, "olddisplay", defaultDisplay(elem.nodeName));
            } else {
                hidden = isHidden(elem);
                if (display && display !== "none" || !hidden) jQuery._data(elem, "olddisplay", hidden ? display : jQuery.css(elem, "display"));
            }
        }
        // Set the display of most of the elements in a second loop
        // to avoid the constant reflow
        for(index = 0; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            if (!show || elem.style.display === "none" || elem.style.display === "") elem.style.display = show ? values[index] || "" : "none";
        }
        return elements;
    }
    function setPositiveNumber(elem, value, subtract) {
        var matches = rnumsplit.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[1] - (subtract || 0)) + (matches[2] || "px") : value;
    }
    function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
        var i = extra === (isBorderBox ? "border" : "content") ? // If we already have the right measurement, avoid augmentation
        4 : // Otherwise initialize for horizontal or vertical properties
        name === "width" ? 1 : 0, val = 0;
        for(; i < 4; i += 2){
            // both box models exclude margin, so add it if we want it
            if (extra === "margin") val += jQuery.css(elem, extra + cssExpand[i], true, styles);
            if (isBorderBox) {
                // border-box includes padding, so remove it if we want content
                if (extra === "content") val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // at this point, extra isn't border nor margin, so remove border
                if (extra !== "margin") val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            } else {
                // at this point, extra isn't content, so add padding
                val += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // at this point, extra isn't content nor padding, so add border
                if (extra !== "padding") val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        return val;
    }
    function getWidthOrHeight(elem, name, extra) {
        // Start with offset property, which is equivalent to the border-box value
        var valueIsBorderBox = true, val = name === "width" ? elem.offsetWidth : elem.offsetHeight, styles = getStyles(elem), isBorderBox = support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box";
        // some non-html elements return undefined for offsetWidth, so check for null/undefined
        // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
        // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
        if (val <= 0 || val == null) {
            // Fall back to computed then uncomputed css if necessary
            val = curCSS(elem, name, styles);
            if (val < 0 || val == null) val = elem.style[name];
            // Computed unit is not pixels. Stop here and return.
            if (rnumnonpx.test(val)) return val;
            // we need the check for style in case a browser which returns unreliable values
            // for getComputedStyle silently falls back to the reliable elem.style
            valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]);
            // Normalize "", auto, and prepare for extra
            val = parseFloat(val) || 0;
        }
        // use the active box-sizing model to add/subtract irrelevant styles
        return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {
            // normalize float css property
            "float": support.cssFloat ? "cssFloat" : "styleFloat"
        },
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = jQuery.camelCase(name), style = elem.style;
            name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
            // gets hook for the prefixed version
            // followed by the unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug #9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set. See: #7116
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                if (type === "number") value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
                // but it would mean to define eight
                // (for every problematic property) identical functions
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) // Support: IE
                // Swallow errors from 'invalid' CSS values (#5509)
                try {
                    style[name] = value;
                } catch (e) {}
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var num, val, hooks, origName = jQuery.camelCase(name);
            // Make sure that we're working with the right name
            name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
            // gets hook for the prefixed version
            // followed by the unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            //convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Return, converting to number if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(i, name) {
        jQuery.cssHooks[name] = {
            get: function(elem, computed, extra) {
                if (computed) // certain elements can have dimension info if we invisibly show them
                // however, it must have a current display style that would benefit from this
                return rdisplayswap.test(jQuery.css(elem, "display")) && elem.offsetWidth === 0 ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, name, extra);
                }) : getWidthOrHeight(elem, name, extra);
            },
            set: function(elem, value, extra) {
                var styles = extra && getStyles(elem);
                return setPositiveNumber(elem, value, extra ? augmentWidthOrHeight(elem, name, extra, support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box", styles) : 0);
            }
        };
    });
    if (!support.opacity) jQuery.cssHooks.opacity = {
        get: function(elem, computed) {
            // IE uses filters for opacity
            return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? 0.01 * parseFloat(RegExp.$1) + "" : computed ? "1" : "";
        },
        set: function(elem, value) {
            var style = elem.style, currentStyle = elem.currentStyle, opacity = jQuery.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "", filter = currentStyle && currentStyle.filter || style.filter || "";
            // IE has trouble with opacity if it does not have layout
            // Force it by setting the zoom level
            style.zoom = 1;
            // if setting opacity to 1, and no other filters exist -
            // attempt to remove filter attribute #6652
            // if value === "", then remove inline opacity #12685
            if ((value >= 1 || value === "") && jQuery.trim(filter.replace(ralpha, "")) === "" && style.removeAttribute) {
                // Setting style.filter to null, "" & " " still leave "filter:" in the cssText
                // if "filter:" is present at all, clearType is disabled, we want to avoid this
                // style.removeAttribute is IE Only, but so apparently is this code path...
                style.removeAttribute("filter");
                // if there is no filter style applied in a css rule
                // or unset inline opacity, we are done
                if (value === "" || currentStyle && !currentStyle.filter) return;
            }
            // otherwise, set new filter values
            style.filter = ralpha.test(filter) ? filter.replace(ralpha, opacity) : filter + " " + opacity;
        }
    };
    jQuery.cssHooks.marginRight = addGetHookIf(support.reliableMarginRight, function(elem, computed) {
        if (computed) return swap(elem, {
            "display": "inline-block"
        }, curCSS, [
            elem,
            "marginRight"
        ]);
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || // Support: IE<=11+
        // Running getBoundingClientRect on a disconnected node in IE throws an error
        // Support: IE8 only
        // getClientRects() errors on disconnected elems
        (jQuery.contains(elem.ownerDocument, elem) ? elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        }) : 0)) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (!rmargin.test(prefix)) jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (jQuery.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        },
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHidden(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails
                // so, simple values such as "10px" are parsed to Float.
                // complex values such as "rotate(1rad)" are returned as is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // use step hook for back compat - use cssHook if its there - use .style if its
                // available and use plain properties where available
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back Compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, timerId, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = jQuery.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, attrs = {
            height: type
        }, i = 0;
        // if we include width, step value is 1 to do all cssExpand values,
        // if we don't include width, step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // we're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        /* jshint validthis: true */ var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHidden(elem), dataShow = jQuery._data(elem, "fxshow");
        // handle queue: false promises
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // doing this makes sure that the complete handler will be called
                // before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // height/width overflow pass
        if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
            // Make sure that nothing sneaks out
            // Record all 3 overflow attributes because IE does not
            // change the overflow attribute when overflowX and
            // overflowY are set to the same value
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Set display property to inline-block for height/width
            // animations on inline elements that are having width/height animated
            display = jQuery.css(elem, "display");
            // Test default display if display is currently "none"
            checkDisplay = display === "none" ? jQuery._data(elem, "olddisplay") || defaultDisplay(elem.nodeName) : display;
            if (checkDisplay === "inline" && jQuery.css(elem, "float") === "none") {
                // inline-level elements accept inline-block;
                // block-level elements need to be inline with layout
                if (!support.inlineBlockNeedsLayout || defaultDisplay(elem.nodeName) === "inline") style.display = "inline-block";
                else style.zoom = 1;
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            if (!support.shrinkWrapBlocks()) anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // show/hide pass
        for(prop in props){
            value = props[prop];
            if (rfxtypes.exec(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // If there is dataShow left over from a stopped hide or show
                    // and we are going to proceed with show, we should pretend to be hidden
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            // Any non-fx value stops us from restoring the original display value
            } else display = undefined;
        }
        if (!jQuery.isEmptyObject(orig)) {
            if (dataShow) {
                if ("hidden" in dataShow) hidden = dataShow.hidden;
            } else dataShow = jQuery._data(elem, "fxshow", {});
            // store state if its toggle - enables .stop().toggle() to "reverse"
            if (toggle) dataShow.hidden = !hidden;
            if (hidden) jQuery(elem).show();
            else anim.done(function() {
                jQuery(elem).hide();
            });
            anim.done(function() {
                var prop;
                jQuery._removeData(elem, "fxshow");
                for(prop in orig)jQuery.style(elem, prop, orig[prop]);
            });
            for(prop in orig){
                tween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
                if (!(prop in dataShow)) {
                    dataShow[prop] = tween.start;
                    if (hidden) {
                        tween.end = tween.start;
                        tween.start = prop === "width" || prop === "height" ? 1 : 0;
                    }
                }
            }
        // If this is a noop like .hide().hide(), restore an overwritten display value
        } else if ((display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline") style.display = display;
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = jQuery.camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (jQuery.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // not quite $.extend, this wont overwrite keys already present.
                // also - reusing 'index' from above because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            if (percent < 1 && length) return remaining;
            else {
                deferred.resolveWith(elem, [
                    animation
                ]);
                return false;
            }
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // if we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // resolve when we played the last frame
                // otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (jQuery.isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = jQuery.proxy(result.stop, result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (jQuery.isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        // attach callbacks from options
        return animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (jQuery.isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnotwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || jQuery.isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
        };
        opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default;
        // normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (jQuery.isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // show any hidden elements after setting opacity to 0
            return this.filter(isHidden).css("opacity", 0).show()// animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || jQuery._data(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue && type !== false) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = jQuery._data(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // start the next in the queue if the last step wasn't forced
                // timers currently will call their complete callbacks, which will dequeue
                // but only if they were gotoEnd
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = jQuery._data(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // enable finishing flag on private data
                data.finish = true;
                // empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, timers = jQuery.timers, i = 0;
        fxNow = jQuery.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Checks the timer has not already been removed
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        if (timer()) jQuery.fx.start();
        else jQuery.timers.pop();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (!timerId) timerId = window1.setInterval(jQuery.fx.tick, jQuery.fx.interval);
    };
    jQuery.fx.stop = function() {
        window1.clearInterval(timerId);
        timerId = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    // http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var a, input = document.createElement("input"), div = document.createElement("div"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        // Setup
        div = document.createElement("div");
        div.setAttribute("className", "t");
        div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
        a = div.getElementsByTagName("a")[0];
        // Support: Windows Web Apps (WWA)
        // `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "checkbox");
        div.appendChild(input);
        a = div.getElementsByTagName("a")[0];
        // First batch of tests.
        a.style.cssText = "top:1px";
        // Test setAttribute on camelCase class.
        // If it works, we need attrFixes when doing get/setAttribute (ie6/7)
        support.getSetAttribute = div.className !== "t";
        // Get the style information from getAttribute
        // (IE uses .cssText instead)
        support.style = /top/.test(a.getAttribute("style"));
        // Make sure that URLs aren't manipulated
        // (IE normalizes it by default)
        support.hrefNormalized = a.getAttribute("href") === "/a";
        // Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
        support.checkOn = !!input.value;
        // Make sure that a selected-by-default option has a working selected property.
        // (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
        support.optSelected = opt.selected;
        // Tests for enctype support on a form (#6743)
        support.enctype = !!document.createElement("form").enctype;
        // Make sure that the options inside disabled selects aren't marked as disabled
        // (WebKit marks them as disabled)
        select.disabled = true;
        support.optDisabled = !opt.disabled;
        // Support: IE8 only
        // Check if we can trust getAttribute("value")
        input = document.createElement("input");
        input.setAttribute("value", "");
        support.input = input.getAttribute("value") === "";
        // Check if an input maintains its value after becoming a radio
        input.value = "t";
        input.setAttribute("type", "radio");
        support.radioValue = input.value === "t";
    })();
    var rreturn = /\r/g, rspaces = /[\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, isFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    return typeof ret === "string" ? // handle most common string cases
                    ret.replace(rreturn, "") : // handle cases where value is null/undef or number
                    ret == null ? "" : ret;
                }
                return;
            }
            isFunction = jQuery.isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (isFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (jQuery.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE10-11+
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    jQuery.trim(jQuery.text(elem)).replace(rspaces, " ");
                }
            },
            select: {
                get: function(elem) {
                    var value, option, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one" || index < 0, values = one ? null : [], max = one ? index + 1 : options.length, i = index < 0 ? max : one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // oldIE doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        (support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) // Support: IE6
                        // When new option element is added to select box we need to
                        // force reflow of newly added node in order to workaround delay
                        // of initialization properties
                        try {
                            option.selected = optionSet = true;
                        } catch (_) {
                            // Will be executed only in IE6
                            option.scrollHeight;
                        }
                        else option.selected = false;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return options;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (jQuery.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    var nodeHook, boolHook, attrHandle = jQuery.expr.attrHandle, ruseDefault = /^(?:checked|selected)$/i, getSetAttribute = support.getSetAttribute, getSetInput = support.input;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // All attributes are lowercase
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                name = name.toLowerCase();
                hooks = jQuery.attrHooks[name] || (jQuery.expr.match.bool.test(name) ? boolHook : nodeHook);
            }
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
                        // Setting the type on a radio button after the value resets the value in IE8-9
                        // Reset value to default in case type is set after value during creation
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, propName, i = 0, attrNames = value && value.match(rnotwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++]){
                propName = jQuery.propFix[name] || name;
                // Boolean attributes get special treatment (#10870)
                if (jQuery.expr.match.bool.test(name)) {
                    // Set corresponding property to false
                    if (getSetInput && getSetAttribute || !ruseDefault.test(name)) elem[propName] = false;
                    else elem[jQuery.camelCase("default-" + name)] = elem[propName] = false;
                } else jQuery.attr(elem, name, "");
                elem.removeAttribute(getSetAttribute ? name : propName);
            }
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else if (getSetInput && getSetAttribute || !ruseDefault.test(name)) // IE<8 needs the *property* name
            elem.setAttribute(!getSetAttribute && jQuery.propFix[name] || name, name);
            else // Support: IE<9
            // Use defaultChecked and defaultSelected for oldIE
            elem[jQuery.camelCase("default-" + name)] = elem[name] = true;
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        if (getSetInput && getSetAttribute || !ruseDefault.test(name)) attrHandle[name] = function(elem, name, isXML) {
            var ret, handle;
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[name];
                attrHandle[name] = ret;
                ret = getter(elem, name, isXML) != null ? name.toLowerCase() : null;
                attrHandle[name] = handle;
            }
            return ret;
        };
        else attrHandle[name] = function(elem, name, isXML) {
            if (!isXML) return elem[jQuery.camelCase("default-" + name)] ? name.toLowerCase() : null;
        };
    });
    // fix oldIE attroperties
    if (!getSetInput || !getSetAttribute) jQuery.attrHooks.value = {
        set: function(elem, value, name) {
            if (jQuery.nodeName(elem, "input")) // Does not return so that setAttribute is also used
            elem.defaultValue = value;
            else // Use nodeHook if defined (#1954); otherwise setAttribute is fine
            return nodeHook && nodeHook.set(elem, value, name);
        }
    };
    // IE6/7 do not support getting/setting some attributes with get/setAttribute
    if (!getSetAttribute) {
        // Use this for any attribute in IE6/7
        // This fixes almost every IE6/7 issue
        nodeHook = {
            set: function(elem, value, name) {
                // Set the existing or create a new attribute node
                var ret = elem.getAttributeNode(name);
                if (!ret) elem.setAttributeNode(ret = elem.ownerDocument.createAttribute(name));
                ret.value = value += "";
                // Break association with cloned elements by also using setAttribute (#9646)
                if (name === "value" || value === elem.getAttribute(name)) return value;
            }
        };
        // Some attributes are constructed with empty-string values when not defined
        attrHandle.id = attrHandle.name = attrHandle.coords = function(elem, name, isXML) {
            var ret;
            if (!isXML) return (ret = elem.getAttributeNode(name)) && ret.value !== "" ? ret.value : null;
        };
        // Fixing value retrieval on a button requires this module
        jQuery.valHooks.button = {
            get: function(elem, name) {
                var ret = elem.getAttributeNode(name);
                if (ret && ret.specified) return ret.value;
            },
            set: nodeHook.set
        };
        // Set contenteditable to false on removals(#10429)
        // Setting to empty string throws an error as an invalid value
        jQuery.attrHooks.contenteditable = {
            set: function(elem, value, name) {
                nodeHook.set(elem, value === "" ? false : value, name);
            }
        };
        // Set width and height to auto instead of 0 on empty string( Bug #8150 )
        // This is for removals
        jQuery.each([
            "width",
            "height"
        ], function(i, name) {
            jQuery.attrHooks[name] = {
                set: function(elem, value) {
                    if (value === "") {
                        elem.setAttribute(name, "auto");
                        return value;
                    }
                }
            };
        });
    }
    if (!support.style) jQuery.attrHooks.style = {
        get: function(elem) {
            // Return undefined in the case of empty string
            // Note: IE uppercases css property names, but if we were to .toLowerCase()
            // .cssText, that would destroy case sensitivity in URL's, like in "background"
            return elem.style.cssText || undefined;
        },
        set: function(elem, value) {
            return elem.style.cssText = value + "";
        }
    };
    var rfocusable = /^(?:input|select|textarea|button|object)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            name = jQuery.propFix[name] || name;
            return this.each(function() {
                // try/catch handles cases where IE balks (such as removing a property on window)
                try {
                    this[name] = undefined;
                    delete this[name];
                } catch (e) {}
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Some attributes require a special call on IE
    // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
    if (!support.hrefNormalized) // href/src property should get the full normalized URL (#10299/#12915)
    jQuery.each([
        "href",
        "src"
    ], function(i, name) {
        jQuery.propHooks[name] = {
            get: function(elem) {
                return elem.getAttribute(name, 4);
            }
        };
    });
    // Support: Safari, IE9+
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                // Make sure that it also works with optgroups, see #5701
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // IE6/7 call enctype encoding
    if (!support.enctype) jQuery.propFix.enctype = "encoding";
    var rclass = /[\t\r\n\f]/g;
    function getClass(elem) {
        return jQuery.attr(elem, "class") || "";
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (jQuery.isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            if (typeof value === "string" && value) {
                classes = value.match(rnotwhite) || [];
                while(elem = this[i++]){
                    curValue = getClass(elem);
                    cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                        // only assign if different to avoid unneeded rendering.
                        finalValue = jQuery.trim(cur);
                        if (curValue !== finalValue) jQuery.attr(elem, "class", finalValue);
                    }
                }
            }
            return this;
        },
        removeClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (jQuery.isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            if (typeof value === "string" && value) {
                classes = value.match(rnotwhite) || [];
                while(elem = this[i++]){
                    curValue = getClass(elem);
                    // This expression is here for better compressibility (see addClass)
                    cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])// Remove *all* instances
                        while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                        // Only assign if different to avoid unneeded rendering.
                        finalValue = jQuery.trim(cur);
                        if (curValue !== finalValue) jQuery.attr(elem, "class", finalValue);
                    }
                }
            }
            return this;
        },
        toggleClass: function(value, stateVal) {
            var type = typeof value;
            if (typeof stateVal === "boolean" && type === "string") return stateVal ? this.addClass(value) : this.removeClass(value);
            if (jQuery.isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            return this.each(function() {
                var className, i, self, classNames;
                if (type === "string") {
                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = value.match(rnotwhite) || [];
                    while(className = classNames[i++])// Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // store className if set
                    jQuery._data(this, "__className__", className);
                    // If the element has a class name or if we're passed "false",
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    jQuery.attr(this, "class", className || value === false ? "" : jQuery._data(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + getClass(elem) + " ").replace(rclass, " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    // Return jQuery for attributes-only inclusion
    jQuery.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    jQuery.fn.extend({
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    var location = window1.location;
    var nonce = jQuery.now();
    var rquery = /\?/;
    var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    jQuery.parseJSON = function(data) {
        // Attempt to parse using the native JSON parser first
        if (window1.JSON && window1.JSON.parse) // Support: Android 2.3
        // Workaround failure to string-cast null input
        return window1.JSON.parse(data + "");
        var requireNonComma, depth = null, str = jQuery.trim(data + "");
        // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
        // after removing valid tokens
        return str && !jQuery.trim(str.replace(rvalidtokens, function(token, comma, open, close) {
            // Force termination if we see a misplaced comma
            if (requireNonComma && comma) depth = 0;
            // Perform no more replacements after returning to outermost depth
            if (depth === 0) return token;
            // Commas must not follow "[", "{", or ","
            requireNonComma = open || comma;
            // Determine new depth
            // array/object open ("[" or "{"): depth += true - false (increment)
            // array/object close ("]" or "}"): depth += false - true (decrement)
            // other cases ("," or primitive): depth += true - true (numeric cast)
            depth += !close - !open;
            // Remove this token
            return "";
        })) ? Function("return " + str)() : jQuery.error("Invalid JSON: " + data);
    };
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, tmp;
        if (!data || typeof data !== "string") return null;
        try {
            if (window1.DOMParser) {
                tmp = new window1.DOMParser();
                xml = tmp.parseFromString(data, "text/xml");
            } else {
                xml = new window1.ActiveXObject("Microsoft.XMLDOM");
                xml.async = "false";
                xml.loadXML(data);
            }
        } catch (e) {
            xml = undefined;
        }
        if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) jQuery.error("Invalid XML: " + data);
        return xml;
    };
    var rhash = /#.*$/, rts = /([?&])_=[^&]*/, // IE leaves an \r character at EOL
    rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Document location
    ajaxLocation = location.href, // Segment location into parts
    ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];
            if (jQuery.isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType.charAt(0) === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var deep, key, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var firstDataType, ct, finalDataType, type, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s["throws"]) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ajaxLocation,
            type: "GET",
            isLocal: rlocalProtocol.test(ajaxLocParts[1]),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": jQuery.parseJSON,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var // Cross-domain detection vars
            parts, // Loop variable
            i, // URL without anti-cache param
            cacheURL, // Response headers as string
            responseHeadersString, // timeout handle
            timeoutTimer, // To know if global events are to be dispatched
            fireGlobals, transport, // Response headers
            responseHeaders, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // The jqXHR state
            state = 0, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (state === 2) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase()] = match[2];
                        }
                        match = responseHeaders[key.toLowerCase()];
                    }
                    return match == null ? null : match;
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return state === 2 ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    var lname = name.toLowerCase();
                    if (!state) {
                        name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (!state) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (state < 2) for(code in map)// Lazy-add the new callback in a way that preserves old ones
                        statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                        else // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR).complete = completeDeferred.add;
            jqXHR.success = jqXHR.done;
            jqXHR.error = jqXHR.fail;
            // Remove hash character (#7531: and string promotion)
            // Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || ajaxLocation) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//");
            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [
                ""
            ];
            // A cross-domain request is in order when we have a protocol:host:port mismatch
            if (s.crossDomain == null) {
                parts = rurl.exec(s.url.toLowerCase());
                s.crossDomain = !!(parts && (parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] || (parts[3] || (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? "80" : "443"))));
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (state === 2) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            cacheURL = s.url;
            // More options handling for requests with no content
            if (!s.hasContent) {
                // If data is available, append data to url
                if (s.data) {
                    cacheURL = s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add anti-cache in url if needed
                if (s.cache === false) s.url = rts.test(cacheURL) ? // If there is already a '_' parameter, set its value
                cacheURL.replace(rts, "$1_=" + nonce++) : // Otherwise add one to the end
                cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++;
            }
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) // Abort if not done already and return
            return jqXHR.abort();
            // aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            for(i in {
                success: 1,
                error: 1,
                complete: 1
            })jqXHR[i](s[i]);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (state === 2) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    state = 1;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Propagate exception as error if not done
                    if (state < 2) done(-1, e);
                    else throw e;
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Called once
                if (state === 2) return;
                // State is "done" now
                state = 2;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // We extract error from statusText
                    // then normalize statusText and status for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // shift arguments if data argument was omitted
            if (jQuery.isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery._evalUrl = function(url) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            "throws": true
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            if (jQuery.isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapAll(html.call(this, i));
            });
            if (this[0]) {
                // The elements to wrap the target around
                var wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstChild && elem.firstChild.nodeType === 1)elem = elem.firstChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (jQuery.isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var isFunction = jQuery.isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function() {
            return this.parent().each(function() {
                if (!jQuery.nodeName(this, "body")) jQuery(this).replaceWith(this.childNodes);
            }).end();
        }
    });
    function getDisplay(elem) {
        return elem.style && elem.style.display || jQuery.css(elem, "display");
    }
    function filterHidden(elem) {
        // Disconnected elements are considered hidden
        if (!jQuery.contains(elem.ownerDocument || document, elem)) return true;
        while(elem && elem.nodeType === 1){
            if (getDisplay(elem) === "none" || elem.type === "hidden") return true;
            elem = elem.parentNode;
        }
        return false;
    }
    jQuery.expr.filters.hidden = function(elem) {
        // Support: Opera <= 12.12
        // Opera reports offsetWidths and offsetHeights less than zero on some elements
        return support.reliableHiddenOffsets() ? elem.offsetWidth <= 0 && elem.offsetHeight <= 0 && !elem.getClientRects().length : filterHidden(elem);
    };
    jQuery.expr.filters.visible = function(elem) {
        return !jQuery.expr.filters.hidden(elem);
    };
    var r20 = /%20/g, rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (jQuery.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && jQuery.type(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, value) {
            // If value is a function, invoke it and return its value
            value = jQuery.isFunction(value) ? value() : value == null ? "" : value;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
        };
        // Set traditional to true for jQuery <= 1.3.2 behavior.
        if (traditional === undefined) traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
        // If an array was passed in, assume that it is an array of form elements.
        if (jQuery.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&").replace(r20, "+");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is(":disabled") so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(i, elem) {
                var val = jQuery(this).val();
                return val == null ? null : jQuery.isArray(val) ? jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                }) : {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    // Create the request object
    // (This is still attached to ajaxSettings for backward compatibility)
    jQuery.ajaxSettings.xhr = window1.ActiveXObject !== undefined ? // Support: IE6-IE8
    function() {
        // XHR cannot access local files, always use ActiveX for that case
        if (this.isLocal) return createActiveXHR();
        // Support: IE 9-11
        // IE seems to error on cross-domain PATCH requests when ActiveX XHR
        // is used. In IE 9+ always use the native XHR.
        // Note: this condition won't catch Edge as it doesn't define
        // document.documentMode but it also doesn't support ActiveX so it won't
        // reach this code.
        if (document.documentMode > 8) return createStandardXHR();
        // Support: IE<9
        // oldIE XHR does not support non-RFC2616 methods (#13240)
        // See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
        // and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
        // Although this check for six methods instead of eight
        // since IE also does not support "trace" and "connect"
        return /^(get|post|head|put|delete|options)$/i.test(this.type) && createStandardXHR() || createActiveXHR();
    } : // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;
    var xhrId = 0, xhrCallbacks = {}, xhrSupported = jQuery.ajaxSettings.xhr();
    // Support: IE<10
    // Open requests must be manually aborted on unload (#5280)
    // See https://support.microsoft.com/kb/2856746 for more info
    if (window1.attachEvent) window1.attachEvent("onunload", function() {
        for(var key in xhrCallbacks)xhrCallbacks[key](undefined, true);
    });
    // Determine support properties
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    xhrSupported = support.ajax = !!xhrSupported;
    // Create transport if the browser can provide an xhr
    if (xhrSupported) jQuery.ajaxTransport(function(options) {
        // Cross domain only allowed if supported through XMLHttpRequest
        if (!options.crossDomain || support.cors) {
            var callback;
            return {
                send: function(headers, complete) {
                    var i, xhr = options.xhr(), id = ++xhrId;
                    // Open the socket
                    xhr.open(options.type, options.url, options.async, options.username, options.password);
                    // Apply custom fields if provided
                    if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                    // Override mime type if needed
                    if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                    // X-Requested-With header
                    // For cross-domain requests, seeing as conditions for a preflight are
                    // akin to a jigsaw puzzle, we simply never set it to be sure.
                    // (it can always be set on a per-request basis or even using ajaxSetup)
                    // For same-domain requests, won't change header if already provided.
                    if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                    // Set headers
                    for(i in headers)// Support: IE<9
                    // IE's ActiveXObject throws a 'Type Mismatch' exception when setting
                    // request header to a null-value.
                    //
                    // To keep consistent with other XHR implementations, cast the value
                    // to string and ignore `undefined`.
                    if (headers[i] !== undefined) xhr.setRequestHeader(i, headers[i] + "");
                    // Do send the request
                    // This may raise an exception which is actually
                    // handled in jQuery.ajax (so no try/catch here)
                    xhr.send(options.hasContent && options.data || null);
                    // Listener
                    callback = function(_, isAbort) {
                        var status, statusText, responses;
                        // Was never called and is aborted or complete
                        if (callback && (isAbort || xhr.readyState === 4)) {
                            // Clean up
                            delete xhrCallbacks[id];
                            callback = undefined;
                            xhr.onreadystatechange = jQuery.noop;
                            // Abort manually if needed
                            if (isAbort) {
                                if (xhr.readyState !== 4) xhr.abort();
                            } else {
                                responses = {};
                                status = xhr.status;
                                // Support: IE<10
                                // Accessing binary-data responseText throws an exception
                                // (#11426)
                                if (typeof xhr.responseText === "string") responses.text = xhr.responseText;
                                // Firefox throws an exception when accessing
                                // statusText for faulty cross-domain requests
                                try {
                                    statusText = xhr.statusText;
                                } catch (e) {
                                    // We normalize with Webkit giving an empty statusText
                                    statusText = "";
                                }
                                // Filter status for non standard behaviors
                                // If the request is local and we have data: assume a success
                                // (success with no data won't get notified, that's the best we
                                // can do given current implementations)
                                if (!status && options.isLocal && !options.crossDomain) status = responses.text ? 200 : 404;
                                else if (status === 1223) status = 204;
                            }
                        }
                        // Call complete if needed
                        if (responses) complete(status, statusText, responses, xhr.getAllResponseHeaders());
                    };
                    // Do send the request
                    // `xhr.send` may raise an exception, but it will be
                    // handled in jQuery.ajax (so no try/catch here)
                    if (!options.async) // If we're in sync mode we fire the callback
                    callback();
                    else if (xhr.readyState === 4) // (IE6 & IE7) if it's in cache and has been
                    // retrieved directly we need to fire the callback
                    window1.setTimeout(callback);
                    else // Register the callback, but delay it in case `xhr.send` throws
                    // Add to the list of active xhr callbacks
                    xhr.onreadystatechange = xhrCallbacks[id] = callback;
                },
                abort: function() {
                    if (callback) callback(undefined, true);
                }
            };
        }
    });
    // Functions to create xhrs
    function createStandardXHR() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    }
    function createActiveXHR() {
        try {
            return new window1.ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {}
    }
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and global
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) {
            s.type = "GET";
            s.global = false;
        }
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain requests
        if (s.crossDomain) {
            var script, head = document.head || jQuery("head")[0] || document.documentElement;
            return {
                send: function(_, callback) {
                    script = document.createElement("script");
                    script.async = true;
                    if (s.scriptCharset) script.charset = s.scriptCharset;
                    script.src = s.url;
                    // Attach handlers for all browsers
                    script.onload = script.onreadystatechange = function(_, isAbort) {
                        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                            // Handle memory leak in IE
                            script.onload = script.onreadystatechange = null;
                            // Remove the script
                            if (script.parentNode) script.parentNode.removeChild(script);
                            // Dereference the script
                            script = null;
                            // Callback if not abort
                            if (!isAbort) callback(200, "success");
                        }
                    };
                    // Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    head.insertBefore(script, head.firstChild);
                },
                abort: function() {
                    if (script) script.onload(undefined, true);
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && jQuery.isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // data: string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (!data || typeof data !== "string") return null;
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        context = context || document;
        var parsed = rsingleTag.exec(data), scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    // Keep a copy of the old load method
    var _load = jQuery.fn.load;
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        if (typeof url !== "string" && _load) return _load.apply(this, arguments);
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = jQuery.trim(url.slice(off, url.length));
            url = url.slice(0, off);
        }
        // If it's a function
        if (jQuery.isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    // Attach a bunch of functions for handling common AJAX events
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.expr.filters.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    /**
 * Gets a window from an element
 */ function getWindow(elem) {
        return jQuery.isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
    }
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && jQuery.inArray("auto", [
                curCSSTop,
                curCSSLeft
            ]) > -1;
            // need to be able to calculate position if either top or left
            // is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (jQuery.isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        offset: function(options) {
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var docElem, win, box = {
                top: 0,
                left: 0
            }, elem = this[0], doc = elem && elem.ownerDocument;
            if (!doc) return;
            docElem = doc.documentElement;
            // Make sure it's not a disconnected DOM node
            if (!jQuery.contains(docElem, elem)) return box;
            // If we don't have gBCR, just use 0,0 rather than error
            // BlackBerry 5, iOS 3 (original iPhone)
            if (typeof elem.getBoundingClientRect !== "undefined") box = elem.getBoundingClientRect();
            win = getWindow(doc);
            return {
                top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
                left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
            };
        },
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, parentOffset = {
                top: 0,
                left: 0
            }, elem = this[0];
            // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
            // because it is its only offset parent
            if (jQuery.css(elem, "position") === "fixed") // we assume that getBoundingClientRect is available when computed position is fixed
            offset = elem.getBoundingClientRect();
            else {
                // Get *real* offsetParent
                offsetParent = this.offsetParent();
                // Get correct offsets
                offset = this.offset();
                if (!jQuery.nodeName(offsetParent[0], "html")) parentOffset = offsetParent.offset();
                // Add offsetParent borders
                parentOffset.top += jQuery.css(offsetParent[0], "borderTopWidth", true);
                parentOffset.left += jQuery.css(offsetParent[0], "borderLeftWidth", true);
            }
            // Subtract parent offsets and element margins
            // note: when an element has margin: auto the offsetLeft and marginLeft
            // are the same in Safari causing offset.left to incorrectly be 0
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && !jQuery.nodeName(offsetParent, "html") && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = /Y/.test(prop);
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                var win = getWindow(elem);
                if (val === undefined) return win ? prop in win ? win[prop] : win.document.documentElement[method] : elem[method];
                if (win) win.scrollTo(!top ? val : jQuery(win).scrollLeft(), top ? val : jQuery(win).scrollTop());
                else elem[method] = val;
            }, method, val, arguments.length, null);
        };
    });
    // Support: Safari<7-8+, Chrome<37-44+
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // getComputedStyle returns percent when specified for top/left/bottom/right
    // rather than make the css module depend on the offset module, we just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // if curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (jQuery.isWindow(elem)) // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
                    // isn't a whole lot we can do. See pull request at this URL for discussion:
                    // https://github.com/jquery/jquery/pull/764
                    return elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        // unfortunately, this causes bug #3838 in IE6/8 only,
                        // but there is currently no good, small way to fix it.
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable, null);
            };
        });
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        }
    });
    // The number of elements contained in the matched element set
    jQuery.fn.size = function() {
        return this.length;
    };
    jQuery.fn.andSelf = jQuery.fn.addBack;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in
    // AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (#13566)
    if (!noGlobal) window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{}],"jiucr":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"hBcxX":[function(require,module,exports) {
/*!
Jssor Slider (MIT license)
*/ /* eslint-disable */ !function(i, h, m, e, d, k, f) {
    var c = {
        u: m.PI,
        l: m.max,
        j: m.min,
        H: m.ceil,
        G: m.floor,
        P: m.abs,
        gb: m.sin,
        Cb: m.cos,
        Oe: m.tan,
        Xf: m.atan,
        Yf: m.atan2,
        xb: m.sqrt,
        B: m.pow,
        dd: m.random,
        $Round: m.round,
        Y: function(d, b) {
            var a1 = c.B(10, b || 0);
            return c.$Round(d * a1) / a1;
        }
    };
    function r(a1) {
        return function(b) {
            return c.$Round(b * a1) / a1;
        };
    }
    var g = i.$Jease$ = {
        $Swing: function(a1) {
            return -c.Cb(a1 * c.u) / 2 + .5;
        },
        $Linear: function(a1) {
            return a1;
        },
        $InQuad: function(a1) {
            return a1 * a1;
        },
        $OutQuad: function(a1) {
            return -a1 * (a1 - 2);
        },
        $InOutQuad: function(a1) {
            return (a1 *= 2) < 1 ? 0.5 * a1 * a1 : -0.5 * (--a1 * (a1 - 2) - 1);
        },
        $InCubic: function(a1) {
            return a1 * a1 * a1;
        },
        $OutCubic: function(a1) {
            return (a1 -= 1) * a1 * a1 + 1;
        },
        $InOutCubic: function(a1) {
            return (a1 *= 2) < 1 ? 0.5 * a1 * a1 * a1 : 0.5 * ((a1 -= 2) * a1 * a1 + 2);
        },
        $InQuart: function(a1) {
            return a1 * a1 * a1 * a1;
        },
        $OutQuart: function(a1) {
            return -((a1 -= 1) * a1 * a1 * a1 - 1);
        },
        $InOutQuart: function(a1) {
            return (a1 *= 2) < 1 ? 0.5 * a1 * a1 * a1 * a1 : -0.5 * ((a1 -= 2) * a1 * a1 * a1 - 2);
        },
        $InQuint: function(a1) {
            return a1 * a1 * a1 * a1 * a1;
        },
        $OutQuint: function(a1) {
            return (a1 -= 1) * a1 * a1 * a1 * a1 + 1;
        },
        $InOutQuint: function(a1) {
            return (a1 *= 2) < 1 ? 0.5 * a1 * a1 * a1 * a1 * a1 : 0.5 * ((a1 -= 2) * a1 * a1 * a1 * a1 + 2);
        },
        $InSine: function(a1) {
            return 1 - c.Cb(c.u / 2 * a1);
        },
        $OutSine: function(a1) {
            return c.gb(c.u / 2 * a1);
        },
        $InOutSine: function(a1) {
            return -0.5 * (c.Cb(c.u * a1) - 1);
        },
        $InExpo: function(a1) {
            return a1 == 0 ? 0 : c.B(2, 10 * (a1 - 1));
        },
        $OutExpo: function(a1) {
            return a1 == 1 ? 1 : -c.B(2, -10 * a1) + 1;
        },
        $InOutExpo: function(a1) {
            return a1 == 0 || a1 == 1 ? a1 : (a1 *= 2) < 1 ? 0.5 * c.B(2, 10 * (a1 - 1)) : 0.5 * (-c.B(2, -10 * --a1) + 2);
        },
        $InCirc: function(a1) {
            return -(c.xb(1 - a1 * a1) - 1);
        },
        $OutCirc: function(a1) {
            return c.xb(1 - (a1 -= 1) * a1);
        },
        $InOutCirc: function(a1) {
            return (a1 *= 2) < 1 ? -0.5 * (c.xb(1 - a1 * a1) - 1) : 0.5 * (c.xb(1 - (a1 -= 2) * a1) + 1);
        },
        $InElastic: function(a1) {
            if (!a1 || a1 == 1) return a1;
            var b = .3, d = .075;
            return -(c.B(2, 10 * (a1 -= 1)) * c.gb((a1 - d) * 2 * c.u / b));
        },
        $OutElastic: function(a1) {
            if (!a1 || a1 == 1) return a1;
            var b = .3, d = .075;
            return c.B(2, -10 * a1) * c.gb((a1 - d) * 2 * c.u / b) + 1;
        },
        $InOutElastic: function(a1) {
            if (!a1 || a1 == 1) return a1;
            var b = .45, d = .1125;
            return (a1 *= 2) < 1 ? -0.5 * c.B(2, 10 * (a1 -= 1)) * c.gb((a1 - d) * 2 * c.u / b) : c.B(2, -10 * (a1 -= 1)) * c.gb((a1 - d) * 2 * c.u / b) * .5 + 1;
        },
        $InBack: function(a1) {
            var b = 1.70158;
            return a1 * a1 * ((b + 1) * a1 - b);
        },
        $OutBack: function(a1) {
            var b = 1.70158;
            return (a1 -= 1) * a1 * ((b + 1) * a1 + b) + 1;
        },
        $InOutBack: function(a1) {
            var b = 1.70158;
            return (a1 *= 2) < 1 ? 0.5 * a1 * a1 * (((b *= 1.525) + 1) * a1 - b) : 0.5 * ((a1 -= 2) * a1 * (((b *= 1.525) + 1) * a1 + b) + 2);
        },
        $InBounce: function(a1) {
            return 1 - g.$OutBounce(1 - a1);
        },
        $OutBounce: function(a1) {
            return a1 < 1 / 2.75 ? 7.5625 * a1 * a1 : a1 < 2 / 2.75 ? 7.5625 * (a1 -= 1.5 / 2.75) * a1 + .75 : a1 < 2.5 / 2.75 ? 7.5625 * (a1 -= 2.25 / 2.75) * a1 + .9375 : 7.5625 * (a1 -= 2.625 / 2.75) * a1 + .984375;
        },
        $InOutBounce: function(a1) {
            return a1 < 0.5 ? g.$InBounce(a1 * 2) * .5 : g.$OutBounce(a1 * 2 - 1) * .5 + .5;
        },
        $GoBack: function(a1) {
            return 1 - c.P(1);
        },
        $InWave: function(a1) {
            return 1 - c.Cb(a1 * c.u * 2);
        },
        $OutWave: function(a1) {
            return c.gb(a1 * c.u * 2);
        },
        $OutJump: function(a1) {
            return 1 - ((a1 *= 2) < 1 ? (a1 = 1 - a1) * a1 * a1 : (a1 -= 1) * a1 * a1);
        },
        $InJump: function(a1) {
            return (a1 *= 2) < 1 ? a1 * a1 * a1 : (a1 = 2 - a1) * a1 * a1;
        },
        $Early: c.H,
        $Late: c.G,
        $Mid: c.$Round,
        $Mid2: r(2),
        $Mid3: r(3),
        $Mid4: r(4),
        $Mid5: r(5),
        $Mid6: r(6)
    };
    function v(k, l, p) {
        var d = this, f = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            k || 0,
            l || 0,
            p || 0,
            1
        ], j = c.gb, i = c.Cb, n = c.Oe;
        function h(a1) {
            return a1 * c.u / 180;
        }
        function o(b, c, f, g, i, l, n, o, q, t, u, w, y, A, C, F, a1, d, e, h, j, k, m, p, r, s, v, x, z, B, D, E) {
            return [
                b * a1 + c * j + f * r + g * z,
                b * d + c * k + f * s + g * B,
                b * e + c * m + f * v + g * D,
                b * h + c * p + f * x + g * E,
                i * a1 + l * j + n * r + o * z,
                i * d + l * k + n * s + o * B,
                i * e + l * m + n * v + o * D,
                i * h + l * p + n * x + o * E,
                q * a1 + t * j + u * r + w * z,
                q * d + t * k + u * s + w * B,
                q * e + t * m + u * v + w * D,
                q * h + t * p + u * x + w * E,
                y * a1 + A * j + C * r + F * z,
                y * d + A * k + C * s + F * B,
                y * e + A * m + C * v + F * D,
                y * h + A * p + C * x + F * E
            ];
        }
        function g(b, a1) {
            return o.apply(e, (a1 || f).concat(b));
        }
        d.$Scale = function(a1, b, c) {
            if (a1 != 1 || b != 1 || c != 1) f = g([
                a1,
                0,
                0,
                0,
                0,
                b,
                0,
                0,
                0,
                0,
                c,
                0,
                0,
                0,
                0,
                1
            ]);
        };
        d.$Move = function(a1, b, c) {
            f[12] += a1 || 0;
            f[13] += b || 0;
            f[14] += c || 0;
        };
        d.$RotateX = function(b) {
            if (b) {
                a = h(b);
                var c = i(a), d = j(a);
                f = g([
                    1,
                    0,
                    0,
                    0,
                    0,
                    c,
                    d,
                    0,
                    0,
                    -d,
                    c,
                    0,
                    0,
                    0,
                    0,
                    1
                ]);
            }
        };
        d.$RotateY = function(b) {
            if (b) {
                a = h(b);
                var c = i(a), d = j(a);
                f = g([
                    c,
                    0,
                    -d,
                    0,
                    0,
                    1,
                    0,
                    0,
                    d,
                    0,
                    c,
                    0,
                    0,
                    0,
                    0,
                    1
                ]);
            }
        };
        d.Cg = function(a1) {
            d.Vg(h(a1));
        };
        d.Vg = function(a1) {
            if (a1) {
                var b = i(a1), c = j(a1);
                f = g([
                    b,
                    c,
                    0,
                    0,
                    -c,
                    b,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ]);
            }
        };
        d.Ug = function(a1, b) {
            if (a1 || b) {
                k = h(a1);
                l = h(b);
                f = g([
                    1,
                    n(l),
                    0,
                    0,
                    n(k),
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ]);
            }
        };
        d.Sg = function() {
            return "matrix3d(" + f.join(",") + ")";
        };
        d.Og = function() {
            return "matrix(" + [
                f[0],
                f[1],
                f[4],
                f[5],
                f[12],
                f[13]
            ].join(",") + ")";
        };
    }
    var b = i.$Jssor$ = new function() {
        var a1 = this, Eb = /\S+/g, R = 1, mb = 2, qb = 3, pb = 4, tb = 5, T, t = 0, n = 0, I = 0, M = navigator, Ab = M.appName, o = M.userAgent, r = parseFloat;
        function w(c, a1, b) {
            return c.indexOf(a1, b);
        }
        function Qb() {
            if (!T) {
                T = {
                    td: "ontouchstart" in i || "createTouch" in h
                };
                var a1;
                if (M.pointerEnabled || (a1 = M.msPointerEnabled)) T.re = a1 ? "msTouchAction" : "touchAction";
            }
            return T;
        }
        function y(g) {
            if (!t) {
                t = -1;
                if (Ab == "Microsoft Internet Explorer" && !!i.attachEvent && !!i.ActiveXObject) {
                    var e = w(o, "MSIE");
                    t = R;
                    n = r(o.substring(e + 5, w(o, ";", e)));
                } else if (Ab == "Netscape" && !!i.addEventListener) {
                    var d = w(o, "Firefox"), b = w(o, "Safari"), f = w(o, "Chrome"), c = w(o, "AppleWebKit");
                    if (d >= 0) {
                        t = mb;
                        n = r(o.substring(d + 8));
                    } else if (b >= 0) {
                        var h = o.substring(0, b).lastIndexOf("/");
                        t = f >= 0 ? pb : qb;
                        n = r(o.substring(h + 1, b));
                    } else {
                        var a1 = /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/i.exec(o);
                        if (a1) {
                            t = R;
                            n = r(a1[1]);
                        }
                    }
                    if (c >= 0) I = r(o.substring(c + 12));
                } else {
                    var a1 = /(opera)(?:.*version|)[ \/]([\w.]+)/i.exec(o);
                    if (a1) {
                        t = tb;
                        n = r(a1[2]);
                    }
                }
            }
            return g == t;
        }
        function F() {
            return y(R);
        }
        function ob() {
            return y(qb);
        }
        function sb() {
            return y(tb);
        }
        function B() {
            y();
            return I > 537 || n > 42 || t == R && n >= 11;
        }
        function U(a1) {
            var b;
            return function(d) {
                if (!b) {
                    var c = a1.substr(0, 1).toUpperCase() + a1.substr(1);
                    b = j([
                        "",
                        "WebKit",
                        "ms",
                        "Moz",
                        "O",
                        "webkit"
                    ], function(b) {
                        var e = b + (b ? c : a1);
                        return d.style[e] != f && e;
                    }) || a1;
                }
                return b;
            };
        }
        var O = l("transform", 8);
        function J(a1) {
            return a1;
        }
        function P(a1) {
            return i.SVGElement && a1 instanceof i.SVGElement;
        }
        function Ob(a1) {
            return ({}).toString.call(a1);
        }
        var S = Array.isArray || function(a1) {
            return N(a1) == "array";
        }, wb = {};
        j([
            "Boolean",
            "Number",
            "String",
            "Function",
            "Array",
            "Date",
            "RegExp",
            "Object"
        ], function(a1) {
            wb["[object " + a1 + "]"] = a1.toLowerCase();
        });
        function j(b, d) {
            var a1, c;
            if (S(b)) {
                for(a1 = 0; a1 < m(b); a1++)if (c = d(b[a1], a1, b)) return c;
            } else for(a1 in b)if (c = d(b[a1], a1, b)) return c;
        }
        function N(a1) {
            return a1 == e ? String(a1) : wb[Ob(a1)] || "object";
        }
        function Z(a1) {
            for(var b in a1)return d;
        }
        function D(a1) {
            try {
                return N(a1) == "object" && !a1.nodeType && a1 != a1.window && (!a1.constructor || ({}).hasOwnProperty.call(a1.constructor.prototype, "isPrototypeOf"));
            } catch (b) {}
        }
        function Db(a1, b) {
            return {
                x: a1,
                y: b
            };
        }
        function Rb(b, a1) {
            setTimeout(b, a1 || 0);
        }
        function q(a1, b) {
            return a1 === f ? b : a1;
        }
        a1.ud = Qb;
        a1.ue = F;
        a1.He = ob;
        a1.gg = B;
        a1.Cd = function() {
            return n;
        };
        a1.$Delay = Rb;
        a1.wc = q;
        a1.W = function(a1, b) {
            b.call(a1);
            return x({}, a1);
        };
        function bb(a1) {
            a1.constructor === bb.caller && a1.F && a1.F.apply(a1, bb.caller.arguments);
        }
        a1.F = bb;
        a1.$GetElement = function(b) {
            if (a1.ag(b)) b = h.getElementById(b);
            return b;
        };
        a1.xc = function(c) {
            var b = [];
            j(c, function(d) {
                var c = a1.$GetElement(d);
                c && b.push(c);
            });
            return b;
        };
        function u(a1) {
            return a1 || i.event;
        }
        a1.Zf = u;
        a1.$EvtSrc = function(c) {
            c = u(c);
            var b = c.target || c.srcElement || h;
            if (b.nodeType == 3) b = a1.Lb(b);
            return b;
        };
        a1.Fe = function(a1) {
            a1 = u(a1);
            return a1.relatedTarget || a1.toElement;
        };
        a1.Je = function(a1) {
            a1 = u(a1);
            return a1.which || [
                0,
                1,
                3,
                0,
                2
            ][a1.button] || a1.charCode || a1.keyCode;
        };
        a1.Tc = function(a1) {
            a1 = u(a1);
            return {
                x: a1.clientX || 0,
                y: a1.clientY || 0
            };
        };
        a1.Ue = function(a1, b) {
            return Db(a1.x - b.x, a1.y - b.y);
        };
        a1.eg = function(a1, b) {
            return a1.x >= b.x && a1.x <= b.t && a1.y >= b.y && a1.y <= b.m;
        };
        a1.Ie = function(d, f) {
            var c = b.dg(f), e = b.Tc(d);
            return a1.eg(e, c);
        };
        a1.Ib = function(b) {
            return P(a1.Lb(b));
        };
        function A(c, d, a1) {
            if (a1 !== f) c.style[d] = a1 == f ? "" : a1;
            else {
                var b = c.currentStyle || c.style;
                a1 = b[d];
                if (a1 == "" && i.getComputedStyle) {
                    b = c.ownerDocument.defaultView.getComputedStyle(c, e);
                    b && (a1 = b.getPropertyValue(d) || b[d]);
                }
                return a1;
            }
        }
        function fb(b, c, a1, d) {
            if (a1 === f) {
                a1 = r(A(b, c));
                isNaN(a1) && (a1 = e);
                return a1;
            }
            d && a1 != e && (a1 += d);
            A(b, c, a1);
        }
        function l(g, a1, b, d) {
            var c;
            if (a1 & 2) c = "px";
            if (a1 & 4) c = "%";
            if (a1 & 16) c = "em";
            var f = a1 & 8 && U(g);
            a1 &= -9;
            d = d || (a1 ? fb : A);
            return function(i, h) {
                b && h && (h *= b);
                var a1 = d(i, f ? f(i) : g, h, c);
                return b && a1 != e ? a1 / b : a1;
            };
        }
        function C(a1) {
            return function(c, b) {
                s(c, a1, b);
            };
        }
        var hb = {
            r: [
                "rotate"
            ],
            sX: [
                "scaleX",
                2
            ],
            sY: [
                "scaleY",
                2
            ],
            tX: [
                "translateX",
                1
            ],
            tY: [
                "translateY",
                1
            ],
            kX: [
                "skewX"
            ],
            kY: [
                "skewY"
            ]
        };
        function jb(a1) {
            var b = "";
            if (a1) {
                j(a1, function(d, c) {
                    var a1 = hb[c];
                    if (a1) {
                        var e = a1[1] || 0;
                        if (ib[c] != d) b += " " + a1[0] + "(" + d + [
                            "deg",
                            "px",
                            ""
                        ][e] + ")";
                    }
                });
                if (B()) {
                    if (a1.tX || a1.tY || a1.tZ != f) b += " translate3d(" + (a1.tX || 0) + "px," + (a1.tY || 0) + "px," + (a1.tZ || 0) + "px)";
                }
            }
            return b;
        }
        function nb(a1) {
            return "rect(" + a1.y + "px " + a1.t + "px " + a1.m + "px " + a1.x + "px)";
        }
        a1.ug = l("transformOrigin", 8);
        a1.tg = l("backfaceVisibility", 8);
        a1.Jc = l("transformStyle", 8);
        a1.yg = l("perspective", 10);
        a1.xg = l("perspectiveOrigin", 8);
        a1.we = function(b, a1) {
            O(b, a1 == 1 ? "" : "scale(" + a1 + ")");
        };
        a1.$AddEvent = function(b, c, d, e) {
            b = a1.$GetElement(b);
            b.addEventListener(c, d, e);
        };
        a1.$RemoveEvent = function(b, c, d, e) {
            b = a1.$GetElement(b);
            b.removeEventListener(c, d, e);
        };
        a1.$CancelEvent = function(a1) {
            a1 = u(a1);
            a1.preventDefault && a1.preventDefault();
            a1.cancel = d;
            a1.returnValue = k;
        };
        a1.$StopEvent = function(a1) {
            a1 = u(a1);
            a1.stopPropagation && a1.stopPropagation();
            a1.cancelBubble = d;
        };
        a1.Z = function(d, c) {
            var a1 = [].slice.call(arguments, 2), b = function() {
                var b = a1.concat([].slice.call(arguments, 0));
                return c.apply(d, b);
            };
            return b;
        };
        a1.bd = function(b, c) {
            if (c == f) return b.textContent || b.innerText;
            var d = h.createTextNode(c);
            a1.Rb(b);
            b.appendChild(d);
        };
        a1.ng = function(a1, b) {
            if (b == f) return a1.innerHTML;
            a1.innerHTML = b;
        };
        a1.dg = function(b) {
            var a1 = b.getBoundingClientRect();
            return {
                x: a1.left,
                y: a1.top,
                w: a1.right - a1.left,
                h: a1.bottom - a1.top,
                t: a1.right,
                m: a1.bottom
            };
        };
        a1.jb = function(d, c) {
            for(var b = [], a1 = d.firstChild; a1; a1 = a1.nextSibling)(c || a1.nodeType == 1) && b.push(a1);
            return b;
        };
        function zb(a1, c, f, b) {
            b = b || "u";
            for(a1 = a1 ? a1.firstChild : e; a1; a1 = a1.nextSibling)if (a1.nodeType == 1) {
                if (K(a1, b) == c) return a1;
                if (!f) {
                    var d = zb(a1, c, f, b);
                    if (d) return d;
                }
            }
        }
        a1.$FindChild = zb;
        function Y(a1, d, g, b) {
            b = b || "u";
            var c = [];
            for(a1 = a1 ? a1.firstChild : e; a1; a1 = a1.nextSibling)if (a1.nodeType == 1) {
                K(a1, b) == d && c.push(a1);
                if (!g) {
                    var f = Y(a1, d, g, b);
                    if (m(f)) c = c.concat(f);
                }
            }
            return c;
        }
        a1.rg = function(b, a1) {
            return b.getElementsByTagName(a1);
        };
        a1.kb = function(a1, f, d, g) {
            d = d || "u";
            var e;
            do {
                if (a1.nodeType == 1) {
                    var c;
                    d && (c = K(a1, d));
                    if (c && c == q(f, c) || g == a1.tagName) {
                        e = a1;
                        break;
                    }
                }
                a1 = b.Lb(a1);
            }while (a1 && a1 != h.body);
            return e;
        };
        a1.qe = function(a1) {
            return db([
                "INPUT",
                "TEXTAREA",
                "SELECT"
            ])[a1.tagName];
        };
        function x() {
            for(var d = arguments, h = 1 & d[0], e = 1 + h, g = d[e - 1] || {}, c, b, a1; e < m(d); e++)if (c = d[e]) for(b in c){
                a1 = c[b];
                if (a1 !== f) {
                    a1 = c[b];
                    var i = g[b];
                    g[b] = h && (D(i) || D(a1)) ? x(h, {}, i, a1) : a1;
                }
            }
            return g;
        }
        a1.v = x;
        function cb(f, g) {
            var d = {}, c, a1, b;
            for(c in f){
                a1 = f[c];
                b = g[c];
                if (a1 !== b) {
                    var e = k;
                    if (D(a1) && D(b)) {
                        a1 = cb(a1, b);
                        e = !Z(a1);
                    }
                    !e && (d[c] = a1);
                }
            }
            return d;
        }
        a1.Zg = cb;
        a1.Pd = function(a1, c) {
            if (a1) {
                var b;
                j(c, function(c) {
                    if (a1[c] != f) (b = b || {})[c] = a1[c];
                    delete a1[c];
                });
                return b;
            }
        };
        a1.Ph = function(a1) {
            return N(a1) == "function";
        };
        a1.Md = S;
        a1.ag = function(a1) {
            return N(a1) == "string";
        };
        a1.Nd = function(a1) {
            return !S(a1) && !isNaN(r(a1)) && isFinite(a1);
        };
        a1.f = j;
        a1.Th = Z;
        a1.Sh = D;
        function W(a1) {
            return h.createElement(a1);
        }
        a1.bc = function() {
            return W("DIV");
        };
        a1.Rd = function() {
            return W("SPAN");
        };
        a1.Kc = function() {};
        function s(b, c, a1, d) {
            if (a1 === f) return b.getAttribute(c);
            a1 = a1 == e ? "" : d ? a1 + d : a1;
            b.setAttribute(c, a1);
        }
        function K(a1, b) {
            return s(a1, b) || s(a1, "data-" + b);
        }
        a1.g = s;
        a1.hb = K;
        a1.q = function(e, c, d) {
            var b = a1.od(K(e, c));
            if (isNaN(b)) b = d;
            return b;
        };
        a1.Hc = function(b, c, a1) {
            return eb(s(b, c), a1);
        };
        function G(b, a1) {
            return s(b, "class", a1) || "";
        }
        function db(b) {
            var a1 = {};
            j(b, function(b) {
                if (b != f) a1[b] = b;
            });
            return a1;
        }
        function eb(a1, b) {
            return a1 && a1.match(b || Eb) || e;
        }
        function V(b, a1) {
            return db(eb(b || "", a1));
        }
        a1.Fd = db;
        a1.Ud = eb;
        a1.mg = function(a1) {
            a1 && (a1 = a1.toLowerCase());
            return a1;
        };
        function gb(b, c) {
            var a1 = "";
            j(c, function(c) {
                a1 && (a1 += b);
                a1 += c;
            });
            return a1;
        }
        function Q(a1, c, b) {
            G(a1, gb(" ", x(cb(V(G(a1)), V(c)), V(b))));
        }
        a1.je = gb;
        a1.Lb = function(a1) {
            return a1.parentNode;
        };
        a1.Fc = function(b) {
            a1.nb(b, "none");
        };
        a1.mb = function(b, c) {
            a1.nb(b, q(c, d) ? "" : "none");
        };
        a1.Oh = function(b, a1) {
            b.removeAttribute(a1);
        };
        a1.kh = function(b, a1) {
            b.style.clip = nb(a1);
        };
        a1.Tb = function() {
            return +new Date;
        };
        a1.O = function(b, a1) {
            b.appendChild(a1);
        };
        a1.ph = function(c, b) {
            j(b, function(b) {
                a1.O(c, b);
            });
        };
        a1.pb = function(b, a1, c) {
            (c || a1.parentNode).insertBefore(b, a1);
        };
        a1.oh = function(b, a1, c) {
            b.insertAdjacentHTML(a1, c);
        };
        a1.ib = function(b, a1) {
            a1 = a1 || b.parentNode;
            a1 && a1.removeChild(b);
        };
        a1.ch = function(b, c) {
            j(b, function(b) {
                a1.ib(b, c);
            });
        };
        a1.Rb = function(b) {
            a1.ch(a1.jb(b, d), b);
        };
        function Bb() {
            j([].slice.call(arguments, 0), function(b) {
                if (a1.Md(b)) Bb.apply(e, b);
                else b && b.$Destroy && b.$Destroy();
            });
        }
        a1.$Destroy = Bb;
        a1.Uc = function(b, c) {
            var d = a1.Lb(b);
            if (c & 1) {
                a1.U(b, (a1.K(d) - a1.K(b)) / 2);
                a1.Vd(b, e);
            }
            if (c & 2) {
                a1.V(b, (a1.J(d) - a1.J(b)) / 2);
                a1.be(b, e);
            }
        };
        var X = {
            $Top: e,
            $Right: e,
            $Bottom: e,
            $Left: e,
            Eb: e,
            Gb: e
        };
        a1.Ch = function(b) {
            var c = a1.bc();
            L(c, {
                Me: "block",
                Pb: a1.db(b),
                $Top: 0,
                $Left: 0,
                Eb: 0,
                Gb: 0
            });
            var e = a1.ve(b, X);
            a1.pb(c, b);
            a1.O(c, b);
            var f = a1.ve(b, X), d = {};
            j(e, function(b, a1) {
                if (b == f[a1]) d[a1] = b;
            });
            L(c, X);
            L(c, d);
            L(b, {
                $Top: 0,
                $Left: 0
            });
            return d;
        };
        a1.Fh = function(b, a1) {
            return parseInt(b, a1 || 10);
        };
        a1.od = r;
        a1.Ae = function(b, a1) {
            var c = h.body;
            while(a1 && b !== a1 && c !== a1)a1 = a1.parentNode;
            return b === a1;
        };
        function ab(e, d, c) {
            var b = e.cloneNode(!d);
            !c && a1.Oh(b, "id");
            return b;
        }
        a1.ab = ab;
        a1.Vb = function(f, g) {
            var b = new Image;
            function c(f, d) {
                a1.$RemoveEvent(b, "load", c);
                a1.$RemoveEvent(b, "abort", e);
                a1.$RemoveEvent(b, "error", e);
                g && g(b, d);
            }
            function e(a1) {
                c(a1, d);
            }
            if (sb() && n < 11.6 || !f) c(!f);
            else {
                a1.$AddEvent(b, "load", c);
                a1.$AddEvent(b, "abort", e);
                a1.$AddEvent(b, "error", e);
                b.src = f;
            }
        };
        a1.Eh = function(g, c, f) {
            var d = 1;
            function e(a1) {
                d--;
                if (c && a1 && a1.src == c.src) c = a1;
                !d && f && f(c);
            }
            j(g, function(f) {
                var c = b.hb(f, "src");
                if (c) {
                    d++;
                    a1.Vb(c, e);
                }
            });
            e();
        };
        a1.Ce = function(a1, g, i, h) {
            if (h) a1 = ab(a1);
            var c = Y(a1, g);
            if (!m(c)) c = b.rg(a1, g);
            for(var f = m(c) - 1; f > -1; f--){
                var d = c[f], e = ab(i);
                G(e, G(d));
                b.th(e, d.style.cssText);
                b.pb(e, d);
                b.ib(d);
            }
            return a1;
        };
        function Lb() {
            var c = this;
            b.W(c, p);
            var e, q = "", t = [
                "av",
                "pv",
                "ds",
                "dn"
            ], g = [], r, n = 0, l = 0, k = 0;
            function m() {
                Q(e, r, (g[k || l & 2 || l] || "") + " " + (g[n] || ""));
                a1.lc(e, k ? "none" : "");
            }
            function d() {
                n = 0;
                c.T(i, "mouseup", d);
                c.T(h, "mouseup", d);
                c.T(h, "touchend", d);
                c.T(h, "touchcancel", d);
                c.T(i, "blur", d);
                m();
            }
            function o() {
                n = 4;
                m();
                c.a(i, "mouseup", d);
                c.a(h, "mouseup", d);
                c.a(h, "touchend", d);
                c.a(h, "touchcancel", d);
                c.a(i, "blur", d);
            }
            c.Ye = function(a1) {
                if (a1 === f) return l;
                l = a1 & 2 || a1 & 1;
                m();
            };
            c.$Enable = function(a1) {
                if (a1 === f) return !k;
                k = a1 ? 0 : 3;
                m();
            };
            c.F = function(f) {
                c.$Elmt = e = a1.$GetElement(f);
                s(e, "data-jssor-button", "1");
                var d = b.Ud(G(e));
                if (d) q = d.shift();
                j(t, function(a1) {
                    g.push(q + a1);
                });
                r = gb(" ", g);
                g.unshift("");
                c.a(e, "mousedown", o);
                c.a(e, "touchstart", o);
            };
            b.F(c);
        }
        a1.Lc = function(a1) {
            return new Lb(a1);
        };
        a1.xh = function(a1, b) {
            return c.xb(a1 * a1 + b * b);
        };
        a1.R = A;
        l("backgroundColor");
        a1.Fb = l("overflow");
        a1.lc = l("pointerEvents");
        a1.V = l("top", 2);
        a1.U = l("left", 2);
        a1.cb = l("opacity", 1);
        a1.N = l("zIndex", 1);
        function yb(m, n, a1, k, b, g, f) {
            if (b) {
                var h = b[0], d = b[1];
                if (f) {
                    var e = c.l(d * 2, 1), l = e * (f - 1) + 1;
                    a1 = (a1 * l - h) / e;
                    if (a1 > 0) {
                        d /= e;
                        h = 0;
                        var j = c.H(a1) - 1;
                        a1 = a1 - j;
                        if (a1 > d && j < f - 1) a1 = 1 - a1;
                    }
                }
                a1 = (a1 - h) / d;
                a1 = c.j(c.l(a1, 0), 1);
            }
            if (g) {
                a1 = a1 * g;
                var i = c.G(a1);
                a1 - i && (a1 -= i);
                a1 = c.j(c.l(a1, 0), 1);
            }
            if (b || g) a1 = c.Y(a1, 3);
            return m + n * k(a1);
        }
        function kb(d, e, h, i) {
            d = d || {};
            var g = {}, b = {};
            function n(a1) {
                b[a1] = d[a1];
            }
            function l() {
                b.cc = d.x;
                h && !e && (b.cc -= h);
            }
            function m() {
                b.Wb = d.y;
                i && !e && (b.Wb -= i);
            }
            var k = {
                cc: 0,
                Wb: 0,
                sX: 1,
                sY: 1,
                r: 0,
                rX: 0,
                rY: 0,
                tX: 0,
                tY: 0,
                tZ: 0,
                kX: 0,
                kY: 0
            }, c = {};
            if (!B() || e) {
                c.tZ = a1.Kc;
                c.tX = a1.Kc;
                c.tY = a1.Kc;
            }
            if (B() || e) {
                c.x = l;
                c.y = m;
            }
            j(d, function(b, a1) {
                (c[a1] || n)(a1);
            });
            j(b, function(c, a1) {
                if (k[a1] != f) {
                    g[a1] = c;
                    delete b[a1];
                }
            });
            Z(g) && (b.Kd = g);
            return b;
        }
        function vb(f, e) {
            var b = [], h = e & 1;
            e & 2 && (h = !h);
            for(var k = c.H(f / 2), a1 = 0; a1 < f; a1++){
                var d = a1;
                if (e & 4) {
                    var g = c.G(c.dd() * f);
                    d = q(b[a1], a1);
                    b[a1] = q(b[g], g);
                    b[g] = d;
                } else {
                    if (e & 2) {
                        d = a1 < k ? a1 * 2 : (f - a1 - 1) * 2 + 1;
                        b[d] = a1;
                    }
                    if (e & 32) d = c.G(a1 / 2) + (a1 % 2 ? c.H(k) : 0);
                    b[d] = a1;
                }
            }
            h && b.reverse();
            var i = [];
            j(b, function(b, a1) {
                i[b] = a1;
            });
            return i;
        }
        function xb(b, h, e, d) {
            for(var g = [], i = e ? c.H((b + d) / 2) : b, f = 1 / (h * (i - 1) + 1), a1 = 0; a1 < b; a1++){
                var j = e ? c.G((a1 + d) / 2) : a1;
                g[a1] = [
                    j * h * f,
                    f
                ];
            }
            return g;
        }
        function Jb(h, u, e) {
            h = h || {
                d: e.$Elmt ? s(e.$Elmt, "d") : ""
            };
            var E = e.$Easing, k = e.Bd || {}, g = k.r, z = g == 0, F = k.dl || 0;
            function x(c, a1) {
                var d = c[0], o = c[1], e = c[2], p = c[3], g = c[4], q = c[5], h = c[6], r = c[7];
                if (a1 === f) a1 = .5;
                var b = 1 - a1, i = b * d + a1 * e, s = b * o + a1 * p, j = b * e + a1 * g, t = b * p + a1 * q, k = b * g + a1 * h, u = b * q + a1 * r, l = b * i + a1 * j, v = b * s + a1 * t, m = b * j + a1 * k, w = b * t + a1 * u, n = b * l + a1 * m, x = b * v + a1 * w;
                return [
                    [
                        d,
                        o,
                        i,
                        s,
                        l,
                        v,
                        n,
                        x
                    ],
                    [
                        n,
                        x,
                        m,
                        w,
                        k,
                        u,
                        h,
                        r
                    ]
                ];
            }
            function w(c, g) {
                for(var d = 0, e = 0, a1 = 0, b = g ? 6 : 0; b < m(c); b += 6){
                    d += c[b];
                    e += c[b + 1];
                    a1++;
                }
                return {
                    x: a1 ? d / a1 : f,
                    y: a1 ? e / a1 : f
                };
            }
            function b(b) {
                var l = m(b), j = b[0] == b[l - 2] && b[1] == b[l - 1], g = w(b, j), k = [], h = [];
                function e(a1) {
                    return {
                        x: b[a1],
                        y: b[a1 + 1]
                    };
                }
                function f(j, f, b) {
                    var d = a1.Ue(j, f);
                    h[b] = a1.xh(d.x, d.y);
                    if (!h[b] && b % 6) {
                        var g = b % 6 < 3 ? 2 : -2;
                        d = a1.Ue(e(b + g), f);
                    }
                    var i = c.Yf(d.y, d.x);
                    k[b] = i;
                }
                for(var d = 0; d < m(b); d += 6){
                    var i = e(d);
                    f(i, g, d);
                    f(e(d - 2), i, d - 2);
                    f(e(d + 2), i, d + 2);
                }
                return {
                    lb: b,
                    qb: (m(b) - 2) / 6,
                    kc: g.x,
                    ic: g.y,
                    Nc: k,
                    Vc: h,
                    vc: j
                };
            }
            function n(o) {
                function i(a1) {
                    return a1.replace(/[\^\s]*([mhvlzcsqta]|\-?\d*\.?\d+)[,\$\s]*/gi, " $1").replace(/([mhvlzcsqta])/gi, " $1").trim().split("  ").map(l);
                }
                function l(a1) {
                    return a1.split(" ").map(k);
                }
                function k(a1, b) {
                    return b === 0 ? a1 : +a1;
                }
                var h = [], a1, n = i(o || ""), d, e, f, g;
                function c(b) {
                    f = b[m(b) - 2];
                    g = b[m(b) - 1];
                    a1 = a1.concat(b);
                }
                j(n, function(i) {
                    var j = i.shift();
                    switch(j){
                        case "M":
                            a1 && h.push(b(a1));
                            a1 = [];
                            d = i[0];
                            e = i[1];
                            c(i);
                            break;
                        case "L":
                            c([
                                f,
                                g,
                                i[0],
                                i[1],
                                i[0],
                                i[1]
                            ]);
                            break;
                        case "C":
                            c(i);
                            break;
                        case "Z":
                        case "z":
                            (f != d || g != e) && c([
                                f,
                                g,
                                d,
                                e,
                                d,
                                e
                            ]);
                    }
                });
                a1 && h.push(b(a1));
                return h;
            }
            function d(a1, b) {
                return c.Y(a1, 2) + "," + c.Y(b, 2);
            }
            function A(a1) {
                for(var c = "M" + d(a1[0], a1[1]), b = 2; b < m(a1) - 2; b += 6){
                    c += "C";
                    c += d(a1[b], a1[b + 1]) + " ";
                    c += d(a1[b + 2], a1[b + 3]) + " ";
                    c += d(a1[b + 4], a1[b + 5]);
                }
                return c;
            }
            function y(b) {
                var a1 = "";
                j(b, function(b) {
                    a1 += A(b);
                });
                return a1;
            }
            function D(d) {
                for(var c = [], a1 = 0; a1 < m(d) - 2; a1 += 6)c.push(b(d.slice(a1, a1 + 8)));
                return c;
            }
            function B(c) {
                var a1 = [];
                j(c, function(c, d) {
                    var b = c.lb;
                    !d && a1.push(b[0], b[1]);
                    a1 = a1.concat(b.slice(2));
                });
                return b(a1);
            }
            function l(d, a1) {
                var p = a1.gf = [], q = a1.bf = [], e = a1.qb + (!d.vc || !d.vc);
                function n(b) {
                    return a1.Nc[b] - d.Nc[b];
                }
                function h(b, a1) {
                    a1 = a1 || 0;
                    return c.Y((b - a1 + c.u * 101) % (c.u * 2) - c.u + a1, 8);
                }
                function i(b, f) {
                    var e = d.Vc[b], g = a1.Vc[b], i = g - e, c = n(b);
                    c = h(c, f);
                    p[b] = i;
                    q[b] = c;
                    return c;
                }
                for(var l = 0, b = 0; b < e; b++)l += h(n(b * 6));
                var f = h(l / e);
                if (g) {
                    var j = g > 0 ? 1 : -1;
                    f = (f + c.u * 2 * j) % (c.u * 2) || c.u * 2 * j;
                    f += c.u * 2 * (g - j);
                }
                for(var b = 0; b < m(d.lb); b += 6){
                    var o = i(b, f);
                    i(b - 2, o);
                    i(b + 2, o);
                }
                var s = xb(e, F), r = vb(e, k.o);
                a1.ad = function(b, c) {
                    if (b >= 0 && b <= a1.qb) return yb(0, 1, c, E, s[r[b % e]]);
                };
            }
            function t(d, a1, s, n, i) {
                function q(d) {
                    for(var a1 = [
                        0,
                        .2,
                        0,
                        .09,
                        .09,
                        0,
                        .2,
                        0,
                        .31,
                        0,
                        .4,
                        .09,
                        .4,
                        .2,
                        .4,
                        .31,
                        .31,
                        .4,
                        .2,
                        .4,
                        .09,
                        .4,
                        0,
                        .31,
                        0,
                        .2
                    ], c = 0; c < m(a1); c += 2){
                        a1[c] += d.kc - .2;
                        a1[c + 1] += d.ic - .2;
                    }
                    var e = b(a1);
                    e.vc = d.vc;
                    return e;
                }
                d = s[i] = d || q(a1);
                a1 = n[i] = a1 || q(d);
                var h = d.qb, g = a1 && a1.qb;
                if (h < g) return t(a1, d, n, s, i);
                if (g < h) {
                    for(var r = D(a1.lb), u = h / g, o = h - g, f = 0, p = 0; p < 10 && f < o; p++){
                        var v = u + u * p / 10, e = 0;
                        j(r, function(d, g) {
                            e += d.qb;
                            var b = c.$Round((g + 1) * v);
                            if (e < b) {
                                var a1 = c.j(b - e, o - f);
                                d.qb += a1;
                                f += a1;
                                e += a1;
                            }
                            return o < f;
                        });
                    }
                    var k = [];
                    j(r, function(d) {
                        var a1 = d.qb, c = d.lb;
                        while(a1 - 1){
                            var e = x(c, 1 / a1);
                            k.push(b(e[0]));
                            c = e[1];
                            a1--;
                        }
                        k.push(b(c));
                    });
                    a1 = n[i] = B(k);
                }
                l(d, a1);
                l(a1, d);
            }
            function r(b, a1) {
                if (m(b) < m(a1)) return r(a1, b);
                j(b, function(d, c) {
                    t(d, a1[c], b, a1, c);
                });
            }
            var o = n(h.d), p = n(u.d);
            r(o, p);
            function i(b, h, i, e, a1, l) {
                var d = b.lb;
                if (a1 >= 0 && a1 < m(b.lb)) {
                    var k = h.lb, f, g;
                    if (z) {
                        f = d[a1] + (k[a1] - d[a1]) * e;
                        g = d[a1 + 1] + (k[a1 + 1] - d[a1 + 1]) * e;
                    } else {
                        var o = b.Vc[a1], p = h.gf[a1], q = b.Nc[a1], r = h.bf[a1], j = o + p * e, n = q + r * e;
                        f = j * c.Cb(n) + i.x;
                        g = j * c.gb(n) + i.y;
                    }
                    l[a1] = f;
                    l[a1 + 1] = g;
                    return {
                        x: f,
                        y: g
                    };
                }
            }
            var v = {
                E: function(a1) {
                    if (!a1) return h;
                    if (a1 == 1) return u;
                    var b = [];
                    j(o, function(c, n) {
                        for(var g = [], d = p[n], e = 0; e < m(c.lb); e += 6){
                            var f = d.ad(e / 6, a1), l = q(d.ad(e / 6 - 1, a1), f), k = q(d.ad(e / 6 + 1, a1), f), j = {
                                x: c.kc + (d.kc - c.kc) * f,
                                y: c.ic + (d.ic - c.ic) * f
                            }, h = i(c, d, j, f, e, g);
                            i(c, d, h, (f + l) / 2, e - 2, g);
                            i(c, d, h, (f + k) / 2, e + 2, g);
                        }
                        b.push(g);
                    });
                    return {
                        d: y(b)
                    };
                },
                X: function(a1) {
                    return a1 && a1.d || "";
                },
                sb: C("d")
            };
            return v;
        }
        function Hb(b) {
            return x({
                wc: a1.Ph(b) ? b : g.$Linear
            }, b);
        }
        function z(i, u, h, M, o) {
            i = i || {};
            h = x({}, h);
            var ab = h.$Elmt, p = {}, W = {}, w, y, r = h.le, P = h.Ib, F = k(Hb(h.$Easing)), V = k(h.Bd), X = k(h.$During), Z = k(h.$Round), Y = k(h.Pc, E), G = S(u);
            i = k(i, f, d);
            u = k(u, f, d);
            var U = B(), K = o ? {
                c: R,
                Kd: L,
                pt: Jb,
                bl: Q,
                da: H,
                fc: n(C("fill"), [
                    0,
                    0,
                    0,
                    1
                ]),
                sc: n(C("stroke")),
                cl: n(l("color"), [
                    0,
                    0,
                    0,
                    1
                ]),
                bgc: n(l("backgroundColor")),
                bdc: n(l("borderColor")),
                rp: N
            } : {}, s = h.Yc || o && {
                o: 4,
                so: 4,
                Kd: 4,
                ls: 4,
                lh: 4,
                sX: 4,
                sY: 4
            };
            function T(c) {
                var d = V[c] || {};
                return b.v({}, h, {
                    $Easing: F[c] || F.wc || e,
                    Pc: Y[c] || e,
                    Bd: d,
                    $During: X[c] || e,
                    $Round: Z[c] || e,
                    Mf: d.rd,
                    Yc: a1.Nd(s) ? s : s && s[c],
                    le: 0
                });
            }
            function t(a1) {
                return m(a1) % 2 ? a1.concat(a1) : a1;
            }
            function k(a1, c, b) {
                a1 = M ? kb(a1, P, b && h.Lf, b && h.Of) : a1 || {};
                return o ? x({}, c, a1) : a1;
            }
            function n(f, d) {
                function c(a1) {
                    return a1 == "transparent" ? e : a1 || d;
                }
                function a1(a1, b) {
                    a1 = c(a1);
                    b = c(b);
                    if (!a1 && b) {
                        a1 = b.slice(0);
                        a1[3] = 0;
                    }
                    return a1 || [
                        0,
                        0,
                        0,
                        0
                    ];
                }
                return function(c, d, g) {
                    d = a1(d, c);
                    c = a1(c, d);
                    var e = z(c, d, b.v({
                        Yc: [
                            0,
                            0,
                            0,
                            4
                        ]
                    }, g));
                    return {
                        E: function(a1) {
                            return e.E(a1);
                        },
                        X: function(a1) {
                            return "rgba(" + a1.join(",") + ")";
                        },
                        sb: f
                    };
                };
            }
            function I(b, k, a1) {
                b = b || 0;
                var f = a1.$Easing || g.$Linear, e = a1.$During, i = a1.$Round, h = a1.Mf, j = k - b, d = q(a1.Yc, 2);
                return {
                    E: function(a1) {
                        return c.Y(yb(b, j, a1, f, e, i, h), d);
                    },
                    X: J,
                    sb: a1.Pc
                };
            }
            function A(c, d, a1, b) {
                return {
                    E: z(c, d, a1).E,
                    X: function(a1) {
                        return a1.join(",");
                    },
                    sb: b
                };
            }
            function Q(b, c, a1) {
                return A(t(b || [
                    0
                ]), t(c), a1, C("stdDeviation"));
            }
            function H(a1, c, h) {
                var e = m(c);
                c = t(c);
                if (!a1) {
                    a1 = c.slice(0);
                    j(a1, function(c, b) {
                        b % 2 && (a1[b] = 0);
                    });
                }
                a1 = t(a1);
                for(var d = m(a1), f, b = 1; b <= d && b <= e; b++)if (!(d % b) && !(e % b)) f = b;
                function g(b) {
                    var a1 = b;
                    while(m(a1) < d * e / f)a1 = a1.concat(b);
                    return a1;
                }
                return A(g(a1), g(c), h, C("stroke-dasharray"));
            }
            function R(b, c, a1) {
                return {
                    E: z(b, c, a1).E,
                    X: function(b) {
                        return (b.y || b.x || b.m - a1.$OriginalHeight || b.t - a1.$OriginalWidth) && nb(b) || "";
                    },
                    sb: l("clip")
                };
            }
            function L(e, f, c) {
                var a1 = c.Nf, b;
                function d(b) {
                    var d = (b.rX || 0) % 360, e = (b.rY || 0) % 360, f = (b.r || 0) % 360, g = q(b.sX, 1), h = q(b.sY, 1), i = q(b.sZ, 1), c = new v(b.tX, b.tY, b.tZ || 0);
                    a1 && c.$Move(-a1.x, -a1.y);
                    c.$Scale(g, h, i);
                    c.Ug(b.kX, b.kY);
                    c.$RotateX(d);
                    c.$RotateY(e);
                    c.Cg(f);
                    a1 && c.$Move(a1.x, a1.y);
                    c.$Move(b.cc, b.Wb);
                    return c;
                }
                if (c.Ib) {
                    y = C("transform");
                    b = function(a1) {
                        return d(a1).Og();
                    };
                } else {
                    y = O;
                    if (U) b = function(a1) {
                        return d(a1).Sg();
                    };
                    else b = jb;
                }
                return {
                    E: z(e, f, c).E,
                    sb: y,
                    X: b || J
                };
            }
            function N() {
                var b = 1e-5;
                return {
                    E: J,
                    X: J,
                    sb: function(d) {
                        b *= -1;
                        a1.cb(d, c.Y(a1.cb(d), 4) + b);
                    }
                };
            }
            j(u, function(b, a1) {
                var c = i && i[a1] || 0;
                if (G || b !== c) {
                    var d = o && K[a1] || (D(b) ? z : I);
                    p[a1] = d(c, b, T(a1));
                }
            });
            w = function(b) {
                var a1;
                j(p, function(c, e) {
                    var d = c.E(b);
                    c.sb(c.$Elmt || ab, c.X(d));
                    e == "o" && (a1 = d);
                });
                return a1;
            };
            r && b.f(p, function(a1, e) {
                for(var d = [], b = 0; b < r + 1; b++)d[b] = a1.X(a1.E(b / r));
                W[e] = d;
                a1.E = function(a1) {
                    return d[c.$Round(a1 * r)];
                };
                a1.X = J;
            });
            w.E = function(c) {
                var a1 = x(d, G ? [] : {}, i);
                b.f(p, function(b, d) {
                    a1[d] = b.E(c);
                });
                return a1;
            };
            return w;
        }
        a1.Kf = z;
        a1.Zd = vb;
        a1.K = l("width", 2);
        a1.J = l("height", 2);
        a1.Vd = l("right", 2);
        a1.be = l("bottom", 2);
        l("marginLeft", 2);
        l("marginTop", 2);
        a1.db = l("position");
        a1.nb = l("display");
        a1.th = function(a1, b) {
            if (b != f) a1.style.cssText = b;
            else return a1.style.cssText;
        };
        a1.Jf = function(b, a1) {
            if (a1 === f) {
                a1 = A(b, "backgroundImage") || "";
                var c = /\burl\s*\(\s*["']?([^"'\r\n,]+)["']?\s*\)/gi.exec(a1) || [];
                return c[1];
            }
            A(b, "backgroundImage", a1 ? "url('" + a1 + "')" : "");
        };
        var E;
        a1.If = E = {
            $Opacity: a1.cb,
            $Top: a1.V,
            $Right: a1.Vd,
            $Bottom: a1.be,
            $Left: a1.U,
            Eb: a1.K,
            Gb: a1.J,
            Pb: a1.db,
            Me: a1.nb,
            $ZIndex: a1.N,
            o: a1.cb,
            x: a1.U,
            y: a1.V,
            i: a1.N,
            dO: l("stroke-dashoffset", 1),
            ls: l("letterSpacing", 16),
            lh: l("lineHeight", 1),
            so: l("startOffset", 4, 100, s)
        };
        a1.ve = function(c, b) {
            var a1 = {};
            j(b, function(d, b) {
                if (E[b]) a1[b] = E[b](c);
            });
            return a1;
        };
        function L(b, a1) {
            j(a1, function(c, a1) {
                E[a1] && E[a1](b, c);
            });
        }
        a1.rb = L;
        var ib = {
            cc: 0,
            Wb: 0,
            sX: 1,
            sY: 1,
            r: 0,
            rX: 0,
            rY: 0,
            tX: 0,
            tY: 0,
            tZ: 0,
            kX: 0,
            kY: 0
        }, Pb = [
            g.$Linear,
            g.$Swing,
            g.$InQuad,
            g.$OutQuad,
            g.$InOutQuad,
            g.$InCubic,
            g.$OutCubic,
            g.$InOutCubic,
            g.$InQuart,
            g.$OutQuart,
            g.$InOutQuart,
            g.$InQuint,
            g.$OutQuint,
            g.$InOutQuint,
            g.$InSine,
            g.$OutSine,
            g.$InOutSine,
            g.$InExpo,
            g.$OutExpo,
            g.$InOutExpo,
            g.$InCirc,
            g.$OutCirc,
            g.$InOutCirc,
            g.$InElastic,
            g.$OutElastic,
            g.$InOutElastic,
            g.$InBack,
            g.$OutBack,
            g.$InOutBack,
            g.$InBounce,
            g.$OutBounce,
            g.$InOutBounce,
            g.$Early,
            g.$Late,
            g.$Mid,
            g.$Mid2,
            g.$Mid3,
            g.$Mid4,
            g.$Mid5,
            g.$Mid6
        ];
        function ub(a1) {
            var c;
            if (b.Nd(a1)) c = Pb[a1];
            else if (b.Sh(a1)) {
                c = {};
                j(a1, function(a1, b) {
                    c[b] = ub(a1);
                });
            }
            return c || a1;
        }
        a1.Ld = ub;
        function m(a1) {
            return a1.length;
        }
        a1.A = m;
        a1.Qd = w;
        a1.Vf = function(k, j, n, o) {
            b.cb(k, 1);
            var m = {
                o: {
                    j: 0,
                    l: 1
                }
            }, e = {
                x: 0,
                y: 0,
                o: 1,
                r: 0,
                rX: 0,
                rY: 0,
                sX: 1,
                sY: 1,
                tZ: 0,
                kX: 0,
                kY: 0
            };
            function h(e) {
                var a1 = [], c = b.jb(e, d);
                b.f(c, function(d) {
                    if (d.nodeType == 3) {
                        for(var f = b.bd(d), e = 0; e < b.A(f); e++){
                            var g = f[e], c = b.Rd();
                            b.nb(c, "inline-block");
                            b.db(c, "relative");
                            g == " " ? b.ng(c, "&nbsp;") : b.bd(c, g);
                            b.pb(c, d);
                            a1.push(c);
                            b.cb(c, j);
                        }
                        b.ib(d);
                    } else a1 = a1.concat(h(d));
                });
                return a1;
            }
            function l(n) {
                var j = this, h = b.Zd(a1, 4), e = b.Pd(n, [
                    "b",
                    "d",
                    "e",
                    "p",
                    "dr"
                ]) || {}, g = {};
                function i(d, g, f) {
                    var b = f ? a1 : g, e = 0;
                    if (d.Sd & 2) {
                        b = c.H(b / 2);
                        if (!d.$Reverse) {
                            e = (b + 1) % 2 * d.ed;
                            b += e;
                        }
                    }
                    return b;
                }
                function d(d) {
                    var g = d & 1, i = d & 2 || 1, e = 0;
                    if (d & 2) e = a1 % 2;
                    var f = d == 68 ? h : b.Zd(a1, d);
                    return {
                        Sd: d,
                        ed: e,
                        $Reverse: g,
                        Od: f,
                        Le: function(a1) {
                            return c.G((f[a1] + e * !g) / i);
                        }
                    };
                }
                function l(a1, b, f, d) {
                    var e = i(a1, b, f), c = 1 / (d * (e - 1) + 1);
                    return {
                        nc: function(e) {
                            return a1.Od[e] < b && [
                                a1.Le(e) * d * c,
                                c
                            ];
                        }
                    };
                }
                function m(a1) {
                    return {
                        Pe: function(b) {
                            return a1.Od[b] % 2 ? 1 : -1;
                        }
                    };
                }
                function k(b, g, k, h, j) {
                    var d = i(b, g, k), e = 0;
                    function f(a1) {
                        return c.B(1 - a1 / d, h);
                    }
                    if (b.Sd & 2) {
                        d = c.H(a1 / 2) - b.ed;
                        e = f(d - 1) / 2 * !b.ed;
                    }
                    return {
                        Se: function(a1) {
                            a1 = b.Le(a1);
                            j && (a1 = d - a1 - 1);
                            return f(a1) - e;
                        }
                    };
                }
                j.Uf = e;
                j.Rf = function(o) {
                    var i = g[o];
                    if (!i) {
                        var h = e.p && e.p[o] || {}, y = b.wc(h.dl, .5), x = h.o || 0, z = h.r || 1, p = h.c, r = h.d, n = b.wc(h.dO, 8), q = c.$Round(a1 * z), j = d(x), w = l(j, q, h.dlc, y), t = p & 8 ? j : d(p), v = m(t), s = n & 8 ? j : d(n), u = k(s, q, h.dc, r, n == 9);
                        i = g[o] = {
                            nc: w.nc,
                            Qf: function(a1) {
                                return (p != f ? v.Pe(a1) : 1) * (r ? u.Se(a1) : 1);
                            }
                        };
                    }
                    return i;
                };
            }
            var i = h(k), a1 = b.A(i), g = [];
            b.f(i, function(i, h) {
                var a1 = [], d = b.v({}, e), f = b.v({}, e, {
                    o: j
                });
                b.f(n, function(j, n) {
                    var i = {}, o = {}, k = g[n] = g[n] || new l(j);
                    b.f(j, function(l, b) {
                        var n = k.Rf(b), p = n.nc(h);
                        if (p) {
                            var a1, g = c.Y(l - d[b], 8);
                            if (g) {
                                g = c.Y(l - e[b], 8);
                                g *= n.Qf(h);
                                a1 = c.Y(g + e[b], 4);
                                var j = m[b];
                                if (j) {
                                    a1 = c.l(a1, j.j);
                                    a1 = c.j(a1, j.l);
                                }
                            } else a1 = l;
                            if (a1 - f[b]) {
                                i[b] = a1;
                                o[b] = p;
                            }
                        }
                    });
                    b.v(d, j);
                    b.v(f, i);
                    if (b.Th(i)) {
                        b.v(i, k.Uf);
                        i.dr = o;
                        a1.push(i);
                    }
                });
                b.A(a1) && o(i, a1);
            });
        };
    };
    function p() {
        var a1 = this, f, e = [], c = [];
        function k(a1, b) {
            e.push({
                ec: a1,
                gc: b
            });
        }
        function j(a1, c) {
            b.f(e, function(b, d) {
                b.ec == a1 && b.gc === c && e.splice(d, 1);
            });
        }
        function h() {
            e = [];
        }
        function g() {
            b.f(c, function(a1) {
                b.$RemoveEvent(a1.Ne, a1.ec, a1.gc, a1.Xe);
            });
            c = [];
        }
        a1.Oc = function() {
            return f;
        };
        a1.a = function(f, d, e, a1) {
            b.$AddEvent(f, d, e, a1);
            c.push({
                Ne: f,
                ec: d,
                gc: e,
                Xe: a1
            });
        };
        a1.T = function(f, d, e, a1) {
            b.f(c, function(g, h) {
                if (g.Ne === f && g.ec == d && g.gc === e && g.Xe == a1) {
                    b.$RemoveEvent(f, d, e, a1);
                    c.splice(h, 1);
                }
            });
        };
        a1.Ve = g;
        a1.$On = a1.addEventListener = k;
        a1.$Off = a1.removeEventListener = j;
        a1.k = function(a1) {
            var c = [].slice.call(arguments, 1);
            b.f(e, function(b) {
                b.ec == a1 && b.gc.apply(i, c);
            });
        };
        a1.$Destroy = function() {
            if (!f) {
                f = d;
                g();
                h();
            }
        };
    }
    var l = function(C, F, l, m, L, M) {
        C = C || 0;
        var a1 = this, t, p, n, o, v, D = 0, O = 1, E, B = 0, h = 0, r = 0, A, j, e, g, u, z, s = [], I = k, J, H = k;
        function R(a1) {
            e += a1;
            g += a1;
            j += a1;
            h += a1;
            r += a1;
            B += a1;
        }
        function y(C) {
            var k = C;
            if (u) {
                if (!z && (k >= g || k < e) || z && k >= e) k = ((k - e) % u + u) % u + e;
            }
            if (!A || v || h != k) {
                var i = c.j(k, g);
                i = c.l(i, e);
                if (l.$Reverse) i = g - i + e;
                if (!A || v || i != r) {
                    if (t) {
                        var y = (i - j) / (F || 1), x = t(y), n;
                        if (J) {
                            var o = i > e && i < g;
                            if (o != H) n = H = o;
                        }
                        if (!n && x != f) {
                            var p = !x;
                            if (p != I) n = I = p;
                        }
                        if (n != f) {
                            n && b.lc(m, "none");
                            !n && b.lc(m, b.g(m, "data-events"));
                        }
                    }
                    var w = r, q = r = i;
                    b.f(s, function(c, d) {
                        var a1 = !A && z || k <= h ? s[b.A(s) - d - 1] : c;
                        a1.L(i - B);
                    });
                    h = k;
                    A = d;
                    a1.kd(w - j, q - j);
                    a1.zc(w, q);
                }
            }
        }
        function G(a1, b, d) {
            b && a1.$Shift(g);
            if (!d) {
                e = c.j(e, a1.yc() + B);
                g = c.l(g, a1.vb() + B);
            }
            s.push(a1);
        }
        var w = i.requestAnimationFrame || i.webkitRequestAnimationFrame || i.mozRequestAnimationFrame || i.msRequestAnimationFrame;
        if (b.He() && b.Cd() < 7 || !w) w = function(a1) {
            b.$Delay(a1, l.$Interval);
        };
        function N() {
            if (p) {
                var c = b.Tb(), d = c - D;
                D = c;
                var a1 = h + d * o * O;
                if (a1 * o >= n * o) a1 = n;
                y(a1);
                if (!v && a1 * o >= n * o) P(E);
                else w(N);
            }
        }
        function x(f, i, j) {
            if (!p) {
                p = d;
                v = j;
                E = i;
                f = c.l(f, e);
                f = c.j(f, g);
                n = f;
                o = n < h ? -1 : 1;
                a1.Qc();
                D = b.Tb();
                w(N);
            }
        }
        function P(b) {
            if (p) {
                v = p = E = k;
                a1.Rc();
                b && b();
            }
        }
        a1.$Play = function(a1, b, c) {
            x(a1 ? h + a1 : g, b, c);
        };
        a1.tc = x;
        a1.Ff = function(a1, b) {
            x(g, a1, b);
        };
        a1.S = P;
        a1.Be = function() {
            return h;
        };
        a1.Ee = function() {
            return n;
        };
        a1.z = function() {
            return r;
        };
        a1.L = y;
        a1.uf = function() {
            y(g, d);
        };
        a1.$IsPlaying = function() {
            return p;
        };
        a1.De = function(a1) {
            O = a1;
        };
        a1.$Shift = R;
        a1.je = G;
        a1.M = function(a1, b) {
            G(a1, 0, b);
        };
        a1.zd = function(a1) {
            G(a1, 1);
        };
        a1.qd = function(a1) {
            g += a1;
        };
        a1.yc = function() {
            return e;
        };
        a1.vb = function() {
            return g;
        };
        a1.zc = a1.Qc = a1.Rc = a1.kd = b.Kc;
        b.Tb();
        a1.nf = function() {
            return t && t.E(1);
        };
        l = b.v({
            $Interval: 16
        }, l);
        m && (J = b.g(m, "data-inactive"));
        u = l.hc;
        z = l.pf;
        e = j = C;
        g = C + F;
        l.$Elmt = m;
        m && (t = b.Kf(L, M, l, d, d));
    };
    var u = i.$JssorSlideshowFormations$ = new function() {
        var i = this, e = 0, a1 = 1, g = 2, f = 3, t = 1, s = 2, u = 4, r = 8, x = 256, y = 512, w = 1024, v = 2048, k = v + t, j = v + s, p = y + t, n = y + s, o = x + u, l = x + r, m = w + u, q = w + r;
        function z(a1) {
            return (a1 & s) == s;
        }
        function A(a1) {
            return (a1 & u) == u;
        }
        function h(b, a1, c) {
            c.push(a1);
            b[a1] = b[a1] || [];
            b[a1].push(c);
        }
        i.$FormationStraight = function(f) {
            for(var d = f.$Cols, e = f.$Rows, s = f.$Assembly, t = f.mc, r = [], a1 = 0, b = 0, i = d - 1, q = e - 1, g = t - 1, c, b = 0; b < e; b++)for(a1 = 0; a1 < d; a1++){
                switch(s){
                    case k:
                        c = g - (a1 * e + (q - b));
                        break;
                    case m:
                        c = g - (b * d + (i - a1));
                        break;
                    case p:
                        c = g - (a1 * e + b);
                    case o:
                        c = g - (b * d + a1);
                        break;
                    case j:
                        c = a1 * e + b;
                        break;
                    case l:
                        c = b * d + (i - a1);
                        break;
                    case n:
                        c = a1 * e + (q - b);
                        break;
                    default:
                        c = b * d + a1;
                }
                h(r, c, [
                    b,
                    a1
                ]);
            }
            return r;
        };
        i.$FormationSwirl = function(r) {
            var y = r.$Cols, z = r.$Rows, C = r.$Assembly, x = r.mc, B = [], A = [], v = 0, c = 0, i = 0, s = y - 1, t = z - 1, u, q, w = 0;
            switch(C){
                case k:
                    c = s;
                    i = 0;
                    q = [
                        g,
                        a1,
                        f,
                        e
                    ];
                    break;
                case m:
                    c = 0;
                    i = t;
                    q = [
                        e,
                        f,
                        a1,
                        g
                    ];
                    break;
                case p:
                    c = s;
                    i = t;
                    q = [
                        f,
                        a1,
                        g,
                        e
                    ];
                    break;
                case o:
                    c = s;
                    i = t;
                    q = [
                        a1,
                        f,
                        e,
                        g
                    ];
                    break;
                case j:
                    c = 0;
                    i = 0;
                    q = [
                        g,
                        e,
                        f,
                        a1
                    ];
                    break;
                case l:
                    c = s;
                    i = 0;
                    q = [
                        a1,
                        g,
                        e,
                        f
                    ];
                    break;
                case n:
                    c = 0;
                    i = t;
                    q = [
                        f,
                        e,
                        g,
                        a1
                    ];
                    break;
                default:
                    c = 0;
                    i = 0;
                    q = [
                        e,
                        g,
                        a1,
                        f
                    ];
            }
            v = 0;
            while(v < x){
                u = i + "," + c;
                if (c >= 0 && c < y && i >= 0 && i < z && !A[u]) {
                    A[u] = d;
                    h(B, v++, [
                        i,
                        c
                    ]);
                } else switch(q[w++ % b.A(q)]){
                    case e:
                        c--;
                        break;
                    case g:
                        i--;
                        break;
                    case a1:
                        c++;
                        break;
                    case f:
                        i++;
                }
                switch(q[w % b.A(q)]){
                    case e:
                        c++;
                        break;
                    case g:
                        i++;
                        break;
                    case a1:
                        c--;
                        break;
                    case f:
                        i--;
                }
            }
            return B;
        };
        i.$FormationZigZag = function(q) {
            var x = q.$Cols, y = q.$Rows, A = q.$Assembly, w = q.mc, u = [], v = 0, c = 0, d = 0, r = x - 1, s = y - 1, z, i, t = 0;
            switch(A){
                case k:
                    c = r;
                    d = 0;
                    i = [
                        g,
                        a1,
                        f,
                        a1
                    ];
                    break;
                case m:
                    c = 0;
                    d = s;
                    i = [
                        e,
                        f,
                        a1,
                        f
                    ];
                    break;
                case p:
                    c = r;
                    d = s;
                    i = [
                        f,
                        a1,
                        g,
                        a1
                    ];
                    break;
                case o:
                    c = r;
                    d = s;
                    i = [
                        a1,
                        f,
                        e,
                        f
                    ];
                    break;
                case j:
                    c = 0;
                    d = 0;
                    i = [
                        g,
                        e,
                        f,
                        e
                    ];
                    break;
                case l:
                    c = r;
                    d = 0;
                    i = [
                        a1,
                        g,
                        e,
                        g
                    ];
                    break;
                case n:
                    c = 0;
                    d = s;
                    i = [
                        f,
                        e,
                        g,
                        e
                    ];
                    break;
                default:
                    c = 0;
                    d = 0;
                    i = [
                        e,
                        g,
                        a1,
                        g
                    ];
            }
            v = 0;
            while(v < w){
                z = d + "," + c;
                if (c >= 0 && c < x && d >= 0 && d < y && typeof u[z] == "undefined") {
                    h(u, v++, [
                        d,
                        c
                    ]);
                    switch(i[t % b.A(i)]){
                        case e:
                            c++;
                            break;
                        case g:
                            d++;
                            break;
                        case a1:
                            c--;
                            break;
                        case f:
                            d--;
                    }
                } else {
                    switch(i[t++ % b.A(i)]){
                        case e:
                            c--;
                            break;
                        case g:
                            d--;
                            break;
                        case a1:
                            c++;
                            break;
                        case f:
                            d++;
                    }
                    switch(i[t++ % b.A(i)]){
                        case e:
                            c++;
                            break;
                        case g:
                            d++;
                            break;
                        case a1:
                            c--;
                            break;
                        case f:
                            d--;
                    }
                }
            }
            return u;
        };
        i.$FormationStraightStairs = function(i) {
            var u = i.$Cols, v = i.$Rows, e = i.$Assembly, t = i.mc, r = [], s = 0, c = 0, d = 0, f = u - 1, g = v - 1, x = t - 1;
            switch(e){
                case k:
                case n:
                case p:
                case j:
                    var a1 = 0, b = 0;
                    break;
                case l:
                case m:
                case o:
                case q:
                    var a1 = f, b = 0;
                    break;
                default:
                    e = q;
                    var a1 = f, b = 0;
            }
            c = a1;
            d = b;
            while(s < t){
                if (A(e) || z(e)) h(r, x - s++, [
                    d,
                    c
                ]);
                else h(r, s++, [
                    d,
                    c
                ]);
                switch(e){
                    case k:
                    case n:
                        c--;
                        d++;
                        break;
                    case p:
                    case j:
                        c++;
                        d--;
                        break;
                    case l:
                    case m:
                        c--;
                        d--;
                        break;
                    case q:
                    case o:
                    default:
                        c++;
                        d++;
                }
                if (c < 0 || d < 0 || c > f || d > g) {
                    switch(e){
                        case k:
                        case n:
                            a1++;
                            break;
                        case l:
                        case m:
                        case p:
                        case j:
                            b++;
                            break;
                        case q:
                        case o:
                        default:
                            a1--;
                    }
                    if (a1 < 0 || b < 0 || a1 > f || b > g) {
                        switch(e){
                            case k:
                            case n:
                                a1 = f;
                                b++;
                                break;
                            case p:
                            case j:
                                b = g;
                                a1++;
                                break;
                            case l:
                            case m:
                                b = g;
                                a1--;
                                break;
                            case q:
                            case o:
                            default:
                                a1 = 0;
                                b++;
                        }
                        if (b > g) b = g;
                        else if (b < 0) b = 0;
                        else if (a1 > f) a1 = f;
                        else if (a1 < 0) a1 = 0;
                    }
                    d = b;
                    c = a1;
                }
            }
            return r;
        };
        i.$FormationRectangle = function(f) {
            var d = f.$Cols || 1, e = f.$Rows || 1, g = [], a1, b, i;
            i = c.$Round(c.j(d / 2, e / 2)) + 1;
            for(a1 = 0; a1 < d; a1++)for(b = 0; b < e; b++)h(g, i - c.j(a1 + 1, b + 1, d - a1, e - b), [
                b,
                a1
            ]);
            return g;
        };
        i.$FormationRandom = function(d) {
            for(var e = [], a1, b = 0; b < d.$Rows; b++)for(a1 = 0; a1 < d.$Cols; a1++)h(e, c.H(1e5 * c.dd()) % 13, [
                b,
                a1
            ]);
            return e;
        };
        i.$FormationCircle = function(d) {
            for(var e = d.$Cols || 1, f = d.$Rows || 1, g = [], a1, i = e / 2 - .5, j = f / 2 - .5, b = 0; b < e; b++)for(a1 = 0; a1 < f; a1++)h(g, c.$Round(c.xb(c.B(b - i, 2) + c.B(a1 - j, 2))), [
                a1,
                b
            ]);
            return g;
        };
        i.$FormationCross = function(d) {
            for(var e = d.$Cols || 1, f = d.$Rows || 1, g = [], a1, i = e / 2 - .5, j = f / 2 - .5, b = 0; b < e; b++)for(a1 = 0; a1 < f; a1++)h(g, c.$Round(c.j(c.P(b - i), c.P(a1 - j))), [
                a1,
                b
            ]);
            return g;
        };
        i.$FormationRectangleCross = function(f) {
            for(var g = f.$Cols || 1, i = f.$Rows || 1, j = [], a1, d = g / 2 - .5, e = i / 2 - .5, k = c.l(d, e) + 1, b = 0; b < g; b++)for(a1 = 0; a1 < i; a1++)h(j, c.$Round(k - c.l(d - c.P(b - d), e - c.P(a1 - e))) - 1, [
                a1,
                b
            ]);
            return j;
        };
    };
    i.$JssorSlideshowRunner$ = function(n, q, o, r, w, v) {
        var a1 = this, f, m, i, t = 0, s = r.$TransitionsOrder;
        function h(a1) {
            var c = {
                $Left: "x",
                $Top: "y",
                $Bottom: "m",
                $Right: "t",
                $Rotate: "r",
                $ScaleX: "sX",
                $ScaleY: "sY",
                $TranslateX: "tX",
                $TranslateY: "tY",
                $SkewX: "kX",
                $SkewY: "kY",
                $Opacity: "o",
                $ZIndex: "i",
                $Clip: "c"
            };
            b.f(a1, function(e, d) {
                var b = c[d];
                if (b) {
                    a1[b] = e;
                    delete a1[d];
                    b == "c" && h(e);
                }
            });
            if (a1.$Zoom) a1.sX = a1.sY = a1.$Zoom;
        }
        function j(f, e) {
            var a1 = {
                $Duration: 1,
                $Delay: 0,
                $Cols: 1,
                $Rows: 1,
                $Opacity: 0,
                $Zoom: 0,
                $Clip: 0,
                $Move: k,
                $SlideOut: k,
                $Reverse: k,
                $Formation: u.$FormationRandom,
                $Assembly: 1032,
                $ChessMode: {
                    $Column: 0,
                    $Row: 0
                },
                $Easing: g.$Linear,
                $Round: {},
                Ic: [],
                $During: {}
            };
            b.v(a1, f);
            if (a1.$Rows == 0) a1.$Rows = c.$Round(a1.$Cols * e);
            a1.$Easing = b.Ld(a1.$Easing);
            h(a1);
            h(a1.$Easing);
            h(a1.$During);
            h(a1.$Round);
            a1.mc = a1.$Cols * a1.$Rows;
            a1.Af = function(c, b) {
                c /= a1.$Cols;
                b /= a1.$Rows;
                var f = c + "x" + b;
                if (!a1.Ic[f]) {
                    a1.Ic[f] = {
                        w: c,
                        h: b
                    };
                    for(var d = 0; d < a1.$Cols; d++)for(var e = 0; e < a1.$Rows; e++)a1.Ic[f][e + "," + d] = {
                        y: e * b,
                        t: d * c + c,
                        m: e * b + b,
                        x: d * c
                    };
                }
                return a1.Ic[f];
            };
            if (a1.$Brother) {
                a1.$Brother = j(a1.$Brother, e);
                a1.$SlideOut = d;
            }
            return a1;
        }
        function p(s, g, a1, t, o, n) {
            var h, e, j = a1.$ChessMode.$Column || 0, m = a1.$ChessMode.$Row || 0, i = a1.Af(o, n), p = a1.$Formation(a1), r = a1.$SlideOut;
            g = b.ab(g);
            b.N(g, 1);
            b.Fb(g, "hidden");
            b.db(g, "absolute");
            v(g, 0, 0);
            !a1.$Reverse && p.reverse();
            var f = {
                x: a1.c & 1,
                t: a1.c & 2,
                y: a1.c & 4,
                m: a1.c & 8
            }, q = new l(0, 0);
            b.f(p, function(w, v) {
                if (r) v = b.A(p) - v - 1;
                var x = a1.$Delay * v;
                b.f(w, function(G) {
                    var J = G[0], I = G[1], O = J + "," + I, v = k, w = k, z = k;
                    if (j && I % 2) {
                        if (j & 3) v = !v;
                        if (j & 12) w = !w;
                        if (j & 16) z = !z;
                    }
                    if (m && J % 2) {
                        if (m & 3) v = !v;
                        if (m & 12) w = !w;
                        if (m & 16) z = !z;
                    }
                    var E = w ? f.m : f.y, B = w ? f.y : f.m, D = v ? f.t : f.x, C = v ? f.x : f.t, H = E || B || D || C, A = b.ab(g);
                    e = {
                        x: 0,
                        y: 0,
                        o: 1
                    };
                    h = b.v({}, e);
                    if (a1.o) e.o = 2 - a1.o;
                    var N = a1.$Cols * a1.$Rows > 1 || H;
                    if (a1.sX || a1.r) {
                        var M = d;
                        if (M) {
                            e.sX = e.sY = a1.sX ? a1.sX - 1 : 1;
                            h.sX = h.sY = 1;
                            var T = a1.r || 0;
                            e.r = T * 360 * (z ? -1 : 1);
                            h.r = 0;
                        }
                    }
                    if (N) {
                        var F = i[O];
                        if (H) {
                            var p = {}, y = a1.$ScaleClip || 1;
                            if (E && B) {
                                p.y = i.h / 2 * y;
                                p.m = -p.y;
                            } else if (E) p.m = -i.h * y;
                            else if (B) p.y = i.h * y;
                            if (D && C) {
                                p.x = i.w / 2 * y;
                                p.t = -p.x;
                            } else if (D) p.t = -i.w * y;
                            else if (C) p.x = i.w * y;
                            if (a1.$Move) {
                                var R = (p.x || 0) + (p.t || 0), S = (p.y || 0) + (p.m || 0);
                                e.x += R;
                                e.y += S;
                            }
                            h.c = F;
                            b.f(p, function(b, a1) {
                                p[a1] = F[a1] + b;
                            });
                            e.c = p;
                        } else b.kh(A, F);
                    }
                    var P = v ? 1 : -1, Q = w ? 1 : -1;
                    if (a1.x) e.x += o * a1.x * P;
                    if (a1.y) e.y += n * a1.y * Q;
                    var K = {
                        $Elmt: A,
                        $Easing: a1.$Easing,
                        $During: a1.$During,
                        $Round: a1.$Round,
                        $Move: a1.$Move,
                        Eb: o,
                        Gb: n,
                        le: c.$Round(a1.$Duration / 4),
                        $Reverse: !r
                    };
                    e = b.Zg(e, h);
                    var L = new l(t + x, a1.$Duration, K, A, h, e);
                    q.M(L);
                    s.Ef(A);
                });
            });
            q.L(-1);
            return q;
        }
        a1.Bf = function() {
            var a1 = 0, d = r.$Transitions, e = b.A(d);
            if (s) a1 = t++ % e;
            else a1 = c.G(c.dd() * e);
            d[a1] && (d[a1].Qb = a1);
            return d[a1];
        };
        a1.Ob = function() {
            n.Ob();
            m = e;
            i = e;
        };
        a1.Cf = function(v, y, w, x, s, k) {
            f = j(s, k);
            var h = x.Re, d = w.Re, e = h, g = d, r = f, b = f.$Brother || j({}, k);
            if (!f.$SlideOut) {
                e = d;
                g = h;
            }
            var l = b.$Shift || 0, u = c.l(l, 0), t = c.l(-l, 0);
            m = p(n, g, b, u, q, o);
            i = p(n, e, r, t, q, o);
            a1.Qb = v;
        };
        a1.of = function() {
            var a1 = e;
            if (i) {
                a1 = new l(0, 0);
                a1.M(i);
                a1.M(m);
                a1.ye = f;
            }
            return a1;
        };
    };
    var o = {
        qf: "data-scale",
        yb: "data-autocenter",
        Dd: "data-nofreeze",
        ze: "data-nodrag"
    }, q = new function() {
        var a1 = this;
        a1.Ac = function(c, a1, e, d) {
            (d || !b.g(c, a1)) && b.g(c, a1, e);
        };
        a1.Cc = function(a1) {
            var c = b.q(a1, o.yb);
            b.Uc(a1, c);
        };
    }, s = {
        uc: 1
    };
    i.$JssorBulletNavigator$ = function() {
        var a1 = this, E = b.W(a1, p), h, v, C, B, m, l = 0, g, r, n, z, A, i, k, u, t, x, j;
        function y(a1) {
            j[a1] && j[a1].Ye(a1 == l);
        }
        function w(b) {
            a1.k(s.uc, b * r);
        }
        a1.Sc = function(a1) {
            if (a1 != m) {
                var d = l, b = c.G(a1 / r);
                l = b;
                m = a1;
                y(d);
                y(b);
            }
        };
        a1.id = function(a1) {
            b.mb(h, !a1);
        };
        a1.nd = function(J) {
            b.$Destroy(j);
            m = f;
            a1.Ve();
            x = [];
            j = [];
            b.Rb(h);
            v = c.H(J / r);
            l = 0;
            var F = u + z, G = t + A, s = c.H(v / n) - 1;
            C = u + F * (!i ? s : n - 1);
            B = t + G * (i ? s : n - 1);
            b.K(h, C);
            b.J(h, B);
            for(var o = 0; o < v; o++){
                var H = b.Rd();
                b.bd(H, o + 1);
                var p = b.Ce(k, "numbertemplate", H, d);
                b.db(p, "absolute");
                var E = o % (s + 1), I = c.G(o / (s + 1)), y = g.Yb && !i ? s - E : E;
                b.U(p, (!i ? y : I) * F);
                b.V(p, (i ? y : I) * G);
                b.O(h, p);
                x[o] = p;
                g.$ActionMode & 1 && a1.a(p, "click", b.Z(e, w, o));
                g.$ActionMode & 2 && a1.a(p, "mouseenter", b.Z(e, w, o));
                j[o] = b.Lc(p);
            }
            q.Cc(h);
        };
        a1.F = function(d, c) {
            a1.$Elmt = h = b.$GetElement(d);
            a1.gd = g = b.v({
                $SpacingX: 10,
                $SpacingY: 10,
                $ActionMode: 1
            }, c);
            k = b.$FindChild(h, "prototype");
            u = b.K(k);
            t = b.J(k);
            b.ib(k, h);
            r = g.$Steps || 1;
            n = g.$Rows || 1;
            z = g.$SpacingX;
            A = g.$SpacingY;
            i = g.$Orientation & 2;
            g.$AutoCenter && q.Ac(h, o.yb, g.$AutoCenter);
        };
        a1.$Destroy = function() {
            b.$Destroy(j, E);
        };
        b.F(a1);
    };
    i.$JssorArrowNavigator$ = function() {
        var a1 = this, v = b.W(a1, p), f, c, g, l, r, k, h, m, j, i;
        function n(b) {
            a1.k(s.uc, b, d);
        }
        function u(a1) {
            b.mb(f, !a1);
            b.mb(c, !a1);
        }
        function t() {
            j.$Enable((g.$Loop || !l.lf(h)) && k > 1);
            i.$Enable((g.$Loop || !l.ef(h)) && k > 1);
        }
        a1.Sc = function(c, a1, b) {
            h = a1;
            !b && t();
        };
        a1.id = u;
        a1.nd = function(g) {
            k = g;
            h = 0;
            if (!r) {
                a1.a(f, "click", b.Z(e, n, -m));
                a1.a(c, "click", b.Z(e, n, m));
                j = b.Lc(f);
                i = b.Lc(c);
                b.g(f, o.Dd, 1);
                b.g(c, o.Dd, 1);
                r = d;
            }
        };
        a1.F = function(e, d, h, i) {
            a1.gd = g = b.v({
                $Steps: 1
            }, h);
            f = e;
            c = d;
            if (g.Yb) {
                f = d;
                c = e;
            }
            m = g.$Steps;
            l = i;
            if (g.$AutoCenter) {
                q.Ac(f, o.yb, g.$AutoCenter);
                q.Ac(c, o.yb, g.$AutoCenter);
            }
            q.Cc(f);
            q.Cc(c);
        };
        a1.$Destroy = function() {
            b.$Destroy(j, i, v);
        };
        b.F(a1);
    };
    i.$JssorThumbnailNavigator$ = function() {
        var i = this, E = b.W(i, p), h, B, a1, y, C, m, l = [], A, z, g, n, r, w, v, x, t, u;
        function D() {
            var c = this;
            b.W(c, p);
            var h, f, n, l;
            function o() {
                n.Ye(m == h);
            }
            function j(e) {
                if (e || !t.$LastDragSucceeded()) {
                    var c = g - h % g, a1 = t.Id((h + c) / g - 1), b = a1 * g + g - c;
                    if (a1 < 0) b += y % g;
                    if (a1 >= C) b -= y % g;
                    i.k(s.uc, b, k, d);
                }
            }
            c.Hd = o;
            c.F = function(g, i) {
                c.Qb = h = i;
                l = g.nh || g.ih || b.bc();
                c.Wc = f = b.Ce(u, "thumbnailtemplate", l, d);
                n = b.Lc(f);
                a1.$ActionMode & 1 && c.a(f, "click", b.Z(e, j, 0));
                a1.$ActionMode & 2 && c.a(f, "mouseenter", b.Z(e, j, 1));
            };
            b.F(c);
        }
        i.Sc = function(a1, e, d) {
            if (a1 != m) {
                var b = m;
                m = a1;
                b != -1 && l[b].Hd();
                l[a1] && l[a1].Hd();
            }
            !d && t.$PlayTo(t.Id(c.G(a1 / g)));
        };
        i.id = function(a1) {
            b.mb(h, !a1);
        };
        i.nd = function(I, J) {
            b.$Destroy(t, l);
            m = f;
            l = [];
            var K = b.ab(B);
            b.Rb(h);
            a1.Yb && b.g(h, "dir", "rtl");
            b.ph(h, b.jb(K));
            var i = b.$FindChild(h, "slides", d);
            y = I;
            C = c.H(y / g);
            m = -1;
            var e = a1.$Orientation & 1, s = w + (w + n) * (g - 1) * (1 - e), p = v + (v + r) * (g - 1) * e, E = (e ? c.l : c.j)(A, s), u = (e ? c.j : c.l)(z, p);
            x = c.H((A - n) / (w + n) * e + (z - r) / (v + r) * (1 - e));
            var G = s + (s + n) * (x - 1) * e, F = p + (p + r) * (x - 1) * (1 - e);
            E = c.j(E, G);
            u = c.j(u, F);
            b.K(i, E);
            b.J(i, u);
            b.Uc(i, 3);
            var o = [];
            b.f(J, function(k, f) {
                var h = new D(k, f), d = h.Wc, a1 = c.G(f / g), j = f % g;
                b.U(d, (w + n) * j * (1 - e));
                b.V(d, (v + r) * j * e);
                if (!o[a1]) {
                    o[a1] = b.bc();
                    b.O(i, o[a1]);
                }
                b.O(o[a1], d);
                l.push(h);
            });
            var H = b.v({
                $AutoPlay: 0,
                $NaviQuitDrag: k,
                $SlideWidth: s,
                $SlideHeight: p,
                $SlideSpacing: n * e + r * (1 - e),
                $MinDragOffsetToSlide: 12,
                $SlideDuration: 200,
                $PauseOnHover: 1,
                $Cols: x,
                $PlayOrientation: a1.$Orientation,
                $DragOrientation: a1.$NoDrag || a1.$DisableDrag ? 0 : a1.$Orientation
            }, a1);
            t = new j(h, H);
            q.Cc(h);
        };
        i.F = function(j, f, e) {
            h = j;
            i.gd = a1 = b.v({
                $SpacingX: 0,
                $SpacingY: 0,
                $Orientation: 1,
                $ActionMode: 1
            }, f);
            A = b.K(h);
            z = b.J(h);
            var c = b.$FindChild(h, "slides", d);
            u = b.$FindChild(c, "prototype");
            e = b.ab(e);
            b.pb(e, c);
            w = b.K(u);
            v = b.J(u);
            b.ib(u, c);
            b.db(c, "absolute");
            b.Fb(c, "hidden");
            g = a1.$Rows || 1;
            n = a1.$SpacingX;
            r = a1.$SpacingY;
            a1.$AutoCenter &= a1.$Orientation;
            a1.$AutoCenter && q.Ac(h, o.yb, a1.$AutoCenter);
            B = b.ab(h);
        };
        i.$Destroy = function() {
            b.$Destroy(t, l, E);
        };
        b.F(i);
    };
    function n(e, d, c) {
        var a1 = this;
        b.W(a1, p);
        l.call(a1, 0, c.$Idle);
        a1.qc = 0;
        a1.fd = c.$Idle;
    }
    n.pc = 21;
    n.Zb = 24;
    var t = i.$JssorCaptionSlideo$ = function() {
        var a1 = this, db = b.W(a1, p);
        l.call(a1, 0, 0);
        var f, j, B, C, w = new l(0, 0), L = [], u = [], F, q = 0;
        function H(c, f) {
            var a1 = L[c];
            if (a1 == e) {
                a1 = L[c] = {
                    ob: c,
                    Zc: [],
                    Te: []
                };
                var d = 0;
                !b.f(u, function(a1, b) {
                    d = b;
                    return a1.ob > c;
                }) && d++;
                u.splice(d, 0, a1);
            }
            return a1;
        }
        function Q(f, v) {
            var s = b.K(f), r = b.J(f), m = b.Ib(f), j = {
                x: m ? 0 : b.U(f),
                y: m ? 0 : b.V(f),
                cc: 0,
                Wb: 0,
                o: b.cb(f),
                i: b.N(f) || 0,
                r: 0,
                rX: 0,
                rY: 0,
                sX: 1,
                sY: 1,
                tX: 0,
                tY: 0,
                tZ: 0,
                kX: 0,
                kY: 0,
                ls: 0,
                lh: 1,
                so: 0,
                c: {
                    y: 0,
                    t: s,
                    m: r,
                    x: 0
                }
            }, a1, g;
            if (C) {
                var o = C[b.q(f, "c")];
                if (o) {
                    a1 = H(o.r, 0);
                    a1.sg = o.e || 0;
                }
            }
            var h = b.g(f, "data-to");
            if (h && m) {
                h = b.Ud(h);
                h = {
                    x: b.od(h[0]),
                    y: b.od(h[1])
                };
            }
            var u = {
                $Elmt: f,
                $OriginalWidth: s,
                $OriginalHeight: r,
                Nf: h,
                Lf: j.x,
                Of: j.y,
                Ib: m
            };
            b.f(v, function(e) {
                var m = b.v({
                    $Easing: b.Ld(e.e),
                    $During: e.dr,
                    Bd: e.p
                }, u), i = b.v(d, {}, e);
                b.Pd(i, [
                    "b",
                    "d",
                    "e",
                    "p",
                    "dr"
                ]);
                var h = new l(e.b, e.d, m, f, j, i);
                q = c.l(q, e.b + e.d);
                if (a1) {
                    if (!g) g = new l(e.b, 0);
                    g.M(h);
                } else {
                    var k = H(e.b, e.b + e.d);
                    k.Zc.push(h);
                }
                j = h.nf();
            });
            if (a1 && g) {
                g.uf();
                var i = g, n, k = g.yc(), p = g.vb(), t = c.l(p, a1.sg);
                if (a1.ob < p) {
                    if (a1.ob > k) {
                        i = new l(k, a1.ob - k);
                        i.M(g, d);
                    } else i = e;
                    n = new l(a1.ob, t - k, {
                        hc: t - a1.ob,
                        pf: d
                    });
                    n.M(g, d);
                }
                i && a1.Zc.push(i);
                n && a1.Te.push(n);
            }
            return j;
        }
        function N(d, c) {
            b.f(d, function(d) {
                var f = b.q(d, "play");
                if (c && f) {
                    var e = new t(d, j, {
                        xe: f
                    });
                    E.push(e);
                    a1.a(e, n.pc, I);
                    a1.a(e, n.Zb, G);
                } else {
                    N(b.jb(d).concat(b.xc(b.Hc(d, "data-tchd"))), c + 1);
                    var g = b.xc(b.Hc(d, "data-tsep"));
                    g.push(d);
                    b.f(g, function(c) {
                        var a1 = B[b.q(c, "t")];
                        a1 && Q(c, a1);
                    });
                }
            });
        }
        function cb(f, e, g) {
            var c = f.b - e;
            if (c) {
                var b = new l(e, c);
                b.M(w, d);
                b.$Shift(g);
                a1.M(b);
            }
            a1.qd(f.d);
            return c;
        }
        function bb(e) {
            var c = w.yc(), d = 0;
            b.f(e, function(e, f) {
                e = b.v({
                    d: 3e3
                }, e);
                cb(e, c, d);
                c = e.b;
                d += e.d;
                if (!f || e.t == 2) {
                    a1.qc = c;
                    a1.fd = c + e.d;
                }
            });
        }
        function A(i, d, e) {
            var f = b.A(d);
            if (f > 4) for(var j = c.H(f / 4), a1 = 0; a1 < j; a1++){
                var g = d.slice(a1 * 4, c.j(a1 * 4 + 4, f)), h = new l(g[0].ob, 0);
                A(h, g, e);
                i.M(h);
            }
            else b.f(d, function(a1) {
                b.f(e ? a1.Te : a1.Zc, function(a1) {
                    e && a1.qd(q - a1.vb());
                    i.M(a1);
                });
            });
        }
        var i, M, y = 0, g, x, S, R, z, E = [], O = [], r, D, m;
        function v(a1) {
            return a1 & 2 || a1 & 4 && b.ud().td;
        }
        function Z() {
            if (!z) {
                g & 8 && a1.a(h, "keydown", J);
                if (g & 32) {
                    a1.a(h, "mousedown", s);
                    a1.a(h, "touchstart", s);
                }
                z = d;
            }
        }
        function Y() {
            a1.T(h, "keydown", J);
            a1.T(h, "mousedown", s);
            a1.T(h, "touchstart", s);
            z = k;
        }
        function T(b) {
            if (!r || b) {
                r = d;
                a1.S();
                b && y && a1.L(0);
                a1.De(1);
                a1.Ff();
                Z();
                a1.k(n.pc, a1);
            }
        }
        function o() {
            if (!D && (r || a1.z())) {
                D = d;
                a1.S();
                a1.Be() > a1.qc && a1.L(a1.qc);
                a1.De(S || 1);
                a1.tc(0);
            }
        }
        function V() {
            !m && o();
        }
        function U(c) {
            var b = c;
            if (c < 0 && a1.z()) b = 1;
            if (b != y) {
                y = b;
                M && a1.k(n.Zb, a1, y);
            }
        }
        function J(a1) {
            g & 8 && b.Je(a1) == 27 && o();
        }
        function X(a1) {
            if (m && b.Fe(a1) !== e) {
                m = k;
                g & 16 && b.$Delay(V, 160);
            }
        }
        function s(a1) {
            g & 32 && !b.Ae(f, b.$EvtSrc(a1)) && o();
        }
        function W(a1) {
            if (!m) {
                m = d;
                if (i & 1) b.Ie(a1, f) && T();
            }
        }
        function ab(j) {
            var h = b.$EvtSrc(j), a1 = b.kb(h, e, e, "A"), c = a1 && (b.qe(a1) || a1 === f || b.Ae(f, a1));
            if (r && v(g)) !c && o();
            else if (v(i)) !c && T(d);
        }
        function I(b) {
            var c = b.wg(), a1 = O[c];
            a1 !== b && a1 && a1.vg();
            O[c] = b;
        }
        function G(b, c) {
            a1.k(n.Zb, b, c);
        }
        a1.wg = function() {
            return R || "";
        };
        a1.vg = o;
        a1.Qc = function() {
            U(1);
        };
        a1.Rc = function() {
            r = k;
            D = k;
            U(-1);
            !a1.z() && Y();
        };
        a1.zc = function() {
            !m && x && a1.Be() > a1.fd && o();
        };
        a1.F = function(m, k, e) {
            f = m;
            j = k;
            i = e.xe;
            F = e.cg;
            B = j.$Transitions;
            C = j.$Controls;
            N([
                f
            ], 0);
            A(w, u);
            if (i) {
                a1.M(w);
                F = d;
                x = b.q(f, "idle");
                g = b.q(f, "rollback");
                S = b.q(f, "speed", 1);
                R = b.hb(f, "group");
                (v(i) || v(g)) && a1.a(f, "click", ab);
                if ((i & 1 || x) && !b.ud().td) {
                    a1.a(f, "mouseenter", W);
                    a1.a(f, "mouseleave", X);
                }
                M = b.q(f, "pause");
            }
            var l = j.$Breaks || [], c = l[b.q(f, "b")] || [], h = {
                b: q,
                d: b.A(c) ? 0 : e.$Idle || x || 0
            };
            c = c.concat([
                h
            ]);
            bb(c);
            a1.vb();
            F && a1.qd(1e8);
            q = a1.vb();
            A(a1, u, d);
            a1.L(-1);
            a1.L(b.q(f, "initial") || 0);
        };
        a1.$Destroy = function() {
            b.$Destroy(db, E);
            a1.S();
            a1.L(-1);
        };
        b.F(a1);
    }, j = i.$JssorSlider$ = (i.module || {}).exports = function() {
        var a1 = this, Gc = b.W(a1, p), Ob = "data-jssor-slider", ic = "data-jssor-thumb", u, m, S, Cb, kb, jb, X, J, O, M, Zb, Cc, Hc = 1, Bc = 1, kc = 1, sc = 1, nc = {}, w, R, Mb, bc, Yb, wb, zb, yb, ab, H = [], Rb, r = -1, tc, q, I, G, P, ob, pb, E, N, lb, T, z, W, nb, Z = [], vc, xc, oc, t, vb, Hb, qb, eb, Y, Kb, Gb, Qb, Sb, F, Lb = 0, cb = 0, Q = Number.MAX_VALUE, K = Number.MIN_VALUE, C, mb, db, U = 1, Xb = 0, fb, y, Fb, Eb, L, Ab, Db, B, V, rb, A, Bb, cc = b.ud(), Vb = cc.td, x = [], D, hb, bb, Nb, hc, mc, ib;
        function Jb() {
            return !U && Y & 12;
        }
        function Ic() {
            return Xb || !U && Y & 3;
        }
        function Ib() {
            return !y && !Jb() && !A.$IsPlaying();
        }
        function Wc() {
            return !Ic() && Ib();
        }
        function jc() {
            return z || S;
        }
        function Pc() {
            return jc() & 2 ? pb : ob;
        }
        function lc(a1, c, d) {
            b.U(a1, c);
            b.V(a1, d);
        }
        function Fc(c, b) {
            var a1 = jc(), d = (ob * b + Lb) * (a1 & 1), e = (pb * b + Lb) * (a1 & 2) / 2;
            lc(c, d, e);
        }
        function dc(b, f) {
            if (y && !(C & 1)) {
                var e = b, d;
                if (b < K) {
                    e = K;
                    d = -1;
                }
                if (b > Q) {
                    e = Q;
                    d = 1;
                }
                if (d) {
                    var a1 = b - e;
                    if (f) {
                        a1 = c.Xf(a1) * 2 / c.u;
                        a1 = c.B(a1 * d, 1.6);
                    } else {
                        a1 = c.B(a1 * d, .625);
                        a1 = c.Oe(a1 * c.u / 2);
                    }
                    b = e + a1 * d;
                }
            }
            return b;
        }
        function qc(a1) {
            return dc(a1, d);
        }
        function Nc(a1) {
            return dc(a1);
        }
        function xb(a1, b) {
            if (!(C & 1)) {
                var c = a1 - Q + (b || 0), d = K - a1 + (b || 0);
                if (c > 0 && c > d) a1 = Q;
                else if (d > 0) a1 = K;
            }
            return a1;
        }
        function yc(a1) {
            return !(C & 1) && a1 - K < .0001;
        }
        function wc(a1) {
            return !(C & 1) && Q - a1 < .0001;
        }
        function sb(a1) {
            return !(C & 1) && (a1 - K < .0001 || Q - a1 < .0001);
        }
        function Tb(c, a1, d) {
            !ib && b.f(Z, function(b) {
                b.Sc(c, a1, d);
            });
        }
        function ec(b) {
            var a1 = b, d = sb(b);
            if (d) a1 = xb(a1);
            else {
                b = v(b);
                a1 = b;
            }
            a1 = c.G(a1);
            a1 = c.l(a1, 0);
            return a1;
        }
        function fd(a1) {
            x[r];
            Rb = r;
            r = a1;
            tc = x[r];
        }
        function zc() {
            z = 0;
            var b = B.z(), d = ec(b);
            Tb(d, b);
            if (sb(b) || b == c.G(b)) {
                if (t & 2 && (eb > 0 && d == q - 1 || eb < 0 && !d)) t = 0;
                fd(d);
                a1.k(j.$EVT_PARK, r, Rb);
            }
        }
        function pc(a1, b) {
            if (q && (!b || !A.$IsPlaying())) {
                A.S();
                realPosition = qc(a1);
                V.L(realPosition);
                zc();
            }
        }
        function ub(a1) {
            if (q) {
                a1 = xb(a1);
                a1 = v(a1);
                fb = k;
                _IsStandBy = k;
                y = k;
                pc(a1);
            } else Tb(0, 0);
        }
        function Zc() {
            var b = j.Ke || 0, a1 = mb;
            j.Ke |= a1;
            return W = a1 & ~b;
        }
        function Uc() {
            if (W) {
                j.Ke &= ~mb;
                W = 0;
            }
        }
        function Dc(c) {
            var a1 = b.bc();
            b.rb(a1, ab);
            c && b.Fb(a1, "hidden");
            return a1;
        }
        function v(b, a1) {
            a1 = a1 || q || 1;
            return (b % a1 + a1) % a1;
        }
        function fc(c, a1, b) {
            t & 8 && (t = 0);
            tb(c, Gb, a1, b);
        }
        function Ub() {
            b.f(Z, function(a1) {
                a1.id(a1.gd.$ChanceToShow <= U);
            });
        }
        function Mc(c) {
            if (!U && (b.Fe(c) || !b.Ie(c, u))) {
                U = 1;
                Ub();
                if (!y) {
                    Y & 12 && Jc();
                    x[r] && x[r].Bc();
                }
                a1.k(j.$EVT_MOUSE_LEAVE);
            }
        }
        function Lc() {
            if (U) {
                U = 0;
                Ub();
                y || !(Y & 12) || Kc();
            }
            a1.k(j.$EVT_MOUSE_ENTER);
        }
        function Wb(b, a1) {
            tb(b, a1, d);
        }
        function tb(g, h, l, p) {
            if (q && (!y || m.$NaviQuitDrag) && !Jb() && !isNaN(g)) {
                var e = B.z(), a1 = g;
                if (l) {
                    a1 = e + g;
                    if (C & 2) {
                        if (yc(e) && g < 0) a1 = Q;
                        if (wc(e) && g > 0) a1 = K;
                    }
                }
                if (!(C & 1)) {
                    if (p) a1 = v(a1);
                    else a1 = xb(a1, .5);
                }
                if (l && !sb(a1)) a1 = c.$Round(a1);
                var i = (a1 - e) % q;
                a1 = e + i;
                if (h == f) h = Gb;
                var b = c.P(i), j = 0;
                if (b) {
                    if (b < 1) b = c.B(b, .5);
                    if (b > 1) {
                        var o = Pc(), n = (S & 1 ? zb : yb) / o;
                        b = c.j(b, n * 1.5);
                    }
                    j = h * b;
                }
                ib = d;
                A.S();
                ib = k;
                A.se(e, a1, j);
            }
        }
        function Rc(e, h, n) {
            var l = this, i = {
                $Top: 2,
                $Right: 1,
                $Bottom: 2,
                $Left: 1
            }, m = {
                $Top: "top",
                $Right: "right",
                $Bottom: "bottom",
                $Left: "left"
            }, g, a1, f, j, k = {};
            l.$Elmt = e;
            l.$ScaleSize = function(q, p, t) {
                var l, s = q, r = p;
                if (!f) {
                    f = b.Ch(e);
                    g = e.parentNode;
                    j = {
                        $Scale: b.q(e, o.qf, 1),
                        $AutoCenter: b.q(e, o.yb)
                    };
                    b.f(m, function(c, a1) {
                        k[a1] = b.q(e, "data-scale-" + c, 1);
                    });
                    a1 = e;
                    if (h) {
                        a1 = b.ab(g, d);
                        b.rb(a1, {
                            $Top: 0,
                            $Left: 0
                        });
                        b.O(a1, e);
                        b.O(g, a1);
                    }
                }
                if (n) {
                    l = c.l(q, p);
                    if (h) {
                        if (t >= 0 && t < 1) {
                            var v = c.j(q, p);
                            l = c.j(l / v, 1 / (1 - t)) * v;
                        }
                    }
                } else s = r = l = c.B(O < M ? p : q, j.$Scale);
                l *= h && (l != 1 || b.He()) ? 1.001 : 1;
                h && (sc = l);
                b.we(a1, l);
                b.K(g, f.Eb * s);
                b.J(g, f.Gb * r);
                var u = b.ue() && b.Cd() < 9 ? l : 1, w = (s - u) * f.Eb / 2, x = (r - u) * f.Gb / 2;
                b.U(a1, w);
                b.V(a1, x);
                b.f(f, function(d, a1) {
                    if (i[a1] && d) {
                        var e = (i[a1] & 1) * c.B(q, k[a1]) * d + (i[a1] & 2) * c.B(p, k[a1]) * d / 2;
                        b.If[a1](g, e);
                    }
                });
                b.Uc(g, j.$AutoCenter);
            };
        }
        function dd() {
            var a1 = this;
            l.call(a1, 0, 0, {
                hc: q
            });
            b.f(x, function(b) {
                a1.zd(b);
                b.$Shift(F / E);
            });
        }
        function cd() {
            var a1 = this, b = Bb.$Elmt;
            l.call(a1, -1, 2, {
                $Easing: g.$Linear,
                Pc: {
                    Pb: Fc
                },
                hc: q,
                $Reverse: Hb
            }, b, {
                Pb: 1
            }, {
                Pb: -1
            });
            a1.Wc = b;
        }
        function ed() {
            var b = this;
            l.call(b, -100000000, 2e8);
            b.zc = function(e, b) {
                if (c.P(b - e) > 1e-5) {
                    var g = b, f = b;
                    if (c.G(b) != b && b > e && (C & 1 || b > cb)) f++;
                    var h = ec(f);
                    Tb(h, g, d);
                    a1.k(j.$EVT_POSITION_CHANGE, v(g), v(e), b, e);
                }
            };
        }
        function Tc(o, n) {
            var b = this, g, i, f, c, h;
            l.call(b, -100000000, 2e8, {});
            b.Qc = function() {
                fb = d;
                a1.k(j.$EVT_SWIPE_START, v(B.z()), V.z());
            };
            b.Rc = function() {
                fb = k;
                c = k;
                a1.k(j.$EVT_SWIPE_END, v(B.z()), V.z());
                !y && zc();
            };
            b.zc = function(e, b) {
                var a1 = b;
                if (c) a1 = h;
                else if (f) {
                    var d = b / f;
                    a1 = m.$SlideEasing(d) * (i - g) + g;
                }
                a1 = qc(a1);
                V.L(a1);
            };
            b.se = function(a1, c, h, e) {
                y = k;
                f = h || 1;
                g = a1;
                i = c;
                ib = d;
                V.L(a1);
                ib = k;
                b.L(0);
                b.tc(f, e);
            };
            b.Ng = function() {
                c = d;
                c && b.$Play(e, e, d);
            };
            b.Wg = function(a1) {
                h = a1;
            };
            V = new ed;
            V.M(o);
            Sb && V.M(n);
        }
        function Qc() {
            var c = this, a1 = Dc();
            b.N(a1, 0);
            c.$Elmt = a1;
            c.Ef = function(c) {
                b.O(a1, c);
                b.mb(a1);
            };
            c.Ob = function() {
                b.Fc(a1);
                b.Rb(a1);
            };
        }
        function bd(w, h) {
            var g = this, hb = b.W(g, p), z, H = 0, V, y, u, F, K, o, E = [], U, M, J, i, s, A, S;
            l.call(g, -N, N + 1, {
                hc: C & 1 ? q : f,
                $Reverse: Hb
            });
            function Q() {
                z && z.$Destroy();
                Xb -= H;
                H = 0;
                z = new kb.$Class(y, kb, {
                    $Idle: b.q(y, "idle", Kb),
                    cg: !t
                });
                z.$On(n.Zb, X);
            }
            function X(b, a1) {
                H += a1;
                Xb += a1;
                if (h == r) !H && g.Bc();
            }
            function P(p, s, n) {
                if (!M) {
                    M = d;
                    if (o && n) {
                        var q = b.q(o, "data-expand", 0) * 2, f = n.width, e = n.height, l = f, i = e;
                        if (f && e) {
                            if (F) {
                                if (F & 3 && (!(F & 4) || f > I || e > G)) {
                                    var m = k, r = I / G * e / f;
                                    if (F & 1) m = r > 1;
                                    else if (F & 2) m = r < 1;
                                    l = m ? f * G / e : I;
                                    i = m ? G : e * I / f;
                                }
                                b.K(o, l);
                                b.J(o, i);
                                b.V(o, (G - i) / 2);
                                b.U(o, (I - l) / 2);
                            }
                            b.we(o, c.l((l + q) / l, (i + q) / i));
                        }
                        b.db(o, "absolute");
                    }
                    a1.k(j.$EVT_LOAD_END, h);
                }
                s.Qe(k);
                p && p(g);
            }
            function W(f, b, c, e) {
                if (e == A && r == h && t && Ib() && !g.Oc()) {
                    var a1 = v(f);
                    D.Cf(a1, h, b, g, c, G / I);
                    rb.$Shift(a1 - rb.yc() - 1);
                    rb.L(a1);
                    b.Tg();
                    pc(a1, d);
                }
            }
            function Z(b) {
                if (b == A && r == h && Ib() && !g.Oc()) {
                    if (!i) {
                        var a1 = e;
                        if (D) {
                            if (D.Qb == h) a1 = D.of();
                            else D.Ob();
                        }
                        i = new ad(w, h, a1, z);
                        i.zg(s);
                    }
                    !i.$IsPlaying() && i.sd();
                }
            }
            function L(a1, d, k) {
                if (a1 == h) {
                    if (a1 != d) x[d] && x[d].Jd();
                    else !k && i && i.Ag();
                    s && s.$Enable();
                    A = b.Tb();
                    g.Vb(b.Z(e, Z, A));
                } else {
                    var j = c.j(h, a1), f = c.l(h, a1), n = c.j(f - j, j + q - f), l = N + m.$LazyLoading - 1;
                    (!J || n <= l) && g.Vb();
                }
            }
            function bb() {
                if (r == h && i) {
                    i.S();
                    s && s.$Quit();
                    s && s.$Disable();
                    i.he();
                }
            }
            function fb() {
                r == h && i && i.S();
            }
            function Y(b) {
                !db && a1.k(j.$EVT_CLICK, h, b);
            }
            g.Qe = function(a1) {
                if (S != a1) {
                    S = a1;
                    a1 && b.O(w, K);
                    !a1 && b.ib(K);
                }
            };
            g.Vb = function(f, c) {
                c = c || g;
                if (b.A(E) && !M) {
                    c.Qe(d);
                    if (!U) {
                        U = d;
                        a1.k(j.$EVT_LOAD_START, h);
                        b.f(E, function(a1) {
                            var c = b.g(a1, "data-load") || "src", d = !b.Qd(c, "data-") ? c.substring(5) : c;
                            if (!b.g(a1, d)) {
                                var e = b.hb(a1, d) || b.hb(a1, "src2");
                                if (e) {
                                    b.g(a1, d, e);
                                    b.nb(a1, b.g(a1, "data-display"));
                                }
                            }
                        });
                    }
                    b.Eh(E, o, b.Z(e, P, f, c));
                } else P(f, c);
            };
            g.Gg = function() {
                if (Wc()) {
                    if (q == 1) {
                        g.Jd();
                        L(h, h);
                    } else {
                        var a1;
                        if (D) a1 = D.Bf(q);
                        if (a1) {
                            A = b.Tb();
                            var c = h + eb, d = x[v(c)];
                            return d.Vb(b.Z(e, W, c, d, a1, A), g);
                        } else (C || !sb(B.z()) || !sb(B.z() + eb)) && Wb(eb);
                    }
                }
            };
            g.Bc = function() {
                L(h, h, d);
            };
            g.Jd = function() {
                s && s.$Quit();
                s && s.$Disable();
                g.Wd();
                i && i.Hg();
                i = e;
                Q();
            };
            g.Tg = function() {
                b.Fc(w);
            };
            g.Wd = function() {
                b.mb(w);
            };
            function T(a1, h) {
                if (!h) {
                    u = b.$FindChild(a1, "bg");
                    y = u && b.Lb(u);
                }
                if (!b.g(a1, Ob) && (h || !u)) {
                    var l = b.q(a1, "data-arr");
                    if (l != f) {
                        function k(d, c) {
                            b.g(d, c, b.g(a1, c));
                        }
                        var j = kb && kb.$Transitions || {};
                        b.Vf(a1, b.cb(a1), j[l], function(a1, c) {
                            b.g(a1, "data-t", b.A(j));
                            j.push(c);
                            k(a1, "data-to");
                            k(a1, "data-bf");
                            k(a1, "data-c");
                        });
                        b.g(a1, "data-arr", "");
                    }
                    var c = b.jb(a1);
                    if (!u) {
                        y = a1;
                        u = Dc(d);
                        b.g(u, "data-u", "bg");
                        var g = "background";
                        b.R(u, g + "Color", b.R(y, g + "Color"));
                        b.R(u, g + "Image", b.R(y, g + "Image"));
                        b.R(y, g, e);
                        b.A(c) ? b.pb(u, c[0]) : b.O(y, u);
                    }
                    c = c.concat(b.xc(b.Hc(a1, "data-tchd")));
                    b.f(c, function(c) {
                        if (h < 3 && !o) {
                            if (b.hb(c, "u") == "image") {
                                o = c;
                                o.border = 0;
                                b.rb(o, ab);
                                b.rb(a1, ab);
                                b.R(o, "maxWidth", "10000px");
                                b.O(u, o);
                            }
                        }
                        T(c, h + 1);
                    });
                    if (h) {
                        b.g(a1, "data-events", b.lc(a1));
                        b.g(a1, "data-display", b.nb(a1));
                        !b.Ib(a1) && b.ug(a1, b.g(a1, "data-to"));
                        b.tg(a1, b.g(a1, "data-bf"));
                        if (a1.tagName == "IMG") {
                            E.push(a1);
                            if (!b.g(a1, "src")) {
                                J = d;
                                b.Fc(a1);
                            }
                        }
                        var i = b.g(a1, "data-load");
                        i && E.push(a1) && (J = J || !b.Qd(i, "data-"));
                        var m = i && b.g(a1, i) || b.Jf(a1);
                        if (m) {
                            var n = new Image;
                            b.g(n, "data-src", m);
                            E.push(n);
                        }
                        b.N(a1, (b.N(a1) || 0) + 1);
                    }
                    b.yg(a1, b.q(a1, "data-p"));
                    b.xg(a1, b.hb(a1, "po"));
                    b.Jc(a1, b.g(a1, "data-ts"));
                }
            }
            g.kd = function(c, b) {
                var a1 = N - b;
                Fc(V, a1);
            };
            g.Qb = h;
            T(w, 0);
            b.rb(w, ab);
            b.Fb(w, "hidden");
            b.Jc(w, "flat");
            F = b.q(y, "data-fillmode", m.$FillMode);
            var O = b.$FindChild(y, "thumb", d);
            if (O) {
                g.nh = b.ab(O);
                b.Fc(O);
            }
            b.mb(w);
            K = b.ab(R);
            b.N(K, 1e3);
            g.a(w, "click", Y);
            Q();
            g.ih = o;
            g.Re = w;
            g.Wc = V = w;
            g.a(a1, 203, L);
            g.a(a1, 28, fb);
            g.a(a1, 24, bb);
            g.$Destroy = function() {
                b.$Destroy(hb, z, i);
            };
        }
        function ad(F, h, q, s) {
            var c = this, E = b.W(c, p), i = 0, u = 0, g, m, f, e, o, w, v, z = x[h];
            l.call(c, 0, 0);
            function B() {
                c.sd();
            }
            function C(a1) {
                v = a1;
                c.S();
                c.sd();
            }
            function A() {}
            c.sd = function() {
                if (!y && !fb && !v && r == h && !c.Oc()) {
                    var k = c.z();
                    if (!k) {
                        if (g && !o) {
                            o = d;
                            c.he(d);
                            a1.k(j.$EVT_SLIDESHOW_START, h, u, i, u, g, e);
                        }
                    }
                    a1.k(j.$EVT_STATE_CHANGE, h, k, i, m, f, e);
                    if (!Jb()) {
                        var l;
                        if (k == e) t && b.$Delay(z.Gg, 20);
                        else {
                            if (k == f) l = e;
                            else if (!k) l = f;
                            else l = c.Ee();
                            (k != f || !Ic()) && c.tc(l, B);
                        }
                    }
                }
            };
            c.Ag = function() {
                f == e && f == c.z() && c.L(m);
            };
            c.Hg = function() {
                D && D.Qb == h && D.Ob();
                var b = c.z();
                b < e && a1.k(j.$EVT_STATE_CHANGE, h, -b - 1, i, m, f, e);
            };
            c.he = function(a1) {
                q && b.Fb(T, a1 && q.ye.$Outside ? "" : "hidden");
            };
            c.kd = function(c, b) {
                if (o && b >= g) {
                    o = k;
                    z.Wd();
                    D.Ob();
                    a1.k(j.$EVT_SLIDESHOW_END, h, g, i, u, g, e);
                }
                a1.k(j.$EVT_PROGRESS_CHANGE, h, b, i, m, f, e);
            };
            c.zg = function(a1) {
                if (a1 && !w) {
                    w = a1;
                    a1.$On($JssorPlayer$.vf, C);
                }
            };
            c.a(s, n.pc, A);
            q && c.zd(q);
            g = c.vb();
            c.zd(s);
            m = g + s.qc;
            e = c.vb();
            f = t ? g + s.fd : e;
            c.$Destroy = function() {
                E.$Destroy();
                c.S();
            };
        }
        function rc() {
            Nb = fb;
            hc = A.Ee();
            bb = B.z();
            hb = Nc(bb);
        }
        function Kc() {
            rc();
            if (y || Jb()) {
                A.S();
                a1.k(j.kg);
            }
        }
        function Jc(f) {
            if (Ib()) {
                var b = B.z(), a1 = hb, e = 0;
                if (f && c.P(L) >= m.$MinDragOffsetToSlide) {
                    a1 = b;
                    e = Db;
                }
                a1 = c.H(a1);
                a1 = xb(a1 + e, .5);
                var d = c.P(a1 - b);
                if (d < 1 && m.$SlideEasing != g.$Linear) d = c.B(d, .5);
                if ((!db || !f) && Nb) A.tc(hc);
                else if (b == a1) tc.Bc();
                else A.se(b, a1, d * Gb);
            }
        }
        function gc(a1) {
            !b.kb(b.$EvtSrc(a1), f, o.ze) && b.$CancelEvent(a1);
        }
        function Ac(b) {
            Fb = k;
            y = d;
            Kc();
            if (!Nb) z = 0;
            a1.k(j.$EVT_DRAG_START, v(bb), bb, b);
        }
        function Yc(a1) {
            Ec(a1, 1);
        }
        function Ec(c, d) {
            L = 0;
            Ab = 0;
            Db = 0;
            kc = sc;
            if (d) {
                var i = c.touches[0];
                Eb = {
                    x: i.clientX,
                    y: i.clientY
                };
            } else Eb = b.Tc(c);
            var e = b.$EvtSrc(c), g = b.kb(e, "1", ic);
            if ((!g || g === u) && !W && (!d || b.A(c.touches) == 1)) {
                nb = b.kb(e, f, o.ze) || !mb || !Zc();
                a1.a(h, d ? "touchmove" : "mousemove", ac);
                Fb = !nb && b.kb(e, f, o.Dd);
                !Fb && !nb && Ac(c, d);
            }
        }
        function ac(a1) {
            var e, f;
            a1 = b.Zf(a1);
            if (a1.type != "mousemove") {
                if (b.A(a1.touches) == 1) {
                    f = a1.touches[0];
                    e = {
                        x: f.clientX,
                        y: f.clientY
                    };
                } else gb();
            } else e = b.Tc(a1);
            if (e) {
                var i = e.x - Eb.x, j = e.y - Eb.y, g = c.P(i), h = c.P(j);
                if (z || g > 1.5 || h > 1.5) {
                    if (Fb) Ac(a1, f);
                    else {
                        if (c.G(hb) != hb) z = z || S & W;
                        if ((i || j) && !z) {
                            if (W == 3) {
                                if (h > g) z = 2;
                                else z = 1;
                            } else z = W;
                            if (Vb && z == 1 && h > g * 2.4) nb = d;
                        }
                        var l = i, k = ob;
                        if (z == 2) {
                            l = j;
                            k = pb;
                        }
                        (L - Ab) * qb < -1.5 && (Db = 0);
                        (L - Ab) * qb > 1.5 && (Db = -1);
                        Ab = L;
                        L = l;
                        mc = hb - L * qb / k / kc * m.$DragRatio;
                        if (L && z && !nb) {
                            b.$CancelEvent(a1);
                            A.Ng(d);
                            A.Wg(mc);
                        }
                    }
                }
            }
        }
        function gb() {
            Uc();
            a1.T(h, "mousemove", ac);
            a1.T(h, "touchmove", ac);
            db = L;
            if (y) {
                db && t & 8 && (t = 0);
                A.S();
                y = k;
                var b = B.z();
                a1.k(j.$EVT_DRAG_END, v(b), b, v(bb), bb);
                Y & 12 && rc();
                Jc(d);
            }
        }
        function Oc(c) {
            var e = b.$EvtSrc(c), a1 = b.kb(e, "1", Ob);
            if (u === a1) {
                if (db) {
                    b.$StopEvent(c);
                    a1 = b.kb(e, f, "data-jssor-button", "A");
                    a1 && b.$CancelEvent(c);
                } else {
                    t & 4 && (t = 0);
                    a1 = b.kb(e, f, "data-jssor-click");
                    if (a1) {
                        b.$CancelEvent(c);
                        hitValues = (b.g(a1, "data-jssor-click") || "").split(":");
                        var g = b.Fh(hitValues[1]);
                        hitValues[0] == "to" && tb(g - 1);
                        hitValues[0] == "next" && tb(g, f, d);
                    }
                }
            }
        }
        a1.$SlidesCount = function() {
            return q;
        };
        a1.$CurrentIndex = function() {
            return r;
        };
        a1.$CurrentPosition = function() {
            return B.z();
        };
        a1.$Idle = function(a1) {
            if (a1 == f) return Kb;
            Kb = a1;
        };
        a1.$AutoPlay = function(a1) {
            if (a1 == f) return t;
            if (a1 != t) {
                t = a1;
                t && x[r] && x[r].Bc();
            }
        };
        a1.$IsDragging = function() {
            return y;
        };
        a1.$IsSliding = function() {
            return fb;
        };
        a1.$IsMouseOver = function() {
            return !U;
        };
        a1.$LastDragSucceeded = function() {
            return db;
        };
        a1.$OriginalWidth = function() {
            return O;
        };
        a1.$OriginalHeight = function() {
            return M;
        };
        a1.$ScaleHeight = function(b) {
            if (b == f) return Cc || M;
            a1.$ScaleSize(b / M * O, b);
        };
        a1.$ScaleWidth = function(b) {
            if (b == f) return Zb || O;
            a1.$ScaleSize(b, b / O * M);
        };
        a1.$ScaleSize = function(c, a1, d) {
            b.K(u, c);
            b.J(u, a1);
            Hc = c / O;
            Bc = a1 / M;
            b.f(nc, function(a1) {
                a1.$ScaleSize(Hc, Bc, d);
            });
            if (!Zb) {
                b.pb(T, w);
                b.V(T, 0);
                b.U(T, 0);
            }
            Zb = c;
            Cc = a1;
        };
        a1.lf = yc;
        a1.ef = wc;
        a1.$PlayTo = tb;
        a1.$GoTo = ub;
        a1.$Next = function() {
            Wb(1);
        };
        a1.$Prev = function() {
            Wb(-1);
        };
        a1.$Pause = function() {
            t = 0;
        };
        a1.$Play = function() {
            a1.$AutoPlay(t || 1);
        };
        a1.$SetSlideshowTransitions = function(a1) {
            m.$SlideshowOptions.$Transitions = a1;
        };
        a1.Id = function(a1) {
            a1 = v(a1);
            if (C & 1) {
                var d = F / E, b = v(B.z()), e = v(a1 - b + d), f = v(c.P(a1 - b));
                if (e >= N) {
                    if (f > q / 2) {
                        if (a1 > b) a1 -= q;
                        else a1 += q;
                    }
                } else if (a1 > b && e < d) a1 -= q;
                else if (a1 < b && e > d) a1 += q;
            }
            return a1;
        };
        function Xc() {
            cc.re && b.R(w, cc.re, [
                e,
                "pan-y",
                "pan-x",
                "auto"
            ][mb] || "");
            a1.a(u, "click", Oc, d);
            a1.a(u, "mouseleave", Mc);
            a1.a(u, "mouseenter", Lc);
            a1.a(u, "mousedown", Ec);
            a1.a(u, "touchstart", Yc);
            a1.a(u, "dragstart", gc);
            a1.a(u, "selectstart", gc);
            a1.a(i, "mouseup", gb);
            a1.a(h, "mouseup", gb);
            a1.a(h, "touchend", gb);
            a1.a(h, "touchcancel", gb);
            a1.a(i, "blur", gb);
            m.$ArrowKeyNavigation && a1.a(h, "keydown", function(c) {
                if (!b.qe(b.$EvtSrc(c))) {
                    var a1 = b.Je(c);
                    if (a1 == 37 || a1 == 39) {
                        t & 8 && (t = 0);
                        fc(m.$ArrowKeyNavigation * (a1 - 38) * qb, d);
                    }
                }
            });
        }
        function uc(d) {
            Gc.Ve();
            H = [];
            x = [];
            var e = b.jb(w), g = b.Fd([
                "DIV",
                "A",
                "LI"
            ]);
            b.f(e, function(a1) {
                var c = a1;
                if (g[a1.tagName.toUpperCase()] && !b.hb(a1, "u") && b.nb(a1) != "none") {
                    b.Jc(a1, "flat");
                    b.rb(a1, ab);
                    H.push(a1);
                }
                b.N(c, (b.N(c) || 0) + 1);
            });
            q = b.A(H);
            if (q) {
                var a1 = S & 1 ? zb : yb;
                b.rb(R, ab);
                F = m.$Align;
                if (F == f) F = (a1 - E + P) / 2;
                lb = a1 / E;
                N = c.j(q, m.$Cols || q, c.H(lb));
                C = N < q ? m.$Loop : 0;
                if (q * E - P <= a1) {
                    lb = q - P / E;
                    F = (a1 - E + P) / 2;
                    Lb = (a1 - E * q + P) / 2;
                }
                if (Cb) {
                    Qb = Cb.$Class;
                    Sb = !F && N == 1 && q > 1 && Qb && (!b.ue() || b.Cd() >= 9);
                }
                if (!(C & 1)) {
                    cb = F / E;
                    if (cb > q - 1) {
                        cb = q - 1;
                        F = cb * E;
                    }
                    K = cb;
                    Q = K + q - lb - P / E;
                }
                mb = (N > 1 || F ? S : -1) & m.$DragOrientation;
                if (Sb) D = new Qb(Bb, I, G, Cb, Vb, lc);
                b.f(H, function(a1, b) {
                    x.push(new bd(a1, b));
                });
                rb = new cd;
                B = new dd;
                A = new Tc(B, rb);
                Xc();
            }
            b.f(Z, function(a1) {
                a1.nd(q, x);
                d && a1.$On(s.uc, fc);
            });
        }
        function Pb(a1, d, g) {
            b.Md(a1) && (a1 = b.je("", a1));
            var c, e;
            if (q) {
                if (d == f) d = q;
                e = "beforebegin";
                c = H[d];
                if (!c) {
                    e = "afterend";
                    c = H[q - 1];
                }
            }
            b.$Destroy(x);
            a1 && b.oh(c || w, e || "afterbegin", a1);
            b.f(g, function(a1) {
                b.ib(a1);
            });
            uc();
        }
        a1.$AppendSlides = function(e, a1) {
            if (a1 == f) a1 = r + 1;
            var d = H[r];
            Pb(e, a1);
            var c = 0;
            b.f(H, function(a1, b) {
                a1 == d && (c = b);
            });
            ub(c);
        };
        a1.$ReloadSlides = function(a1) {
            Pb(a1, e, H);
            ub(0);
        };
        a1.$RemoveSlides = function(f) {
            var a1 = r, d = [];
            b.f(f, function(b) {
                if (b < q && b >= 0) {
                    d.push(H[b]);
                    b < r && a1--;
                }
            });
            Pb(e, e, d);
            a1 = c.j(a1, q - 1);
            ub(a1);
        };
        a1.F = function(i, e) {
            a1.$Elmt = u = b.$GetElement(i);
            O = b.K(u);
            M = b.J(u);
            m = b.v({
                $FillMode: 0,
                $LazyLoading: 1,
                $ArrowKeyNavigation: 1,
                $StartIndex: 0,
                $AutoPlay: 0,
                $Loop: 1,
                $HWA: d,
                $NaviQuitDrag: d,
                $AutoPlaySteps: 1,
                $Idle: 3e3,
                $PauseOnHover: 1,
                $SlideDuration: 500,
                $SlideEasing: g.$OutQuad,
                $MinDragOffsetToSlide: 20,
                $DragRatio: 1,
                $SlideSpacing: 0,
                $UISearchMode: 1,
                $PlayOrientation: 1,
                $DragOrientation: 1
            }, e);
            m.$HWA = m.$HWA && b.gg();
            if (m.$DisplayPieces != f) m.$Cols = m.$DisplayPieces;
            if (m.$ParkingPosition != f) m.$Align = m.$ParkingPosition;
            t = m.$AutoPlay & 63;
            m.$UISearchMode;
            eb = m.$AutoPlaySteps;
            Y = m.$PauseOnHover;
            Y &= Vb ? 10 : 5;
            Kb = m.$Idle;
            Gb = m.$SlideDuration;
            S = m.$PlayOrientation & 3;
            vb = b.mg(b.g(u, "dir")) == "rtl";
            Hb = vb && (S == 1 || m.$DragOrientation & 1);
            qb = Hb ? -1 : 1;
            Cb = m.$SlideshowOptions;
            kb = b.v({
                $Class: n
            }, m.$CaptionSliderOptions);
            jb = m.$BulletNavigatorOptions;
            X = m.$ArrowNavigatorOptions;
            J = m.$ThumbnailNavigatorOptions;
            var c = b.jb(u);
            b.f(c, function(a1, d) {
                var c = b.hb(a1, "u");
                if (c == "loading") R = a1;
                else {
                    if (c == "slides") {
                        w = a1;
                        b.R(w, "margin", 0);
                        b.R(w, "padding", 0);
                        b.Jc(w, "flat");
                    }
                    if (c == "navigator") Mb = a1;
                    if (c == "arrowleft") bc = a1;
                    if (c == "arrowright") Yb = a1;
                    if (c == "thumbnavigator") wb = a1;
                    if (a1.tagName != "STYLE" && a1.tagName != "SCRIPT") nc[c || d] = new Rc(a1, c == "slides", b.Fd([
                        "slides",
                        "thumbnavigator"
                    ])[c]);
                }
            });
            R && b.ib(R);
            R = R || b.bc(h);
            zb = b.K(w);
            yb = b.J(w);
            I = m.$SlideWidth || zb;
            G = m.$SlideHeight || yb;
            ab = {
                Eb: I,
                Gb: G,
                $Top: 0,
                $Left: 0,
                Me: "block",
                Pb: "absolute"
            };
            P = m.$SlideSpacing;
            ob = I + P;
            pb = G + P;
            E = S & 1 ? ob : pb;
            Bb = new Qc;
            b.g(u, Ob, "1");
            b.N(w, b.N(w) || 0);
            b.db(w, "absolute");
            T = b.ab(w, d);
            b.R(T, "pointerEvents", "none");
            b.pb(T, w);
            b.O(T, Bb.$Elmt);
            b.Fb(w, "hidden");
            if (Mb && jb) {
                jb.Yb = vb;
                vc = new jb.$Class(Mb, jb, O, M);
                Z.push(vc);
            }
            if (X && bc && Yb) {
                X.Yb = vb;
                X.$Loop = m.$Loop;
                xc = new X.$Class(bc, Yb, X, a1);
                Z.push(xc);
            }
            if (wb && J) {
                J.$StartIndex = m.$StartIndex;
                J.$ArrowKeyNavigation = J.$ArrowKeyNavigation || 0;
                J.Yb = vb;
                oc = new J.$Class(wb, J, R);
                !J.$NoDrag && b.g(wb, ic, "1");
                Z.push(oc);
            }
            uc(d);
            a1.$ScaleSize(O, M);
            Ub();
            ub(m.$StartIndex);
            b.R(u, "visibility", "visible");
        };
        a1.$Destroy = function() {
            t = 0;
            b.$Destroy(x, Z, Gc);
            b.Rb(u);
        };
        b.F(a1);
    };
    j.$EVT_CLICK = 21;
    j.$EVT_DRAG_START = 22;
    j.$EVT_DRAG_END = 23;
    j.$EVT_SWIPE_START = 24;
    j.$EVT_SWIPE_END = 25;
    j.$EVT_LOAD_START = 26;
    j.$EVT_LOAD_END = 27;
    j.kg = 28;
    j.$EVT_MOUSE_ENTER = 31;
    j.$EVT_MOUSE_LEAVE = 32;
    j.$EVT_POSITION_CHANGE = 202;
    j.$EVT_PARK = 203;
    j.$EVT_SLIDESHOW_START = 206;
    j.$EVT_SLIDESHOW_END = 207;
    j.$EVT_PROGRESS_CHANGE = 208;
    j.$EVT_STATE_CHANGE = 209;
}(window, document, Math, null, true, false);

},{}],"4XqhK":[function(require,module,exports) {
/*
 nanoGALLERY v5.1.1
 Plugin for jQuery by Christophe Brisbois
 Demo: http://nanogallery.brisbois.fr
 Sources: https://github.com/Kris-B/nanoGALLERY

 License: For personal, non-profit organizations, or open source projects, you may use nanoGALLERY for jQuery for free.
 -------- ALL OTHER USES REQUIRE THE PURCHASE OF A PROFESSIONAL LICENSE.


 Components:
  - jQuery (http://www.jquery.com)
  - jQuery Color plugin - is embedded
  - imagesloaded (https://github.com/desandro/imagesloaded) - is embebed
  - Transit (http://ricostacruz.com/jquery.transit) - optional
  - webfont generated by http://fontello.com - based on Font Awesome Copyright (C) 2012 by Dave Gandy (http://fortawesome.github.com/Font-Awesome/)
  - http://closure-compiler.appspot.com/home - minifying javascript
  - http://gpbmike.github.io/refresh-sf/ - minifying css
*/ (function(t) {
    jQuery.fn.nanoGallery = function(K) {
        var J = t.extend(!0, {
            userID: "",
            kind: "",
            album: "",
            photoset: "",
            blackList: "scrapbook|profil",
            whiteList: "",
            albumList: "",
            galleryToolbarWidthAligned: !0,
            galleryToolbarHideIcons: !1,
            galleryFullpageButton: !1,
            galleryFullpageBgColor: "#111",
            breadcrumbAutoHideTopLevel: !1,
            displayBreadcrumb: !1,
            theme: "default",
            colorScheme: "none",
            colorSchemeViewer: "default",
            items: null,
            itemsBaseURL: "",
            paginationMaxLinesPerPage: 0,
            maxWidth: 0,
            viewer: "internal",
            viewerDisplayLogo: !1,
            imageTransition: "slide",
            viewerToolbar: {
                position: "bottom",
                style: "innerImage",
                autoMinimize: 800
            },
            thumbnailAlignment: "center",
            thumbnailWidth: 230,
            thumbnailHeight: 154,
            thumbnailGutterWidth: 2,
            thumbnailGutterHeight: 2,
            thumbnailAdjustLastRowHeight: !0,
            thumbnailFeatured: !1,
            thumbnailHoverEffect: null,
            thumbnailLabel: {
                position: "overImageOnBottom",
                display: !0,
                displayDescription: !0,
                titleMaxLength: 0,
                descriptionMaxLength: 0,
                hideIcons: !1,
                title: "",
                itemsCount: ""
            },
            thumbnailDisplayInterval: 30,
            thumbnailDisplayTransition: !0,
            thumbnailLazyLoad: !1,
            thumbnailLazyLoadTreshold: 100,
            thumbnailGlobalImageTitle: "",
            thumbnailGlobalAlbumTitle: "",
            thumbnailSizeSM: 480,
            thumbnailSizeME: 992,
            thumbnailSizeLA: 1200,
            thumbnailSizeXL: 1800,
            fnThumbnailInit: null,
            fnThumbnailHoverInit: null,
            fnThumbnailHoverResize: null,
            fnThumbnailHover: null,
            fnThumbnailHoverOut: null,
            fnThumbnailDisplayEffect: null,
            fnViewerInfo: null,
            fnProcessData: null,
            touchAnimation: !0,
            touchAutoOpenDelay: 0,
            useTags: !1,
            preset: "none",
            locationHash: !1,
            slideshowDelay: 3E3,
            slideshowAutoStart: !1,
            photoSorting: "",
            albumSorting: "",
            dataSorting: "",
            lazyBuild: "none",
            lazyBuildTreshold: 150,
            flickrSkipOriginal: !0,
            i18n: {
                breadcrumbHome: "Galleries",
                breadcrumbHome_FR: "Galeries",
                paginationPrevious: "Previous",
                paginationPrevious_FR: "Pr&eacute;c&eacute;dent",
                paginationPrevious_DE: "Zur&uuml;ck",
                paginationPrevious_IT: "Indietro",
                paginationNext: "Next",
                paginationNext_FR: "Suivant",
                paginationNext_DE: "Weiter",
                paginationNext_IT: "Avanti",
                thumbnailLabelItemsCountPart1: "| ",
                thumbnailLabelItemsCountPart2: " photos",
                thumbnailLabelItemsCountPart2_DE: " Fotos",
                thumbnailImageTitle: "",
                thumbnailAlbumTitle: "",
                thumbnailImageDescription: "",
                thumbnailAlbumDescription: "",
                infoBoxPhoto: "Photo",
                infoBoxDate: "Date",
                infoBoxAlbum: "Album",
                infoBoxDimensions: "Dimensions",
                infoBoxFilename: "Filename",
                infoBoxFileSize: "File size",
                infoBoxCamera: "Camera",
                infoBoxFocalLength: "Focal length",
                infoBoxExposure: "Exposure",
                infoBoxFNumber: "F Number",
                infoBoxISO: "ISO",
                infoBoxMake: "Make",
                infoBoxFlash: "Flash",
                infoBoxViews: "Views",
                infoBoxComments: "Comments"
            }
        }, K);
        return this.each(function() {
            (new nanoGALLERY).Initiate(this, J);
        });
    };
})(jQuery);
function nanoGALLERY() {
    function t() {
        return {
            animationEngine: D,
            t: "test"
        };
    }
    function K(a) {
        for(var c = document.createElement("div"), b = 0; b < a.length; ++b)if ("undefined" != typeof c.style[a[b]]) return a[b];
        return null;
    }
    function J() {
        for(var a = Math.max(window.screen.width, window.screen.height), c = 0; c < B.length; c++)switch(B[c].name){
            case "imageScale150":
            case "imageScale150Outside":
            case "imageScaleIn80":
            case "imageSlide2Up":
            case "imageSlide2Down":
            case "imageSlide2Left":
            case "imageSlide2Right":
            case "imageSlide2UpRight":
            case "imageSlide2UpLeft":
            case "imageSlide2DownRight":
            case "imageSlide2DownLeft":
            case "imageSlide2Random":
                f.scale = Math.max(f.scale, 1.5);
                break;
            case "scale120":
                f.scale = Math.max(f.scale, 1.2);
        }
        "auto" == v() ? (ha = Math.ceil(m() * f.scale), L.thumbSizeDir = "width_") : "auto" == m() ? ha = Math.ceil(v() * f.scale) : m() > v() ? (ha = Math.ceil(m() * f.scale), L.thumbSizeDir = "width_") : ha = Math.ceil(v() * f.scale);
        switch(g.kind){
            case "":
                V(R.breadcrumbHome, "", "", "", "", "album", "", "0", "-1");
                0 < g.itemsBaseURL.length && (g.itemsBaseURL += "/");
                void 0 !== g.items && null !== g.items ? (Sb(), r(!1) || Y(0, !1)) : (a = jQuery(d.base).children("a"), 0 < a.length ? (Tb(a), r(!1) || Y(0, !1)) : W("error: no image to process."));
                break;
            case "flickr":
                g.flickrSkipOriginal || (L.photoAvailableSizes.push(1E4), L.photoAvailableSizesStr.push("o"));
                for(i = 0; i < L.photoAvailableSizes.length && !(L.photoSize = i, a <= L.photoAvailableSizes[i]); i++);
                V(R.breadcrumbHome, "", "", "", "", "album", "", 0 < g.photoset.length ? g.photoset : "0", "-1");
                xb(0, !0, -1, !1);
                break;
            case "smugmug":
                W("SMUGMUG IS NO MORE SUPPORTED BY NANOGALLERY.");
                for(i = 0; i < Q.photoAvailableSizes.length && !(Q.thumbSize = i, ha <= Q.photoAvailableSizes[i]); i++);
                for(i = 0; i < Q.photoAvailableSizes.length && !(Q.thumbSizeX2 = i, 2 * ha <= Q.photoAvailableSizes[i]); i++);
                for(i = 0; i < Q.photoAvailableSizes.length && !(Q.photoSize = i, a <= Q.photoAvailableSizes[i]); i++);
                V(R.breadcrumbHome, "", "", "", "", "album", "", "0", "-1");
                $a(0, !0, -1, !1);
                break;
            default:
                0 < g.album.length ? (c = g.album.indexOf("&authkey="), 0 <= c ? (a = g.album.substring(0, c), c = g.album.substring(c), -1 == c.indexOf("Gv1sRg") && (c = "&authkey=Gv1sRg" + c.substring(9)), V(R.breadcrumbHome, "", "", "", "", "album", "", a, "-1").customData.authkey = c) : V(R.breadcrumbHome, "", "", "", "", "album", "", g.album, "-1")) : V(R.breadcrumbHome, "", "", "", "", "album", "", "0", "-1"), yb(0, !0, -1, !1);
        }
        jQuery(document).keyup(function(b) {
            if (Z) switch(b.keyCode){
                case 27:
                    Aa(!0);
                    break;
                case 32:
                case 13:
                    ab();
                    break;
                case 38:
                case 39:
                case 33:
                    Ba();
                    break;
                case 40:
                case 37:
                case 34:
                    Ca();
            }
        });
        jQuery(window).bind("hashchange", function(b) {
            g.locationHash && r(!0);
        });
        g.galleryFullpageButton && (d.conNavBFullpage = jQuery('<div class="nanoGalleryFullpage setFullPageButton"></div>').appendTo(d.conNavB), d.conNavBFullpage.on("click", function(b) {
            d.conNavBFullpage.hasClass("setFullPageButton") ? (0 < g.maxWidth && jQuery(d.base).css({
                maxWidth: ""
            }), d.conNavBFullpage.removeClass("setFullPageButton").addClass("removeFullPageButton"), M("", d.base), d.base.addClass("fullpage"), jQuery("body").css({
                overflow: "hidden"
            })) : (d.conNavBFullpage.removeClass("removeFullPageButton").addClass("setFullPageButton"), 0 < g.maxWidth && jQuery(d.base).css({
                maxWidth: g.maxWidth
            }), d.base.removeClass("fullpage"), jQuery("body").css({
                overflow: "inherit"
            }));
            Ja();
        }));
    }
    function C(a) {
        function c() {
            Da = 0;
            S = la = null;
            jQuery(d.conTn[0]).css({
                left: 0
            });
            if (Z) aa = null, ma = !1;
            else if (null != aa) {
                if (10 < Math.abs(k.t - P().t)) aa = null, ma = !1;
                else {
                    var b = aa, a = b.data("index");
                    void 0 != a && (g.touchAnimation && !ma ? 0 < g.touchAutoOpenDelay ? (Ea(), bb(b), window.clearInterval(cb), cb = window.setInterval(function() {
                        window.clearInterval(cb);
                        10 < Math.abs(k.t - P().t) ? (ma = !1, aa = null, db(b)) : eb(a);
                    }, g.touchAutoOpenDelay)) : p[a].hovered ? eb(a) : (Ea(), bb(b)) : eb(a));
                }
            } else ma = !1;
        }
        function b(b) {
            var a = {};
            b.targetTouches ? (a.x = b.targetTouches[0].clientX, a.y = b.targetTouches[0].clientY) : (a.x = b.clientX, a.y = b.clientY);
            return a;
        }
        function e() {
            if (s) {
                if (0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H]) {
                    var b = Da - (la.x - S.x);
                    jQuery(l).css({
                        left: b
                    });
                }
                s = !1;
            }
        }
        var l = a, s = !1, la = null, S = null, Da = 0, h = !1, k = 0;
        this.handleGestureStartNoDelay = (function(b) {
            Z || 400 > (new Date).getTime() - fb || (ma = !0, this.handleGestureStart(b));
        }).bind(this);
        this.handleGestureStart = (function(a) {
            if (!(Z || 400 > (new Date).getTime() - fb)) {
                fb = (new Date).getTime();
                for(var c = a.target || a.srcElement, e = !1; c != d.conTn[0];)"nanoGalleryThumbnailContainer" == c.getAttribute("class") && (null == aa || aa.is(jQuery(c)) || Ea(), aa = jQuery(c), e = !0), c = c.parentNode;
                e && (k = P(), la = b(a), initialOffsetTop = P().t, window.navigator.msPointerEnabled ? (document.addEventListener("MSPointerMove", this.handleGestureMove, !0), document.addEventListener("MSPointerUp", this.handleGestureEnd, !0)) : (document.addEventListener("touchmove", this.handleGestureMove, !0), document.addEventListener("touchend", this.handleGestureEnd, !0), document.addEventListener("touchcancel", this.handleGestureEnd, !0), document.addEventListener("mousemove", this.handleGestureMove, !0), document.addEventListener("mouseup", this.handleGestureEnd, !0)), d.base.addClass("unselectable").find("*").attr("draggable", "false").attr("unselectable", "on"));
            }
        }).bind(this);
        this.handleGestureMove = (function(a) {
            S = b(a);
            !s && 0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H] && (15 < Math.abs(la.x - S.x) || h) && (a.preventDefault(), s = h = !0, window.requestAnimFrame(e));
        }).bind(this);
        this.handleGestureEnd = (function(b) {
            b.preventDefault();
            h = s = !1;
            window.navigator.msPointerEnabled ? (document.removeEventListener("MSPointerMove", this.handleGestureMove, !0), document.removeEventListener("MSPointerUp", this.handleGestureEnd, !0)) : (document.removeEventListener("touchmove", this.handleGestureMove, !0), document.removeEventListener("touchend", this.handleGestureEnd, !0), document.removeEventListener("touchcancel", this.handleGestureEnd, !0), document.removeEventListener("mousemove", this.handleGestureMove, !0), document.removeEventListener("mouseup", this.handleGestureEnd, !0));
            d.base.addClass("unselectable").find("*").attr("draggable", "true").attr("unselectable", "off");
            null == S || null == la ? c() : (b = la.x - S.x, Da -= b, 0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H] ? 30 < Math.abs(b) ? (aa = null, Da = 0, S = la = null, Ea(), -30 > b ? zb() : Ab()) : c() : c());
        }).bind(this);
        window.navigator.msPointerEnabled ? l.addEventListener("MSPointerDown", this.handleGestureStartNoDelay, !0) : (l.addEventListener("touchstart", this.handleGestureStart, !0), Ub || l.addEventListener("mousedown", this.handleGestureStartNoDelay, !0));
        l.addEventListener("mouseenter", X, !0);
        l.addEventListener("mouseleave", E, !0);
    }
    function X(a) {
        Z || (a = a.target || a.srcElement, "nanoGalleryThumbnailContainer" == a.getAttribute("class") && bb(jQuery(a)));
    }
    function E(a) {
        a = a.target || a.srcElement;
        "nanoGalleryThumbnailContainer" == a.getAttribute("class") && db(jQuery(a));
    }
    function q() {
        "fancybox" == g.viewer && "undefined" === typeof jQuery.fancybox && (g.viewer = "internal", ia("Fancybox could not be found. Fallback to internal viewer. Please check the file includes of the page."));
        if ("CBRISBOIS@GMAIL.COM" == g.userID.toUpperCase() || "111186676244625461692" == g.userID) {
            if ("" == g.blackList || "SCRAPBOOK|PROFIL" == g.blackList.toUpperCase()) g.blackList = "profil|scrapbook|forhomepage";
        }
        "" != g.blackList && (Ka = g.blackList.toUpperCase().split("|"));
        "" != g.whiteList && (La = g.whiteList.toUpperCase().split("|"));
        "" != g.albumList && (Fa = g.albumList.toUpperCase().split("|"));
        if ("picasa" == g.kind || "flickr" == g.kind || "smugmug" == g.kind) g.displayBreadcrumb = !0;
        void 0 !== g.photoset ? 0 < g.photoset.length && (g.displayBreadcrumb = !1) : g.photoset = "";
        void 0 !== g.album ? 0 < g.album.length && (g.displayBreadcrumb = !1) : g.album = "";
        void 0 !== g.gallery ? 0 < g.gallery.length && (g.displayBreadcrumb = !1) : g.gallery = "";
        0 < g.maxWidth && (jQuery(d.base).css({
            maxWidth: g.maxWidth
        }), jQuery(d.base).css({
            "margin-left": "auto"
        }), jQuery(d.base).css({
            "margin-right": "auto"
        }));
        "number" == T(g.slideshowDelay) && 2E3 <= g.slideshowDelay ? Ma = g.slideshowDelay : ia('Parameter "slideshowDelay" must be an integer >= 2000 ms.');
        "number" == T(g.thumbnailDisplayInterval) && 0 <= g.thumbnailDisplayInterval ? f.displayInterval = g.thumbnailDisplayInterval : ia('Parameter "thumbnailDisplayInterval" must be an integer.');
        "number" == T(g.thumbnailLazyLoadTreshold) && 0 <= g.thumbnailLazyLoadTreshold ? f.lazyLoadTreshold = g.thumbnailLazyLoadTreshold : ia('Parameter "thumbnailLazyLoadTreshold" must be an integer.');
        "number" == T(g.paginationMaxLinesPerPage) && 0 <= g.paginationMaxLinesPerPage ? U = g.paginationMaxLinesPerPage : ia('Parameter "paginationMaxLinesPerPage" must be an integer.');
        var a = g.albumSorting.toUpperCase();
        0 == a.indexOf("RANDOM") && 6 < a.length && (n = parseInt(a.substring(6)), 0 < n && (Na = n), g.albumSorting = "random");
        a = g.photoSorting.toUpperCase();
        0 == a.indexOf("RANDOM") && 6 < a.length && (n = parseInt(a.substring(6)), 0 < n && (Oa = n), g.photoSorting = "random");
        switch(T(g.thumbnailHoverEffect)){
            case "string":
                for(var c = g.thumbnailHoverEffect.split(","), a = 0; a < c.length; a++)if ("none" != c[a] && h(c[a])) {
                    var b = u();
                    b.name = c[a];
                    B.push(b);
                }
                break;
            case "object":
                "none" != g.thumbnailHoverEffect.name && h(g.thumbnailHoverEffect.name) && (b = u(), B.push(jQuery.extend(b, g.thumbnailHoverEffect)));
                break;
            case "array":
                for(a = 0; a < g.thumbnailHoverEffect.length; a++)"none" != g.thumbnailHoverEffect[a].name && h(g.thumbnailHoverEffect[a].name) && (b = u(), B.push(jQuery.extend(b, g.thumbnailHoverEffect[a])));
                break;
            case "null":
                break;
            default:
                W('incorrect parameter for "thumbnailHoverEffect".');
        }
        0 == B.length && (g.touchAnimation = !1);
        H = ba();
        if ("number" == T(g.thumbnailWidth)) k("width", "l1", g.thumbnailWidth, "u"), k("width", "lN", g.thumbnailWidth, "u");
        else {
            c = g.thumbnailWidth.split(" ");
            b = "auto";
            "auto" != c[0].substring(0, 4) && (b = parseInt(c[0]));
            var e = "u";
            "C" == c[0].charAt(c[0].length - 1) && (e = "c");
            k("width", "l1", b, e);
            k("width", "lN", b, e);
            for(a = 1; a < c.length; a++){
                var l = c[a].substring(0, 2).toLowerCase();
                if (/xs|sm|me|la|xl/i.test(l)) {
                    var s = c[a].substring(2), b = "auto";
                    "auto" != s.substring(0, 4) && (b = parseInt(s));
                    e = "u";
                    "C" == s.charAt(s.length - 1) && (e = "c");
                    f.settings.width.l1[l] = b;
                    f.settings.width.lN[l] = b;
                    f.settings.width.l1[l + "c"] = e;
                    f.settings.width.lN[l + "c"] = e;
                }
            }
        }
        if (void 0 != g.thumbnailL1Width) {
            if ("number" == T(g.thumbnailL1Width)) k("width", "l1", g.thumbnailL1Width, "u");
            else for(c = g.thumbnailL1Width.split(" "), b = "auto", "auto" != c[0].substring(0, 4) && (b = parseInt(c[0])), e = "u", "C" == c[0].charAt(c[0].length - 1) && (e = "c"), k("width", "l1", b, e), a = 1; a < c.length; a++)l = c[a].substring(0, 2).toLowerCase(), /xs|sm|me|la|xl/i.test(l) && (s = c[a].substring(2), b = "auto", "auto" != s.substring(0, 4) && (b = parseInt(s)), e = "u", "C" == s.charAt(s.length - 1) && (e = "c"), f.settings.width.l1[l] = b, f.settings.width.l1[l + "c"] = e);
        }
        if ("number" == T(g.thumbnailHeight)) k("height", "l1", g.thumbnailHeight, "u"), k("height", "lN", g.thumbnailHeight, "u");
        else for(c = g.thumbnailHeight.split(" "), b = "auto", "auto" != c[0].substring(0, 4) && (b = parseInt(c[0])), e = "u", "C" == c[0].charAt(c[0].length - 1) && (e = "c"), k("height", "l1", b, e), k("height", "lN", b, e), a = 1; a < c.length; a++)l = c[a].substring(0, 2).toLowerCase(), /xs|sm|me|la|xl/i.test(l) && (s = c[a].substring(2), b = "auto", "auto" != s.substring(0, 4) && (b = parseInt(s)), e = "u", "C" == s.charAt(s.length - 1) && (e = "c"), f.settings.height.l1[l] = b, f.settings.height.lN[l] = b, f.settings.height.l1[l + "c"] = e, f.settings.height.lN[l + "c"] = e);
        if (void 0 != g.thumbnailL1Height) {
            if ("number" == T(g.thumbnailL1Height)) k("height", "l1", g.thumbnailL1Height, "u");
            else for(c = g.thumbnailL1Height.split(" "), b = "auto", "auto" != c[0].substring(0, 4) && (b = parseInt(c[0])), e = "u", "C" == c[0].charAt(c[0].length - 1) && (e = "c"), k("height", "l1", b, e), a = 1; a < c.length; a++)l = c[a].substring(0, 2).toLowerCase(), /xs|sm|me|la|xl/i.test(l) && (s = c[a].substring(2), b = "auto", "auto" != s.substring(0, 4) && (b = parseInt(s)), e = "u", "C" == s.charAt(s.length - 1) && (e = "c"), f.settings.height.l1[l] = b, f.settings.height.l1[l + "c"] = e);
        }
    }
    function k(a, c, b, e) {
        f.settings[a][c].xs = b;
        f.settings[a][c].sm = b;
        f.settings[a][c].me = b;
        f.settings[a][c].la = b;
        f.settings[a][c].xl = b;
        f.settings[a][c].xsc = e;
        f.settings[a][c].smc = e;
        f.settings[a][c].mec = e;
        f.settings[a][c].lac = e;
        f.settings[a][c].xlc = e;
    }
    function m() {
        return f.settings.width[G][H];
    }
    function v() {
        return f.settings.height[G][H];
    }
    function I() {
        return f.outerWidth[G][H];
    }
    function ea() {
        return f.outerHeight[G][H];
    }
    function ba() {
        var a = P().w;
        return 0 < g.thumbnailSizeSM && a < g.thumbnailSizeSM ? "xs" : 0 < g.thumbnailSizeME && a < g.thumbnailSizeME ? "sm" : 0 < g.thumbnailSizeLA && a < g.thumbnailSizeLA ? "me" : 0 < g.thumbnailSizeXL && a < g.thumbnailSizeXL ? "la" : "xl";
    }
    function u() {
        var a = {
            delay: 0,
            delayBack: 0,
            duration: 400,
            durationBack: 200,
            easing: "swing",
            easingBack: "swing",
            animParam: null
        };
        "animate" != D && (a.easing = "ease", a.easingBack = "ease");
        return a;
    }
    function h(a) {
        var c = /labelOpacity50|borderLighter|borderDarker/i.test(a), b = /imageFlipVertical|imageFlipHorizontal|imageRotateCornerBR|imageRotateCornerBL|rotateCornerBL|rotateCornerBR|imageScale150|overScale|overScaleOutside|imageScaleIn80|imageScale150Outside|scale120|scaleLabelOverImage|slideUp|slideDown|slideLeft|slideRight|imageSlideUp|imageSlideDown|imageSlideLeft|imageSlideRight|labelAppear|labelAppear75|descriptionAppear|labelSlideDown|labelSlideUp|labelSlideUpTop|imageInvisible|imageOpacity50|descriptionSlideUp|labelSplitVert|labelSplit4|labelAppearSplitVert|labelAppearSplit4|imageSplitVert|imageSplit4/i.test(a), e = /imageExplode/i.test(a);
        g.touchAutoOpenDelay = parseInt(g.touchAutoOpenDelay);
        0 == g.touchAutoOpenDelay && (g.touchAutoOpenDelay = 1E3);
        return c || b || e ? "onBottom" != g.thumbnailLabel.position || /borderLighter|borderDarker|imageOpacity50|imageScale150|imageScaleIn80|imageSlide2Up|imageSlide2Down|imageSlide2Left|imageSlide2Right|imageSlide2Random|imageSlide2UpRight|imageSlide2UpLeft|imageSlide2DownRight|imageSlide2DownLeft|imageScale150Outside|scale120/i.test(a) ? !e || "animate" != D && null != O ? !0 : (ia('Parameter thumbnailHoverEffect="' + a + '" requires one of the additionals jQuery plugins "Velocity" or "Transit".'), !1) : (W('The parameter combination thumbnailHoverEffect="' + a + '" and thumbnailLabel.position="onBottom" is not supported.'), !1) : (W('Unknow parameter value: thumbnailHoverEffect="' + a + '".'), !1);
    }
    function z() {
        fa = (navigator.language || navigator.userLanguage).toUpperCase();
        "UNDEFINED" === fa && (fa = "");
        var a = -("_" + fa).length;
        "object" == T(g.i18n) && Object.keys(g.i18n).forEach(function(c) {
            var b = c.substr(a);
            b == "_" + fa ? R[c.substr(0, c.length - b.length)] = g.i18n[c] : R[c] = g.i18n[c];
        });
    }
    function r(a) {
        if (!g.locationHash) return !1;
        var c = null, b = null, c = "#nanogallery/" + ga + "/", e = location.hash;
        if (e != sa && ("" == e && -1 != gb && (sa = "", ta(0, !1, -1, !1)), 0 == e.indexOf(c))) {
            var l = e.substring(c.length), s = l.indexOf("/"), d = e = -1, S = p.length;
            if (0 < s) {
                for(c = l.substring(0, s), b = l.substring(s + 1), l = 0; l < S; l++)if ("image" == p[l].kind && p[l].GetID() == b) {
                    d = l;
                    break;
                }
            } else c = l;
            for(l = 0; l < S; l++)if ("album" == p[l].kind && p[l].GetID() == c) {
                e = l;
                break;
            }
            null !== b ? (a || (Pa = e), "" == g.kind ? ua(d) : -1 == d ? ta(e, !1, b, a) : ua(d)) : ta(e, !1, -1, a);
            return !0;
        }
    }
    function N() {
        p = [];
        var a = "";
        g.thumbnailLabel.displayDescription && (a = "d");
        a = V("dummydummydummy", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==", a, "", "image", "", "1", "0");
        a = Bb(a, 0, 0, !1);
        f.borderWidth = a.outerWidth(!0) - a.width();
        f.borderHeight = a.outerHeight(!0) - a.height();
        f.imgcBorderWidth = a.find(".imgContainer").outerWidth(!0) - a.find(".imgContainer").width();
        f.imgcBorderHeight = a.find(".imgContainer").outerHeight(!0) - a.find(".imgContainer").height();
        f.labelBorderHeight = a.find(".labelImage").outerHeight(!0) - a.find(".labelImage").height();
        f.labelBorderWidth = a.find(".labelImage").outerWidth(!0) - a.find(".labelImage").width();
        "onBottom" == g.thumbnailLabel.position && (f.labelHeight = a.find(".labelImage").outerHeight(!0));
        for(var c = [
            "xs",
            "sm",
            "me",
            "la",
            "xl"
        ], b = 0; b < c.length; b++){
            var e = f.settings.width.l1[c[b]];
            f.outerWidth.l1[c[b]] = "auto" != e ? e + f.borderWidth + f.imgcBorderWidth : 0;
            e = f.settings.width.lN[c[b]];
            f.outerWidth.lN[c[b]] = "auto" != e ? e + f.borderWidth + f.imgcBorderWidth : 0;
        }
        for(b = 0; b < c.length; b++)e = f.settings.height.l1[c[b]], f.outerHeight.l1[c[b]] = "auto" != e ? e + f.borderHeight + f.imgcBorderHeight : 0, e = f.settings.height.lN[c[b]], f.outerHeight.lN[c[b]] = "auto" != e ? e + f.borderHeight + f.imgcBorderHeight : 0;
        ja = hb();
        F.oldBorderColor = a.css("border-color");
        if ("" == F.oldBorderColor || null == F.oldBorderColor || void 0 == F.oldBorderColor) F.oldBorderColor = "#000";
        F.oldLabelOpacity = a.find(".labelImage").css("opacity");
        a = jQuery.Color(a.find(".labelImage"), "backgroundColor");
        F.oldLabelRed = a.red();
        F.oldLabelGreen = a.green();
        F.oldLabelBlue = a.blue();
        p = [];
    }
    function Ga(a, c) {
        var b = "";
        return "" != fa && void 0 !== a[c + "_" + fa] && 0 < a[c + "_" + fa].length ? b = a[c + "_" + fa] : b = a[c];
    }
    function ca(a) {
        return "%filename" == g.thumbnailLabel.title ? a.split("/").pop().replace("_", " ") : "%filenameNoExt" == g.thumbnailLabel.title ? a.split("/").pop().split(".").shift().replace("_", " ") : a;
    }
    function Sb() {
        var a = !1;
        "undefined" !== typeof g.dataSorting && ("random" == g.dataSorting ? g.items = na(g.items) : "reversed" == g.dataSorting && (g.items = g.items.reverse()));
        jQuery.each(g.items, function(b, c) {
            var e = "", e = Ga(c, "title");
            void 0 === e && (e = "");
            var l = g.itemsBaseURL + c.src, s = "", s = void 0 !== c.srct && 0 < c.srct.length ? g.itemsBaseURL + c.srct : l, d = "", d = void 0 !== c.srct2x && 0 < c.srct2x.length ? g.itemsBaseURL + c.srct2x : "" != s ? s : l;
            "" != g.thumbnailLabel.title && (e = ca(l));
            var f = "", f = Ga(c, "description");
            void 0 === f && (f = "");
            var h = "";
            void 0 !== c.destURL && 0 < c.destURL.length && (h = c.destURL);
            var p = Ga(c, "tags");
            void 0 === p && (p = "");
            var k = 0;
            void 0 !== c.albumID && (k = c.albumID, a = !0);
            var r = null;
            void 0 !== c.ID && (r = c.ID);
            var m = "image";
            void 0 !== c.kind && 0 < c.kind.length && (m = c.kind);
            e = V(e, s, l, f, h, m, p, r, k);
            e.thumbX2src = d;
            d = 0;
            void 0 !== c.thumbnailWidth && 0 < c.imgtWidth && (d = c.imgtWidth, e.thumbImgWidth = d);
            l = 0;
            void 0 !== c.thumbnailHeight && 0 < c.imgtHeigt && (l = c.imgtHeight, e.thumbImgHeight = l);
            e.thumbs = {
                url: {
                    l1: {
                        xs: s,
                        sm: s,
                        me: s,
                        la: s,
                        xl: s
                    },
                    lN: {
                        xs: s,
                        sm: s,
                        me: s,
                        la: s,
                        xl: s
                    }
                },
                width: {
                    l1: {
                        xs: d,
                        sm: d,
                        me: d,
                        la: d,
                        xl: d
                    },
                    lN: {
                        xs: d,
                        sm: d,
                        me: d,
                        la: d,
                        xl: d
                    }
                },
                height: {
                    l1: {
                        xs: l,
                        sm: l,
                        me: l,
                        la: l,
                        xl: l
                    },
                    lN: {
                        xs: l,
                        sm: l,
                        me: l,
                        la: l,
                        xl: l
                    }
                }
            };
            "function" == typeof g.fnProcessData && g.fnProcessData(e, "api", null);
        });
        a && (g.displayBreadcrumb = !0);
        for(var c = p.length, b = 0, e = 0, l = 0; l < c; l++){
            for(var s = e = b = 0; s < c; s++)l != s && p[l].GetID() == p[s].albumID && (b++, "image" == p[s].kind && (p[s].imageNumber = e++));
            p[l].contentLength = b;
        }
    }
    function Tb(a) {
        var c = !1;
        "undefined" !== typeof g.dataSorting && ("random" == g.dataSorting ? a = na(a) : "reversed" == g.dataSorting && (jQuery.fn.reverse = [].reverse, a = a.reverse()));
        jQuery.each(a, function(b, a) {
            var e = "";
            void 0 !== jQuery(a).attr("data-ngthumb") && 0 < jQuery(a).attr("data-ngthumb").length && (e = g.itemsBaseURL + jQuery(a).attr("data-ngthumb"));
            void 0 !== jQuery(a).attr("data-ngThumb") && 0 < jQuery(a).attr("data-ngThumb").length && (e = g.itemsBaseURL + jQuery(a).attr("data-ngThumb"));
            var l = "";
            void 0 !== jQuery(a).attr("data-ngthumb2x") && 0 < jQuery(a).attr("data-ngthumb2x").length && (l = g.itemsBaseURL + jQuery(a).attr("data-ngthumb2x"));
            void 0 !== jQuery(a).attr("data-ngThumb2x") && 0 < jQuery(a).attr("data-ngThumb2x").length && (l = g.itemsBaseURL + jQuery(a).attr("data-ngThumb2x"));
            src = g.itemsBaseURL + jQuery(a).attr("href");
            var s = "";
            void 0 !== jQuery(a).attr("data-ngdesc") && 0 < jQuery(a).attr("data-ngdesc").length && (s = jQuery(a).attr("data-ngdesc"));
            void 0 !== jQuery(a).attr("data-ngDesc") && 0 < jQuery(a).attr("data-ngDesc").length && (s = jQuery(a).attr("data-ngDesc"));
            var d = "";
            void 0 !== jQuery(a).attr("data-ngdest") && 0 < jQuery(a).attr("data-ngdest").length && (d = jQuery(a).attr("data-ngdest"));
            void 0 !== jQuery(a).attr("data-ngDest") && 0 < jQuery(a).attr("data-ngDest").length && (d = jQuery(a).attr("data-ngDest"));
            var f = 0;
            void 0 !== jQuery(a).attr("data-ngalbumid") && (f = jQuery(a).attr("data-ngalbumid"), c = !0);
            void 0 !== jQuery(a).attr("data-ngAlbumID") && (f = jQuery(a).attr("data-ngAlbumID"), c = !0);
            var h = null;
            void 0 !== jQuery(a).attr("data-ngid") && (h = jQuery(a).attr("data-ngid"));
            void 0 !== jQuery(a).attr("data-ngID") && (h = jQuery(a).attr("data-ngID"));
            var p = "image";
            void 0 !== jQuery(a).attr("data-ngkind") && 0 < jQuery(a).attr("data-ngkind").length && (p = jQuery(a).attr("data-ngkind"));
            void 0 !== jQuery(a).attr("data-ngKind") && 0 < jQuery(a).attr("data-ngKind").length && (p = jQuery(a).attr("data-ngKind"));
            var k = jQuery(a).text();
            "" != g.thumbnailLabel.title && void 0 != g.thumbnailLabel.title && (k = ca(src));
            s = V(k, e, src, s, d, p, "", h, f);
            s.thumbX2src = l;
            l = 0;
            void 0 !== jQuery(a).attr("data-ngthumbImgWidth") && 0 < jQuery(a).attr("data-ngthumbImgWidth").length && (l = jQuery(a).attr("data-ngthumbImgWidth"), s.thumbImgWidth = l);
            d = 0;
            void 0 !== jQuery(a).attr("data-ngthumbImgHeight") && 0 < jQuery(a).attr("data-ngthumbImgHeight").length && (d = jQuery(a).attr("data-ngthumbImgHeight"), s.thumbImgHeight = d);
            s.thumbs = {
                url: {
                    l1: {
                        xs: e,
                        sm: e,
                        me: e,
                        la: e,
                        xl: e
                    },
                    lN: {
                        xs: e,
                        sm: e,
                        me: e,
                        la: e,
                        xl: e
                    }
                },
                width: {
                    l1: {
                        xs: l,
                        sm: l,
                        me: l,
                        la: l,
                        xl: l
                    },
                    lN: {
                        xs: l,
                        sm: l,
                        me: l,
                        la: l,
                        xl: l
                    }
                },
                height: {
                    l1: {
                        xs: d,
                        sm: d,
                        me: d,
                        la: d,
                        xl: d
                    },
                    lN: {
                        xs: d,
                        sm: d,
                        me: d,
                        la: d,
                        xl: d
                    }
                }
            };
            "function" == typeof g.fnProcessData && g.fnProcessData(s, "markup", null);
        });
        jQuery.each(a, function(a, b) {
            jQuery(b).remove();
        });
        c && (g.displayBreadcrumb = !0);
        a = p.length;
        for(var b = 0, e = 0, l = 0; l < a; l++){
            for(var s = e = b = 0; s < a; s++)l != s && p[l].GetID() == p[s].albumID && (b++, "image" == p[s].kind && (p[s].imageNumber = e++));
            p[l].contentLength = b;
        }
    }
    function xb(a, c, b, e) {
        Qa(a);
        if (p[a].contentIsLoaded) Y(a, e);
        else {
            var l = "", s = "album";
            0 == p[a].GetID() ? l = L.url() + "?&method=flickr.photosets.getList&api_key=" + L.ApiKey + "&user_id=" + g.userID + "&per_page=500&primary_photo_extras=url_o,url_sq,url_t,url_q,url_s,url_m,url_z,url_b,url_h,url_k&format=json&jsoncallback=?" : (l = "none" == p[a].GetID() ? L.url() + "?&method=flickr.people.getPublicPhotos&api_key=" + L.ApiKey + "&user_id=" + g.userID + "&extras=description,views,url_o,url_sq,url_t,url_q,url_s,url_m,url_z,url_b,url_h,url_k&per_page=500&format=json&jsoncallback=?" : L.url() + "?&method=flickr.photosets.getPhotos&api_key=" + L.ApiKey + "&photoset_id=" + p[a].GetID() + "&extras=description,views,url_o,url_sq,url_t,url_q,url_s,url_m,url_z,url_b,url_h,url_k&format=json&jsoncallback=?", s = "image");
            ib();
            jQuery.ajaxSetup({
                cache: !1
            });
            jQuery.support.cors = !0;
            jQuery.getJSON(l, function(l) {
                oa();
                "album" == s ? Vb(a, l) : Wb(a, l);
                if (c) r(!1) || Y(a, e);
                else if (-1 != b) {
                    l = -1;
                    for(var d = p.length, g = 0; g < d; g++)if ("image" == p[g].kind && p[g].GetID() == b) {
                        l = g;
                        break;
                    }
                    ua(l, !0);
                } else Y(a, e);
            }).fail(function(b, a, c) {
                oa();
                W("Could not retrieve Flickr photoset list (jQuery): " + (a + ", " + c));
            });
        }
    }
    function Vb(a, c) {
        var b = !0;
        void 0 !== c.stat && "fail" === c.stat && (W("Could not retrieve Flickr photoset list: " + c.message + " (code: " + c.code + ")."), b = !1);
        if (b) {
            var e = 0, b = c.photosets.photoset;
            switch(g.albumSorting){
                case "random":
                    b = na(b);
                    break;
                case "reversed":
                    b = b.reverse();
                    break;
                case "titleAsc":
                    b.sort(function(a, b) {
                        var c = a.title._content.toUpperCase(), e = b.title._content.toUpperCase();
                        return c < e ? -1 : c > e ? 1 : 0;
                    });
                    break;
                case "titleDesc":
                    b.sort(function(a, b) {
                        var c = a.title._content.toUpperCase(), e = b.title._content.toUpperCase();
                        return c > e ? -1 : c < e ? 1 : 0;
                    });
            }
            jQuery.each(b, function(b, c) {
                itemTitle = c.title._content;
                if (jb(itemTitle, c.id)) {
                    itemID = c.id;
                    itemDescription = "";
                    void 0 != c.description._content && (itemDescription = c.description._content);
                    var d = 0;
                    for(b = 0; b < L.thumbAvailableSizes.length; b++){
                        var g = c.primary_photo_extras[L.thumbSizeDir + L.photoAvailableSizesStr[b]];
                        if (void 0 != g && (d = b, g > ha)) break;
                    }
                    var d = c.primary_photo_extras["url_" + L.photoAvailableSizesStr[d]], g = {}, f;
                    for(f in c.primary_photo_extras)g[f] = c.primary_photo_extras[f];
                    tags = "";
                    void 0 !== c.primary_photo_extras && void 0 !== c.primary_photo_extras.tags && (tags = c.primary_photo_extras.tags);
                    f = V(itemTitle, "", "", itemDescription, "", "album", tags, itemID, p[a].GetID());
                    f.contentLength = c.photos;
                    f.thumbX2src = d;
                    f.thumbSizes = g;
                    d = {
                        url: {
                            l1: {
                                xs: "",
                                sm: "",
                                me: "",
                                la: "",
                                xl: ""
                            },
                            lN: {
                                xs: "",
                                sm: "",
                                me: "",
                                la: "",
                                xl: ""
                            }
                        },
                        width: {
                            l1: {
                                xs: 0,
                                sm: 0,
                                me: 0,
                                la: 0,
                                xl: 0
                            },
                            lN: {
                                xs: 0,
                                sm: 0,
                                me: 0,
                                la: 0,
                                xl: 0
                            }
                        },
                        height: {
                            l1: {
                                xs: 0,
                                sm: 0,
                                me: 0,
                                la: 0,
                                xl: 0
                            },
                            lN: {
                                xs: 0,
                                sm: 0,
                                me: 0,
                                la: 0,
                                xl: 0
                            }
                        }
                    };
                    d = Ra(d, c.primary_photo_extras, "l1");
                    d = Ra(d, c.primary_photo_extras, "lN");
                    f.thumbs = d;
                    e++;
                    if (e >= Na) return !1;
                }
            });
            p[a].contentIsLoaded = !0;
            p[a].contentLength = e;
        }
    }
    function Ra(a, c, b) {
        for(var e = [
            "xs",
            "sm",
            "me",
            "la",
            "xl"
        ], l = 0; l < e.length; l++){
            if ("auto" == f.settings.width[b][e[l]]) var s = "height_", d = Math.ceil(f.settings.height[b][e[l]] * f.scale);
            else "auto" == f.settings.height[b][e[l]] ? (s = "width_", d = Math.ceil(f.settings.width[b][e[l]] * f.scale)) : (s = "height_", d = Math.ceil(f.settings.height[b][e[l]] * f.scale), f.settings.width[b][e[l]] > f.settings.height[b][e[l]] && (s = "width_", d = Math.ceil(f.settings.width[b][e[l]] * f.scale)));
            s = Xb(s, d, c);
            a.url[b][e[l]] = s.url;
            a.width[b][e[l]] = s.width;
            a.height[b][e[l]] = s.height;
        }
        return a;
    }
    function Xb(a, c, b) {
        for(var e = {
            url: "",
            width: 0,
            height: 0
        }, l = 0, d = 0; d < L.thumbAvailableSizes.length; d++){
            var g = b[a + L.photoAvailableSizesStr[d]];
            if (void 0 != g && (l = d, g >= c)) break;
        }
        a = L.photoAvailableSizesStr[l];
        e.url = b["url_" + a];
        e.width = parseInt(b["width_" + a]);
        e.height = parseInt(b["height_" + a]);
        return e;
    }
    function Wb(a, c) {
        var b = "", b = "none" == p[a].GetID() ? c.photos.photo : c.photoset.photo;
        switch(g.photoSorting){
            case "random":
                b = na(b);
                break;
            case "reversed":
                b = b.reverse();
                break;
            case "titleAsc":
                b.sort(function(b, a) {
                    var c = b.title.toUpperCase(), e = a.title.toUpperCase();
                    return c < e ? -1 : c > e ? 1 : 0;
                });
                break;
            case "titleDesc":
                b.sort(function(b, a) {
                    var c = b.title.toUpperCase(), e = a.title.toUpperCase();
                    return c > e ? -1 : c < e ? 1 : 0;
                });
        }
        var e = p[a].GetID(), l = 0;
        jQuery.each(b, function(b, a) {
            var c = a.title, d = a.id, f = a.description._content, h = 0;
            for(b = 0; b < L.thumbAvailableSizes.length; b++){
                var p = a[L.thumbSizeDir + L.photoAvailableSizesStr[b]];
                if (void 0 != p && (h = b, p > ha)) break;
            }
            h = a["url_" + L.photoAvailableSizesStr[h]];
            p = a.url_sq;
            for(b = L.photoSize; 0 <= b; b--)if (void 0 != a["url_" + L.photoAvailableSizesStr[b]]) {
                p = a["url_" + L.photoAvailableSizesStr[b]];
                break;
            }
            for(var k in a)0 == k.indexOf("height_") || 0 == k.indexOf("width_") || k.indexOf("url_");
            "" != g.thumbnailLabel.title && (c = ca(p));
            c = V(c, "", p, f, "", "image", "", d, e);
            c.imageNumber = l;
            void 0 !== a.url_o ? (c.width = a.width_o, c.height = a.height_o) : (c.width = a.width_z, c.height = a.height_z);
            c.thumbX2src = h;
            d = {
                url: {
                    l1: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    },
                    lN: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    }
                },
                width: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                },
                height: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                }
            };
            d = Ra(d, a, "l1");
            d = Ra(d, a, "lN");
            c.thumbs = d;
            l++;
            if (l >= Oa) return !1;
        });
        p[a].contentIsLoaded = !0;
        p[a].contentLength = l;
    }
    function da(a, c, b, e, l) {
        var d = Math.ceil(b * f.scale) + l;
        "auto" == c ? d = Math.ceil(b * f.scale) + l : "auto" == b ? d = Math.ceil(c * f.scale) + e : c > b && (d = Math.ceil(c * f.scale) + e);
        0 < a.length && (a += ",");
        return a + d;
    }
    function yb(a, c, b, e) {
        Qa(a);
        if (p[a].contentIsLoaded) Y(a, e);
        else {
            var l = "", d = "album", l = da("", f.settings.width.l1.xs, f.settings.height.l1.xs, f.settings.width.l1.xsc, f.settings.height.l1.xsc), l = da(l, f.settings.width.l1.sm, f.settings.height.l1.sm, f.settings.width.l1.smc, f.settings.height.l1.smc), l = da(l, f.settings.width.l1.me, f.settings.height.l1.me, f.settings.width.l1.mec, f.settings.height.l1.mec), l = da(l, f.settings.width.l1.la, f.settings.height.l1.la, f.settings.width.l1.lac, f.settings.height.l1.lac), l = da(l, f.settings.width.l1.xl, f.settings.height.l1.xl, f.settings.width.l1.xlc, f.settings.height.l1.xlc), l = da(l, f.settings.width.lN.xs, f.settings.height.lN.xs, f.settings.width.lN.xsc, f.settings.height.lN.xsc), l = da(l, f.settings.width.lN.sm, f.settings.height.lN.sm, f.settings.width.lN.smc, f.settings.height.lN.smc), l = da(l, f.settings.width.lN.me, f.settings.height.lN.me, f.settings.width.lN.mec, f.settings.height.lN.mec), l = da(l, f.settings.width.lN.la, f.settings.height.lN.la, f.settings.width.lN.lac, f.settings.height.lN.lac), l = da(l, f.settings.width.lN.xl, f.settings.height.lN.xl, f.settings.width.lN.xlc, f.settings.height.lN.xlc);
            if (0 == p[a].GetID()) l = Cb.url() + "user/" + g.userID + "?alt=json&kind=album&imgmax=d&thumbsize=" + l;
            else {
                var h = "";
                "undefined" !== typeof p[a].customData.authkey && (h = p[a].customData.authkey);
                l = Cb.url() + "user/" + g.userID + "/albumid/" + p[a].GetID() + "?alt=json&kind=photo" + h + "&thumbsize=" + l + "&imgmax=d";
                d = "image";
            }
            l += "&callback=?";
            ib();
            jQuery.ajaxSetup({
                cache: !1
            });
            jQuery.support.cors = !0;
            jQuery.getJSON(l, function(l) {
                oa();
                Yb(a, l, d);
                if (c) r(!1) || Y(a, e);
                else if (-1 != b) {
                    l = -1;
                    for(var g = p.length, f = 0; f < g; f++)if ("image" == p[f].kind && p[f].GetID() == b) {
                        l = f;
                        break;
                    }
                    ua(l, !0);
                } else Y(a, e);
            }).fail(function(a, b, c) {
                oa();
                W("Could not retrieve Picasa/Google+ data. Error: " + (b + ", " + c));
            });
        }
    }
    function Yb(a, c, b) {
        var e = 0, l = p[a].GetID();
        c = c.feed.entry;
        var d = g.albumSorting;
        "image" == b && (d = g.photoSorting);
        switch(d){
            case "random":
                c = na(c);
                break;
            case "reversed":
                c = c.reverse();
                break;
            case "titleAsc":
                c.sort(function(a, c) {
                    var e = "image" == b ? a.media$group.media$description.$t.toUpperCase() : a.media$group.media$title.$t.toUpperCase(), l = "image" == b ? c.media$group.media$description.$t.toUpperCase() : c.media$group.media$title.$t.toUpperCase();
                    return e < l ? -1 : e > l ? 1 : 0;
                });
                break;
            case "titleDesc":
                c.sort(function(a, c) {
                    var e = "image" == b ? a.media$group.media$description.$t.toUpperCase() : a.media$group.media$title.$t.toUpperCase(), l = "image" == b ? c.media$group.media$description.$t.toUpperCase() : c.media$group.media$title.$t.toUpperCase();
                    return e > l ? -1 : e < l ? 1 : 0;
                });
        }
        jQuery.each(c, function(a, c) {
            var d = c.media$group.media$title.$t, s = c.media$group.media$thumbnail[0].url, f = c.gphoto$id.$t, h = "", p = c.media$group.media$description.$t;
            "image" == b && (h = d, d = p, p = "");
            var k = c.media$group.media$content[0].url;
            "image" == b && "" != g.thumbnailLabel.title && (d = ca(unescape(unescape(unescape(unescape(k))))));
            var r = !0;
            "album" == b && (jb(d, f) || (r = !1));
            if (r && (r = "", "album" == b ? r = f : (k = k.substring(0, k.lastIndexOf("/")), k = k.substring(0, k.lastIndexOf("/")) + "/", r = window.screen.width > window.screen.height ? k + "w" + window.screen.width + "/" + h : k + "h" + window.screen.height + "/" + h), d = V(d, s, r, p, "", b, "", f, l), d.picasaThumbBaseURL = "", d.imageNumber = e, "album" == b && (d.author = c.author[0].name.$t, d.contentLength = c.gphoto$numphotos.$t), d.thumbX2src = "", s = {
                url: {
                    l1: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    },
                    lN: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    }
                },
                width: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                },
                height: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                }
            }, s = Db("l1", 0, s, c, b), s = Db("lN", 5, s, c, b), d.thumbs = s, "function" == typeof g.fnProcessData && g.fnProcessData(d, "picasa", c), e++, e >= ("album" == b ? Na : Oa))) return !1;
        });
        p[a].contentIsLoaded = !0;
        p[a].contentLength = e;
    }
    function Db(a, c, b, e, l) {
        for(var d = [
            "xs",
            "sm",
            "me",
            "la",
            "xl"
        ], g = 0; g < d.length; g++)if (b.url[a][d[g]] = e.media$group.media$thumbnail[c + g].url, "image" == l) {
            b.width[a][d[g]] = e.media$group.media$thumbnail[c + g].width;
            b.height[a][d[g]] = e.media$group.media$thumbnail[c + g].height;
            var h = e.media$group.media$thumbnail[c + g].width, p = e.media$group.media$thumbnail[c + g].height;
            if ("auto" == f.settings.width[a][d[g]] && p < f.settings.height[a][d[g]]) {
                var k = h / p;
                b.width[a][d[g]] = h * k;
                b.height[a][d[g]] = p * k;
                k = b.url[a][d[g]].substring(0, b.url[a][d[g]].lastIndexOf("/"));
                k = k.substring(0, k.lastIndexOf("/")) + "/";
                b.url[a][d[g]] = k + "h" + f.settings.height[a][d[g]] + "/";
            }
            "auto" == f.settings.height[a][d[g]] && h < f.settings.width[a][d[g]] && (k = p / h, b.height[a][d[g]] = p * k, b.width[a][d[g]] = h * k, k = b.url[a][d[g]].substring(0, b.url[a][d[g]].lastIndexOf("/")), k = k.substring(0, k.lastIndexOf("/")) + "/", b.url[a][d[g]] = k + "w" + f.settings.width[a][d[g]] + "/");
        } else "auto" != f.settings.width[a][d[g]] ? b.width[a][d[g]] = e.media$group.media$thumbnail[c + g].width : (k = b.url[a][d[g]].substring(0, b.url[a][d[g]].lastIndexOf("/")), k = k.substring(0, k.lastIndexOf("/")) + "/", b.url[a][d[g]] = k + "h" + f.settings.height[a][d[g]] + "/"), "auto" != f.settings.height[a][d[g]] ? b.height[a][d[g]] = e.media$group.media$thumbnail[c + g].height : (k = b.url[a][d[g]].substring(0, b.url[a][d[g]].lastIndexOf("/")), k = k.substring(0, k.lastIndexOf("/")) + "/", b.url[a][d[g]] = k + "w" + f.settings.width[a][d[g]] + "/");
        return b;
    }
    function $a(a, c, b, e) {
        Qa(a);
        if (p[a].contentIsLoaded) Y(a, e);
        else {
            var l = "", d = "album";
            0 == p[a].GetID() ? l = Q.url() + "?method=smugmug.albums.get&NickName=" + g.userID + "&Heavy=true&APIKey=" + Q.APIKey : (l = Q.url() + "?method=smugmug.images.get&NickName=" + g.userID + "&Heavy=true&AlbumID=" + p[a].GetID() + "&APIKey=" + Q.APIKey, d = "image");
            l += "&Callback=?";
            ib();
            jQuery.ajaxSetup({
                cache: !1
            });
            jQuery.support.cors = !0;
            jQuery.getJSON(l, function(l) {
                oa();
                if ("fail" == l.stat) W("Could not retrieve SMUGMUG data (jQuery): " + l.message);
                else {
                    Zb(a, l, d);
                    if ("" != g.gallery) {
                        g.displayBreadcrumb = !1;
                        l = p.length;
                        for(var f = 0; f < l; f++)if (p[f].title.toUpperCase() == g.gallery.toUpperCase()) {
                            $a(f, c, b, e);
                            return;
                        }
                        g.displayBreadcrumb = !0;
                        g.gallery = "";
                    }
                    if (c) r(!1) || Y(a, e);
                    else if (-1 != b) {
                        var h = -1;
                        l = p.length;
                        for(f = 0; f < l; f++)if ("image" == p[f].kind && p[f].GetID() == b) {
                            h = f;
                            break;
                        }
                        ua(h, !0);
                    } else Y(a, e);
                }
            }).fail(function(a, b, c) {
                oa();
                W("Could not retrieve SMUGMUG data (jQuery): " + (b + ", " + c));
            });
        }
    }
    function Zb(a, c, b) {
        var e = 0, l = p[a].GetID();
        if ("album" == b) {
            var d = c.Albums;
            switch(g.albumSorting){
                case "random":
                    d = na(d);
                    break;
                case "reversed":
                    d = d.reverse();
                    break;
                case "titleAsc":
                    d.sort(function(a, b) {
                        var c = a.title.toUpperCase(), e = b.title.toUpperCase();
                        return c < e ? -1 : c > e ? 1 : 0;
                    });
                    break;
                case "titleDesc":
                    d.sort(function(a, b) {
                        var c = a.title.toUpperCase(), e = b.title.toUpperCase();
                        return c > e ? -1 : c < e ? 1 : 0;
                    });
            }
            jQuery.each(c.Albums, function(a, c) {
                var d = c.Title, f = c.id + "&AlbumKey=" + c.Key, s = c.Description, h = !0;
                jb(d, "noID") || (h = !1);
                if (h && (d = V(d, "css/nano_gallery.png", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==", s, "", b, "", f, l), d.imageNumber = e, d.contentLength = c.ImageCount, "auto" == m() ? (d.thumbImgWidth = v(), d.thumbImgHeight = v()) : "auto" == v() ? (d.thumbImgWidth = m(), d.thumbImgHeight = m()) : (d.thumbImgWidth = m(), d.thumbImgHeight = v()), "function" == typeof g.fnProcessData && g.fnProcessData(d, "smugmug", c), e++, e >= Na)) return !1;
            });
        } else {
            d = c.Album.Images;
            switch(g.photoSorting){
                case "random":
                    d = na(d);
                    break;
                case "reversed":
                    d = d.reverse();
                    break;
                case "titleAsc":
                    d.sort(function(a, b) {
                        var c = a.Caption.toUpperCase(), e = b.Caption.toUpperCase();
                        return c < e ? -1 : c > e ? 1 : 0;
                    });
                    break;
                case "titleDesc":
                    d.sort(function(a, b) {
                        var c = a.Caption.toUpperCase(), e = b.Caption.toUpperCase();
                        return c > e ? -1 : c < e ? 1 : 0;
                    });
            }
            jQuery.each(c.Album.Images, function(c, d) {
                var f = d.Caption;
                "" != g.thumbnailLabel.title && (f = ca(d.FileName));
                var s = d.TinyURL;
                for(c = Q.thumbSize; 0 <= c; c--)if (void 0 != d[Q.photoAvailableSizesStr[c]]) {
                    s = d[Q.photoAvailableSizesStr[c]];
                    break;
                }
                var h = d.TinyURL;
                for(c = Q.thumbSizeX2; 0 <= c; c--)if (void 0 != d[Q.photoAvailableSizesStr[c]]) {
                    h = d[Q.photoAvailableSizesStr[c]];
                    break;
                }
                0 == e && (p[a].thumbsrc = s);
                var k = d.Key, r = d.ThumbURL;
                for(c = Q.photoSize; 0 <= c; c--)if (void 0 != d[Q.photoAvailableSizesStr[c]]) {
                    r = d[Q.photoAvailableSizesStr[c]];
                    break;
                }
                f = V(f, s, r, "", "", b, "", k, l);
                f.imageNumber = e;
                "auto" == v() && (f.thumbImgWidth = m());
                "auto" == m() && (f.thumbImgHeight = v());
                "function" == typeof g.fnProcessData && g.fnProcessData(f, "smugmug", d);
                f.thumbX2src = h;
                e++;
                if (e >= Oa) return !1;
            });
        }
        p[a].contentIsLoaded = !0;
        p[a].contentLength = e;
    }
    function V(a, c, b, e, l, d, g, f, h) {
        a = new $b(a, f);
        a.thumbsrc = c;
        a.src = b;
        a.description = e;
        a.destinationURL = l;
        a.kind = d;
        a.albumID = h;
        a.tags = 0 == g.length ? null : g.split(" ");
        p.push(a);
        return a;
    }
    function jb(a, c) {
        var b = a.toUpperCase();
        if (null !== Fa) for(var e = 0; e < Fa.length; e++){
            if (b == Fa[e].toUpperCase() || c == Fa[e]) return !0;
        }
        else {
            var l = !1;
            if (null !== La) {
                for(e = 0; e < La.length; e++)-1 !== b.indexOf(La[e]) && (l = !0);
                if (!l) return !1;
            }
            if (null !== Ka) {
                for(e = 0; e < Ka.length; e++)if (-1 !== b.indexOf(Ka[e])) return !1;
            }
            return !0;
        }
    }
    function Y(a, c) {
        "display" == g.lazyBuild ? va(d.conTnParent, g.lazyBuildTreshold) ? kb(a, c) : (Sa = a, Eb = c) : kb(a, c);
    }
    function kb(a, c) {
        g.lazyBuild = "none";
        Pa = Sa = -1;
        Z && Aa(!1);
        if (a != gb) {
            if (g.locationHash && c) {
                var b = "nanogallery/" + ga + "/" + p[a].GetID();
                sa = "#" + b;
                top.location.hash = b;
            }
            gb = p[a].GetID();
            Qa(a);
            b = 0;
            0 < p[a].paginationLastPage && p[a].paginationLastWidth == d.conTnParent.width() && (b = p[a].paginationLastPage);
            wa(a, b);
        }
    }
    function Fb(a) {
        var c = "folder";
        0 == a && (c = "folderHome");
        c = jQuery('<div class="' + c + ' oneFolder">' + p[a].title + "</div>").appendTo(d.conBC);
        jQuery(c).data("albumIdx", a);
        c.click(function() {
            var a = jQuery(this).data("albumIdx");
            jQuery(this).nextAll().remove();
            ta(a, !1, -1, !0);
        });
    }
    function Gb(a) {
        var c = jQuery('<div class="separator"></div>').appendTo(d.conBC);
        jQuery(c).data("albumIdx", a);
        c.click(function() {
            var a = jQuery(this).data("albumIdx");
            jQuery(this).nextAll().remove();
            jQuery(this).remove();
            ta(a, !1, -1, !0);
        });
    }
    function Qa(a) {
        var c = !1;
        if (1 == g.displayBreadcrumb) {
            0 == d.conBC.children().length && d.conNavBCon.css({
                opacity: 0,
                "max-height": "0px"
            });
            c = !0;
            d.conBC.children().remove();
            Fb(0);
            if (0 != a) {
                var b = p.length, e = [];
                for(e.push(a); 0 != p[a].albumID;)for(i = 1; i < b; i++)if (p[i].GetID() == p[a].albumID) {
                    a = i;
                    e.push(a);
                    break;
                }
                Gb(0);
                for(i = e.length - 1; 0 <= i; i--)0 < i && Gb(e[i - 1]), Fb(e[i]);
            }
            b = d.conBC.children().length;
            0 == b ? (G = "l1", g.breadcrumbAutoHideTopLevel && (d.conNavBCon.css({
                opacity: 0,
                "max-height": "0px"
            }), c = !1)) : (G = 1 == b ? "l1" : "lN", 1 == b && g.breadcrumbAutoHideTopLevel ? d.conNavBCon.animate({
                opacity: "0",
                "max-height": "0px"
            }) : d.conNavBCon.animate({
                opacity: "1",
                "max-height": "50px"
            }));
        }
        g.useTags && (c = !0, null == Hb && (Hb = jQuery('<div class="nanoGalleryTags"></div>').appendTo(d.conNavB)));
        g.galleryFullpageButton && (c = !0);
        !Ib && c && (Ib = !0, d.conNavBCon.show());
    }
    function ib() {
        d.conLoadingB.css({
            visibility: "visible"
        });
    }
    function oa() {
        d.conLoadingB.css({
            visibility: "hidden"
        });
    }
    function ta(a, c, b, e) {
        switch(g.kind){
            case "":
                Y(a, e);
                break;
            case "flickr":
                xb(a, c, b, e);
                break;
            case "smugmug":
                $a(a, c, b, e);
                break;
            default:
                yb(a, c, b, e);
        }
    }
    function Ja() {
        "auto" == v() ? ac() : "auto" == m() ? bc() : cc();
        lb();
        if (g.galleryToolbarWidthAligned && void 0 !== d.conNavBCon) {
            var a = d.conTn.outerWidth(!0);
            d.conNavBCon.width();
            d.conNavBCon.width(a);
        }
    }
    function ac() {
        var a = d.conTnParent.width(), c = 0, b = 0, e = 0, l = [], f = hb(), h = 0, k = g.thumbnailGutterHeight, r = I(), m = d.conTn.find(".nanoGalleryThumbnailContainer");
        "justified" == g.thumbnailAlignment ? (f = Math.min(f, m.length), h = 1 == f ? 0 : (a - f * r) / (f - 1)) : h = g.thumbnailGutterWidth;
        var z = 0;
        m.each(function() {
            var a = jQuery(this), d = a.data("index");
            if (void 0 !== d) {
                "onBottom" == g.thumbnailLabel.position && mb(a, p[d]);
                var r = 0, m = 0;
                if (0 == b) r = c * (I() + h), l[c] = p[d].thumbFullHeight + k, c++, z++, c >= f && (c = 0, b++);
                else {
                    var u = 0, r = l[0];
                    for(i = 1; i < f; i++)if (l[i] + 5 < r) {
                        u = i;
                        break;
                    }
                    m = l[u];
                    r = u * (I() + h);
                    l[u] = m + p[d].thumbFullHeight + k;
                }
                a.css({
                    top: m,
                    left: r
                });
                nb(a, p[d], e);
                e++;
            }
        });
        a = l.length * (r + h) - h;
        r = l[0];
        for(i = 1; i < z; i++)r = Math.max(r, l[i]);
        d.conTn.width(a).height(r);
    }
    function bc() {
        var a = d.conTnParent.width(), c = 0, b = 0, e = 0, l = [], s = 0, h = [], k = !1, r = 0, m = 0, z = 0, u = 0, N = g.thumbnailGutterWidth, w = g.thumbnailGutterHeight, x = 0, q = 0, y = !1, t = !1, A = d.conTn.find(".nanoGalleryThumbnailContainer");
        A.each(function() {
            var b = jQuery(this).data("index");
            if (void 0 !== b && 0 < p[b].thumbImg().width) {
                var e = p[b], d = Math.floor(e.thumbImg().width / e.thumbImg().height * v()) + f.borderWidth + f.imgcBorderWidth;
                g.thumbnailFeatured && 0 == r && (z = d *= 2);
                k && (k = !1, s++, c = 0, t = y = !1, 1 == s && 0 < z && (c = z, z = 0));
                e.thumbImg().height > e.thumbImg().width ? y = !0 : t = !0;
                c + d + N < a ? (c += d + N, h[s] = v(), e = Math.max(y ? x : 0, t ? q : 0), g.thumbnailAdjustLastRowHeight && 0 < e && (h[s] = Math.min(h[s], e)), l[s] = b) : (c += d, e = Math.floor(v() * a / c), h[s] = e, y && (x = Math.max(x, e)), t && (q = Math.max(q, e)), l[s] = b, k = !0);
                r++;
            }
        });
        r = b = e = s = 0;
        A.each(function() {
            var c = jQuery(this), d = c.data("index");
            if (void 0 !== d && 0 < p[d].thumbImg().width) {
                var k = p[d], z = Math.floor(k.thumbImg().width / k.thumbImg().height * h[s]);
                0 == r && g.thumbnailFeatured && (z *= 2, m = 1 == h.length ? 2 * parseInt(h[0]) : parseInt(h[0]) + parseInt(h[1]) + f.borderHeight + f.imgcBorderHeight);
                d == l[s] && (l.length != s + 1 ? z = a - b - f.borderWidth - f.imgcBorderWidth : b + z + f.borderWidth + f.imgcBorderWidth + N > a && (z = a - b - f.borderWidth - f.imgcBorderWidth));
                var S = 0;
                0 == r && g.thumbnailFeatured ? (S = m, u = z + f.borderWidth + f.imgcBorderWidth, k.customData.featured = !0, c.find("img").attr("src", k.thumbX2src)) : S = h[s];
                S = parseInt(S);
                z = parseInt(z);
                c.width(z + f.imgcBorderWidth).height(S + f.imgcBorderHeight + f.labelHeight);
                c.find(".imgContainer").height(S).width(z);
                c.find("img").css({
                    "max-height": S + 2,
                    "max-width": z + 2
                });
                c.find(".subcontainer").width(z + f.imgcBorderWidth).height(S + f.imgcBorderHeight + f.labelHeight);
                c.css({
                    top: e,
                    left: b
                });
                k.thumbFullWidth = z + f.borderWidth + f.imgcBorderWidth;
                k.thumbFullHeight = S + f.borderHeight + f.imgcBorderHeight + f.labelHeight;
                ob(c);
                nb(c, k, r);
                b += z + f.borderWidth + f.imgcBorderWidth + N;
                d == l[s] && (e += h[s] + f.labelHeight + w + f.imgcBorderHeight + f.borderHeight, s++, b = 0, 1 == s && 0 < u && (b = u, u = 0));
            }
            r++;
        });
        0 < s && (e -= w);
        m = m + ea() + f.labelHeight;
        d.conTn.width(a).height(e > m ? e : m);
    }
    function hb() {
        var a = m() + f.borderWidth + f.imgcBorderWidth, c = d.conTnParent.width(), b = 0, b = "justified" == g.thumbnailAlignment ? Math.floor(c / a) : Math.floor((c + g.thumbnailGutterWidth) / (a + g.thumbnailGutterWidth));
        0 < g.maxItemsPerLine && b > g.maxItemsPerLine && (b = g.maxItemsPerLine);
        1 > b && (b = 1);
        return b;
    }
    function cc() {
        var a = 0, c = 0, b = 0, e = g.thumbnailGutterHeight, l = d.conTnParent.width(), f = hb(), h = 0, k = 0, r = 0, z = [], m = 0;
        if (0 < U && 0 < I() && f != ja) ja = f, l = d.conPagin.data("galleryIdx"), wa(l, 0);
        else {
            var u = d.conTn.find(".nanoGalleryThumbnailContainer"), N = u.length;
            "justified" == g.thumbnailAlignment ? (f = Math.min(f, N), b = 1 == f ? 0 : (l - f * I()) / (f - 1)) : b = g.thumbnailGutterWidth;
            u.each(function() {
                var d = jQuery(this), l = d.data("index");
                void 0 !== l && (0 == c ? (a = m * (I() + b), r = z[m] = a) : (a = z[m], k = c), d.css({
                    top: c,
                    left: a
                }), nb(d, p[l], h), m++, m >= f && (m = 0, c += ea() + e), h++);
            });
            d.conTn.width(r + I()).height(k + ea());
        }
    }
    function nb(a, c, b) {
        0 == a.css("opacity") && (a.removeClass("nanogalleryHideElement"), g.thumbnailDisplayTransition ? "function" == typeof g.fnThumbnailDisplayEffect ? g.fnThumbnailDisplayEffect(a, c, 0) : a.delay(b * f.displayInterval).fadeTo(150, 1) : a.css({
            opacity: 1
        }));
    }
    function lb() {
        var a = d.conTn.find(".nanoGalleryThumbnailContainer").filter(function() {
            return Jb(jQuery(this), f.lazyLoadTreshold);
        });
        jQuery(a).each(function() {
            var a = jQuery(this).find("img");
            if ("data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==" == jQuery(a).attr("src")) {
                var b = jQuery(this).data("index");
                jQuery(a).attr("src", "");
                jQuery(a).attr("src", p[b].thumbImg().src);
            }
        });
    }
    function dc(a, c) {
        if (void 0 != d.conPagin) {
            if (d.conPagin.children().remove(), "auto" == f.settings.height[G][H] || "auto" == f.settings.width[G][H]) d.conPagin.hide();
            else {
                d.conPagin.show();
                d.conPagin.data("galleryIdx", a);
                d.conPagin.data("currentPageNumber", c);
                var b = 0, e = 0;
                if (0 < c) {
                    var l = jQuery('<div class="paginationPrev">' + R.paginationPrevious + "</div>").appendTo(d.conPagin), e = e + jQuery(l).outerWidth(!0);
                    l.click(function(a) {
                        zb();
                    });
                }
                l = 0;
                0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H] && (b = Math.ceil(p[a].contentLength / (U * ja)));
                5 <= c ? (l = c - 5, b > c + 6 && (b = c + 6)) : 10 < b && (b = 10);
                if (1 == b) d.conPagin.hide();
                else {
                    for(; l < b; l++){
                        var g = "";
                        l == c && (g = " currentPage");
                        g = jQuery('<div class="paginationItem' + g + '">' + (l + 1) + "</div>").appendTo(d.conPagin);
                        g.data("pageNumber", l);
                        e += g.outerWidth(!0);
                        g.click(function(a) {
                            a = d.conPagin.data("galleryIdx");
                            var b = jQuery(this).data("pageNumber");
                            va(d.base, 0) || $("html, body").animate({
                                scrollTop: d.base.offset().top
                            }, 200);
                            wa(a, b);
                        });
                    }
                    c + 1 < b && (b = jQuery('<div class="paginationNext">' + R.paginationNext + "</div>").appendTo(d.conPagin), e += b.outerWidth(!0), b.click(function(a) {
                        Ab();
                    }));
                    d.conPagin.width(e);
                }
            }
        }
    }
    function Ab() {
        var a = d.conPagin.data("galleryIdx"), c = 0;
        0 < U && (c = p[a].contentLength / (U * ja));
        n2 = Math.ceil(c);
        c = d.conPagin.data("currentPageNumber");
        c < n2 - 1 ? c++ : c = 0;
        va(d.base, 0) || $("html, body").animate({
            scrollTop: d.base.offset().top
        }, 200);
        wa(a, c);
    }
    function zb() {
        var a = d.conPagin.data("galleryIdx"), c = 0;
        0 < U && (c = p[a].contentLength / (U * ja));
        n2 = Math.ceil(c);
        c = d.conPagin.data("currentPageNumber");
        0 < c ? c-- : c = n2 - 1;
        va(d.base, 0) || $("html, body").animate({
            scrollTop: d.base.offset().top
        }, 200);
        wa(a, c);
    }
    function wa(a, c) {
        Ta = -1;
        d.conTn.parent().animate({
            opacity: 0
        }, 100).promise().done(function() {
            d.conTn.off().empty();
            for(var b = p.length, e = 0; e < b; e++)p[e].hovered = !1;
            d.conTnParent.css({
                left: 0,
                opacity: 1
            });
            jQuery(d.conTn[0]).css({
                left: 0
            });
            ec(a, c, fc);
        });
    }
    function ec(a, c, b) {
        if (-1 != a && void 0 != p[a]) {
            p[a].paginationLastPage = c;
            p[a].paginationLastWidth = d.conTnParent.width();
            var e = p.length, l = 0, h = 0, k = 0;
            0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H] && (k = c * U * ja);
            oa();
            var r = !1, z = !1, m = 0;
            (function() {
                for(var u = 0; 100 > u; u++){
                    if (m >= e) {
                        b(a, c);
                        return;
                    }
                    var N = p[m];
                    if (N.albumID == p[a].GetID()) {
                        h++;
                        if (0 < U && "auto" != f.settings.height[G][H] && "auto" != f.settings.width[G][H] && l + 1 > U * ja) {
                            b(a, c);
                            return;
                        }
                        if (h > k) {
                            l++;
                            var w = Bb(N, m, 0, !1);
                            mb(w, N);
                            $p = w.detach();
                            $p.css({
                                opacity: 0
                            });
                            $p.appendTo(d.conTn);
                            g.thumbnailLazyLoad && !r && (Jb(w, f.lazyLoadTreshold) ? (w.find("img").attr("src", ""), w.find("img").attr("src", N.thumbImg().src), z = !0) : z && (r = !0));
                            Kb(w);
                            ob(w);
                        }
                    }
                    m++;
                }
                m < e ? setTimeout(arguments.callee, 0) : b(a, c);
            })();
        }
    }
    function fc(a, c) {
        Ja();
        dc(a, c);
        Ta = a;
    }
    function Bb(a, c, b, e) {
        var l = [], f = 0, h = "", k = " nanogalleryHideElement";
        g.thumbnailLazyLoad && "auto" == m() && (h = "top:0px;left:0px;", k = "");
        l[f++] = '<div class="nanoGalleryThumbnailContainer' + k + '" style="display:block,opacity:' + b + ";" + h + '" ><div class="subcontainer" style="display:block;">';
        var h = "", h = g.thumbnailLazyLoad ? "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==" : a.thumbImg().src, k = gc(a), r = hc(a);
        b = !1;
        "auto" == v() ? (l[f++] = '<div class="imgContainer" style="width:' + m() + 'px;"><img class="image" src=' + h + ' alt=" " style="max-width:' + m() + 'px;"></div>', 0 == p[c].thumbImg().height && (b = !0)) : "auto" == m() ? (l[f++] = '<div class="imgContainer" style="height:' + v() + 'px;"><img class="image" src=' + h + ' alt=" " style="max-height:' + v() + 'px;" ></div>', 0 == p[c].thumbImg().width && (b = !0)) : l[f++] = '<div class="imgContainer" style="width:' + m() + "px;height:" + v() + 'px;"><img class="image" src=' + h + ' alt=" " style="max-width:' + m() + "px;max-height:" + v() + 'px;" ></div>';
        if ("album" == a.kind) {
            if (1 == g.thumbnailLabel.display) {
                if (0 < a.contentLength) switch(g.thumbnailLabel.itemsCount){
                    case "title":
                        k += " " + R.thumbnailLabelItemsCountPart1 + a.contentLength + R.thumbnailLabelItemsCountPart2;
                        break;
                    case "description":
                        r += " " + R.thumbnailLabelItemsCountPart1 + a.contentLength + R.thumbnailLabelItemsCountPart2;
                }
                l[f++] = '<div class="labelImage" style="width:' + m() + 'px;"><div class="labelFolderTitle labelTitle" >' + k + '</div><div class="labelDescription" >' + r + "</div></div>";
            }
        } else 1 == g.thumbnailLabel.display && (e && 0 == r.length && "onBottom" == g.thumbnailLabel.position && (r = "&nbsp;"), l[f++] = '<div class="labelImage" style="width:' + m() + 'px;"><div class="labelImageTitle labelTitle" >' + k + '</div><div class="labelDescription" >' + r + "</div></div>");
        l[f++] = "</div></div>";
        e = jQuery(l.join("")).appendTo(d.conTnHid);
        a.$elt = e;
        e.data("index", c);
        e.find("img").data("index", c);
        ic(e, a);
        if (b) ngimagesLoaded(e).on("always", function(a) {
            var b = p[jQuery(a.images[0].img).data("index")];
            if (void 0 != b && "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==" != jQuery(a.images[0].img).attr("src")) {
                var c = !1;
                b.thumbImg().height != a.images[0].img.naturalHeight && (b.thumbSetImgHeight(a.images[0].img.naturalHeight), b.thumbSetImgWidth(a.images[0].img.naturalWidth), c = !0);
                b.thumbImg().width != a.images[0].img.naturalWidth && (b.thumbSetImgHeight(a.images[0].img.naturalHeight), b.thumbSetImgWidth(a.images[0].img.naturalWidth), c = !0);
                c && (mb(b.$elt, b), ob(b.$elt), Ja());
            }
        });
        return e;
    }
    function gc(a) {
        a = a.title;
        if (1 == g.thumbnailLabel.display) {
            if (void 0 === a || 0 == a.length) a = "&nbsp;";
            "" != R.thumbnailImageTitle && (a = R.thumbnailImageTitle);
            3 < g.thumbnailLabel.titleMaxLength && a.length > g.thumbnailLabel.titleMaxLength && (a = a.substring(0, g.thumbnailLabel.titleMaxLength) + "...");
        }
        return a;
    }
    function hc(a) {
        var c = "";
        1 == g.thumbnailLabel.displayDescription && (c = "album" == a.kind ? "" != R.thumbnailImageDescription ? R.thumbnailAlbumDescription : a.description : "" != R.thumbnailImageDescription ? R.thumbnailImageDescription : a.description, 3 < g.thumbnailLabel.descriptionMaxLength && c.length > g.thumbnailLabel.descriptionMaxLength && (c = c.substring(0, g.thumbnailLabel.descriptionMaxLength) + "..."));
        return c;
    }
    function mb(a, c) {
        if ("auto" == v()) {
            if (0 < c.thumbImg().height) {
                var b = c.thumbImg().height / c.thumbImg().width;
                a.find(".imgContainer").height(m() * b);
                "onBottom" == g.thumbnailLabel.position ? (c.thumbLabelHeight = a.find(".labelImage").outerHeight(!0), c.thumbFullHeight = m() * b + c.thumbLabelHeight + f.borderHeight + f.imgcBorderHeight, a.width(I() - f.borderWidth).height(c.thumbFullHeight - f.borderHeight), a.find(".labelImage").css({
                    position: "absolute",
                    top: "",
                    bottom: "0px"
                })) : (c.thumbFullHeight = m() * b + c.thumbLabelHeight + f.borderHeight + f.imgcBorderHeight, a.width(I() - f.borderWidth).height(c.thumbFullHeight - f.borderHeight));
            }
            c.thumbFullWidth = I();
            a.find(".subcontainer").width(I() - f.borderWidth).height(c.thumbFullHeight - f.borderHeight);
        } else "auto" != m() && (c.thumbFullHeight = ea(), c.thumbFullWidth = I(), a.width(c.thumbFullWidth - f.borderWidth).height(c.thumbFullHeight - f.borderHeight), a.find(".subcontainer").width(c.thumbFullWidth - f.borderWidth).height(c.thumbFullHeight - f.borderHeight));
    }
    function ic(a, c) {
        if ("function" == typeof g.fnThumbnailInit) g.fnThumbnailInit(a, c, t());
        else switch(g.thumbnailLabel.position){
            case "onBottom":
                a.find(".labelImage").css({
                    top: 0,
                    position: "relative",
                    left: 0,
                    right: 0
                });
                "auto" == v() ? (a.find(".labelImageTitle").css({
                    "white-space": "normal"
                }), a.find(".labelFolderTitle").css({
                    "white-space": "normal"
                }), a.find(".labelDescription").css({
                    "white-space": "normal"
                })) : (a.find(".labelImageTitle").css({
                    "white-space": "nowrap"
                }), a.find(".labelFolderTitle").css({
                    "white-space": "nowrap"
                }), a.find(".labelDescription").css({
                    "white-space": "nowrap"
                }));
                break;
            case "overImageOnTop":
                a.find(".labelImage").css({
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                });
                break;
            case "overImageOnMiddle":
                a.find(".labelImage").css({
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                });
                a.find(".labelFolderTitle").css({
                    left: 0,
                    right: 0,
                    position: "absolute",
                    bottom: "50%"
                });
                a.find(".labelImageTitle").css({
                    left: 0,
                    right: 0,
                    position: "absolute",
                    bottom: "50%"
                });
                a.find(".labelDescription").css({
                    left: 0,
                    right: 0,
                    position: "absolute",
                    top: "50%"
                });
                break;
            default:
                g.thumbnailLabel.position = "overImageOnBottom", a.find(".labelImage").css({
                    bottom: 0,
                    left: 0,
                    right: 0
                });
        }
    }
    function eb(a) {
        void 0 != a && (aa = null, void 0 !== p[a].destinationURL && 0 < p[a].destinationURL.length ? window.location = p[a].destinationURL : (ma = !1, "album" == p[a].kind ? ta(a, !1, -1, !0) : ua(a, !1)));
    }
    function Ea() {
        for(var a = p.length, c = 0; c < a; c++)p[c].hovered && db(p[c].$elt);
    }
    function Kb(a) {
        var c = a.data("index");
        if (void 0 != c) {
            var b = p[c];
            "function" == typeof g.fnThumbnailHoverInit && g.fnThumbnailHoverInit(a, b, t());
            for(var e in b.eltTransform)delete b.eltTransform[e];
            for(j = 0; j < B.length; j++)switch(B[j].name){
                case "imageSplit4":
                    e = a.find(".subcontainer");
                    var c = a.find(".labelImage"), l = a.find(".imgContainer");
                    a.find(".imgContainer").css({
                        position: "absolute"
                    });
                    e.css({
                        overflow: "hidden",
                        position: "relative",
                        width: "100%",
                        height: "100%"
                    });
                    e.prepend(l.clone());
                    e.prepend(a.find(".imgContainer").clone());
                    l = a.find(".imgContainer");
                    M("", l);
                    A(b, "imgContainer0", l.eq(0));
                    x(b, "imgContainer0");
                    A(b, "imgContainer1", l.eq(1));
                    x(b, "imgContainer1");
                    A(b, "imgContainer2", l.eq(2));
                    x(b, "imgContainer2");
                    A(b, "imgContainer3", l.eq(3));
                    x(b, "imgContainer3");
                    break;
                case "imageSplitVert":
                    e = a.find(".subcontainer");
                    l = a.find(".imgContainer");
                    l.css({
                        position: "absolute"
                    });
                    e.css({
                        overflow: "hidden",
                        position: "relative"
                    });
                    e.prepend(l.clone());
                    l = a.find(".imgContainer");
                    M("", l);
                    A(b, "imgContainer0", l.eq(0));
                    x(b, "imgContainer0");
                    A(b, "imgContainer1", l.eq(1));
                    x(b, "imgContainer1");
                    break;
                case "labelSplit4":
                    e = a.find(".subcontainer");
                    c = a.find(".labelImage").css({
                        top: 0,
                        bottom: 0
                    });
                    e.css({
                        overflow: "hidden",
                        position: "relative"
                    });
                    c.clone().appendTo(e);
                    a.find(".labelImage").clone().appendTo(e);
                    c = a.find(".labelImage");
                    A(b, "labelImage0", c.eq(0));
                    x(b, "labelImage0");
                    A(b, "labelImage1", c.eq(1));
                    x(b, "labelImage1");
                    A(b, "labelImage2", c.eq(2));
                    x(b, "labelImage2");
                    A(b, "labelImage3", c.eq(3));
                    x(b, "labelImage3");
                    break;
                case "labelSplitVert":
                    e = a.find(".subcontainer");
                    c = a.find(".labelImage");
                    e.css({
                        overflow: "hidden",
                        position: "relative"
                    });
                    c.clone().appendTo(e);
                    c = a.find(".labelImage");
                    A(b, "labelImage0", c.eq(0));
                    x(b, "labelImage0");
                    A(b, "labelImage1", c.eq(1));
                    x(b, "labelImage1");
                    break;
                case "labelAppearSplit4":
                    e = a.find(".subcontainer");
                    c = a.find(".labelImage");
                    c.css({
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    });
                    e.css({
                        overflow: "hidden",
                        position: "relative"
                    });
                    c.clone().appendTo(e);
                    a.find(".labelImage").clone().appendTo(e);
                    c = a.find(".labelImage");
                    e = A(b, "labelImage0", c.eq(0));
                    e.translateX = -b.thumbFullWidth / 2;
                    e.translateY = -b.thumbFullHeight / 2;
                    x(b, "labelImage0");
                    e = A(b, "labelImage1", c.eq(1));
                    e.translateX = b.thumbFullWidth / 2;
                    e.translateY = -b.thumbFullHeight / 2;
                    x(b, "labelImage1");
                    e = A(b, "labelImage2", c.eq(2));
                    e.translateX = b.thumbFullWidth / 2;
                    e.translateY = b.thumbFullHeight / 2;
                    x(b, "labelImage2");
                    e = A(b, "labelImage3", c.eq(3));
                    e.translateX = -b.thumbFullWidth / 2;
                    e.translateY = b.thumbFullHeight / 2;
                    x(b, "labelImage3");
                    break;
                case "labelAppearSplitVert":
                    e = a.find(".subcontainer");
                    c = a.find(".labelImage");
                    e.css({
                        overflow: "hidden",
                        position: "relative"
                    });
                    c.clone().appendTo(e);
                    c = a.find(".labelImage");
                    A(b, "labelImage0", c.eq(0)).translateX = -b.thumbFullWidth / 2;
                    x(b, "labelImage0");
                    A(b, "labelImage1", c.eq(1)).translateX = b.thumbFullWidth / 2;
                    x(b, "labelImage1");
                    break;
                case "imageScale150Outside":
                    d.base.css({
                        overflow: "visible"
                    });
                    d.conTn.css({
                        overflow: "visible"
                    });
                    a.css({
                        overflow: "visible"
                    });
                    a.find(".subcontainer").css({
                        overflow: "visible"
                    });
                    a.find(".imgContainer").css({
                        overflow: "visible"
                    });
                    A(b, "img0", a.find("img"));
                    x(b, "img0");
                    M(a.find(".imgContainer"), a.find(".labelImage"));
                    break;
                case "scale120":
                    d.base.css({
                        overflow: "visible"
                    });
                    d.conTn.css({
                        overflow: "visible"
                    });
                    A(b, "base", a);
                    x(b, "base");
                    break;
                case "scaleLabelOverImage":
                    e = a.find(".imgContainer");
                    c = a.find(".labelImage");
                    M(e, c);
                    a.find(".labelImage").css({
                        opacity: 0
                    });
                    A(b, "labelImage0", c).scale = 50;
                    x(b, "labelImage0");
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "overScale":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".imgContainer");
                    c = a.find(".labelImage");
                    M("", c);
                    c.css({
                        opacity: 0
                    });
                    e.css({
                        opacity: 1
                    });
                    A(b, "labelImage0", c).scale = 150;
                    x(b, "labelImage0");
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "overScaleOutside":
                    d.base.css({
                        overflow: "visible"
                    });
                    d.conTn.css({
                        overflow: "visible"
                    });
                    a.css({
                        overflow: "visible"
                    });
                    e = a.find(".imgContainer");
                    c = a.find(".labelImage");
                    M("", c);
                    c.css({
                        opacity: 0
                    });
                    e.css({
                        opacity: 1
                    });
                    A(b, "labelImage0", c).scale = 150;
                    x(b, "labelImage0");
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "rotateCornerBL":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1
                    });
                    e[0].style[O + "Origin"] = "100% 100%";
                    A(b, "labelImage0", e).rotateZ = -90;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e[0].style[O + "Origin"] = "100% 100%";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "rotateCornerBR":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1
                    });
                    e[0].style[O + "Origin"] = "0% 100%";
                    A(b, "labelImage0", e).rotateZ = 90;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e[0].style[O + "Origin"] = "0 100%";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "imageRotateCornerBL":
                    e = a.find(".imgContainer");
                    M(a, e);
                    a.css({
                        overflow: "hidden"
                    });
                    a.find(".labelImage").css({
                        opacity: 1
                    });
                    e[0].style[O + "Origin"] = "bottom right";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "imageRotateCornerBR":
                    e = a.find(".imgContainer");
                    M(a, e);
                    a.css({
                        overflow: "hidden"
                    });
                    a.find(".labelImage").css({
                        opacity: 1
                    });
                    e[0].style[O + "Origin"] = "0 100%";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "slideUp":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1,
                        top: 0
                    });
                    A(b, "labelImage0", e).translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e.css({
                        left: 0,
                        top: 0
                    });
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "slideDown":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1,
                        top: 0
                    });
                    A(b, "labelImage0", e).translateY = -b.thumbFullHeight;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e.css({
                        left: 0,
                        top: 0
                    });
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "slideRight":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1,
                        top: 0
                    });
                    A(b, "labelImage0", e).translateX = -b.thumbFullWidth;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e.css({
                        left: 0,
                        top: 0
                    });
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "slideLeft":
                    a.css({
                        overflow: "hidden"
                    });
                    e = a.find(".labelImage");
                    e.css({
                        opacity: 1,
                        top: 0
                    });
                    A(b, "labelImage0", e).translateX = b.thumbFullWidth;
                    x(b, "labelImage0");
                    e = a.find(".imgContainer");
                    e.css({
                        left: 0,
                        top: 0
                    });
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "imageSlideUp":
                case "imageSlideDown":
                case "imageSlideRight":
                case "imageSlideLeft":
                    e = a.find(".imgContainer");
                    M(a, e);
                    a.css({
                        overflow: "visible"
                    });
                    a.find(".labelImage").css({
                        opacity: 1
                    });
                    e.css({
                        left: 0,
                        top: 0
                    });
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    break;
                case "labelAppear":
                case "labelAppear75":
                    var h = "rgb(" + F.oldLabelRed + "," + F.oldLabelGreen + "," + F.oldLabelBlue + ",0)";
                    a.find(".labelImage").css({
                        backgroundColor: h
                    });
                    a.find(".labelImageTitle").css({
                        opacity: 0
                    });
                    a.find(".labelFolderTitle").css({
                        opacity: 0
                    });
                    a.find(".labelDescription").css({
                        opacity: 0
                    });
                    break;
                case "descriptionAppear":
                    a.find(".labelDescription").css({
                        opacity: 0
                    });
                    break;
                case "labelSlideUpTop":
                    a.css({
                        overflow: "hidden"
                    });
                    a.find(".labelImage").css({
                        top: 0,
                        bottom: 0
                    });
                    A(b, "labelImage0", a.find(".labelImage")).translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "labelSlideUp":
                    a.css({
                        overflow: "hidden"
                    });
                    A(b, "labelImage0", a.find(".labelImage")).translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "labelSlideDown":
                    a.css({
                        overflow: "hidden"
                    });
                    A(b, "labelImage0", a.find(".labelImage")).translateY = -b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "descriptionSlideUp":
                    a.css({
                        overflow: "hidden"
                    });
                    c = "album" == b.kind ? a.find(".labelFolderTitle").outerHeight(!0) : a.find(".labelImageTitle").outerHeight(!0);
                    a.find(".labelDescription").css({
                        opacity: 0
                    });
                    a.find(".labelImage").css({
                        height: c
                    });
                    A(b, "labelImage0", a.find(".labelImage"));
                    x(b, "labelImage0");
                    break;
                case "imageExplode":
                    M("", a);
                    M(a.find(".labelImage"), a.find(".imgContainer"));
                    e = a.find(".subcontainer");
                    for(var c = 7, l = a.find(".imgContainer"), k = l.outerWidth(!0) / c, r = l.outerHeight(!0), r = l.outerHeight(!0) / c, m = 0; m < c; m++)for(h = 0; h < c; h++){
                        var z = "rect(" + r * m + "px, " + k * (h + 1) + "px, " + r * (m + 1) + "px, " + k * h + "px)";
                        l.clone().appendTo(e).css({
                            top: 0,
                            scale: 1,
                            clip: z,
                            left: 0,
                            position: "absolute"
                        }).data("ngScale", 1);
                    }
                    l.remove();
                    break;
                case "imageFlipHorizontal":
                    switch(g.thumbnailLabel.position){
                        case "overImageOnTop":
                            a.find(".labelImage").css({
                                top: -f.imgcBorderHeight / 2,
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                            break;
                        case "overImageOnMiddle":
                            a.find(".labelImage").css({
                                top: -f.imgcBorderHeight / 2,
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                            break;
                        default:
                            a.find(".labelImage").css({
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                    }
                    d.base.css({
                        overflow: "visible"
                    });
                    d.conTn.css({
                        overflow: "visible"
                    });
                    a.css({
                        overflow: "visible"
                    });
                    M("", a);
                    M(a.find(".labelImage"), a.find(".imgContainer"));
                    e = a.find(".subcontainer");
                    e.css({
                        overflow: "visible"
                    });
                    e[0].style[Lb] = "preserve-3d";
                    c = Math.round(1.2 * b.thumbFullHeight) + "px";
                    e[0].style[Ua] = c;
                    e = a.find(".imgContainer");
                    e[0].style[xa] = "hidden";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    a.find(".image")[0].style[xa] = "hidden";
                    e = a.find(".labelImage");
                    e[0].style[xa] = "hidden";
                    A(b, "labelImage0", e).rotateX = 180;
                    x(b, "labelImage0");
                    break;
                case "imageFlipVertical":
                    switch(g.thumbnailLabel.position){
                        case "overImageOnTop":
                            a.find(".labelImage").css({
                                top: -f.imgcBorderHeight / 2,
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                            break;
                        case "overImageOnMiddle":
                            a.find(".labelImage").css({
                                top: -f.imgcBorderHeight / 2,
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                            break;
                        default:
                            a.find(".labelImage").css({
                                bottom: f.imgcBorderWidth / 2,
                                left: 0,
                                right: 0
                            });
                    }
                    d.base.css({
                        overflow: "visible"
                    });
                    d.conTn.css({
                        overflow: "visible"
                    });
                    a.css({
                        overflow: "visible"
                    });
                    M("", a);
                    M(a.find(".labelImage"), a.find(".imgContainer"));
                    e = a.find(".subcontainer");
                    e.css({
                        overflow: "visible"
                    });
                    e[0].style[Lb] = "preserve-3d";
                    c = Math.round(1.2 * b.thumbFullWidth) + "px";
                    e[0].style[Ua] = c;
                    e = a.find(".imgContainer");
                    e[0].style[xa] = "hidden";
                    A(b, "imgContainer0", e);
                    x(b, "imgContainer0");
                    a.find(".image")[0].style[xa] = "hidden";
                    e = a.find(".labelImage");
                    e[0].style[xa] = "hidden";
                    A(b, "labelImage0", e).rotateY = 180;
                    x(b, "labelImage0");
                    break;
                case "imageScale150":
                    a.css({
                        overflow: "hidden"
                    });
                    A(b, "img0", a.find("img"));
                    x(b, "img0");
                    break;
                case "imageScaleIn80":
                    a.css({
                        overflow: "hidden"
                    });
                    A(b, "img0", a.find("img")).scale = 120;
                    x(b, "img0");
                    break;
                case "imageSlide2Up":
                case "imageSlide2Down":
                case "imageSlide2Left":
                case "imageSlide2Right":
                case "imageSlide2UpRight":
                case "imageSlide2UpLeft":
                case "imageSlide2DownRight":
                case "imageSlide2DownLeft":
                    a.css({
                        overflow: "hidden"
                    });
                    b.customData.hoverEffectRDir = B[j].name;
                    pb(a, b);
                    break;
                case "imageSlide2Random":
                    a.css({
                        overflow: "hidden"
                    }), c = "imageSlide2Up imageSlide2Down imageSlide2Left imageSlide2Left imageSlide2UpRight imageSlide2UpLeft imageSlide2DownRight imageSlide2DownLeft".split(" "), b.customData.hoverEffectRDir = c[Math.floor(Math.random() * c.length)], pb(a, b);
            }
            b.hoverInitDone = !0;
        }
    }
    function pb(a, c) {
        var b = c.thumbFullWidth, e = c.thumbFullHeight, d = A(c, "img0", a.find("img"));
        d.scale = 140;
        switch(c.customData.hoverEffectRDir){
            case "imageSlide2Up":
                d.translateY = c.thumbFullHeight < 1.4 * c.thumbImg().height ? (1.4 * c.thumbImg().height - c.thumbFullHeight) / 2 : 0;
                d.translateX = c.thumbFullWidth < 1.4 * c.thumbImg().width ? -(1.4 * c.thumbImg().width - c.thumbFullWidth) / 2 : 0;
                break;
            case "imageSlide2Down":
                e = c.thumbFullHeight < 1.4 * c.thumbImg().height ? Math.min((1.4 * c.thumbImg().height - c.thumbFullHeight) / 2 * .1, .1 * e) : 0;
                d.translateY = -e;
                b = c.thumbFullWidth < 1.4 * c.thumbImg().width ? Math.min((1.4 * c.thumbImg().width - c.thumbFullWidth) / 2 * .1, .1 * b) : 0;
                d.translateX = b;
                break;
            case "imageSlide2Left":
                d.translateY = .1 * -e;
                d.translateX = .1 * b;
                break;
            case "imageSlide2Right":
                d.translateY = .1 * -e;
                d.translateX = .1 * -b;
                break;
            case "imageSlide2UpRight":
                d.translateY = .05 * e;
                d.translateX = .05 * -b;
                break;
            case "imageSlide2UpLeft":
                d.translateY = .05 * e;
                d.translateX = .05 * b;
                break;
            case "imageSlide2DownRight":
                d.translateY = .05 * -e;
                d.translateX = .05 * -b;
                break;
            case "imageSlide2DownLeft":
                d.translateY = .05 * -e, d.translateX = .05 * b;
        }
        x(c, "img0");
    }
    function ob(a) {
        var c = a.data("index");
        if (void 0 != c) {
            var b = p[c];
            if (b.hoverInitDone) for("function" == typeof g.fnThumbnailHoverResize && g.fnThumbnailHoverResize(a, b, t()), j = 0; j < B.length; j++)switch(B[j].name){
                case "imageSplit4":
                    var c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth, e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight, d = a.find(".imgContainer"), h = "rect(0px, " + Math.ceil(c / 2) + "px, " + Math.ceil(e / 2) + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(2).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(3).css({
                        clip: h
                    });
                    break;
                case "imageSplitVert":
                    d = a.find(".imgContainer");
                    c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth;
                    e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight;
                    h = "rect(0px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    break;
                case "labelSplit4":
                    c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth;
                    e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight;
                    d = a.find(".labelImage");
                    h = "rect(0px, " + Math.ceil(c / 2) + "px, " + Math.ceil(e / 2) + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(2).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(3).css({
                        clip: h
                    });
                    break;
                case "labelSplitVert":
                    c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth;
                    e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight;
                    d = a.find(".labelImage");
                    h = "rect(0px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    break;
                case "labelAppearSplit4":
                    c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth;
                    e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight;
                    d = a.find(".labelImage");
                    h = "rect(0px, " + Math.ceil(c / 2) + "px, " + Math.ceil(e / 2) + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(2).css({
                        clip: h
                    });
                    h = "rect(" + Math.ceil(e / 2) + "px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(3).css({
                        clip: h
                    });
                    b.eltTransform.labelImage0.translateX = -b.thumbFullWidth / 2;
                    b.eltTransform.labelImage0.translateY = -b.thumbFullHeight / 2;
                    x(b, "labelImage0");
                    b.eltTransform.labelImage1.translateX = b.thumbFullWidth / 2;
                    b.eltTransform.labelImage1.translateY = -b.thumbFullHeight / 2;
                    x(b, "labelImage1");
                    b.eltTransform.labelImage2.translateX = b.thumbFullWidth / 2;
                    b.eltTransform.labelImage2.translateY = b.thumbFullHeight / 2;
                    x(b, "labelImage2");
                    b.eltTransform.labelImage3.translateX = -b.thumbFullWidth / 2;
                    b.eltTransform.labelImage3.translateY = b.thumbFullHeight / 2;
                    x(b, "labelImage3");
                    break;
                case "labelAppearSplitVert":
                    c = b.thumbFullWidth - f.borderWidth - f.imgcBorderWidth;
                    e = b.thumbFullHeight - f.borderHeight - f.imgcBorderHeight;
                    d = a.find(".labelImage");
                    h = "rect(0px, " + Math.ceil(c / 2) + "px, " + e + "px, 0px)";
                    d.eq(0).css({
                        clip: h
                    });
                    h = "rect(0px, " + c + "px, " + e + "px, " + Math.ceil(c / 2) + "px)";
                    d.eq(1).css({
                        clip: h
                    });
                    b.eltTransform.labelImage0.translateX = -b.thumbFullWidth / 2;
                    x(b, "labelImage0");
                    b.eltTransform.labelImage1.translateX = b.thumbFullWidth / 2;
                    x(b, "labelImage1");
                    break;
                case "slideUp":
                    b.eltTransform.labelImage0.translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "slideDown":
                    b.eltTransform.labelImage0.translateY = -b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "slideRight":
                    b.eltTransform.labelImage0.translateX = -b.thumbFullWidth;
                    x(b, "labelImage0");
                    break;
                case "slideLeft":
                    b.eltTransform.labelImage0.translateX = b.thumbFullWidth;
                    x(b, "labelImage0");
                    break;
                case "imageExplode":
                    a.find(".subcontainer");
                    d = a.find(".imgContainer");
                    c = Math.sqrt(d.length);
                    d.eq(0).outerWidth(!0);
                    d.eq(0).outerHeight(!0);
                    for(e = 0; e < c; e++)for(d = 0; d < c; d++);
                    break;
                case "imageFlipHorizontal":
                    e = a.find(".subcontainer");
                    c = Math.round(1.2 * b.thumbFullHeight) + "px";
                    e[0].style[Ua] = c;
                    break;
                case "imageFlipVertical":
                    e = a.find(".subcontainer");
                    c = Math.round(1.2 * b.thumbFullWidth) + "px";
                    e[0].style[Ua] = c;
                    break;
                case "imageSlide2Up":
                case "imageSlide2Down":
                case "imageSlide2Left":
                case "imageSlide2Right":
                case "imageSlide2UpRight":
                case "imageSlide2UpLeft":
                case "imageSlide2DownRight":
                case "imageSlide2DownLeft":
                case "imageSlide2Random":
                    pb(a, b);
                    break;
                case "slideUp":
                    b.eltTransform.labelImage0.translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "slideDown":
                    b.eltTransform.labelImage0.translateY = -b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "slideRight":
                    b.eltTransform.labelImage0.translateX = -b.thumbFullWidth;
                    x(b, "labelImage0");
                    break;
                case "slideLeft":
                    b.eltTransform.labelImage0.translateX = b.thumbFullWidth;
                    x(b, "labelImage0");
                    break;
                case "labelSlideUpTop":
                case "labelSlideUp":
                    b.eltTransform.labelImage0.translateY = b.thumbFullHeight;
                    x(b, "labelImage0");
                    break;
                case "labelSlideDown":
                    a.css({
                        overflow: "hidden"
                    }), b.eltTransform.labelImage0.translateY = -b.thumbFullHeight, x(b, "labelImage0");
            }
            else Kb(a);
        }
    }
    function A(a, c, b) {
        void 0 == a.eltTransform[c] && (a.eltTransform[c] = {
            translateX: 0,
            translateY: 0,
            rotateX: 0,
            rotateY: 0,
            rotateZ: 0,
            scale: 100
        }, a.eltTransform[c].$elt = b);
        return a.eltTransform[c];
    }
    function x(a, c) {
        var b = a.eltTransform[c], e = "translateX(" + b.translateX + "px) translateY(" + b.translateY + "px) scale(" + b.scale / 100 + ")", e = 9 >= jc || kc ? e + (" rotate(" + b.rotateZ + "deg)") : e + (" rotateX(" + b.rotateX + "deg) rotateY(" + b.rotateY + "deg) rotateZ(" + b.rotateZ + "deg)");
        b.$elt[0].style[O] = e;
    }
    function w(a, c, b, e, d) {
        var g = "translateX translateY scale rotateX rotateY rotateZ".split(" ");
        if ("animate" == D) for(var f = 0; f < g.length; f++){
            var h = g[f];
            if (void 0 !== b[h]) {
                var k = {
                    v: parseInt(e.eltTransform[d][h]),
                    item: e,
                    tf: h,
                    eltClass: d,
                    to: parseInt(b[h])
                }, p = {
                    v: parseInt(b[h])
                };
                0 < B[c].delay ? jQuery(k).delay(B[c].delay).animate(p, {
                    duration: B[c].duration,
                    easing: B[c].easing,
                    queue: !1,
                    step: function(a) {
                        this.item.hovered && (e.eltTransform[this.eltClass][this.tf] = a, x(this.item, this.eltClass));
                    },
                    complete: function() {
                        this.item.hovered && (e.eltTransform[this.eltClass][this.tf] = this.to, x(this.item, this.eltClass));
                    }
                }) : jQuery(k).animate(p, {
                    duration: B[c].duration,
                    easing: B[c].easing,
                    queue: !1,
                    step: function(a) {
                        this.item.hovered && (e.eltTransform[this.eltClass][this.tf] = a, x(this.item, this.eltClass));
                    },
                    complete: function() {
                        this.item.hovered && (e.eltTransform[this.eltClass][this.tf] = this.to, x(this.item, this.eltClass));
                    }
                });
                delete b[h];
            }
        }
        if (0 != b.length) {
            if (0 < B[c].delay) {
                if ("transition" == D) a.delay(B[c].delay)[D](b, B[c].duration, B[c].easing);
                else a.delay(B[c].delay)[D](b, {
                    duration: B[c].duration,
                    easing: B[c].easing,
                    queue: !1
                });
            } else if ("transition" == D) a[D](b, B[c].duration, B[c].easing);
            else a[D](b, {
                duration: B[c].duration,
                easing: B[c].easing,
                queue: !1
            });
        }
    }
    function bb(a) {
        var c = a.data("index");
        if (void 0 != c) {
            "velocity" == D ? a.find("*").velocity("stop", !0) : a.find("*").stop(!0, !1);
            var b = p[c];
            b.hovered = !0;
            var e = "animate" == D ? 1 : 100;
            "function" == typeof g.fnThumbnailHover && g.fnThumbnailHover(a, b, t());
            try {
                for(j = 0; j < B.length; j++)switch(B[j].name){
                    case "imageSplit4":
                        var d = a.find(".imgContainer");
                        w(d.eq(0), j, {
                            translateX: -b.thumbFullWidth / 2,
                            translateY: -b.thumbFullHeight / 2
                        }, b, "imgContainer0");
                        w(d.eq(1), j, {
                            translateX: b.thumbFullWidth / 2,
                            translateY: -b.thumbFullHeight / 2
                        }, b, "imgContainer1");
                        w(d.eq(2), j, {
                            translateX: b.thumbFullWidth / 2,
                            translateY: b.thumbFullHeight / 2
                        }, b, "imgContainer2");
                        w(d.eq(3), j, {
                            translateX: -b.thumbFullWidth / 2,
                            translateY: b.thumbFullHeight / 2
                        }, b, "imgContainer3");
                        break;
                    case "imageSplitVert":
                        d = a.find(".imgContainer");
                        w(d.eq(0), j, {
                            translateX: -b.thumbFullWidth / 2
                        }, b, "imgContainer0");
                        w(d.eq(1), j, {
                            translateX: b.thumbFullWidth / 2
                        }, b, "imgContainer1");
                        break;
                    case "labelSplit4":
                        d = a.find(".labelImage");
                        w(d.eq(0), j, {
                            translateX: -b.thumbFullWidth / 2,
                            translateY: -b.thumbFullHeight / 2
                        }, b, "labelImage0");
                        w(d.eq(1), j, {
                            translateX: b.thumbFullWidth / 2,
                            translateY: -b.thumbFullHeight / 2
                        }, b, "labelImage1");
                        w(d.eq(2), j, {
                            translateX: b.thumbFullWidth / 2,
                            translateY: b.thumbFullHeight / 2
                        }, b, "labelImage2");
                        w(d.eq(3), j, {
                            translateX: -b.thumbFullWidth / 2,
                            translateY: b.thumbFullHeight / 2
                        }, b, "labelImage3");
                        break;
                    case "labelSplitVert":
                        d = a.find(".labelImage");
                        w(d.eq(0), j, {
                            translateX: -b.thumbFullWidth / 2
                        }, b, "labelImage0");
                        w(d.eq(1), j, {
                            translateX: b.thumbFullWidth / 2
                        }, b, "labelImage1");
                        break;
                    case "labelAppearSplit4":
                        d = a.find(".labelImage");
                        w(d.eq(0), j, {
                            translateX: 0,
                            translateY: 0
                        }, b, "labelImage0");
                        w(d.eq(1), j, {
                            translateX: 0,
                            translateY: 0
                        }, b, "labelImage1");
                        w(d.eq(2), j, {
                            translateX: 0,
                            translateY: 0
                        }, b, "labelImage2");
                        w(d.eq(3), j, {
                            translateX: 0,
                            translateY: 0
                        }, b, "labelImage3");
                        break;
                    case "labelAppearSplitVert":
                        d = a.find(".labelImage");
                        w(d.eq(0), j, {
                            translateX: 0
                        }, b, "labelImage0");
                        w(d.eq(1), j, {
                            translateX: 0
                        }, b, "labelImage1");
                        break;
                    case "scaleLabelOverImage":
                        w(a.find(".labelImage"), j, {
                            scale: 100 / e,
                            opacity: 1
                        }, b, "labelImage0");
                        w(a.find(".imgContainer"), j, {
                            scale: 50 / e
                        }, b, "imgContainer0");
                        break;
                    case "overScale":
                    case "overScaleOutside":
                        w(a.find(".labelImage"), j, {
                            opacity: 1,
                            scale: 100 / e
                        }, b, "labelImage0");
                        w(a.find(".imgContainer"), j, {
                            opacity: 0,
                            scale: 50 / e
                        }, b, "imgContainer0");
                        break;
                    case "imageInvisible":
                        w(a.find(".imgContainer"), j, {
                            opacity: 0
                        }, b);
                        break;
                    case "rotateCornerBL":
                        var f = "transition" == D ? {
                            rotate: "0deg"
                        } : {
                            rotateZ: "0"
                        };
                        w(a.find(".labelImage"), j, f, b, "labelImage0");
                        f = "transition" == D ? {
                            rotate: "90deg"
                        } : {
                            rotateZ: "90"
                        };
                        w(a.find(".imgContainer"), j, f, b, "imgContainer0");
                        break;
                    case "rotateCornerBR":
                        f = "transition" == D ? {
                            rotate: "0deg"
                        } : {
                            rotateZ: "0"
                        };
                        w(a.find(".labelImage"), j, f, b, "labelImage0");
                        f = "transition" == D ? {
                            rotate: "-90deg"
                        } : {
                            rotateZ: "-90"
                        };
                        w(a.find(".imgContainer"), j, f, b, "imgContainer0");
                        break;
                    case "imageRotateCornerBL":
                        f = "transition" == D ? {
                            rotate: "90deg"
                        } : {
                            rotateZ: "90"
                        };
                        w(a.find(".imgContainer"), j, f, b, "imgContainer0");
                        break;
                    case "imageRotateCornerBR":
                        f = "transition" == D ? {
                            rotate: "-90deg"
                        } : {
                            rotateZ: "-90"
                        };
                        w(a.find(".imgContainer"), j, f, b, "imgContainer0");
                        break;
                    case "slideUp":
                        w(a.find(".imgContainer"), j, {
                            translateY: -b.thumbFullHeight
                        }, b, "imgContainer0");
                        w(a.find(".labelImage"), j, {
                            translateY: 0
                        }, b, "labelImage0");
                        break;
                    case "slideDown":
                        w(a.find(".imgContainer"), j, {
                            translateY: b.thumbFullHeight
                        }, b, "imgContainer0");
                        w(a.find(".labelImage"), j, {
                            translateY: 0
                        }, b, "labelImage0");
                        break;
                    case "slideRight":
                        w(a.find(".imgContainer"), j, {
                            translateX: b.thumbFullWidth
                        }, b, "imgContainer0");
                        w(a.find(".labelImage"), j, {
                            translateX: 0
                        }, b, "labelImage0");
                        break;
                    case "slideLeft":
                        w(a.find(".imgContainer"), j, {
                            translateX: -b.thumbFullWidth
                        }, b, "imgContainer0");
                        w(a.find(".labelImage"), j, {
                            translateX: 0
                        }, b, "labelImage0");
                        break;
                    case "imageSlideUp":
                        w(a.find(".imgContainer"), j, {
                            translateY: -b.thumbFullHeight
                        }, b, "imgContainer0");
                        break;
                    case "imageSlideDown":
                        w(a.find(".imgContainer"), j, {
                            translateY: b.thumbFullHeight
                        }, b, "imgContainer0");
                        break;
                    case "imageSlideLeft":
                        w(a.find(".imgContainer"), j, {
                            translateX: -b.thumbFullWidth
                        }, b, "imgContainer0");
                        break;
                    case "imageSlideRight":
                        w(a.find(".imgContainer"), j, {
                            translateX: b.thumbFullWidth
                        }, b, "imgContainer0");
                        break;
                    case "labelAppear":
                        if ("velocity" == D) w(a.find(".labelImage"), j, {
                            backgroundColorRed: F.oldLabelRed,
                            backgroundColorGreen: F.oldLabelGreen,
                            backgroundColorBlue: F.oldLabelBlue,
                            backgroundColorAlpha: 1
                        }, b);
                        else {
                            var h = "rgba(" + F.oldLabelRed + "," + F.oldLabelGreen + "," + F.oldLabelBlue + ",1)";
                            w(a.find(".labelImage"), j, {
                                backgroundColor: h
                            }, b);
                        }
                        w(a.find(".labelImageTitle"), j, {
                            opacity: 1
                        }, b);
                        w(a.find(".labelFolderTitle"), j, {
                            opacity: 1
                        }, b);
                        w(a.find(".labelDescription"), j, {
                            opacity: 1
                        }, b);
                        break;
                    case "labelAppear75":
                        "velocity" == D ? w(a.find(".labelImage"), j, {
                            backgroundColorRed: F.oldLabelRed,
                            backgroundColorGreen: F.oldLabelGreen,
                            backgroundColorBlue: F.oldLabelBlue,
                            backgroundColorAlpha: .75
                        }, b) : (h = "rgba(" + F.oldLabelRed + "," + F.oldLabelGreen + "," + F.oldLabelBlue + ",0.75)", w(a.find(".labelImage"), j, {
                            backgroundColor: h
                        }, b));
                        w(a.find(".labelImageTitle"), j, {
                            opacity: 1
                        }, b);
                        w(a.find(".labelFolderTitle"), j, {
                            opacity: 1
                        }, b);
                        w(a.find(".labelDescription"), j, {
                            opacity: 1
                        }, b);
                        break;
                    case "descriptionAppear":
                        w(a.find(".labelDescription"), j, {
                            opacity: 1
                        }, b);
                        break;
                    case "labelSlideDown":
                        w(a.find(".labelImage"), j, {
                            translateY: 0
                        }, b, "labelImage0");
                        break;
                    case "labelSlideUpTop":
                    case "labelSlideUp":
                        w(a.find(".labelImage"), j, {
                            translateY: 0
                        }, b, "labelImage0");
                        break;
                    case "descriptionSlideUp":
                        var k = "album" == b.kind ? a.find(".labelFolderTitle").outerHeight(!0) : a.find(".labelImageTitle").outerHeight(!0), r = a.find(".labelDescription").outerHeight(!0), m = b.thumbFullHeight - k - r;
                        0 > m && (m = 0);
                        w(a.find(".labelImage"), j, {
                            translateY: 0,
                            height: k + r
                        }, b, "labelImage0");
                        w(a.find(".labelDescription"), j, {
                            opacity: 1
                        }, b);
                        break;
                    case "labelOpacity50":
                        w(a.find(".labelImage"), j, {
                            opacity: .5
                        }, b);
                        break;
                    case "imageOpacity50":
                        w(a.find(".imgContainer"), j, {
                            opacity: .5
                        }, b);
                        break;
                    case "borderLighter":
                        if ("velocity" == D) {
                            var z = Va(F.oldBorderColor, .5, !1), u = z.substring(z.indexOf("(") + 1, z.lastIndexOf(")")).split(/,\s*/);
                            w(a, j, {
                                borderColorRed: u[0],
                                borderColorGreen: u[1],
                                borderColorBlue: u[2],
                                colorAlpha: u[3]
                            }, b);
                        } else w(a, j, {
                            borderColor: Va(F.oldBorderColor, .5, !1)
                        }, b);
                        break;
                    case "borderDarker":
                        "velocity" == D ? (z = Va(F.oldBorderColor, .5, !0), u = z.substring(z.indexOf("(") + 1, z.lastIndexOf(")")).split(/,\s*/), w(a, j, {
                            borderColorRed: u[0],
                            borderColorGreen: u[1],
                            borderColorBlue: u[2],
                            colorAlpha: u[3]
                        }, b)) : w(a, j, {
                            borderColor: Va(F.oldBorderColor, .5, !0)
                        }, b);
                        break;
                    case "imageScale150":
                        w(a.find("img"), j, {
                            scale: 150 / e
                        }, b, "img0");
                        break;
                    case "imageScaleIn80":
                        w(a.find("img"), j, {
                            scale: 100 / e
                        }, b, "img0");
                        break;
                    case "imageSlide2Up":
                    case "imageSlide2Down":
                    case "imageSlide2Left":
                    case "imageSlide2Right":
                    case "imageSlide2UpRight":
                    case "imageSlide2UpLeft":
                    case "imageSlide2DownRight":
                    case "imageSlide2DownLeft":
                    case "imageSlide2Random":
                        switch(b.customData.hoverEffectRDir){
                            case "imageSlide2Up":
                                var N = b.thumbFullHeight < 1.4 * b.imgHeight ? (1.4 * b.imgHeight - b.thumbFullHeight) / 2 : 0;
                                w(a.find("img"), j, {
                                    translateY: -N
                                }, b, "img0");
                                break;
                            case "imageSlide2Down":
                                N = b.thumbFullHeight < 1.4 * b.imgHeight ? (1.4 * b.imgHeight - b.thumbFullHeight) / 2 : 0;
                                w(a.find("img"), j, {
                                    translateY: N
                                }, b, "img0");
                                break;
                            case "imageSlide2Left":
                                w(a.find("img"), j, {
                                    translateX: .1 * -b.thumbFullWidth
                                }, b, "img0");
                                break;
                            case "imageSlide2Right":
                                w(a.find("img"), j, {
                                    translateX: .1 * b.thumbFullWidth
                                }, b, "img0");
                                break;
                            case "imageSlide2UpRight":
                                w(a.find("img"), j, {
                                    translateY: .05 * -b.thumbFullHeight,
                                    translateX: .05 * b.thumbFullWidth
                                }, b, "img0");
                                break;
                            case "imageSlide2UpLeft":
                                w(a.find("img"), j, {
                                    translateY: .05 * -b.thumbFullHeight,
                                    translateX: .05 * -b.thumbFullWidth
                                }, b, "img0");
                                break;
                            case "imageSlide2DownRight":
                                w(a.find("img"), j, {
                                    translateY: .05 * b.thumbFullHeight,
                                    translateX: .05 * b.thumbFullWidth
                                }, b, "img0");
                                break;
                            case "imageSlide2DownLeft":
                                w(a.find("img"), j, {
                                    translateY: .05 * b.thumbFullHeight,
                                    translateX: .05 * -b.thumbFullWidth
                                }, b, "img0");
                        }
                        break;
                    case "imageScale150Outside":
                        M("", a);
                        w(a.find("img"), j, {
                            scale: 150 / e
                        }, b, "img0");
                        break;
                    case "scale120":
                        M("", a);
                        w(a, j, {
                            scale: 120 / e
                        }, b, "base");
                        break;
                    case "imageExplode":
                        M("", a);
                        for(var x = a.find(".imgContainer"), c = Math.sqrt(x.length), q = [], y = 0; y <= Math.PI; y += Math.PI / (c - 1))q.push(Math.sin(y));
                        for(var v = x.outerWidth(!0) / c, A = x.outerHeight(!0) / c, f = y = 0; f < c; f++)for(h = 0; h < c; h++)w(x.eq(y++), j, {
                            top: (-A * c / 3 + A * f - A) * q[h],
                            left: (-v * c / 3 + v * h - v) * q[f],
                            scale: 1.5,
                            opacity: 0
                        }, b);
                        break;
                    case "imageFlipHorizontal":
                        M("", a);
                        w(a.find(".imgContainer"), j, {
                            rotateX: 180
                        }, b, "imgContainer0");
                        w(a.find(".labelImage"), j, {
                            rotateX: 360
                        }, b, "labelImage0");
                        break;
                    case "imageFlipVertical":
                        M("", a), w(a.find(".imgContainer"), j, {
                            rotateY: 180
                        }, b, "imgContainer0"), w(a.find(".labelImage"), j, {
                            rotateY: 360
                        }, b, "labelImage0");
                }
            } catch (Ga) {
                W("error on hover " + Ga.message);
            }
        }
    }
    function y(a, c, b, e, d) {
        var g = "translateX translateY scale rotateX rotateY rotateZ".split(" ");
        if ("animate" == D) for(var f = 0; f < g.length; f++){
            var h = g[f];
            if (void 0 !== b[h]) {
                var k = {
                    v: parseInt(e.eltTransform[d][h]),
                    item: e,
                    tf: h,
                    eltClass: d,
                    to: parseInt(b[h])
                }, p = {
                    v: parseInt(b[h])
                };
                0 < B[c].delayBack ? jQuery(k).delay(B[c].delayBack).animate(p, {
                    duration: B[c].durationBack,
                    easing: B[c].easingBack,
                    queue: !1,
                    step: function(a) {
                        e.eltTransform[this.eltClass][this.tf] = a;
                        x(this.item, this.eltClass);
                    },
                    complete: function() {
                        e.eltTransform[this.eltClass][this.tf] = this.to;
                        x(this.item, this.eltClass);
                    }
                }) : jQuery(k).animate(p, {
                    duration: B[c].durationBack,
                    easing: B[c].easingBack,
                    queue: !1,
                    step: function(a) {
                        e.eltTransform[this.eltClass][this.tf] = a;
                        x(this.item, this.eltClass);
                    },
                    complete: function() {
                        e.eltTransform[this.eltClass][this.tf] = this.to;
                        x(this.item, this.eltClass);
                    }
                });
                delete b[h];
            }
        }
        if (0 != b.length) {
            if (0 < B[c].delay) {
                if ("transition" == D) a.delay(B[c].delayBack)[D](b, B[c].durationBack, B[c].easingBack);
                else a.delay(B[c].delayBack)[D](b, {
                    duration: B[c].durationBack,
                    easing: B[c].easingBack,
                    queue: !1
                });
            } else if ("transition" == D) a[D](b, B[c].durationBack, B[c].easingBack);
            else a[D](b, {
                duration: B[c].durationBack,
                easing: B[c].easingBack,
                queue: !1
            });
        }
    }
    function db(a) {
        if (!Z) {
            var c = a.data("index");
            if (void 0 != c) {
                "velocity" == D ? a.find("*").velocity("stop", !0) : a.find("*").filter(":animated").stop(!0, !1);
                var b = p[c];
                b.hovered = !1;
                var e = "animate" == D ? 1 : 100;
                "function" == typeof g.fnThumbnailHoverOut && g.fnThumbnailHoverOut(a, b, t());
                try {
                    for(j = 0; j < B.length; j++)switch(B[j].name){
                        case "imageSplit4":
                            var d = a.find(".imgContainer");
                            y(d.eq(0), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "imgContainer0");
                            y(d.eq(1), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "imgContainer1");
                            y(d.eq(2), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "imgContainer2");
                            y(d.eq(3), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "imgContainer3");
                            break;
                        case "imageSplitVert":
                            d = a.find(".imgContainer");
                            y(d.eq(0), j, {
                                translateX: 0
                            }, b, "imgContainer0");
                            y(d.eq(1), j, {
                                translateX: 0
                            }, b, "imgContainer1");
                            break;
                        case "labelSplit4":
                            d = a.find(".labelImage");
                            y(d.eq(0), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "labelImage0");
                            y(d.eq(1), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "labelImage1");
                            y(d.eq(2), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "labelImage2");
                            y(d.eq(3), j, {
                                translateX: 0,
                                translateY: 0
                            }, b, "labelImage3");
                            break;
                        case "labelSplitVert":
                            d = a.find(".labelImage");
                            y(d.eq(0), j, {
                                translateX: 0
                            }, b, "labelImage0");
                            y(d.eq(1), j, {
                                translateX: 0
                            }, b, "labelImage1");
                            break;
                        case "labelAppearSplit4":
                            d = a.find(".labelImage");
                            y(d.eq(0), j, {
                                translateX: -b.thumbFullWidth / 2,
                                translateY: -b.thumbFullHeight / 2
                            }, b, "labelImage0");
                            y(d.eq(1), j, {
                                translateX: b.thumbFullWidth / 2,
                                translateY: -b.thumbFullHeight / 2
                            }, b, "labelImage1");
                            y(d.eq(2), j, {
                                translateX: b.thumbFullWidth / 2,
                                translateY: b.thumbFullHeight / 2
                            }, b, "labelImage2");
                            y(d.eq(3), j, {
                                translateX: -b.thumbFullWidth / 2,
                                translateY: b.thumbFullHeight / 2
                            }, b, "labelImage3");
                            break;
                        case "labelAppearSplitVert":
                            d = a.find(".labelImage");
                            y(d.eq(0), j, {
                                translateX: -b.thumbFullWidth / 2
                            }, b, "labelImage0");
                            y(d.eq(1), j, {
                                translateX: b.thumbFullWidth / 2
                            }, b, "labelImage1");
                            break;
                        case "scaleLabelOverImage":
                            y(a.find(".labelImage"), j, {
                                opacity: 0,
                                scale: 50 / e
                            }, b, "labelImage0");
                            y(a.find(".imgContainer"), j, {
                                scale: 100 / e
                            }, b, "imgContainer0");
                            break;
                        case "overScale":
                        case "overScaleOutside":
                            y(a.find(".labelImage"), j, {
                                opacity: 0,
                                scale: 150 / e
                            }, b, "labelImage0");
                            y(a.find(".imgContainer"), j, {
                                opacity: 1,
                                scale: 100 / e
                            }, b, "imgContainer0");
                            break;
                        case "imageInvisible":
                            y(a.find(".imgContainer"), j, {
                                opacity: 1
                            });
                            break;
                        case "rotateCornerBL":
                            var f = "transition" == D ? {
                                rotate: "-90deg"
                            } : {
                                rotateZ: "-90"
                            };
                            y(a.find(".labelImage"), j, f, b, "labelImage0");
                            f = "transition" == D ? {
                                rotate: "0deg"
                            } : {
                                rotateZ: "0"
                            };
                            y(a.find(".imgContainer"), j, f, b, "imgContainer0");
                            break;
                        case "rotateCornerBR":
                            f = "transition" == D ? {
                                rotate: "90deg"
                            } : {
                                rotateZ: "90"
                            };
                            y(a.find(".labelImage"), j, f, b, "labelImage0");
                            f = "transition" == D ? {
                                rotate: "0deg"
                            } : {
                                rotateZ: "0"
                            };
                            y(a.find(".imgContainer"), j, f, b, "imgContainer0");
                            break;
                        case "imageRotateCornerBL":
                        case "imageRotateCornerBR":
                            f = "transition" == D ? {
                                rotate: "0deg"
                            } : {
                                rotateZ: "0"
                            };
                            y(a.find(".imgContainer"), j, f, b, "imgContainer0");
                            break;
                        case "slideUp":
                            y(a.find(".imgContainer"), j, {
                                translateY: 0
                            }, b, "imgContainer0");
                            y(a.find(".labelImage"), j, {
                                translateY: b.thumbFullHeight
                            }, b, "labelImage0");
                            break;
                        case "slideDown":
                            y(a.find(".imgContainer"), j, {
                                translateY: 0
                            }, b, "imgContainer0");
                            y(a.find(".labelImage"), j, {
                                translateY: -b.thumbFullHeight
                            }, b, "labelImage0");
                            break;
                        case "slideRight":
                            y(a.find(".imgContainer"), j, {
                                translateX: 0
                            }, b, "imgContainer0");
                            y(a.find(".labelImage"), j, {
                                translateX: -b.thumbFullWidth
                            }, b, "labelImage0");
                            break;
                        case "slideLeft":
                            y(a.find(".imgContainer"), j, {
                                translateX: 0
                            }, b, "imgContainer0");
                            y(a.find(".labelImage"), j, {
                                translateX: b.thumbFullWidth
                            }, b, "labelImage0");
                            break;
                        case "imageSlideUp":
                        case "imageSlideDown":
                            y(a.find(".imgContainer"), j, {
                                translateY: 0
                            }, b, "imgContainer0");
                            break;
                        case "imageSlideLeft":
                        case "imageSlideRight":
                            y(a.find(".imgContainer"), j, {
                                translateX: 0
                            }, b, "imgContainer0");
                            break;
                        case "labelAppear":
                        case "labelAppear75":
                            if ("velocity" == D) y(a.find(".labelImage"), j, {
                                backgroundColorRed: F.oldLabelRed,
                                backgroundColorGreen: F.oldLabelGreen,
                                backgroundColorBlue: F.oldLabelBlue,
                                backgroundColorAlpha: 0
                            });
                            else {
                                var h = "rgb(" + F.oldLabelRed + "," + F.oldLabelGreen + "," + F.oldLabelBlue + ",0)";
                                y(a.find(".labelImage"), j, {
                                    backgroundColor: h
                                });
                            }
                            y(a.find(".labelImageTitle"), j, {
                                opacity: 0
                            });
                            y(a.find(".labelFolderTitle"), j, {
                                opacity: 0
                            });
                            y(a.find(".labelDescription"), j, {
                                opacity: 0
                            });
                            break;
                        case "descriptionAppear":
                            y(a.find(".labelDescription"), j, {
                                opacity: 0
                            });
                            break;
                        case "labelSlideDown":
                            y(a.find(".labelImage"), j, {
                                translateY: -b.thumbFullHeight
                            }, b, "labelImage0");
                            break;
                        case "labelSlideUpTop":
                        case "labelSlideUp":
                            y(a.find(".labelImage"), j, {
                                translateY: b.thumbFullHeight
                            }, b, "labelImage0");
                            break;
                        case "descriptionSlideUp":
                            var k = "album" == b.kind ? a.find(".labelFolderTitle").outerHeight(!0) : a.find(".labelImageTitle").outerHeight(!0);
                            y(a.find(".labelImage"), j, {
                                translateY: 0,
                                height: k
                            }, b, "labelImage0");
                            break;
                        case "labelOpacity50":
                            y(a.find(".labelImage"), j, {
                                opacity: F.oldLabelOpacity
                            });
                            break;
                        case "imageOpacity50":
                            y(a.find(".imgContainer"), j, {
                                opacity: 1
                            });
                            break;
                        case "borderLighter":
                        case "borderDarker":
                            if ("velocity" == D) {
                                var r = F.oldBorderColor, z = r.substring(r.indexOf("(") + 1, r.lastIndexOf(")")).split(/,\s*/);
                                y(a, j, {
                                    borderColorRed: z[0],
                                    borderColorGreen: z[1],
                                    borderColorBlue: z[2],
                                    colorAlpha: z[3]
                                });
                            } else y(a, j, {
                                borderColor: F.oldBorderColor
                            });
                            break;
                        case "imageScale150":
                        case "imageScale150Outside":
                            y(a.find("img"), j, {
                                scale: 100 / e
                            }, b, "img0");
                            break;
                        case "imageScaleIn80":
                            y(a.find("img"), j, {
                                scale: 120 / e
                            }, b, "img0");
                            break;
                        case "imageSlide2Up":
                        case "imageSlide2Down":
                        case "imageSlide2Left":
                        case "imageSlide2Right":
                        case "imageSlide2UpRight":
                        case "imageSlide2UpLeft":
                        case "imageSlide2DownRight":
                        case "imageSlide2DownLeft":
                        case "imageSlide2Random":
                            switch(b.customData.hoverEffectRDir){
                                case "imageSlide2Up":
                                    var m = b.thumbFullHeight < 1.4 * b.imgHeight ? (1.4 * b.imgHeight - b.thumbFullHeight) / 2 : 0;
                                    y(a.find("img"), j, {
                                        translateY: m
                                    }, b, "img0");
                                    break;
                                case "imageSlide2Down":
                                    m = b.thumbFullHeight < 1.4 * b.imgHeight ? (1.4 * b.imgHeight - b.thumbFullHeight) / 2 : 0;
                                    y(a.find("img"), j, {
                                        translateY: -m
                                    }, b, "img0");
                                    break;
                                case "imageSlide2Left":
                                    y(a.find("img"), j, {
                                        translateX: .1 * b.thumbFullWidth
                                    }, b, "img0");
                                    break;
                                case "imageSlide2Right":
                                    y(a.find("img"), j, {
                                        translateX: .1 * -b.thumbFullWidth
                                    }, b, "img0");
                                    break;
                                case "imageSlide2UpRight":
                                    y(a.find("img"), j, {
                                        translateY: .05 * b.thumbFullHeight,
                                        translateX: .05 * -b.thumbFullWidth
                                    }, b, "img0");
                                    break;
                                case "imageSlide2UpLeft":
                                    y(a.find("img"), j, {
                                        translateY: .05 * b.thumbFullHeight,
                                        translateX: .05 * b.thumbFullWidth
                                    }, b, "img0");
                                    break;
                                case "imageSlide2DownRight":
                                    y(a.find("img"), j, {
                                        translateY: .05 * -b.thumbFullHeight,
                                        translateX: .05 * -b.thumbFullWidth
                                    }, b, "img0");
                                    break;
                                case "imageSlide2DownLeft":
                                    y(a.find("img"), j, {
                                        translateY: .05 * -b.thumbFullHeight,
                                        translateX: .05 * b.thumbFullWidth
                                    }, b, "img0");
                            }
                            break;
                        case "scale120":
                            y(a, j, {
                                scale: 100 / e
                            }, b, "base");
                            break;
                        case "imageExplode":
                            for(var u = a.find(".imgContainer"), c = Math.sqrt(u.length), N = 0, f = 0; f < c; f++)for(h = 0; h < c; h++)y(u.eq(N++), j, {
                                top: 0,
                                left: 0,
                                scale: 1,
                                opacity: 1
                            });
                            break;
                        case "imageFlipHorizontal":
                            y(a.find(".imgContainer"), j, {
                                rotateX: 0
                            }, b, "imgContainer0");
                            y(a.find(".labelImage"), j, {
                                rotateX: 180
                            }, b, "labelImage0");
                            break;
                        case "imageFlipVertical":
                            y(a.find(".imgContainer"), j, {
                                rotateY: 0
                            }, b, "imgContainer0"), y(a.find(".labelImage"), j, {
                                rotateY: 180
                            }, b, "labelImage0");
                    }
                } catch (w) {
                    W("error on hoverOut " + w.message);
                }
            }
        }
    }
    function ua(a) {
        if ("fancybox" == g.viewer) {
            var c = [], b = 0;
            c[b] = {};
            c[b].href = p[a].responsiveURL();
            c[b].title = p[a].title;
            for(var e = p.length, d = a + 1; d < e; d++)"image" == p[d].kind && p[d].albumID == p[a].albumID && "" == p[d].destinationURL && (b++, c[b] = {}, c[b].href = p[d].responsiveURL(), c[b].title = p[d].title);
            for(d = 0; d < a; d++)"image" == p[d].kind && p[d].albumID == p[a].albumID && "" == p[d].destinationURL && (b++, c[b] = {}, c[b].href = p[d].responsiveURL(), c[b].title = p[d].title);
            jQuery.fancybox(c, {
                autoPlay: !1,
                nextEffect: "fade",
                prevEffect: "fade",
                scrolling: "no",
                helpers: {
                    buttons: {
                        position: "bottom"
                    }
                }
            });
        } else Z ? Wa(a, "") : lc(a);
    }
    function lc(a) {
        jQuery("body").css({
            overflow: "hidden"
        });
        d.conVwCon = jQuery('<div  class="nanoGalleryViewerContainer" style="visibility:visible"></div>').appendTo("body");
        d.conVwCon.addClass("nanogallery_theme_" + g.theme);
        mc(d.conVwCon);
        d.conVw = jQuery('<div  id="nanoGalleryViewer" class="nanoGalleryViewer" style="visibility:visible" itemscope itemtype="http://schema.org/ImageObject"></div>').appendTo(d.conVwCon);
        var c;
        c = "" + ('<img class="image" src="' + p[a].responsiveURL() + '" alt=" " style="visibility:visible;opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;zoom:1;" itemprop="contentURL">');
        c += '<img class="image" src="' + p[a].responsiveURL() + '" alt=" " style="visibility:visible;opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;zoom:1;" itemprop="contentURL">';
        c += '<img class="image" src="' + p[a].responsiveURL() + '" alt=" " style="visibility:visible;opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;zoom:1;" itemprop="contentURL">';
        d.vwContent = jQuery('<div class="content">' + c + '<div class="contentAreaPrevious"></div><div class="contentAreaNext"></div></div>').appendTo(d.conVw);
        d.vwImgP = d.conVw.find(".image").eq(0);
        d.vwImgC = d.conVw.find(".image").eq(1);
        d.vwImgN = d.conVw.find(".image").eq(2);
        g.enableElevatezoom && "function" == T(jQuery().elevateZoom) && (d.vwImgP.elevateZoom({
            zoomType: "lens",
            lensShape: "round",
            lensSize: 200,
            onZoomedImageLoaded: function() {
                M("", ".zoomContainer");
            }
        }), d.vwImgN.elevateZoom({
            zoomType: "lens",
            lensShape: "round",
            lensSize: 200,
            onZoomedImageLoaded: function() {
                M("", ".zoomContainer");
            }
        }), d.vwImgC.elevateZoom({
            zoomType: "lens",
            lensShape: "round",
            lensSize: 200,
            onZoomedImageLoaded: function() {
                M("", ".zoomContainer");
            }
        }));
        d.conVwCon.find("*").attr("draggable", "false").attr("unselectable", "on");
        jQuery('<div class="closeButtonFloating"></div>').appendTo(d.conVw).on("touchstart click", function(a) {
            a.stopPropagation();
            400 > (new Date).getTime() - pa || Aa(!0);
        });
        c = "";
        Mb && (c = '<div class="ngbt setFullscreenButton fullscreenButton"></div>');
        var b = "";
        "function" == typeof g.fnViewerInfo && (b = '<div class="ngbt infoButton"></div>');
        d.conVwTb = jQuery('<div class="toolbarContainer" style="visibility:hidden;"><div class="toolbar"><div class="visibilityButton hideToolbarButton ngbt"></div><div class="previousButton ngbt"></div><div class="pageCounter"></div><div class="nextButton ngbt"></div><div class="playButton playPauseButton ngbt"></div>' + c + b + '<div class="closeButton ngbt"></div><div class="label"><div class="title" itemprop="name"></div><div class="description" itemprop="description"></div></div></div>').appendTo(d.conVw);
        g.viewerDisplayLogo && (d.vwLogo = jQuery('<div class="nanoLogo"></div>').appendTo(d.conVw));
        (!Xa || 0 < g.viewerToolbar.autoMinimize && g.viewerToolbar.autoMinimize >= P().w) && Nb();
        M("", d.conVw);
        qa(d.vwImgC);
        pa = (new Date).getTime();
        d.conVwTb.find(".closeButton").on("touchstart click", function(a) {
            a.stopPropagation();
            400 > (new Date).getTime() - pa || Aa(!0);
        });
        d.conVwTb.find(".playPauseButton").on("touchstart click", function(a) {
            a.stopPropagation();
            ab();
        });
        d.conVwTb.find(".visibilityButton").on("touchstart click", function(a) {
            a.stopPropagation();
            Xa ? Nb() : (Xa = !0, d.conVwTb.find(".visibilityButton").removeClass("viewToolbarButton").addClass("hideToolbarButton"), d.conVwTb.find(".ngbt").not(":first").show(), d.conVwTb.find(".description").show(), d.conVwTb.find(".pageCounter").show(), qa(d.vwImgC));
        });
        d.conVwTb.find(".fullscreenButton").on("touchstart click", function(a) {
            a.stopPropagation();
            Ob();
        });
        d.conVwTb.find(".infoButton").on("touchstart click", function(a) {
            a.stopPropagation();
            "function" == typeof g.fnViewerInfo && g.fnViewerInfo(p[Ha], t());
        });
        d.conVwTb.find(".nextButton").on("touchstart click", function(a) {
            a.stopPropagation();
            Ba();
        });
        d.conVwTb.find(".previousButton").on("touchstart click", function(a) {
            a.stopPropagation();
            Ca();
        });
        d.vwContent.find(".contentAreaNext").on("touchstart click", function(a) {
            a.stopPropagation();
            Ba();
        });
        d.vwContent.find(".contentAreaPrevious").on("touchstart click", function(a) {
            a.stopPropagation();
            Ca();
        });
        d.vwContent.on("click", function(a) {
            400 > (new Date).getTime() - pa || (a.stopPropagation(), Aa(!0));
        });
        d.conVw.find(".image").attr("draggable", "false").attr("unselectable", "on").css({
            "-moz-user-select": "none",
            "-khtml-user-select": "none",
            "-webkit-user-select": "none",
            "-o-user-select": "none",
            "user-select": "none"
        });
        Wa(a, "");
        g.slideshowAutoStart && (ka = !0, d.conVwTb.find(".playPauseButton").removeClass("playButton").addClass("pauseButton"), ya(), za = window.setInterval(function() {
            ya();
        }, Ma));
    }
    function nc(a) {
        function c(a) {
            var b = {};
            a.targetTouches ? (b.x = a.targetTouches[0].clientX, b.y = a.targetTouches[0].clientY) : (b.x = a.clientX, b.y = a.clientY);
            return b;
        }
        function b() {
            e && (Pb(g - (d.x - f.x)), e = !1);
        }
        var e = !1, d = null, f = null, g = 0;
        this.handleGestureStart = (function(a) {
            Z && (a.preventDefault(), a.touches && 1 < a.touches.length || (d = c(a), window.navigator.msPointerEnabled ? (document.addEventListener("MSPointerMove", this.handleGestureMove, !0), document.addEventListener("MSPointerUp", this.handleGestureEnd, !0)) : (document.addEventListener("touchmove", this.handleGestureMove, !0), document.addEventListener("touchend", this.handleGestureEnd, !0), document.addEventListener("touchcancel", this.handleGestureEnd, !0), document.addEventListener("mousemove", this.handleGestureMove, !0), document.addEventListener("mouseup", this.handleGestureEnd, !0))));
        }).bind(this);
        this.handleGestureMove = (function(a) {
            a.preventDefault();
            f = c(a);
            e || (e = !0, window.requestAnimFrame(b));
        }).bind(this);
        this.handleGestureEnd = (function(a) {
            a.preventDefault();
            a.touches && 0 < a.touches.length || (e = !1, window.navigator.msPointerEnabled ? (document.removeEventListener("MSPointerMove", this.handleGestureMove, !0), document.removeEventListener("MSPointerUp", this.handleGestureEnd, !0)) : (document.removeEventListener("touchmove", this.handleGestureMove, !0), document.removeEventListener("touchend", this.handleGestureEnd, !0), document.removeEventListener("touchcancel", this.handleGestureEnd, !0), document.removeEventListener("mousemove", this.handleGestureMove, !0), document.removeEventListener("mouseup", this.handleGestureEnd, !0)), null == f ? (g = 0, d = null) : (a = d.x - f.x, g -= a, -50 > a && Ca(), 50 < a && Ba(), g = 0, f = d = null, 50 > Math.abs(a) && Pb(g)));
        }).bind(this);
        window.navigator.msPointerEnabled ? a.addEventListener("MSPointerDown", this.handleGestureStart, !0) : a.addEventListener("touchstart", this.handleGestureStart, !0);
    }
    function Pb(a) {
        Ya = a;
        if (null == O) d.vwImgC.css({
            left: a
        });
        else if (d.vwImgC[0].style[O] = "translateX(" + a + "px)", "slide" == g.imageTransition) {
            if (0 < a) {
                var c = P().w;
                d.vwImgP.css({
                    visibility: "visible",
                    left: 0,
                    opacity: 1
                });
                d.vwImgP[0].style[O] = "translateX(" + (-c + a) + "px) ";
                d.vwImgN[0].style[O] = "translateX(" + -c + "px) ";
            } else c = -P().w, d.vwImgN.css({
                visibility: "visible",
                left: 0,
                opacity: 1
            }), d.vwImgN[0].style[O] = "translateX(" + (-c + a) + "px) ", d.vwImgP[0].style[O] = "translateX(" + -c + "px) ";
        }
    }
    function Ob() {
        Za ? (document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen && document.mozCancelFullScreen(), Za = !1, d.conVwTb.find(".fullscreenButton").removeClass("removeFullscreenButton").addClass("setFullscreenButton")) : (d.conVwCon[0].requestFullscreen ? d.conVwCon[0].requestFullscreen() : d.conVwCon[0].webkitRequestFullscreen ? d.conVwCon[0].webkitRequestFullscreen() : d.conVwCon[0].msRequestFullscreen ? d.conVwCon[0].msRequestFullscreen() : d.conVwCon[0].mozRequestFullScreen && d.conVwCon[0].mozRequestFullScreen(), Za = !0, d.conVwTb.find(".fullscreenButton").removeClass("setFullscreenButton").addClass("removeFullscreenButton"));
    }
    function ab() {
        ka ? (window.clearInterval(za), ka = !1, d.conVwTb.find(".playPauseButton").removeClass("pauseButton").addClass("playButton")) : (ka = !0, d.conVwTb.find(".playPauseButton").removeClass("playButton").addClass("pauseButton"), ya(), za = window.setInterval(function() {
            ya();
        }, Ma));
    }
    function Nb() {
        Xa = !1;
        d.conVwTb.find(".visibilityButton").removeClass("hideToolbarButton").addClass("viewToolbarButton");
        d.conVwTb.find(".ngbt").not(":first").hide();
        d.conVwTb.find(".description").hide();
        d.conVwTb.find(".pageCounter").hide();
        qa(d.vwImgC);
    }
    function Ba() {
        ka && (window.clearInterval(za), za = window.setInterval(function() {
            ya();
        }, Ma));
        ya();
    }
    function ya() {
        if (!(Ia || 300 > (new Date).getTime() - pa)) {
            var a = qb(Ha);
            Wa(a, "nextImage");
        }
    }
    function Ca() {
        if (!(Ia || 300 > (new Date).getTime() - pa)) {
            ka && ab();
            var a = rb(Ha);
            Wa(a, "previousImage");
        }
    }
    function Wa(a, c) {
        pa = (new Date).getTime();
        Ia = !0;
        if (g.locationHash) {
            var b = "nanogallery/" + ga + "/" + p[a].albumID + "/" + p[a].GetID();
            "#" + b != location.hash ? (sa = "#" + b, top.location.hash = b) : sa = top.location.hash;
        }
        oc(a);
        qa(d.vwImgC);
        Ha = a;
        if ("" == c) d.vwImgC.css({
            opacity: 0,
            left: 0,
            visibility: "visible"
        }).attr("src", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==").attr("src", p[a].responsiveURL()), g.enableElevatezoom && "function" == T(jQuery().elevateZoom) && d.vwImgC.attr("data-zoom-image", p[a].responsiveURL()), jQuery.when(d.vwImgC.animate({
            opacity: 1
        }, 300)).done(function() {
            ra(a, c);
        });
        else switch(g.imageTransition){
            case "fade":
                d.vwImgN.css({
                    opacity: 0,
                    left: 0,
                    visibility: "visible"
                });
                jQuery.when(d.vwImgC.animate({
                    opacity: 0
                }, 5E3), d.vwImgN.animate({
                    opacity: 1
                }, 300)).done(function() {
                    ra(a, c);
                });
                break;
            case "slideBETA":
                var e = "nextImage" == c ? d.vwImgN : d.vwImgP;
                e.css({
                    opacity: 1,
                    left: 0,
                    visibility: "visible"
                });
                if (null == O) jQuery.when(d.vwImgC.animate({
                    left: ("nextImage" == c ? -P().w : P().w) + "px",
                    opacity: 0
                }, 500), e.animate({
                    opacity: 1
                }, 300)).done(function() {
                    ra(a, c);
                });
                else {
                    var f = "nextImage" == c ? -P().w : P().w;
                    e[0].style[O] = "translateX(" + -f + "px) ";
                    var b = {
                        v: Ya
                    }, h = {
                        v: "nextImage" == c ? -P().w : P().w
                    };
                    jQuery(b).animate(h, {
                        duration: 500,
                        step: function(a) {
                            d.vwImgC[0].style[O] = "translateX(" + a + "px)";
                            d.vwImgC.css({
                                opacity: 1 - Math.abs(a / f)
                            });
                            e[0].style[O] = "translateX(" + (-f + a) + "px) ";
                        },
                        complete: function() {
                            d.vwImgC[0].style[O] = "";
                            d.vwImgC.css({
                                opacity: 0
                            });
                            ra(a, c);
                        }
                    });
                }
                break;
            case "slide":
                e = "nextImage" == c ? d.vwImgN : d.vwImgP;
                null == O ? (e.css({
                    opacity: 0,
                    left: 0,
                    visibility: "visible"
                }), jQuery.when(d.vwImgC.animate({
                    left: ("nextImage" == c ? -P().w : P().w) + "px"
                }, 500), e.animate({
                    opacity: 1
                }, 300)).done(function() {
                    ra(a, c);
                })) : (e.css({
                    opacity: 1,
                    left: 0,
                    visibility: "visible"
                }), f = "nextImage" == c ? -P().w : P().w, e[0].style[O] = "translateX(" + -f + "px) ", b = {
                    v: Ya
                }, h = {
                    v: "nextImage" == c ? -P().w : P().w
                }, jQuery(b).animate(h, {
                    duration: 500,
                    easing: "linear",
                    step: function(a) {
                        d.vwImgC[0].style[O] = "translateX(" + a + "px)";
                        e[0].style[O] = "translateX(" + (-f + a) + "px) ";
                    },
                    complete: function() {
                        d.vwImgC[0].style[O] = "";
                        ra(a, c);
                    }
                }));
                break;
            default:
                f = P().w + "px", e = d.vwImgP, "nextImage" == c && (f = "-" + f, e = d.vwImgN), e.css({
                    opacity: 0,
                    left: 0,
                    visibility: "visible"
                }), jQuery.when(d.vwImgC.animate({
                    left: f,
                    opacity: 0
                }, 500), e.animate({
                    opacity: 1
                }, 300)).done(function() {
                    ra(a, c);
                });
        }
        Z = !0;
    }
    function ra(a, c) {
        Ya = 0;
        d.vwImgC.off("click");
        d.vwImgC.removeClass("imgCurrent");
        var b = d.vwImgC;
        switch(c){
            case "nextImage":
                d.vwImgC = d.vwImgN;
                d.vwImgN = b;
                break;
            case "previousImage":
                d.vwImgC = d.vwImgP, d.vwImgP = b;
        }
        d.vwImgC.addClass("imgCurrent");
        null == sb && (sb = new nc(d.conVwCon[0]));
        d.vwImgN.css({
            opacity: 0,
            left: 0,
            visibility: "hidden"
        }).attr("src", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==").attr("src", p[qb(a)].responsiveURL());
        d.vwImgP.css({
            opacity: 0,
            left: 0,
            visibility: "hidden"
        }).attr("src", "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==").attr("src", p[rb(a)].responsiveURL());
        d.vwImgC.on("click", function(a) {
            a.stopPropagation();
            a.pageX < jQuery(window).width() / 2 ? Ca() : Ba();
        });
        g.enableElevatezoom && "function" == T(jQuery().elevateZoom) && (d.vwImgN.attr("data-zoom-image", p[qb(a)].responsiveURL()), d.vwImgP.attr("data-zoom-image", p[rb(a)].responsiveURL()), jQuery(".zoomContainer").remove(), b = d.vwImgC.data("elevateZoom"), b.imageSrc = d.vwImgC.attr("src"), b.zoomImage = d.vwImgC.attr("src"), b.fetch(b.imageSrc));
        qa(d.vwImgC);
        Ia = !1;
    }
    function qb(a) {
        for(var c = p.length, b = -1, e = a + 1; e < c; e++)if (p[e].albumID == p[a].albumID && "image" == p[e].kind) {
            b = e;
            break;
        }
        if (-1 == b) {
            for(e = 0; e <= a; e++)if (p[e].albumID == p[a].albumID && "image" == p[e].kind) {
                b = e;
                break;
            }
        }
        return b;
    }
    function rb(a) {
        for(var c = -1, b = a - 1; 0 <= b; b--)if (p[b].albumID == p[a].albumID && "image" == p[b].kind) {
            c = b;
            break;
        }
        if (-1 == c) {
            for(b = p.length - 1; b >= a; b--)if (p[b].albumID == p[a].albumID && "image" == p[b].kind) {
                c = b;
                break;
            }
        }
        return c;
    }
    function oc(a) {
        void 0 !== p[a].title ? d.conVwTb.find(".title").html(p[a].title) : d.conVwTb.find(".title").html("");
        void 0 !== p[a].description ? d.conVwTb.find(".description").html(p[a].description) : d.conVwTb.find(".description").html("");
        for(var c = 0, b = p.length, e = 0; e < b; e++)p[e].albumID == p[a].albumID && "image" == p[e].kind && c++;
        0 < c && d.conVwTb.find(".pageCounter").html(p[a].imageNumber + 1 + "/" + c);
    }
    function Aa(a) {
        Ia && d.vwContent.find("*").stop(!0, !0);
        Z && (sb = null, window.clearInterval(tb), ka && (window.clearInterval(za), ka = !1), Za && Ob(), Z = !1, d.conVwCon.off().remove(), d.base.hasClass("fullpage") || jQuery("body").css({
            overflow: "inherit"
        }), -1 != Pa ? Y(Pa, !0) : (g.locationHash && a && (a = "nanogallery/" + ga + "/" + p[Ha].albumID, sa = "#" + a, top.location.hash = a), Ea()));
    }
    function qa(a) {
        window.clearInterval(tb);
        tb = window.setInterval(function() {
            qa(d.vwImgC);
        }, 200);
        var c = d.conVw.width(), b = d.conVw.height();
        d.conVw.css({
            visibility: "visible",
            position: "fixed"
        });
        40 >= d.vwImgC.height() ? d.conVwTb.css({
            visibility: "hidden"
        }) : d.conVwTb.css({
            visibility: "visible"
        });
        var e = Math.abs(d.vwContent.outerHeight(!0) - d.vwContent.height()), f = Math.abs(d.vwContent.outerWidth(!0) - d.vwContent.width()), h = a.outerHeight(!1) - a.innerHeight(), k = Math.abs(a.outerWidth(!1) - a.innerWidth()), p = Math.abs(a.innerHeight() - a.height());
        a = Math.abs(a.innerWidth() - a.width());
        h += p;
        k += a;
        p = 0;
        "innerImage" != g.viewerToolbar.style && (p = d.conVwTb.find(".toolbar").outerHeight(!0));
        b = b - p - e;
        c -= f;
        switch(g.viewerToolbar.position){
            case "top":
                d.vwContent.css({
                    height: b,
                    width: c,
                    top: p
                });
                f = 0;
                "innerImage" == g.viewerToolbar.style && (f = Math.abs(d.vwImgC.outerHeight(!0) - d.vwImgC.height()) / 2 + 5);
                "stuckImage" == g.viewerToolbar.style && (f = Math.abs(d.vwImgC.outerHeight(!0) - d.vwImgC.height()) / 2 - h);
                d.conVwTb.css({
                    top: f
                });
                break;
            default:
                d.vwContent.css({
                    height: b,
                    width: c
                }), f = 0, "innerImage" == g.viewerToolbar.style && (f = Math.abs(d.vwImgC.outerHeight(!0) - d.vwImgC.height()) / 2 + 5), "stuckImage" == g.viewerToolbar.style && (f = Math.abs(d.vwImgC.outerHeight(!0) - d.vwImgC.height()) / 2 - h), d.conVwTb.css({
                    bottom: f
                });
        }
        "innerImage" == g.viewerToolbar.style && d.conVwTb.find(".toolbar").css({
            "max-width": d.vwImgC.width()
        });
        "fullWidth" == g.viewerToolbar.style && d.conVwTb.find(".toolbar").css({
            width: c
        });
        d.conVwTb.css({
            height: d.conVwTb.find(".toolbar").outerHeight(!0)
        });
        d.vwContent.children("img").css({
            "max-width": c - k,
            "max-height": b - h
        });
    }
    function pc(a) {
        var c = null;
        switch(T(g.colorScheme)){
            case "object":
                c = Qb;
                jQuery.extend(!0, c, g.colorScheme);
                g_colorSchemeLabel = "nanogallery_colorscheme_custom_" + ga;
                break;
            case "string":
                switch(g.colorScheme){
                    case "none":
                        return;
                    case "light":
                        c = qc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_light";
                        break;
                    case "lightBackground":
                        c = rc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_lightBackground";
                        break;
                    case "darkRed":
                        c = sc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_darkred";
                        break;
                    case "darkGreen":
                        c = tc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_darkgreen";
                        break;
                    case "darkBlue":
                        c = uc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_darkblue";
                        break;
                    case "darkOrange":
                        c = vc;
                        g_colorSchemeLabel = "nanogallery_colorscheme_darkorange";
                        break;
                    default:
                        c = Qb, g_colorSchemeLabel = "nanogallery_colorscheme_default";
                }
                break;
            default:
                W("Error in colorScheme parameter.");
                return;
        }
        var b = "." + g_colorSchemeLabel + " ", e = b + ".nanoGalleryNavigationbar { background:" + c.navigationbar.background + " !important; }\n";
        void 0 !== c.navigationbar.border && (e += b + ".nanoGalleryNavigationbar { border:" + c.navigationbar.border + " !important; }\n");
        void 0 !== c.navigationbar.borderTop && (e += b + ".nanoGalleryNavigationbar { border-top:" + c.navigationbar.borderTop + " !important; }\n");
        void 0 !== c.navigationbar.borderBottom && (e += b + ".nanoGalleryNavigationbar { border-bottom:" + c.navigationbar.borderBottom + " !important; }\n");
        void 0 !== c.navigationbar.borderRight && (e += b + ".nanoGalleryNavigationbar { border-right:" + c.navigationbar.borderRight + " !important; }\n");
        void 0 !== c.navigationbar.borderLeft && (e += b + ".nanoGalleryNavigationbar { border-left:" + c.navigationbar.borderLeft + " !important; }\n");
        e += b + ".nanoGalleryNavigationbar .oneFolder  { color:" + c.navigationbar.color + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .separator  { color:" + c.navigationbar.color + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .nanoGalleryTags { color:" + c.navigationbar.color + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .setFullPageButton { color:" + c.navigationbar.color + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .removeFullPageButton { color:" + c.navigationbar.color + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .oneFolder:hover { color:" + c.navigationbar.colorHover + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .separator:hover { color:" + c.navigationbar.colorHover + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .nanoGalleryTags:hover { color:" + c.navigationbar.colorHover + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .setFullPageButton:hover { color:" + c.navigationbar.colorHover + " !important; }\n";
        e += b + ".nanoGalleryNavigationbar .removeFullPageButton:hover { color:" + c.navigationbar.colorHover + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer { background:" + c.thumbnail.background + " !important; border:" + c.thumbnail.border + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .imgContainer { background:" + c.thumbnail.background + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelImage{ background:" + c.thumbnail.labelBackground + " ; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelImageTitle  { color:" + c.thumbnail.titleColor + " !important; Text-Shadow:" + c.thumbnail.titleShadow + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelImageTitle:before { color:" + c.thumbnail.titleColor + " !important; Text-Shadow:" + c.thumbnail.titleShadow + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelFolderTitle { color:" + c.thumbnail.titleColor + " !important; Text-Shadow:" + c.thumbnail.titleShadow + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelFolderTitle:before { color:" + c.thumbnail.titleColor + " !important; Text-Shadow:" + c.thumbnail.titleShadow + " !important; }\n";
        e += b + ".nanoGalleryContainer > .nanoGalleryThumbnailContainer .labelDescription { color:" + c.thumbnail.descriptionColor + " !important; Text-Shadow:" + c.thumbnail.descriptionShadow + " !important; }\n";
        c = "nanogallery_galleryfullpage_bgcolor_" + ga;
        e += "." + c + ".fullpage { background:" + g.galleryFullpageBgColor + " !important; }\n";
        jQuery("head").append("<style>" + e + "</style>");
        jQuery(a).addClass(g_colorSchemeLabel);
        jQuery(a).addClass(c);
    }
    function mc(a) {
        var c = null;
        switch(T(g.colorSchemeViewer)){
            case "object":
                c = Rb;
                jQuery.extend(!0, c, g.colorSchemeViewer);
                g_colorSchemeLabel = "nanogallery_colorschemeviewer_custom";
                break;
            case "string":
                switch(g.colorSchemeViewer){
                    case "none":
                        return;
                    case "light":
                        c = wc;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_light";
                        break;
                    case "darkRed":
                        c = xc;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_darkred";
                        break;
                    case "darkGreen":
                        c = yc;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_darkgreen";
                        break;
                    case "darkBlue":
                        c = zc;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_darkblue";
                        break;
                    case "darkOrange":
                        c = Ac;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_darkorange";
                        break;
                    case "dark":
                        c = Bc;
                        g_colorSchemeLabel = "nanogallery_colorschemeviewer_dark";
                        break;
                    default:
                        c = Rb, g_colorSchemeLabel = "nanogallery_colorschemeviewer_default";
                }
                break;
            default:
                W("Error in colorSchemeViewer parameter.");
                return;
        }
        var b = "." + g_colorSchemeLabel + " ", e = b + ".nanoGalleryViewer { background:" + c.background + " !important; }\n", e = e + (b + ".nanoGalleryViewer .content img { border:" + c.imageBorder + " !important; box-shadow:" + c.imageBoxShadow + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar { background:" + c.barBackground + " !important; border:" + c.barBorder + " !important; color:" + c.barColor + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar .previousButton:after { color:" + c.barColor + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar .nextButton:after { color:" + c.barColor + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar .closeButton:after { color:" + c.barColor + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar .label .title { color:" + c.barColor + " !important; }\n"), e = e + (b + ".nanoGalleryViewer .toolbar .label .description { color:" + c.barDescriptionColor + " !important; }\n");
        jQuery("head").append("<style>" + e + "</style>");
        jQuery(a).addClass(g_colorSchemeLabel);
    }
    function W(a) {
        ia(a);
        null != d.conConsole && (d.conConsole.css({
            visibility: "visible",
            height: "60px"
        }), d.conConsole.append("<p>nanoGALLERY: " + a + " [" + ga + "]</p>"));
    }
    function ia(a) {
        window.console && console.log("nanoGALLERY: " + a + " [" + ga + "]");
    }
    function P() {
        var a = jQuery(window);
        return {
            l: a.scrollLeft(),
            t: a.scrollTop(),
            w: a.width(),
            h: a.height()
        };
    }
    function Jb(a, c) {
        var b = P(), e = a.offset(), d = a.outerHeight(!0), f = a.outerWidth(!0);
        return e.top >= b.t - c && e.top + d <= b.t + b.h + c && e.left >= b.l - c && e.left + f <= b.l + b.w + c ? !0 : !1;
    }
    function va(a, c) {
        var b = P(), e = a.offset(), d = a.outerHeight(!0);
        a.outerWidth(!0);
        return 0 == b.t && e.top <= b.t + b.h ? !0 : e.top >= b.t && e.top + d <= b.t + b.h - c ? !0 : !1;
    }
    function M(a, c) {
        var b = 0;
        "" == a && (a = "*");
        jQuery(a).each(function() {
            var a = parseInt(jQuery(this).css("z-index"));
            b = a > b ? a : b;
        });
        b++;
        jQuery(c).css("z-index", b);
    }
    function na(a) {
        for(var c, b, e = a.length; e; c = Math.floor(Math.random() * e), b = a[--e], a[e] = a[c], a[c] = b);
        return a;
    }
    var R = {
        paginationPrevious: "Previous",
        paginationNext: "Next",
        breadcrumbHome: "List of Albums",
        thumbnailImageTitle: "",
        thumbnailAlbumTitle: "",
        thumbnailImageDescription: "",
        thumbnailAlbumDescription: ""
    }, g = null, p = [], d = {
        base: null,
        conTnParent: null,
        conLoadingB: null,
        conConsole: null,
        conTn: null,
        conTnHid: null,
        conPagin: null,
        conBC: null,
        conNavB: null,
        conNavBCon: null,
        conNavBFullpage: null,
        conVwCon: null,
        conVw: null,
        conVwTb: null,
        vwImgP: null,
        vwImgN: null,
        vwImgC: null,
        vwContent: null,
        vwLogo: null
    }, aa = null, ga = null, Hb = null, Ib = !1, Z = !1, f = {
        displayInterval: 30,
        lazyLoadTreshold: 100,
        scale: 1,
        borderWidth: 0,
        borderHeight: 0,
        imgcBorderHeight: 0,
        imgcBorderWidth: 0,
        labelHeight: 0,
        outerWidth: {
            l1: {
                xs: 0,
                sm: 0,
                me: 0,
                la: 0,
                xl: 0
            },
            lN: {
                xs: 0,
                sm: 0,
                me: 0,
                la: 0,
                xl: 0
            }
        },
        outerHeight: {
            l1: {
                xs: 0,
                sm: 0,
                me: 0,
                la: 0,
                xl: 0
            },
            lN: {
                xs: 0,
                sm: 0,
                me: 0,
                la: 0,
                xl: 0
            }
        },
        settings: {
            width: {
                l1: {
                    xs: 0,
                    sm: 0,
                    me: 0,
                    la: 0,
                    xl: 0,
                    xsc: "u",
                    smc: "u",
                    mec: "u",
                    lac: "u",
                    xlc: "u"
                },
                lN: {
                    xs: 0,
                    sm: 0,
                    me: 0,
                    la: 0,
                    xl: 0,
                    xsc: "u",
                    smc: "u",
                    mec: "u",
                    lac: "u",
                    xlc: "u"
                }
            },
            height: {
                l1: {
                    xs: 0,
                    sm: 0,
                    me: 0,
                    la: 0,
                    xl: 0,
                    xsc: "u",
                    smc: "u",
                    mec: "u",
                    lac: "u",
                    xlc: "u"
                },
                lN: {
                    xs: 0,
                    sm: 0,
                    me: 0,
                    la: 0,
                    xl: 0,
                    xsc: "u",
                    smc: "u",
                    mec: "u",
                    lac: "u",
                    xlc: "u"
                }
            }
        }
    }, B = [], Ka = null, La = null, Fa = null, ka = !1, Xa = !0, za = 0, Ma = 3E3, cb = 0, Mb = !1, Za = !1, fa = "", pa = 0, fb = 0, ja = 1, U = 0, gb = -1, sa = "", Ia = !1, tb = -1, Ha = -1, Ya = 0, Pa = -1, F = {}, ha = 0, Sa = -1, Ta = -1, Eb = !1, sb = null, D = "animate", ub = 0, vb = 0, Na = 1E6, Oa = 1E6, G = "l1", H = "me", O = K([
        "transform",
        "msTransform",
        "MozTransform",
        "WebkitTransform",
        "OTransform"
    ]), Lb = K([
        "transformStyle",
        "msTransformStyle",
        "MozTransformStyle",
        "WebkitTransformStyle",
        "OTransformStyle"
    ]), Ua = K([
        "perspective",
        "msPerspective",
        "MozPerspective",
        "WebkitPerspective",
        "OPerspective"
    ]), xa = K([
        "backfaceVisibility",
        "msBackfaceVisibility",
        "MozBackfaceVisibility",
        "WebkitBackfaceVisibility",
        "OBackfaceVisibility"
    ]);
    K([
        "transition",
        "msTransition",
        "MozTransition",
        "WebkitTransition",
        "OTransition"
    ]);
    K([
        "animation",
        "msAnimation",
        "MozAnimation",
        "WebkitAnimation",
        "OAnimation"
    ]);
    var jc = function() {
        if (document.documentMode) return document.documentMode;
        for(var a = 7; 4 < a; a--){
            var c = document.createElement("div");
            c.innerHTML = "<!--[if IE " + a + "]><span></span><![endif]-->";
            if (c.getElementsByTagName("span").length) return a;
        }
    }(), Ub = /(iPad|iPhone|iPod)/g.test(navigator.userAgent), kc = /Android 2\.3\.[3-7]/i.test(navigator.userAgent), ma = !1, Cb = {
        url: function() {
            return "https://picasaweb.google.com/data/feed/api/";
        },
        thumbSize: 64,
        thumbAvailableSizes: [
            32,
            48,
            64,
            72,
            94,
            104,
            110,
            128,
            144,
            150,
            160,
            200,
            220,
            288,
            320,
            400,
            512,
            576,
            640,
            720,
            800,
            912,
            1024,
            1152,
            1280,
            1440,
            1600
        ],
        thumbAvailableSizesCropped: " 32 48 64 72 104 144 150 160 "
    }, L = {
        url: function() {
            return "https://api.flickr.com/services/rest/";
        },
        thumbSize: "sq",
        thumbSizeX2: "sq",
        thumbSizeDir: "height_",
        thumbAvailableSizes: [
            75,
            100,
            150,
            240,
            500,
            640
        ],
        thumbAvailableSizesStr: "sq t q s m z".split(" "),
        photoSize: "sq",
        photoAvailableSizes: [
            75,
            100,
            150,
            240,
            500,
            640,
            1024,
            1024,
            1600,
            2048
        ],
        photoAvailableSizesStr: "sq t q s m z b l h k".split(" "),
        ApiKey: "2f0e634b471fdb47446abcb9c5afebdc"
    }, Q = {
        url: function() {
            return "https:" == location.protocol ? "https://api.smugmug.com/services/api/json/1.3.0/" : "http://api.smugmug.com/services/api/json/1.3.0/";
        },
        APIKey: "WJlHxuysNWKawKlzgrgDxTSirUOAYpbn",
        photoAvailableSizes: [
            100,
            150,
            400,
            600,
            800,
            1024,
            1280,
            1600
        ],
        photoAvailableSizesStr: "TinyURL ThumbURL SmallURL MediumURL LargeURL XLargeURL X2LargeURL X3LargeURL".split(" "),
        thumbSize: 0,
        thumbSizeX2: 0,
        photoSize: 0
    }, Qb = {
        navigationbar: {
            background: "none",
            borderTop: "1px solid #555",
            borderBottom: "1px solid #555",
            borderRight: "",
            borderLeft: "",
            color: "#ccc",
            colorHover: "#fff"
        },
        thumbnail: {
            background: "#000",
            border: "1px solid #000",
            labelBackground: "rgba(34, 34, 34, 0.75)",
            titleColor: "#eee",
            titleShadow: "",
            descriptionColor: "#ccc",
            descriptionShadow: ""
        }
    }, sc = {
        navigationbar: {
            background: "#a60000",
            border: "1px dotted #ff0000",
            color: "#ccc",
            colorHover: "#fff"
        },
        thumbnail: {
            background: "#a60000",
            border: "1px solid #ff0000",
            labelBackground: "rgba(134, 0, 0, 0.75)",
            titleColor: "#eee",
            titleShadow: "",
            descriptionColor: "#ccc",
            descriptionShadow: ""
        }
    }, tc = {
        navigationbar: {
            background: "#008500",
            border: "1px dotted #00cc00",
            color: "#ccc",
            colorHover: "#fff"
        },
        thumbnail: {
            background: "#008500",
            border: "1px solid #00cc00",
            labelBackground: "rgba(0, 105, 0, 0.75)",
            titleColor: "#eee",
            titleShadow: "",
            descriptionColor: "#ccc",
            descriptionShadow: ""
        }
    }, uc = {
        navigationbar: {
            background: "#071871",
            border: "1px dotted #162ea2",
            color: "#ccc",
            colorHover: "#fff"
        },
        thumbnail: {
            background: "#071871",
            border: "1px solid #162ea2",
            labelBackground: "rgba(7, 8, 81, 0.75)",
            titleColor: "#eee",
            titleShadow: "",
            descriptionColor: "#ccc",
            descriptionShadow: ""
        }
    }, vc = {
        navigationbar: {
            background: "#a67600",
            border: "1px dotted #ffb600",
            color: "#ccc",
            colorHover: "#fff"
        },
        thumbnail: {
            background: "#a67600",
            border: "1px solid #ffb600",
            labelBackground: "rgba(134, 86, 0, 0.75)",
            titleColor: "#eee",
            titleShadow: "",
            descriptionColor: "#ccc",
            descriptionShadow: ""
        }
    }, qc = {
        navigationbar: {
            background: "none",
            borderTop: "1px solid #ddd",
            borderBottom: "1px solid #ddd",
            borderRight: "",
            borderLeft: "",
            color: "#777",
            colorHover: "#eee"
        },
        thumbnail: {
            background: "#fff",
            border: "1px solid #fff",
            labelBackground: "rgba(60, 60, 60, 0.75)",
            titleColor: "#fff",
            titleShadow: "none",
            descriptionColor: "#eee",
            descriptionShadow: "none"
        }
    }, rc = {
        navigationbar: {
            background: "none",
            border: "",
            color: "#000",
            colorHover: "#444"
        },
        thumbnail: {
            background: "#000",
            border: "1px solid #000",
            labelBackground: "rgba(34, 34, 34, 0.85)",
            titleColor: "#fff",
            titleShadow: "",
            descriptionColor: "#eee",
            descriptionShadow: ""
        }
    }, Rb = {
        background: "#000",
        imageBorder: "4px solid #000",
        imageBoxShadow: "#888 0px 0px 0px",
        barBackground: "rgba(4, 4, 4, 0.7)",
        barBorder: "0px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, Bc = {
        background: "rgba(1, 1, 1, 0.75)",
        imageBorder: "4px solid #f8f8f8",
        imageBoxShadow: "#888 0px 0px 20px",
        barBackground: "rgba(4, 4, 4, 0.7)",
        barBorder: "0px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, xc = {
        background: "rgba(1, 1, 1, 0.75)",
        imageBorder: "4px solid #ffa3a3",
        imageBoxShadow: "#ff0000 0px 0px 20px",
        barBackground: "#a60000",
        barBorder: "2px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, yc = {
        background: "rgba(1, 1, 1, 0.75)",
        imageBorder: "4px solid #97e697",
        imageBoxShadow: "#00cc00 0px 0px 20px",
        barBackground: "#008500",
        barBorder: "2px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, zc = {
        background: "rgba(1, 1, 1, 0.75)",
        imageBorder: "4px solid #a0b0d7",
        imageBoxShadow: "#162ea2 0px 0px 20px",
        barBackground: "#071871",
        barBorder: "2px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, Ac = {
        background: "rgba(1, 1, 1, 0.75)",
        imageBorder: "4px solid #ffd7b7",
        imageBoxShadow: "#ffb600 0px 0px 20px",
        barBackground: "#a67600",
        barBorder: "2px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, wc = {
        background: "rgba(187, 187, 187, 0.75)",
        imageBorder: "none",
        imageBoxShadow: "#888 0px 0px 0px",
        barBackground: "rgba(4, 4, 4, 0.7)",
        barBorder: "0px solid #111",
        barColor: "#eee",
        barDescriptionColor: "#aaa"
    }, $b = function() {
        function a(a, e) {
            var d = 0, d = void 0 === e || null === e ? c++ : e;
            this.GetID = function() {
                return d;
            };
            this.title = a;
            this.src = this.description = "";
            this.height = this.width = 0;
            this.thumbX2src = this.thumbsrc = this.author = this.kind = this.destinationURL = "";
            this.thumbLabelHeight = this.thumbLabelWidth = this.thumbFullHeight = this.thumbFullWidth = this.thumbImgHeight = this.thumbImgWidth = 0;
            this.thumbSizes = {};
            this.thumbs = {
                url: {
                    l1: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    },
                    lN: {
                        xs: "",
                        sm: "",
                        me: "",
                        la: "",
                        xl: ""
                    }
                },
                width: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                },
                height: {
                    l1: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    },
                    lN: {
                        xs: 0,
                        sm: 0,
                        me: 0,
                        la: 0,
                        xl: 0
                    }
                }
            };
            this.picasaThumbs = null;
            this.hoverInitDone = this.hovered = !1;
            this.$elt = null;
            this.contentIsLoaded = !1;
            this.imageNumber = this.contentLength = 0;
            this.eltTransform = {};
            this.paginationLastWidth = this.paginationLastPage = this.albumID = 0;
            this.customData = {};
        }
        var c = 1;
        a.get_nextId = function() {
            return c;
        };
        a.prototype = {
            thumbSetImgHeight: function(a) {
                for(var c = [
                    "xs",
                    "sm",
                    "me",
                    "la",
                    "xl"
                ], d = 0; d < c.length; d++)f.settings.height.l1[c[d]] == f.settings.height[G][H] && f.settings.width.l1[c[d]] == f.settings.width[G][H] && (this.thumbs.height.l1[c[d]] = a);
                for(d = 0; d < c.length; d++)f.settings.height.lN[c[d]] == f.settings.height[G][H] && f.settings.width.l1[c[d]] == f.settings.width[G][H] && (this.thumbs.height.lN[c[d]] = a);
            },
            thumbSetImgWidth: function(a) {
                for(var c = [
                    "xs",
                    "sm",
                    "me",
                    "la",
                    "xl"
                ], d = 0; d < c.length; d++)f.settings.height.l1[c[d]] == f.settings.height[G][H] && f.settings.width.l1[c[d]] == f.settings.width[G][H] && (this.thumbs.width.l1[c[d]] = a);
                for(d = 0; d < c.length; d++)f.settings.height.lN[c[d]] == f.settings.height[G][H] && f.settings.width.l1[c[d]] == f.settings.width[G][H] && (this.thumbs.width.lN[c[d]] = a);
            },
            thumbImg: function() {
                var a = {
                    src: "",
                    width: 0,
                    height: 0
                };
                if ("dummydummydummy" == this.title) return a.src = "data:image/gif;base64,R0lGODlhEAAQAIAAAP///////yH5BAEKAAEALAAAAAAQABAAAAIOjI+py+0Po5y02ouzPgUAOw==", a;
                switch(g.kind){
                    case "smugmug":
                        a.src = this.thumbsrc;
                        a.width = this.thumbImgWidth;
                        a.height = this.thumbImgHeight;
                        break;
                    default:
                        a.src = this.thumbs.url[G][H], a.width = this.thumbs.width[G][H], a.height = this.thumbs.height[G][H];
                }
                return a;
            },
            responsiveURL: function() {
                var a = "";
                switch(g.kind){
                    case "":
                        a = this.src;
                        break;
                    case "flickr":
                        a = this.src;
                        break;
                    case "smugmug":
                        a = this.src;
                        break;
                    default:
                        a = this.src;
                }
                return a;
            }
        };
        return a;
    }();
    this.Initiate = function(a, c) {
        g = c;
        d.base = jQuery(a);
        ga = d.base.attr("id");
        Function.prototype.bind || (Function.prototype.bind = function(a) {
            if ("function" !== typeof this) throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
            var b = Array.prototype.slice.call(arguments, 1), c = this, d = function() {}, e = function() {
                return c.apply(this instanceof d && a ? this : a, b.concat(Array.prototype.slice.call(arguments)));
            };
            d.prototype = this.prototype;
            e.prototype = new d;
            return e;
        });
        "object" == T(jQuery.velocity) ? D = "velocity" : "object" == T(jQuery.transit) && (D = "transition");
        jQuery(a).addClass("nanogallery_theme_" + g.theme);
        pc(a);
        if (g.thumbnailLabel.hideIcons) {
            var b = ".nanogallery_thumbnails_icons_off ", b = b + ".nanoGalleryContainer .nanoGalleryThumbnailContainer .labelImageTitle:before { display:none !important; }\n" + (b + ".nanoGalleryContainer .nanoGalleryThumbnailContainer .labelFolderTitle:before { display:none !important; }\n");
            jQuery("head").append("<style>" + b + "</style>");
            jQuery(a).addClass("nanogallery_thumbnails_icons_off");
        }
        g.galleryToolbarHideIcons && (b = ".nanogallery_breadcrumb_icons_off ", b = b + ".nanoGalleryNavigationbar .folderHome:before { display:none !important; }\n" + (b + ".nanoGalleryNavigationbar .folder:before { display:none !important; }\n"), jQuery("head").append("<style>" + b + "</style>"), jQuery(a).addClass("nanogallery_breadcrumb_icons_off"));
        "right" == g.thumbnailLabel.align && (b = ".nanogallery_thumbnails_label_align_right .nanoGalleryContainer .nanoGalleryThumbnailContainer .labelImage { text-align : right !important; }\n", jQuery("head").append("<style>" + b + "</style>"), jQuery(a).addClass("nanogallery_thumbnails_label_align_right"));
        "center" == g.thumbnailLabel.align && (b = ".nanogallery_thumbnails_label_align_center .nanoGalleryContainer .nanoGalleryThumbnailContainer .labelImage { text-align : center !important; }\n", jQuery("head").append("<style>" + b + "</style>"), jQuery(a).addClass("nanogallery_thumbnails_label_align_center"));
        "left" == g.thumbnailLabel.align && (b = ".nanogallery_thumbnails_label_align_left .nanoGalleryContainer .nanoGalleryThumbnailContainer .labelImage { text-align : left !important; }\n", jQuery("head").append("<style>" + b + "</style>"), jQuery(a).addClass("nanogallery_thumbnails_label_align_left"));
        d.conNavBCon = jQuery('<div class="nanoGalleryNavigationbarContainer"></div>').appendTo(a);
        d.conNavBCon.hide();
        d.conNavB = jQuery('<div class="nanoGalleryNavigationbar"></div>').appendTo(d.conNavBCon);
        d.conBC = jQuery('<div class="nanoGalleryBreadcrumb"></div>').appendTo(d.conNavB);
        d.conLoadingB = jQuery('<div class="nanoGalleryLBar" style="visibility:hidden;"><div></div><div></div><div></div><div></div><div></div></div>').appendTo(a);
        d.conTnParent = jQuery('<div class="nanoGalleryContainerParent"></div>').appendTo(a);
        d.conTn = jQuery('<div class="nanoGalleryContainer"></div>').appendTo(d.conTnParent);
        d.conConsole = jQuery('<div class="nanoGalleryConsoleParent"></div>').appendTo(a);
        switch(g.thumbnailAlignment){
            case "left":
                d.conTnParent.css({
                    "text-align": "left"
                });
                d.conNavBCon.css({
                    "margin-left": 0
                });
                break;
            case "right":
                d.conTnParent.css({
                    "text-align": "right"
                }), d.conNavBCon.css({
                    "margin-right": 0
                });
        }
        jQuery("head").append("<style>.nanogalleryHideElement {position: absolute !important; top: -9999px !important; left: -9999px !important;}</style>");
        b = jQuery('<div class="nanogalleryHideElement ' + jQuery(a).attr("class") + '"></div>').appendTo("body");
        b = jQuery('<div class="nanoGalleryContainerParent"></div>').appendTo(b);
        d.conTnHid = jQuery('<div class="nanoGalleryContainer"></div>').appendTo(b);
        q();
        d.conPagin = jQuery('<div class="nanoGalleryPagination"></div>').appendTo(d.conTnParent);
        new C(d.conTn[0]);
        z();
        document.fullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled || document.mozFullScreenEnabled ? Mb = !0 : ia("Your browser does not support the fullscreen API. Fullscreen button will not be displayed.");
        N();
        "loadData" != g.lazyBuild && J();
        var e = 0;
        jQuery(window).resize(function() {
            e && clearTimeout(e);
            Z ? qa(d.vwImgC) : e = setTimeout(function() {
                var a = ba();
                -1 == Ta || f.settings.height[G][H] == f.settings.height[G][a] && f.settings.width[G][H] == f.settings.width[G][a] ? Ja() : (H = a, wa(Ta, 0));
            }, 50);
        });
        jQuery(window).on("scroll", function() {
            ub && clearTimeout(ub);
            ub = setTimeout(function() {
                "loadData" == g.lazyBuild && va(d.conTnParent, g.lazyBuildTreshold) && (g.lazyBuild = "none", J());
                -1 != Sa && va(d.conTnParent, g.lazyBuildTreshold) && kb(Sa, Eb);
                lb();
            }, 200);
        });
        d.base.on("scroll", function() {
            vb && clearTimeout(vb);
            vb = setTimeout(function() {
                lb();
            }, 200);
        });
    };
    window.requestAnimFrame = function() {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(a) {
            window.setTimeout(a, 1E3 / 60);
        };
    }();
    var T = function(a) {
        return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, Va = function(a, c, b) {
        a = a.replace(/^\s*|\s*$/, "");
        a = a.replace(/^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i, "#$1$1$2$2$3$3");
        c = Math.round(256 * c) * (b ? -1 : 1);
        var d = a.match(/^rgba?\(\s*(\d|[1-9]\d|1\d{2}|2[0-4][0-9]|25[0-5])\s*,\s*(\d|[1-9]\d|1\d{2}|2[0-4][0-9]|25[0-5])\s*,\s*(\d|[1-9]\d|1\d{2}|2[0-4][0-9]|25[0-5])(?:\s*,\s*(0|1|0?\.\d+))?\s*\)$/i), f = d && null != d[4] ? d[4] : null;
        a = d ? [
            d[1],
            d[2],
            d[3]
        ] : a.replace(/^#?([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])/i, function(a, b, c, d) {
            return parseInt(b, 16) + "," + parseInt(c, 16) + "," + parseInt(d, 16);
        }).split(/,/);
        return d ? "rgb" + (null !== f ? "a" : "") + "(" + Math[b ? "max" : "min"](parseInt(a[0], 10) + c, b ? 0 : 255) + ", " + Math[b ? "max" : "min"](parseInt(a[1], 10) + c, b ? 0 : 255) + ", " + Math[b ? "max" : "min"](parseInt(a[2], 10) + c, b ? 0 : 255) + (null !== f ? ", " + f : "") + ")" : [
            "#",
            wb(Math[b ? "max" : "min"](parseInt(a[0], 10) + c, b ? 0 : 255).toString(16), 2),
            wb(Math[b ? "max" : "min"](parseInt(a[1], 10) + c, b ? 0 : 255).toString(16), 2),
            wb(Math[b ? "max" : "min"](parseInt(a[2], 10) + c, b ? 0 : 255).toString(16), 2)
        ].join("");
    }, wb = function(a, c) {
        for(a += ""; a.length < c;)a = "0" + a;
        return a;
    };
}
(function(t, K) {
    function J(h, k, r) {
        var m = v[k.type] || {};
        if (null == h) return r || !k.def ? null : k.def;
        h = m.floor ? ~~h : parseFloat(h);
        return isNaN(h) ? k.def : m.mod ? (h + m.mod) % m.mod : 0 > h ? 0 : m.max < h ? m.max : h;
    }
    function C(h) {
        var z = k(), r = z._rgba = [];
        h = h.toLowerCase();
        u(q, function(k, u) {
            var q, v = u.re.exec(h);
            q = v && u.parse(v);
            v = u.space || "rgba";
            if (q) return q = z[v](q), z[m[v].cache] = q[m[v].cache], r = z._rgba = q._rgba, !1;
        });
        return r.length ? ("0,0,0,0" === r.join() && t.extend(r, ba.transparent), z) : ba[h];
    }
    function X(h, k, r) {
        r = (r + 1) % 1;
        return 1 > 6 * r ? h + (k - h) * r * 6 : 1 > 2 * r ? k : 2 > 3 * r ? h + (k - h) * (2 / 3 - r) * 6 : h;
    }
    var E = /^([\-+])=\s*(\d+\.?\d*)/, q = [
        {
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function(h) {
                return [
                    h[1],
                    h[2],
                    h[3],
                    h[4]
                ];
            }
        },
        {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function(h) {
                return [
                    2.55 * h[1],
                    2.55 * h[2],
                    2.55 * h[3],
                    h[4]
                ];
            }
        },
        {
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
            parse: function(h) {
                return [
                    parseInt(h[1], 16),
                    parseInt(h[2], 16),
                    parseInt(h[3], 16)
                ];
            }
        },
        {
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
            parse: function(h) {
                return [
                    parseInt(h[1] + h[1], 16),
                    parseInt(h[2] + h[2], 16),
                    parseInt(h[3] + h[3], 16)
                ];
            }
        },
        {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function(h) {
                return [
                    h[1],
                    h[2] / 100,
                    h[3] / 100,
                    h[4]
                ];
            }
        }
    ], k = t.Color = function(h, k, r, m) {
        return new t.Color.fn.parse(h, k, r, m);
    }, m = {
        rgba: {
            props: {
                red: {
                    idx: 0,
                    type: "byte"
                },
                green: {
                    idx: 1,
                    type: "byte"
                },
                blue: {
                    idx: 2,
                    type: "byte"
                }
            }
        },
        hsla: {
            props: {
                hue: {
                    idx: 0,
                    type: "degrees"
                },
                saturation: {
                    idx: 1,
                    type: "percent"
                },
                lightness: {
                    idx: 2,
                    type: "percent"
                }
            }
        }
    }, v = {
        "byte": {
            floor: !0,
            max: 255
        },
        percent: {
            max: 1
        },
        degrees: {
            mod: 360,
            floor: !0
        }
    }, I = k.support = {}, ea = t("<p>")[0], ba, u = t.each;
    ea.style.cssText = "background-color:rgba(1,1,1,.5)";
    I.rgba = -1 < ea.style.backgroundColor.indexOf("rgba");
    u(m, function(h, k) {
        k.cache = "_" + h;
        k.props.alpha = {
            idx: 3,
            type: "percent",
            def: 1
        };
    });
    k.fn = t.extend(k.prototype, {
        parse: function(h, z, r, q) {
            if (h === K) return this._rgba = [
                null,
                null,
                null,
                null
            ], this;
            if (h.jquery || h.nodeType) h = t(h).css(z), z = K;
            var v = this, ca = t.type(h), I = this._rgba = [];
            z !== K && (h = [
                h,
                z,
                r,
                q
            ], ca = "array");
            if ("string" === ca) return this.parse(C(h) || ba._default);
            if ("array" === ca) return u(m.rgba.props, function(k, r) {
                I[r.idx] = J(h[r.idx], r);
            }), this;
            if ("object" === ca) return h instanceof k ? u(m, function(k, r) {
                h[r.cache] && (v[r.cache] = h[r.cache].slice());
            }) : u(m, function(k, r) {
                var m = r.cache;
                u(r.props, function(k, z) {
                    if (!v[m] && r.to) {
                        if ("alpha" === k || null == h[k]) return;
                        v[m] = r.to(v._rgba);
                    }
                    v[m][z.idx] = J(h[k], z, !0);
                });
                v[m] && 0 > t.inArray(null, v[m].slice(0, 3)) && (v[m][3] = 1, r.from && (v._rgba = r.from(v[m])));
            }), this;
        },
        is: function(h) {
            var z = k(h), r = !0, q = this;
            u(m, function(h, k) {
                var m, v = z[k.cache];
                v && (m = q[k.cache] || k.to && k.to(q._rgba) || [], u(k.props, function(h, k) {
                    if (null != v[k.idx]) return r = v[k.idx] === m[k.idx];
                }));
                return r;
            });
            return r;
        },
        _space: function() {
            var h = [], k = this;
            u(m, function(r, m) {
                k[m.cache] && h.push(r);
            });
            return h.pop();
        },
        transition: function(h, z) {
            var r = k(h), q = r._space(), t = m[q], I = 0 === this.alpha() ? k("transparent") : this, C = I[t.cache] || t.to(I._rgba), E = C.slice(), r = r[t.cache];
            u(t.props, function(h, k) {
                var m = k.idx, u = C[m], q = r[m], N = v[k.type] || {};
                null !== q && (null === u ? E[m] = q : (N.mod && (q - u > N.mod / 2 ? u += N.mod : u - q > N.mod / 2 && (u -= N.mod)), E[m] = J((q - u) * z + u, k)));
            });
            return this[q](E);
        },
        blend: function(h) {
            if (1 === this._rgba[3]) return this;
            var m = this._rgba.slice(), r = m.pop(), u = k(h)._rgba;
            return k(t.map(m, function(h, k) {
                return (1 - r) * u[k] + r * h;
            }));
        },
        toRgbaString: function() {
            var h = "rgba(", k = t.map(this._rgba, function(h, k) {
                return null == h ? 2 < k ? 1 : 0 : h;
            });
            1 === k[3] && (k.pop(), h = "rgb(");
            return h + k.join() + ")";
        },
        toHslaString: function() {
            var h = "hsla(", k = t.map(this.hsla(), function(h, k) {
                null == h && (h = 2 < k ? 1 : 0);
                k && 3 > k && (h = Math.round(100 * h) + "%");
                return h;
            });
            1 === k[3] && (k.pop(), h = "hsl(");
            return h + k.join() + ")";
        },
        toHexString: function(h) {
            var k = this._rgba.slice(), m = k.pop();
            h && k.push(~~(255 * m));
            return "#" + t.map(k, function(h) {
                h = (h || 0).toString(16);
                return 1 === h.length ? "0" + h : h;
            }).join("");
        },
        toString: function() {
            return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();
        }
    });
    k.fn.parse.prototype = k.fn;
    m.hsla.to = function(h) {
        if (null == h[0] || null == h[1] || null == h[2]) return [
            null,
            null,
            null,
            h[3]
        ];
        var k = h[0] / 255, m = h[1] / 255, u = h[2] / 255;
        h = h[3];
        var q = Math.max(k, m, u), v = Math.min(k, m, u), t = q - v, I = q + v, C = .5 * I, I = 0 === t ? 0 : .5 >= C ? t / I : t / (2 - I);
        return [
            Math.round(v === q ? 0 : k === q ? 60 * (m - u) / t + 360 : m === q ? 60 * (u - k) / t + 120 : 60 * (k - m) / t + 240) % 360,
            I,
            C,
            null == h ? 1 : h
        ];
    };
    m.hsla.from = function(h) {
        if (null == h[0] || null == h[1] || null == h[2]) return [
            null,
            null,
            null,
            h[3]
        ];
        var k = h[0] / 360, m = h[1], u = h[2];
        h = h[3];
        m = .5 >= u ? u * (1 + m) : u + m - u * m;
        u = 2 * u - m;
        return [
            Math.round(255 * X(u, m, k + 1 / 3)),
            Math.round(255 * X(u, m, k)),
            Math.round(255 * X(u, m, k - 1 / 3)),
            h
        ];
    };
    u(m, function(h, m) {
        var r = m.props, q = m.cache, v = m.to, I = m.from;
        k.fn[h] = function(h) {
            v && !this[q] && (this[q] = v(this._rgba));
            if (h === K) return this[q].slice();
            var m, z = t.type(h), C = "array" === z || "object" === z ? h : arguments, E = this[q].slice();
            u(r, function(h, k) {
                var m = C["object" === z ? h : k.idx];
                null == m && (m = E[k.idx]);
                E[k.idx] = J(m, k);
            });
            return I ? (m = k(I(E)), m[q] = E, m) : k(E);
        };
        u(r, function(m, r) {
            k.fn[m] || (k.fn[m] = function(k) {
                var u = t.type(k), q = "alpha" === m ? this._hsla ? "hsla" : "rgba" : h, z = this[q](), v = z[r.idx];
                if ("undefined" === u) return v;
                "function" === u && (k = k.call(this, v), u = t.type(k));
                if (null == k && r.empty) return this;
                "string" === u && (u = E.exec(k)) && (k = v + parseFloat(u[2]) * ("+" === u[1] ? 1 : -1));
                z[r.idx] = k;
                return this[q](z);
            });
        });
    });
    k.hook = function(h) {
        h = h.split(" ");
        u(h, function(h, m) {
            t.cssHooks[m] = {
                set: function(h, u) {
                    var q, z = "";
                    if ("transparent" !== u && ("string" !== t.type(u) || (q = C(u)))) {
                        u = k(q || u);
                        if (!I.rgba && 1 !== u._rgba[3]) {
                            for(q = "backgroundColor" === m ? h.parentNode : h; ("" === z || "transparent" === z) && q && q.style;)try {
                                z = t.css(q, "backgroundColor"), q = q.parentNode;
                            } catch (v) {}
                            u = u.blend(z && "transparent" !== z ? z : "_default");
                        }
                        u = u.toRgbaString();
                    }
                    try {
                        h.style[m] = u;
                    } catch (E) {}
                }
            };
            t.fx.step[m] = function(h) {
                h.colorInit || (h.start = k(h.elem, m), h.end = k(h.end), h.colorInit = !0);
                t.cssHooks[m].set(h.elem, h.start.transition(h.end, h.pos));
            };
        });
    };
    k.hook("backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor");
    t.cssHooks.borderColor = {
        expand: function(h) {
            var k = {};
            u([
                "Top",
                "Right",
                "Bottom",
                "Left"
            ], function(m, u) {
                k["border" + u + "Color"] = h;
            });
            return k;
        }
    };
    ba = t.Color.names = {
        aqua: "#00ffff",
        black: "#000000",
        blue: "#0000ff",
        fuchsia: "#ff00ff",
        gray: "#808080",
        green: "#008000",
        lime: "#00ff00",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        purple: "#800080",
        red: "#ff0000",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#ffffff",
        yellow: "#ffff00",
        transparent: [
            null,
            null,
            null,
            0
        ],
        _default: "#ffffff"
    };
})(jQuery);
(function() {
    function t() {}
    function K(q, k) {
        for(var m = q.length; m--;)if (q[m].listener === k) return m;
        return -1;
    }
    function J(q) {
        return function() {
            return this[q].apply(this, arguments);
        };
    }
    var C = t.prototype, X = this, E = X.ngEventEmitter;
    C.getListeners = function(q) {
        var k = this._getEvents(), m, v;
        if ("object" === typeof q) for(v in m = {}, k)k.hasOwnProperty(v) && q.test(v) && (m[v] = k[v]);
        else m = k[q] || (k[q] = []);
        return m;
    };
    C.flattenListeners = function(q) {
        var k = [], m;
        for(m = 0; m < q.length; m += 1)k.push(q[m].listener);
        return k;
    };
    C.getListenersAsObject = function(q) {
        var k = this.getListeners(q), m;
        k instanceof Array && (m = {}, m[q] = k);
        return m || k;
    };
    C.addListener = function(q, k) {
        var m = this.getListenersAsObject(q), v = "object" === typeof k, t;
        for(t in m)m.hasOwnProperty(t) && -1 === K(m[t], k) && m[t].push(v ? k : {
            listener: k,
            once: !1
        });
        return this;
    };
    C.on = J("addListener");
    C.addOnceListener = function(q, k) {
        return this.addListener(q, {
            listener: k,
            once: !0
        });
    };
    C.once = J("addOnceListener");
    C.defineEvent = function(q) {
        this.getListeners(q);
        return this;
    };
    C.defineEvents = function(q) {
        for(var k = 0; k < q.length; k += 1)this.defineEvent(q[k]);
        return this;
    };
    C.removeListener = function(q, k) {
        var m = this.getListenersAsObject(q), v, t;
        for(t in m)m.hasOwnProperty(t) && (v = K(m[t], k), -1 !== v && m[t].splice(v, 1));
        return this;
    };
    C.off = J("removeListener");
    C.addListeners = function(q, k) {
        return this.manipulateListeners(!1, q, k);
    };
    C.removeListeners = function(q, k) {
        return this.manipulateListeners(!0, q, k);
    };
    C.manipulateListeners = function(q, k, m) {
        var v, t, E = q ? this.removeListener : this.addListener;
        q = q ? this.removeListeners : this.addListeners;
        if ("object" !== typeof k || k instanceof RegExp) for(v = m.length; v--;)E.call(this, k, m[v]);
        else for(v in k)k.hasOwnProperty(v) && (t = k[v]) && ("function" === typeof t ? E.call(this, v, t) : q.call(this, v, t));
        return this;
    };
    C.removeEvent = function(q) {
        var k = typeof q, m = this._getEvents(), v;
        if ("string" === k) delete m[q];
        else if ("object" === k) for(v in m)m.hasOwnProperty(v) && q.test(v) && delete m[v];
        else delete this._events;
        return this;
    };
    C.removeAllListeners = J("removeEvent");
    C.emitEvent = function(q, k) {
        var m = this.getListenersAsObject(q), v, t, E, C;
        for(E in m)if (m.hasOwnProperty(E)) for(t = m[E].length; t--;)v = m[E][t], !0 === v.once && this.removeListener(q, v.listener), C = v.listener.apply(this, k || []), C === this._getOnceReturnValue() && this.removeListener(q, v.listener);
        return this;
    };
    C.trigger = J("emitEvent");
    C.emit = function(q) {
        var k = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(q, k);
    };
    C.setOnceReturnValue = function(q) {
        this._onceReturnValue = q;
        return this;
    };
    C._getOnceReturnValue = function() {
        return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0;
    };
    C._getEvents = function() {
        return this._events || (this._events = {});
    };
    t.noConflict = function() {
        X.ngEventEmitter = E;
        return t;
    };
    "function" === typeof define && define.amd ? define("ngEventEmitter/ngEventEmitter", [], function() {
        return t;
    }) : (0, module.exports) ? module.exports = t : this.ngEventEmitter = t;
}).call(this);
(function(t) {
    function K(E) {
        var q = t.event;
        q.target = q.target || q.srcElement || E;
        return q;
    }
    var J = document.documentElement, C = function() {};
    J.addEventListener ? C = function(t, q, k) {
        t.addEventListener(q, k, !1);
    } : J.attachEvent && (C = function(t, q, k) {
        t[q + k] = k.handleEvent ? function() {
            var m = K(t);
            k.handleEvent.call(k, m);
        } : function() {
            var m = K(t);
            k.call(t, m);
        };
        t.attachEvent("on" + q, t[q + k]);
    });
    var X = function() {};
    J.removeEventListener ? X = function(t, q, k) {
        t.removeEventListener(q, k, !1);
    } : J.detachEvent && (X = function(t, q, k) {
        t.detachEvent("on" + q, t[q + k]);
        try {
            delete t[q + k];
        } catch (m) {
            t[q + k] = void 0;
        }
    });
    J = {
        bind: C,
        unbind: X
    };
    "function" === typeof define && define.amd ? define("eventie/eventie", J) : t.eventie = J;
})(this);
(function(t, K) {
    "function" === typeof define && define.amd ? define([
        "ngEventEmitter/ngEventEmitter",
        "eventie/eventie"
    ], function(J, C) {
        return K(t, J, C);
    }) : module.exports = K(t, require("19632af0fea8e936"), require("9156c0ae9a80c28f"));
})(window, function(t, K, J) {
    function C(k, h) {
        for(var m in h)k[m] = h[m];
        return k;
    }
    function X(k) {
        var h = [];
        if ("[object Array]" === ea.call(k)) h = k;
        else if ("number" === typeof k.length) for(var m = 0, r = k.length; m < r; m++)h.push(k[m]);
        else h.push(k);
        return h;
    }
    function E(k, h, q) {
        if (!(this instanceof E)) return new E(k, h);
        "string" === typeof k && (k = document.querySelectorAll(k));
        this.elements = X(k);
        this.options = C({}, this.options);
        "function" === typeof h ? q = h : C(this.options, h);
        if (q) this.on("always", q);
        this.getImages();
        m && (this.jqDeferred = new m.Deferred);
        var r = this;
        setTimeout(function() {
            r.check();
        });
    }
    function q(k) {
        this.img = k;
    }
    function k(k) {
        this.src = k;
        ba[k] = this;
    }
    var m = t.jQuery, v = t.console, I = "undefined" !== typeof v, ea = Object.prototype.toString;
    E.prototype = new K;
    E.prototype.options = {};
    E.prototype.getImages = function() {
        this.images = [];
        for(var k = 0, h = this.elements.length; k < h; k++){
            var m = this.elements[k];
            "IMG" === m.nodeName && this.addImage(m);
            var r = m.nodeType;
            if (r && (1 === r || 9 === r || 11 === r)) for(var m = m.querySelectorAll("img"), r = 0, q = m.length; r < q; r++)this.addImage(m[r]);
        }
    };
    E.prototype.addImage = function(k) {
        k = new q(k);
        this.images.push(k);
    };
    E.prototype.check = function() {
        function k(q, u) {
            h.options.debug && I && v.log("confirm", q, u);
            h.progress(q);
            m++;
            m === r && h.complete();
            return !0;
        }
        var h = this, m = 0, r = this.images.length;
        this.hasAnyBroken = !1;
        if (r) for(var q = 0; q < r; q++){
            var t = this.images[q];
            t.on("confirm", k);
            t.check();
        }
        else this.complete();
    };
    E.prototype.progress = function(k) {
        this.hasAnyBroken = this.hasAnyBroken || !k.isLoaded;
        var h = this;
        setTimeout(function() {
            h.emit("progress", h, k);
            h.jqDeferred && h.jqDeferred.notify && h.jqDeferred.notify(h, k);
        });
    };
    E.prototype.complete = function() {
        var k = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = !0;
        var h = this;
        setTimeout(function() {
            h.emit(k, h);
            h.emit("always", h);
            if (h.jqDeferred) h.jqDeferred[h.hasAnyBroken ? "reject" : "resolve"](h);
        });
    };
    m && (m.fn.ngimagesLoaded = function(k, h) {
        return new E(this, k, h).jqDeferred.promise(m(this));
    });
    q.prototype = new K;
    q.prototype.check = function() {
        var m = ba[this.img.src] || new k(this.img.src);
        if (m.isConfirmed) this.confirm(m.isLoaded, "cached was confirmed");
        else if (this.img.complete && void 0 !== this.img.naturalWidth) this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
        else {
            var h = this;
            m.on("confirm", function(k, m) {
                h.confirm(k.isLoaded, m);
                return !0;
            });
            m.check();
        }
    };
    q.prototype.confirm = function(k, h) {
        this.isLoaded = k;
        this.emit("confirm", this, h);
    };
    var ba = {};
    k.prototype = new K;
    k.prototype.check = function() {
        if (!this.isChecked) {
            var k = new Image;
            J.bind(k, "load", this);
            J.bind(k, "error", this);
            k.src = this.src;
            this.isChecked = !0;
        }
    };
    k.prototype.handleEvent = function(k) {
        var h = "on" + k.type;
        if (this[h]) this[h](k);
    };
    k.prototype.onload = function(k) {
        this.confirm(!0, "onload");
        this.unbindProxyEvents(k);
    };
    k.prototype.onerror = function(k) {
        this.confirm(!1, "onerror");
        this.unbindProxyEvents(k);
    };
    k.prototype.confirm = function(k, h) {
        this.isConfirmed = !0;
        this.isLoaded = k;
        this.emit("confirm", this, h);
    };
    k.prototype.unbindProxyEvents = function(k) {
        J.unbind(k.target, "load", this);
        J.unbind(k.target, "error", this);
    };
    return E;
});

},{"19632af0fea8e936":"2eFNp","9156c0ae9a80c28f":"8jta7"}],"2eFNp":[function(require,module,exports) {
(function(exports) {
    "use strict";
    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */ function EventEmitter() {}
    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var originalGlobalValue = exports.EventEmitter;
    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */ function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while(i--){
            if (listeners[i].listener === listener) return i;
        }
        return -1;
    }
    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */ function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }
    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */ proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;
        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for(key in events)if (events.hasOwnProperty(key) && evt.test(key)) response[key] = events[key];
        } else response = events[evt] || (events[evt] = []);
        return response;
    };
    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */ proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;
        for(i = 0; i < listeners.length; i += 1)flatListeners.push(listeners[i].listener);
        return flatListeners;
    };
    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */ proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;
        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }
        return response || listeners;
    };
    function isValidListener(listener) {
        if (typeof listener === "function" || listener instanceof RegExp) return true;
        else if (listener && typeof listener === "object") return isValidListener(listener.listener);
        else return false;
    }
    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.addListener = function addListener(evt, listener) {
        if (!isValidListener(listener)) throw new TypeError("listener must be a function");
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === "object";
        var key;
        for(key in listeners)if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) listeners[key].push(listenerIsWrapped ? listener : {
            listener: listener,
            once: false
        });
        return this;
    };
    /**
     * Alias of addListener
     */ proto.on = alias("addListener");
    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };
    /**
     * Alias of addOnceListener.
     */ proto.once = alias("addOnceListener");
    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };
    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.defineEvents = function defineEvents(evts) {
        for(var i = 0; i < evts.length; i += 1)this.defineEvent(evts[i]);
        return this;
    };
    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;
        for(key in listeners)if (listeners.hasOwnProperty(key)) {
            index = indexOfListener(listeners[key], listener);
            if (index !== -1) listeners[key].splice(index, 1);
        }
        return this;
    };
    /**
     * Alias of removeListener
     */ proto.off = alias("removeListener");
    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };
    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };
    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;
        // If evt is an object then pass each of its properties to this method
        if (typeof evt === "object" && !(evt instanceof RegExp)) {
            for(i in evt)if (evt.hasOwnProperty(i) && (value = evt[i])) {
                // Pass the single listener straight through to the singular method
                if (typeof value === "function") single.call(this, i, value);
                else // Otherwise pass back to the multiple function
                multiple.call(this, i, value);
            }
        } else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while(i--)single.call(this, evt, listeners[i]);
        }
        return this;
    };
    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;
        // Remove different things depending on the state of evt
        if (type === "string") // Remove all listeners for the specified event
        delete events[evt];
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for(key in events)if (events.hasOwnProperty(key) && evt.test(key)) delete events[key];
        } else // Remove all listeners in all events
        delete this._events;
        return this;
    };
    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */ proto.removeAllListeners = alias("removeEvent");
    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;
        for(key in listenersMap)if (listenersMap.hasOwnProperty(key)) {
            listeners = listenersMap[key].slice(0);
            for(i = 0; i < listeners.length; i++){
                // If the listener returns true then it shall be removed from the event
                // The function is executed either with a basic call or an apply if there is an args array
                listener = listeners[i];
                if (listener.once === true) this.removeListener(evt, listener.listener);
                response = listener.listener.apply(this, args || []);
                if (response === this._getOnceReturnValue()) this.removeListener(evt, listener.listener);
            }
        }
        return this;
    };
    /**
     * Alias of emitEvent
     */ proto.trigger = alias("emitEvent");
    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };
    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */ proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };
    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */ proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty("_onceReturnValue")) return this._onceReturnValue;
        else return true;
    };
    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */ proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };
    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */ EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };
    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === "function" && define.amd) define(function() {
        return EventEmitter;
    });
    else if (0, module.exports) module.exports = EventEmitter;
    else exports.EventEmitter = EventEmitter;
})(typeof window !== "undefined" ? window : this || {});

},{}],"8jta7":[function(require,module,exports) {
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true */ /*global define: false, module: false */ (function(window1) {
    "use strict";
    var docElem = document.documentElement;
    var bind = function() {};
    function getIEEvent(obj) {
        var event = window1.event;
        // add event.target
        event.target = event.target || event.srcElement || obj;
        return event;
    }
    if (docElem.addEventListener) bind = function(obj, type, fn) {
        obj.addEventListener(type, fn, false);
    };
    else if (docElem.attachEvent) bind = function(obj, type, fn) {
        obj[type + fn] = fn.handleEvent ? function() {
            var event = getIEEvent(obj);
            fn.handleEvent.call(fn, event);
        } : function() {
            var event = getIEEvent(obj);
            fn.call(obj, event);
        };
        obj.attachEvent("on" + type, obj[type + fn]);
    };
    var unbind = function() {};
    if (docElem.removeEventListener) unbind = function(obj, type, fn) {
        obj.removeEventListener(type, fn, false);
    };
    else if (docElem.detachEvent) unbind = function(obj, type, fn) {
        obj.detachEvent("on" + type, obj[type + fn]);
        try {
            delete obj[type + fn];
        } catch (err) {
            // can't delete window object properties
            obj[type + fn] = undefined;
        }
    };
    var eventie = {
        bind: bind,
        unbind: unbind
    };
    // ----- module definition ----- //
    if (typeof define === "function" && define.amd) // AMD
    define(eventie);
    else // CommonJS
    module.exports = eventie;
})(window);

},{}],"3wVYm":[function(require,module,exports) {
/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */ if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");
!function(t) {
    "use strict";
    var e = jQuery.fn.jquery.split(" ")[0].split(".");
    if (e[0] < 2 && e[1] < 9 || 1 == e[0] && 9 == e[1] && e[2] < 1 || 3 < e[0]) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
}(), function(n) {
    "use strict";
    n.fn.emulateTransitionEnd = function(t) {
        var e = !1, i = this;
        n(this).one("bsTransitionEnd", function() {
            e = !0;
        });
        return setTimeout(function() {
            e || n(i).trigger(n.support.transition.end);
        }, t), this;
    }, n(function() {
        n.support.transition = function o() {
            var t = document.createElement("bootstrap"), e = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            };
            for(var i in e)if (t.style[i] !== undefined) return {
                end: e[i]
            };
            return !1;
        }(), n.support.transition && (n.event.special.bsTransitionEnd = {
            bindType: n.support.transition.end,
            delegateType: n.support.transition.end,
            handle: function(t) {
                if (n(t.target).is(this)) return t.handleObj.handler.apply(this, arguments);
            }
        });
    });
}(jQuery), function(s) {
    "use strict";
    var e = '[data-dismiss="alert"]', a = function(t) {
        s(t).on("click", e, this.close);
    };
    a.VERSION = "3.4.1", a.TRANSITION_DURATION = 150, a.prototype.close = function(t) {
        var e = s(this), i = e.attr("data-target");
        i || (i = (i = e.attr("href")) && i.replace(/.*(?=#[^\s]*$)/, "")), i = "#" === i ? [] : i;
        var o = s(document).find(i);
        function n() {
            o.detach().trigger("closed.bs.alert").remove();
        }
        t && t.preventDefault(), o.length || (o = e.closest(".alert")), o.trigger(t = s.Event("close.bs.alert")), t.isDefaultPrevented() || (o.removeClass("in"), s.support.transition && o.hasClass("fade") ? o.one("bsTransitionEnd", n).emulateTransitionEnd(a.TRANSITION_DURATION) : n());
    };
    var t = s.fn.alert;
    s.fn.alert = function o(i) {
        return this.each(function() {
            var t = s(this), e = t.data("bs.alert");
            e || t.data("bs.alert", e = new a(this)), "string" == typeof i && e[i].call(t);
        });
    }, s.fn.alert.Constructor = a, s.fn.alert.noConflict = function() {
        return s.fn.alert = t, this;
    }, s(document).on("click.bs.alert.data-api", e, a.prototype.close);
}(jQuery), function(s) {
    "use strict";
    var n = function(t, e) {
        this.$element = s(t), this.options = s.extend({}, n.DEFAULTS, e), this.isLoading = !1;
    };
    function i(o) {
        return this.each(function() {
            var t = s(this), e = t.data("bs.button"), i = "object" == typeof o && o;
            e || t.data("bs.button", e = new n(this, i)), "toggle" == o ? e.toggle() : o && e.setState(o);
        });
    }
    n.VERSION = "3.4.1", n.DEFAULTS = {
        loadingText: "loading..."
    }, n.prototype.setState = function(t) {
        var e = "disabled", i = this.$element, o = i.is("input") ? "val" : "html", n = i.data();
        t += "Text", null == n.resetText && i.data("resetText", i[o]()), setTimeout(s.proxy(function() {
            i[o](null == n[t] ? this.options[t] : n[t]), "loadingText" == t ? (this.isLoading = !0, i.addClass(e).attr(e, e).prop(e, !0)) : this.isLoading && (this.isLoading = !1, i.removeClass(e).removeAttr(e).prop(e, !1));
        }, this), 0);
    }, n.prototype.toggle = function() {
        var t = !0, e = this.$element.closest('[data-toggle="buttons"]');
        if (e.length) {
            var i = this.$element.find("input");
            "radio" == i.prop("type") ? (i.prop("checked") && (t = !1), e.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == i.prop("type") && (i.prop("checked") !== this.$element.hasClass("active") && (t = !1), this.$element.toggleClass("active")), i.prop("checked", this.$element.hasClass("active")), t && i.trigger("change");
        } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
    };
    var t = s.fn.button;
    s.fn.button = i, s.fn.button.Constructor = n, s.fn.button.noConflict = function() {
        return s.fn.button = t, this;
    }, s(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(t) {
        var e = s(t.target).closest(".btn");
        i.call(e, "toggle"), s(t.target).is('input[type="radio"], input[type="checkbox"]') || (t.preventDefault(), e.is("input,button") ? e.trigger("focus") : e.find("input:visible,button:visible").first().trigger("focus"));
    }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(t) {
        s(t.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(t.type));
    });
}(jQuery), function(p) {
    "use strict";
    var c = function(t, e) {
        this.$element = p(t), this.$indicators = this.$element.find(".carousel-indicators"), this.options = e, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", p.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", p.proxy(this.pause, this)).on("mouseleave.bs.carousel", p.proxy(this.cycle, this));
    };
    function r(n) {
        return this.each(function() {
            var t = p(this), e = t.data("bs.carousel"), i = p.extend({}, c.DEFAULTS, t.data(), "object" == typeof n && n), o = "string" == typeof n ? n : i.slide;
            e || t.data("bs.carousel", e = new c(this, i)), "number" == typeof n ? e.to(n) : o ? e[o]() : i.interval && e.pause().cycle();
        });
    }
    c.VERSION = "3.4.1", c.TRANSITION_DURATION = 600, c.DEFAULTS = {
        interval: 5e3,
        pause: "hover",
        wrap: !0,
        keyboard: !0
    }, c.prototype.keydown = function(t) {
        if (!/input|textarea/i.test(t.target.tagName)) {
            switch(t.which){
                case 37:
                    this.prev();
                    break;
                case 39:
                    this.next();
                    break;
                default:
                    return;
            }
            t.preventDefault();
        }
    }, c.prototype.cycle = function(t) {
        return t || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(p.proxy(this.next, this), this.options.interval)), this;
    }, c.prototype.getItemIndex = function(t) {
        return this.$items = t.parent().children(".item"), this.$items.index(t || this.$active);
    }, c.prototype.getItemForDirection = function(t, e) {
        var i = this.getItemIndex(e);
        if (("prev" == t && 0 === i || "next" == t && i == this.$items.length - 1) && !this.options.wrap) return e;
        var o = (i + ("prev" == t ? -1 : 1)) % this.$items.length;
        return this.$items.eq(o);
    }, c.prototype.to = function(t) {
        var e = this, i = this.getItemIndex(this.$active = this.$element.find(".item.active"));
        if (!(t > this.$items.length - 1 || t < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function() {
            e.to(t);
        }) : i == t ? this.pause().cycle() : this.slide(i < t ? "next" : "prev", this.$items.eq(t));
    }, c.prototype.pause = function(t) {
        return t || (this.paused = !0), this.$element.find(".next, .prev").length && p.support.transition && (this.$element.trigger(p.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this;
    }, c.prototype.next = function() {
        if (!this.sliding) return this.slide("next");
    }, c.prototype.prev = function() {
        if (!this.sliding) return this.slide("prev");
    }, c.prototype.slide = function(t, e) {
        var i = this.$element.find(".item.active"), o = e || this.getItemForDirection(t, i), n = this.interval, s = "next" == t ? "left" : "right", a = this;
        if (o.hasClass("active")) return this.sliding = !1;
        var r = o[0], l = p.Event("slide.bs.carousel", {
            relatedTarget: r,
            direction: s
        });
        if (this.$element.trigger(l), !l.isDefaultPrevented()) {
            if (this.sliding = !0, n && this.pause(), this.$indicators.length) {
                this.$indicators.find(".active").removeClass("active");
                var h = p(this.$indicators.children()[this.getItemIndex(o)]);
                h && h.addClass("active");
            }
            var d = p.Event("slid.bs.carousel", {
                relatedTarget: r,
                direction: s
            });
            return p.support.transition && this.$element.hasClass("slide") ? (o.addClass(t), "object" == typeof o && o.length && o[0].offsetWidth, i.addClass(s), o.addClass(s), i.one("bsTransitionEnd", function() {
                o.removeClass([
                    t,
                    s
                ].join(" ")).addClass("active"), i.removeClass([
                    "active",
                    s
                ].join(" ")), a.sliding = !1, setTimeout(function() {
                    a.$element.trigger(d);
                }, 0);
            }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (i.removeClass("active"), o.addClass("active"), this.sliding = !1, this.$element.trigger(d)), n && this.cycle(), this;
        }
    };
    var t = p.fn.carousel;
    p.fn.carousel = r, p.fn.carousel.Constructor = c, p.fn.carousel.noConflict = function() {
        return p.fn.carousel = t, this;
    };
    var e = function(t) {
        var e = p(this), i = e.attr("href");
        i && (i = i.replace(/.*(?=#[^\s]+$)/, ""));
        var o = e.attr("data-target") || i, n = p(document).find(o);
        if (n.hasClass("carousel")) {
            var s = p.extend({}, n.data(), e.data()), a = e.attr("data-slide-to");
            a && (s.interval = !1), r.call(n, s), a && n.data("bs.carousel").to(a), t.preventDefault();
        }
    };
    p(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), p(window).on("load", function() {
        p('[data-ride="carousel"]').each(function() {
            var t = p(this);
            r.call(t, t.data());
        });
    });
}(jQuery), function(a) {
    "use strict";
    var r = function(t, e) {
        this.$element = a(t), this.options = a.extend({}, r.DEFAULTS, e), this.$trigger = a('[data-toggle="collapse"][href="#' + t.id + '"],[data-toggle="collapse"][data-target="#' + t.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
    };
    function n(t) {
        var e, i = t.attr("data-target") || (e = t.attr("href")) && e.replace(/.*(?=#[^\s]+$)/, "");
        return a(document).find(i);
    }
    function l(o) {
        return this.each(function() {
            var t = a(this), e = t.data("bs.collapse"), i = a.extend({}, r.DEFAULTS, t.data(), "object" == typeof o && o);
            !e && i.toggle && /show|hide/.test(o) && (i.toggle = !1), e || t.data("bs.collapse", e = new r(this, i)), "string" == typeof o && e[o]();
        });
    }
    r.VERSION = "3.4.1", r.TRANSITION_DURATION = 350, r.DEFAULTS = {
        toggle: !0
    }, r.prototype.dimension = function() {
        return this.$element.hasClass("width") ? "width" : "height";
    }, r.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var t, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
            if (!(e && e.length && (t = e.data("bs.collapse")) && t.transitioning)) {
                var i = a.Event("show.bs.collapse");
                if (this.$element.trigger(i), !i.isDefaultPrevented()) {
                    e && e.length && (l.call(e, "hide"), t || e.data("bs.collapse", null));
                    var o = this.dimension();
                    this.$element.removeClass("collapse").addClass("collapsing")[o](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
                    var n = function() {
                        this.$element.removeClass("collapsing").addClass("collapse in")[o](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
                    };
                    if (!a.support.transition) return n.call(this);
                    var s = a.camelCase([
                        "scroll",
                        o
                    ].join("-"));
                    this.$element.one("bsTransitionEnd", a.proxy(n, this)).emulateTransitionEnd(r.TRANSITION_DURATION)[o](this.$element[0][s]);
                }
            }
        }
    }, r.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var t = a.Event("hide.bs.collapse");
            if (this.$element.trigger(t), !t.isDefaultPrevented()) {
                var e = this.dimension();
                this.$element[e](this.$element[e]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
                var i = function() {
                    this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
                };
                if (!a.support.transition) return i.call(this);
                this.$element[e](0).one("bsTransitionEnd", a.proxy(i, this)).emulateTransitionEnd(r.TRANSITION_DURATION);
            }
        }
    }, r.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
    }, r.prototype.getParent = function() {
        return a(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(t, e) {
            var i = a(e);
            this.addAriaAndCollapsedClass(n(i), i);
        }, this)).end();
    }, r.prototype.addAriaAndCollapsedClass = function(t, e) {
        var i = t.hasClass("in");
        t.attr("aria-expanded", i), e.toggleClass("collapsed", !i).attr("aria-expanded", i);
    };
    var t = a.fn.collapse;
    a.fn.collapse = l, a.fn.collapse.Constructor = r, a.fn.collapse.noConflict = function() {
        return a.fn.collapse = t, this;
    }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(t) {
        var e = a(this);
        e.attr("data-target") || t.preventDefault();
        var i = n(e), o = i.data("bs.collapse") ? "toggle" : e.data();
        l.call(i, o);
    });
}(jQuery), function(a) {
    "use strict";
    var r = '[data-toggle="dropdown"]', o = function(t) {
        a(t).on("click.bs.dropdown", this.toggle);
    };
    function l(t) {
        var e = t.attr("data-target");
        e || (e = (e = t.attr("href")) && /#[A-Za-z]/.test(e) && e.replace(/.*(?=#[^\s]*$)/, ""));
        var i = "#" !== e ? a(document).find(e) : null;
        return i && i.length ? i : t.parent();
    }
    function s(o) {
        o && 3 === o.which || (a(".dropdown-backdrop").remove(), a(r).each(function() {
            var t = a(this), e = l(t), i = {
                relatedTarget: this
            };
            e.hasClass("open") && (o && "click" == o.type && /input|textarea/i.test(o.target.tagName) && a.contains(e[0], o.target) || (e.trigger(o = a.Event("hide.bs.dropdown", i)), o.isDefaultPrevented() || (t.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", i)))));
        }));
    }
    o.VERSION = "3.4.1", o.prototype.toggle = function(t) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
            var i = l(e), o = i.hasClass("open");
            if (s(), !o) {
                "ontouchstart" in document.documentElement && !i.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", s);
                var n = {
                    relatedTarget: this
                };
                if (i.trigger(t = a.Event("show.bs.dropdown", n)), t.isDefaultPrevented()) return;
                e.trigger("focus").attr("aria-expanded", "true"), i.toggleClass("open").trigger(a.Event("shown.bs.dropdown", n));
            }
            return !1;
        }
    }, o.prototype.keydown = function(t) {
        if (/(38|40|27|32)/.test(t.which) && !/input|textarea/i.test(t.target.tagName)) {
            var e = a(this);
            if (t.preventDefault(), t.stopPropagation(), !e.is(".disabled, :disabled")) {
                var i = l(e), o = i.hasClass("open");
                if (!o && 27 != t.which || o && 27 == t.which) return 27 == t.which && i.find(r).trigger("focus"), e.trigger("click");
                var n = i.find(".dropdown-menu li:not(.disabled):visible a");
                if (n.length) {
                    var s = n.index(t.target);
                    38 == t.which && 0 < s && s--, 40 == t.which && s < n.length - 1 && s++, ~s || (s = 0), n.eq(s).trigger("focus");
                }
            }
        }
    };
    var t = a.fn.dropdown;
    a.fn.dropdown = function e(i) {
        return this.each(function() {
            var t = a(this), e = t.data("bs.dropdown");
            e || t.data("bs.dropdown", e = new o(this)), "string" == typeof i && e[i].call(t);
        });
    }, a.fn.dropdown.Constructor = o, a.fn.dropdown.noConflict = function() {
        return a.fn.dropdown = t, this;
    }, a(document).on("click.bs.dropdown.data-api", s).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
        t.stopPropagation();
    }).on("click.bs.dropdown.data-api", r, o.prototype.toggle).on("keydown.bs.dropdown.data-api", r, o.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", o.prototype.keydown);
}(jQuery), function(a) {
    "use strict";
    var s = function(t, e) {
        this.options = e, this.$body = a(document.body), this.$element = a(t), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.fixedContent = ".navbar-fixed-top, .navbar-fixed-bottom", this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function() {
            this.$element.trigger("loaded.bs.modal");
        }, this));
    };
    function r(o, n) {
        return this.each(function() {
            var t = a(this), e = t.data("bs.modal"), i = a.extend({}, s.DEFAULTS, t.data(), "object" == typeof o && o);
            e || t.data("bs.modal", e = new s(this, i)), "string" == typeof o ? e[o](n) : i.show && e.show(n);
        });
    }
    s.VERSION = "3.4.1", s.TRANSITION_DURATION = 300, s.BACKDROP_TRANSITION_DURATION = 150, s.DEFAULTS = {
        backdrop: !0,
        keyboard: !0,
        show: !0
    }, s.prototype.toggle = function(t) {
        return this.isShown ? this.hide() : this.show(t);
    }, s.prototype.show = function(i) {
        var o = this, t = a.Event("show.bs.modal", {
            relatedTarget: i
        });
        this.$element.trigger(t), this.isShown || t.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
            o.$element.one("mouseup.dismiss.bs.modal", function(t) {
                a(t.target).is(o.$element) && (o.ignoreBackdropClick = !0);
            });
        }), this.backdrop(function() {
            var t = a.support.transition && o.$element.hasClass("fade");
            o.$element.parent().length || o.$element.appendTo(o.$body), o.$element.show().scrollTop(0), o.adjustDialog(), t && o.$element[0].offsetWidth, o.$element.addClass("in"), o.enforceFocus();
            var e = a.Event("shown.bs.modal", {
                relatedTarget: i
            });
            t ? o.$dialog.one("bsTransitionEnd", function() {
                o.$element.trigger("focus").trigger(e);
            }).emulateTransitionEnd(s.TRANSITION_DURATION) : o.$element.trigger("focus").trigger(e);
        }));
    }, s.prototype.hide = function(t) {
        t && t.preventDefault(), t = a.Event("hide.bs.modal"), this.$element.trigger(t), this.isShown && !t.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(s.TRANSITION_DURATION) : this.hideModal());
    }, s.prototype.enforceFocus = function() {
        a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function(t) {
            document === t.target || this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.trigger("focus");
        }, this));
    }, s.prototype.escape = function() {
        this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function(t) {
            27 == t.which && this.hide();
        }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
    }, s.prototype.resize = function() {
        this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
    }, s.prototype.hideModal = function() {
        var t = this;
        this.$element.hide(), this.backdrop(function() {
            t.$body.removeClass("modal-open"), t.resetAdjustments(), t.resetScrollbar(), t.$element.trigger("hidden.bs.modal");
        });
    }, s.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
    }, s.prototype.backdrop = function(t) {
        var e = this, i = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var o = a.support.transition && i;
            if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + i).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function(t) {
                this.ignoreBackdropClick ? this.ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide());
            }, this)), o && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !t) return;
            o ? this.$backdrop.one("bsTransitionEnd", t).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION) : t();
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass("in");
            var n = function() {
                e.removeBackdrop(), t && t();
            };
            a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", n).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION) : n();
        } else t && t();
    }, s.prototype.handleUpdate = function() {
        this.adjustDialog();
    }, s.prototype.adjustDialog = function() {
        var t = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
            paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : ""
        });
    }, s.prototype.resetAdjustments = function() {
        this.$element.css({
            paddingLeft: "",
            paddingRight: ""
        });
    }, s.prototype.checkScrollbar = function() {
        var t = window.innerWidth;
        if (!t) {
            var e = document.documentElement.getBoundingClientRect();
            t = e.right - Math.abs(e.left);
        }
        this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar();
    }, s.prototype.setScrollbar = function() {
        var t = parseInt(this.$body.css("padding-right") || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || "";
        var n = this.scrollbarWidth;
        this.bodyIsOverflowing && (this.$body.css("padding-right", t + n), a(this.fixedContent).each(function(t, e) {
            var i = e.style.paddingRight, o = a(e).css("padding-right");
            a(e).data("padding-right", i).css("padding-right", parseFloat(o) + n + "px");
        }));
    }, s.prototype.resetScrollbar = function() {
        this.$body.css("padding-right", this.originalBodyPad), a(this.fixedContent).each(function(t, e) {
            var i = a(e).data("padding-right");
            a(e).removeData("padding-right"), e.style.paddingRight = i || "";
        });
    }, s.prototype.measureScrollbar = function() {
        var t = document.createElement("div");
        t.className = "modal-scrollbar-measure", this.$body.append(t);
        var e = t.offsetWidth - t.clientWidth;
        return this.$body[0].removeChild(t), e;
    };
    var t = a.fn.modal;
    a.fn.modal = r, a.fn.modal.Constructor = s, a.fn.modal.noConflict = function() {
        return a.fn.modal = t, this;
    }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(t) {
        var e = a(this), i = e.attr("href"), o = e.attr("data-target") || i && i.replace(/.*(?=#[^\s]+$)/, ""), n = a(document).find(o), s = n.data("bs.modal") ? "toggle" : a.extend({
            remote: !/#/.test(i) && i
        }, n.data(), e.data());
        e.is("a") && t.preventDefault(), n.one("show.bs.modal", function(t) {
            t.isDefaultPrevented() || n.one("hidden.bs.modal", function() {
                e.is(":visible") && e.trigger("focus");
            });
        }), r.call(n, s, this);
    });
}(jQuery), function(g) {
    "use strict";
    var o = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ], a = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ], t = {
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            /^aria-[\w-]*$/i
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    }, r = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi, l = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
    function u(t, e) {
        var i = t.nodeName.toLowerCase();
        if (-1 !== g.inArray(i, e)) return -1 === g.inArray(i, a) || Boolean(t.nodeValue.match(r) || t.nodeValue.match(l));
        for(var o = g(e).filter(function(t, e) {
            return e instanceof RegExp;
        }), n = 0, s = o.length; n < s; n++)if (i.match(o[n])) return !0;
        return !1;
    }
    function n(t, e, i) {
        if (0 === t.length) return t;
        if (i && "function" == typeof i) return i(t);
        if (!document.implementation || !document.implementation.createHTMLDocument) return t;
        var o = document.implementation.createHTMLDocument("sanitization");
        o.body.innerHTML = t;
        for(var n = g.map(e, function(t, e) {
            return e;
        }), s = g(o.body).find("*"), a = 0, r = s.length; a < r; a++){
            var l = s[a], h = l.nodeName.toLowerCase();
            if (-1 !== g.inArray(h, n)) for(var d = g.map(l.attributes, function(t) {
                return t;
            }), p = [].concat(e["*"] || [], e[h] || []), c = 0, f = d.length; c < f; c++)u(d[c], p) || l.removeAttribute(d[c].nodeName);
            else l.parentNode.removeChild(l);
        }
        return o.body.innerHTML;
    }
    var m = function(t, e) {
        this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", t, e);
    };
    m.VERSION = "3.4.1", m.TRANSITION_DURATION = 150, m.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: {
            selector: "body",
            padding: 0
        },
        sanitize: !0,
        sanitizeFn: null,
        whiteList: t
    }, m.prototype.init = function(t, e, i) {
        if (this.enabled = !0, this.type = t, this.$element = g(e), this.options = this.getOptions(i), this.$viewport = this.options.viewport && g(document).find(g.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = {
            click: !1,
            hover: !1,
            focus: !1
        }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
        for(var o = this.options.trigger.split(" "), n = o.length; n--;){
            var s = o[n];
            if ("click" == s) this.$element.on("click." + this.type, this.options.selector, g.proxy(this.toggle, this));
            else if ("manual" != s) {
                var a = "hover" == s ? "mouseenter" : "focusin", r = "hover" == s ? "mouseleave" : "focusout";
                this.$element.on(a + "." + this.type, this.options.selector, g.proxy(this.enter, this)), this.$element.on(r + "." + this.type, this.options.selector, g.proxy(this.leave, this));
            }
        }
        this.options.selector ? this._options = g.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle();
    }, m.prototype.getDefaults = function() {
        return m.DEFAULTS;
    }, m.prototype.getOptions = function(t) {
        var e = this.$element.data();
        for(var i in e)e.hasOwnProperty(i) && -1 !== g.inArray(i, o) && delete e[i];
        return (t = g.extend({}, this.getDefaults(), e, t)).delay && "number" == typeof t.delay && (t.delay = {
            show: t.delay,
            hide: t.delay
        }), t.sanitize && (t.template = n(t.template, t.whiteList, t.sanitizeFn)), t;
    }, m.prototype.getDelegateOptions = function() {
        var i = {}, o = this.getDefaults();
        return this._options && g.each(this._options, function(t, e) {
            o[t] != e && (i[t] = e);
        }), i;
    }, m.prototype.enter = function(t) {
        var e = t instanceof this.constructor ? t : g(t.currentTarget).data("bs." + this.type);
        if (e || (e = new this.constructor(t.currentTarget, this.getDelegateOptions()), g(t.currentTarget).data("bs." + this.type, e)), t instanceof g.Event && (e.inState["focusin" == t.type ? "focus" : "hover"] = !0), e.tip().hasClass("in") || "in" == e.hoverState) e.hoverState = "in";
        else {
            if (clearTimeout(e.timeout), e.hoverState = "in", !e.options.delay || !e.options.delay.show) return e.show();
            e.timeout = setTimeout(function() {
                "in" == e.hoverState && e.show();
            }, e.options.delay.show);
        }
    }, m.prototype.isInStateTrue = function() {
        for(var t in this.inState)if (this.inState[t]) return !0;
        return !1;
    }, m.prototype.leave = function(t) {
        var e = t instanceof this.constructor ? t : g(t.currentTarget).data("bs." + this.type);
        if (e || (e = new this.constructor(t.currentTarget, this.getDelegateOptions()), g(t.currentTarget).data("bs." + this.type, e)), t instanceof g.Event && (e.inState["focusout" == t.type ? "focus" : "hover"] = !1), !e.isInStateTrue()) {
            if (clearTimeout(e.timeout), e.hoverState = "out", !e.options.delay || !e.options.delay.hide) return e.hide();
            e.timeout = setTimeout(function() {
                "out" == e.hoverState && e.hide();
            }, e.options.delay.hide);
        }
    }, m.prototype.show = function() {
        var t = g.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            this.$element.trigger(t);
            var e = g.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (t.isDefaultPrevented() || !e) return;
            var i = this, o = this.tip(), n = this.getUID(this.type);
            this.setContent(), o.attr("id", n), this.$element.attr("aria-describedby", n), this.options.animation && o.addClass("fade");
            var s = "function" == typeof this.options.placement ? this.options.placement.call(this, o[0], this.$element[0]) : this.options.placement, a = /\s?auto?\s?/i, r = a.test(s);
            r && (s = s.replace(a, "") || "top"), o.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(s).data("bs." + this.type, this), this.options.container ? o.appendTo(g(document).find(this.options.container)) : o.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);
            var l = this.getPosition(), h = o[0].offsetWidth, d = o[0].offsetHeight;
            if (r) {
                var p = s, c = this.getPosition(this.$viewport);
                s = "bottom" == s && l.bottom + d > c.bottom ? "top" : "top" == s && l.top - d < c.top ? "bottom" : "right" == s && l.right + h > c.width ? "left" : "left" == s && l.left - h < c.left ? "right" : s, o.removeClass(p).addClass(s);
            }
            var f = this.getCalculatedOffset(s, l, h, d);
            this.applyPlacement(f, s);
            var u = function() {
                var t = i.hoverState;
                i.$element.trigger("shown.bs." + i.type), i.hoverState = null, "out" == t && i.leave(i);
            };
            g.support.transition && this.$tip.hasClass("fade") ? o.one("bsTransitionEnd", u).emulateTransitionEnd(m.TRANSITION_DURATION) : u();
        }
    }, m.prototype.applyPlacement = function(t, e) {
        var i = this.tip(), o = i[0].offsetWidth, n = i[0].offsetHeight, s = parseInt(i.css("margin-top"), 10), a = parseInt(i.css("margin-left"), 10);
        isNaN(s) && (s = 0), isNaN(a) && (a = 0), t.top += s, t.left += a, g.offset.setOffset(i[0], g.extend({
            using: function(t) {
                i.css({
                    top: Math.round(t.top),
                    left: Math.round(t.left)
                });
            }
        }, t), 0), i.addClass("in");
        var r = i[0].offsetWidth, l = i[0].offsetHeight;
        "top" == e && l != n && (t.top = t.top + n - l);
        var h = this.getViewportAdjustedDelta(e, t, r, l);
        h.left ? t.left += h.left : t.top += h.top;
        var d = /top|bottom/.test(e), p = d ? 2 * h.left - o + r : 2 * h.top - n + l, c = d ? "offsetWidth" : "offsetHeight";
        i.offset(t), this.replaceArrow(p, i[0][c], d);
    }, m.prototype.replaceArrow = function(t, e, i) {
        this.arrow().css(i ? "left" : "top", 50 * (1 - t / e) + "%").css(i ? "top" : "left", "");
    }, m.prototype.setContent = function() {
        var t = this.tip(), e = this.getTitle();
        this.options.html ? (this.options.sanitize && (e = n(e, this.options.whiteList, this.options.sanitizeFn)), t.find(".tooltip-inner").html(e)) : t.find(".tooltip-inner").text(e), t.removeClass("fade in top bottom left right");
    }, m.prototype.hide = function(t) {
        var e = this, i = g(this.$tip), o = g.Event("hide.bs." + this.type);
        function n() {
            "in" != e.hoverState && i.detach(), e.$element && e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), t && t();
        }
        if (this.$element.trigger(o), !o.isDefaultPrevented()) return i.removeClass("in"), g.support.transition && i.hasClass("fade") ? i.one("bsTransitionEnd", n).emulateTransitionEnd(m.TRANSITION_DURATION) : n(), this.hoverState = null, this;
    }, m.prototype.fixTitle = function() {
        var t = this.$element;
        (t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "");
    }, m.prototype.hasContent = function() {
        return this.getTitle();
    }, m.prototype.getPosition = function(t) {
        var e = (t = t || this.$element)[0], i = "BODY" == e.tagName, o = e.getBoundingClientRect();
        null == o.width && (o = g.extend({}, o, {
            width: o.right - o.left,
            height: o.bottom - o.top
        }));
        var n = window.SVGElement && e instanceof window.SVGElement, s = i ? {
            top: 0,
            left: 0
        } : n ? null : t.offset(), a = {
            scroll: i ? document.documentElement.scrollTop || document.body.scrollTop : t.scrollTop()
        }, r = i ? {
            width: g(window).width(),
            height: g(window).height()
        } : null;
        return g.extend({}, o, a, r, s);
    }, m.prototype.getCalculatedOffset = function(t, e, i, o) {
        return "bottom" == t ? {
            top: e.top + e.height,
            left: e.left + e.width / 2 - i / 2
        } : "top" == t ? {
            top: e.top - o,
            left: e.left + e.width / 2 - i / 2
        } : "left" == t ? {
            top: e.top + e.height / 2 - o / 2,
            left: e.left - i
        } : {
            top: e.top + e.height / 2 - o / 2,
            left: e.left + e.width
        };
    }, m.prototype.getViewportAdjustedDelta = function(t, e, i, o) {
        var n = {
            top: 0,
            left: 0
        };
        if (!this.$viewport) return n;
        var s = this.options.viewport && this.options.viewport.padding || 0, a = this.getPosition(this.$viewport);
        if (/right|left/.test(t)) {
            var r = e.top - s - a.scroll, l = e.top + s - a.scroll + o;
            r < a.top ? n.top = a.top - r : l > a.top + a.height && (n.top = a.top + a.height - l);
        } else {
            var h = e.left - s, d = e.left + s + i;
            h < a.left ? n.left = a.left - h : d > a.right && (n.left = a.left + a.width - d);
        }
        return n;
    }, m.prototype.getTitle = function() {
        var t = this.$element, e = this.options;
        return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title);
    }, m.prototype.getUID = function(t) {
        for(; t += ~~(1e6 * Math.random()), document.getElementById(t););
        return t;
    }, m.prototype.tip = function() {
        if (!this.$tip && (this.$tip = g(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
        return this.$tip;
    }, m.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
    }, m.prototype.enable = function() {
        this.enabled = !0;
    }, m.prototype.disable = function() {
        this.enabled = !1;
    }, m.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled;
    }, m.prototype.toggle = function(t) {
        var e = this;
        t && ((e = g(t.currentTarget).data("bs." + this.type)) || (e = new this.constructor(t.currentTarget, this.getDelegateOptions()), g(t.currentTarget).data("bs." + this.type, e))), t ? (e.inState.click = !e.inState.click, e.isInStateTrue() ? e.enter(e) : e.leave(e)) : e.tip().hasClass("in") ? e.leave(e) : e.enter(e);
    }, m.prototype.destroy = function() {
        var t = this;
        clearTimeout(this.timeout), this.hide(function() {
            t.$element.off("." + t.type).removeData("bs." + t.type), t.$tip && t.$tip.detach(), t.$tip = null, t.$arrow = null, t.$viewport = null, t.$element = null;
        });
    }, m.prototype.sanitizeHtml = function(t) {
        return n(t, this.options.whiteList, this.options.sanitizeFn);
    };
    var e = g.fn.tooltip;
    g.fn.tooltip = function i(o) {
        return this.each(function() {
            var t = g(this), e = t.data("bs.tooltip"), i = "object" == typeof o && o;
            !e && /destroy|hide/.test(o) || (e || t.data("bs.tooltip", e = new m(this, i)), "string" == typeof o && e[o]());
        });
    }, g.fn.tooltip.Constructor = m, g.fn.tooltip.noConflict = function() {
        return g.fn.tooltip = e, this;
    };
}(jQuery), function(n) {
    "use strict";
    var s = function(t, e) {
        this.init("popover", t, e);
    };
    if (!n.fn.tooltip) throw new Error("Popover requires tooltip.js");
    s.VERSION = "3.4.1", s.DEFAULTS = n.extend({}, n.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    }), ((s.prototype = n.extend({}, n.fn.tooltip.Constructor.prototype)).constructor = s).prototype.getDefaults = function() {
        return s.DEFAULTS;
    }, s.prototype.setContent = function() {
        var t = this.tip(), e = this.getTitle(), i = this.getContent();
        if (this.options.html) {
            var o = typeof i;
            this.options.sanitize && (e = this.sanitizeHtml(e), "string" === o && (i = this.sanitizeHtml(i))), t.find(".popover-title").html(e), t.find(".popover-content").children().detach().end()["string" === o ? "html" : "append"](i);
        } else t.find(".popover-title").text(e), t.find(".popover-content").children().detach().end().text(i);
        t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide();
    }, s.prototype.hasContent = function() {
        return this.getTitle() || this.getContent();
    }, s.prototype.getContent = function() {
        var t = this.$element, e = this.options;
        return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content);
    }, s.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow");
    };
    var t = n.fn.popover;
    n.fn.popover = function e(o) {
        return this.each(function() {
            var t = n(this), e = t.data("bs.popover"), i = "object" == typeof o && o;
            !e && /destroy|hide/.test(o) || (e || t.data("bs.popover", e = new s(this, i)), "string" == typeof o && e[o]());
        });
    }, n.fn.popover.Constructor = s, n.fn.popover.noConflict = function() {
        return n.fn.popover = t, this;
    };
}(jQuery), function(s) {
    "use strict";
    function n(t, e) {
        this.$body = s(document.body), this.$scrollElement = s(t).is(document.body) ? s(window) : s(t), this.options = s.extend({}, n.DEFAULTS, e), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", s.proxy(this.process, this)), this.refresh(), this.process();
    }
    function e(o) {
        return this.each(function() {
            var t = s(this), e = t.data("bs.scrollspy"), i = "object" == typeof o && o;
            e || t.data("bs.scrollspy", e = new n(this, i)), "string" == typeof o && e[o]();
        });
    }
    n.VERSION = "3.4.1", n.DEFAULTS = {
        offset: 10
    }, n.prototype.getScrollHeight = function() {
        return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
    }, n.prototype.refresh = function() {
        var t = this, o = "offset", n = 0;
        this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), s.isWindow(this.$scrollElement[0]) || (o = "position", n = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
            var t = s(this), e = t.data("target") || t.attr("href"), i = /^#./.test(e) && s(e);
            return i && i.length && i.is(":visible") && [
                [
                    i[o]().top + n,
                    e
                ]
            ] || null;
        }).sort(function(t, e) {
            return t[0] - e[0];
        }).each(function() {
            t.offsets.push(this[0]), t.targets.push(this[1]);
        });
    }, n.prototype.process = function() {
        var t, e = this.$scrollElement.scrollTop() + this.options.offset, i = this.getScrollHeight(), o = this.options.offset + i - this.$scrollElement.height(), n = this.offsets, s = this.targets, a = this.activeTarget;
        if (this.scrollHeight != i && this.refresh(), o <= e) return a != (t = s[s.length - 1]) && this.activate(t);
        if (a && e < n[0]) return this.activeTarget = null, this.clear();
        for(t = n.length; t--;)a != s[t] && e >= n[t] && (n[t + 1] === undefined || e < n[t + 1]) && this.activate(s[t]);
    }, n.prototype.activate = function(t) {
        this.activeTarget = t, this.clear();
        var e = this.selector + '[data-target="' + t + '"],' + this.selector + '[href="' + t + '"]', i = s(e).parents("li").addClass("active");
        i.parent(".dropdown-menu").length && (i = i.closest("li.dropdown").addClass("active")), i.trigger("activate.bs.scrollspy");
    }, n.prototype.clear = function() {
        s(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
    };
    var t = s.fn.scrollspy;
    s.fn.scrollspy = e, s.fn.scrollspy.Constructor = n, s.fn.scrollspy.noConflict = function() {
        return s.fn.scrollspy = t, this;
    }, s(window).on("load.bs.scrollspy.data-api", function() {
        s('[data-spy="scroll"]').each(function() {
            var t = s(this);
            e.call(t, t.data());
        });
    });
}(jQuery), function(r) {
    "use strict";
    var a = function(t) {
        this.element = r(t);
    };
    function e(i) {
        return this.each(function() {
            var t = r(this), e = t.data("bs.tab");
            e || t.data("bs.tab", e = new a(this)), "string" == typeof i && e[i]();
        });
    }
    a.VERSION = "3.4.1", a.TRANSITION_DURATION = 150, a.prototype.show = function() {
        var t = this.element, e = t.closest("ul:not(.dropdown-menu)"), i = t.data("target");
        if (i || (i = (i = t.attr("href")) && i.replace(/.*(?=#[^\s]*$)/, "")), !t.parent("li").hasClass("active")) {
            var o = e.find(".active:last a"), n = r.Event("hide.bs.tab", {
                relatedTarget: t[0]
            }), s = r.Event("show.bs.tab", {
                relatedTarget: o[0]
            });
            if (o.trigger(n), t.trigger(s), !s.isDefaultPrevented() && !n.isDefaultPrevented()) {
                var a = r(document).find(i);
                this.activate(t.closest("li"), e), this.activate(a, a.parent(), function() {
                    o.trigger({
                        type: "hidden.bs.tab",
                        relatedTarget: t[0]
                    }), t.trigger({
                        type: "shown.bs.tab",
                        relatedTarget: o[0]
                    });
                });
            }
        }
    }, a.prototype.activate = function(t, e, i) {
        var o = e.find("> .active"), n = i && r.support.transition && (o.length && o.hasClass("fade") || !!e.find("> .fade").length);
        function s() {
            o.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), t.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), n ? (t[0].offsetWidth, t.addClass("in")) : t.removeClass("fade"), t.parent(".dropdown-menu").length && t.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), i && i();
        }
        o.length && n ? o.one("bsTransitionEnd", s).emulateTransitionEnd(a.TRANSITION_DURATION) : s(), o.removeClass("in");
    };
    var t = r.fn.tab;
    r.fn.tab = e, r.fn.tab.Constructor = a, r.fn.tab.noConflict = function() {
        return r.fn.tab = t, this;
    };
    var i = function(t) {
        t.preventDefault(), e.call(r(this), "show");
    };
    r(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', i).on("click.bs.tab.data-api", '[data-toggle="pill"]', i);
}(jQuery), function(l) {
    "use strict";
    var h = function(t, e) {
        this.options = l.extend({}, h.DEFAULTS, e);
        var i = this.options.target === h.DEFAULTS.target ? l(this.options.target) : l(document).find(this.options.target);
        this.$target = i.on("scroll.bs.affix.data-api", l.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", l.proxy(this.checkPositionWithEventLoop, this)), this.$element = l(t), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition();
    };
    function i(o) {
        return this.each(function() {
            var t = l(this), e = t.data("bs.affix"), i = "object" == typeof o && o;
            e || t.data("bs.affix", e = new h(this, i)), "string" == typeof o && e[o]();
        });
    }
    h.VERSION = "3.4.1", h.RESET = "affix affix-top affix-bottom", h.DEFAULTS = {
        offset: 0,
        target: window
    }, h.prototype.getState = function(t, e, i, o) {
        var n = this.$target.scrollTop(), s = this.$element.offset(), a = this.$target.height();
        if (null != i && "top" == this.affixed) return n < i && "top";
        if ("bottom" == this.affixed) return null != i ? !(n + this.unpin <= s.top) && "bottom" : !(n + a <= t - o) && "bottom";
        var r = null == this.affixed, l = r ? n : s.top;
        return null != i && n <= i ? "top" : null != o && t - o <= l + (r ? a : e) && "bottom";
    }, h.prototype.getPinnedOffset = function() {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(h.RESET).addClass("affix");
        var t = this.$target.scrollTop(), e = this.$element.offset();
        return this.pinnedOffset = e.top - t;
    }, h.prototype.checkPositionWithEventLoop = function() {
        setTimeout(l.proxy(this.checkPosition, this), 1);
    }, h.prototype.checkPosition = function() {
        if (this.$element.is(":visible")) {
            var t = this.$element.height(), e = this.options.offset, i = e.top, o = e.bottom, n = Math.max(l(document).height(), l(document.body).height());
            "object" != typeof e && (o = i = e), "function" == typeof i && (i = e.top(this.$element)), "function" == typeof o && (o = e.bottom(this.$element));
            var s = this.getState(n, t, i, o);
            if (this.affixed != s) {
                null != this.unpin && this.$element.css("top", "");
                var a = "affix" + (s ? "-" + s : ""), r = l.Event(a + ".bs.affix");
                if (this.$element.trigger(r), r.isDefaultPrevented()) return;
                this.affixed = s, this.unpin = "bottom" == s ? this.getPinnedOffset() : null, this.$element.removeClass(h.RESET).addClass(a).trigger(a.replace("affix", "affixed") + ".bs.affix");
            }
            "bottom" == s && this.$element.offset({
                top: n - t - o
            });
        }
    };
    var t = l.fn.affix;
    l.fn.affix = i, l.fn.affix.Constructor = h, l.fn.affix.noConflict = function() {
        return l.fn.affix = t, this;
    }, l(window).on("load", function() {
        l('[data-spy="affix"]').each(function() {
            var t = l(this), e = t.data();
            e.offset = e.offset || {}, null != e.offsetBottom && (e.offset.bottom = e.offsetBottom), null != e.offsetTop && (e.offset.top = e.offsetTop), i.call(t, e);
        });
    });
}(jQuery);

},{}]},["2RPtJ"], "2RPtJ", "parcelRequire087b")

//# sourceMappingURL=index.a8258f0c.js.map
